"use strict";

(function () {
  'use strict';

  angular.module('app.scc.notes', []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    $stateProvider.state('app.scc.notes', {
      url: '/notes',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/notes/notes.html',
          controller: 'NotesController as vm'
        }
      },
      resolve: {
        Notes: function Notes(NotesService) {
          return NotesService.getData();
        },
        Labels: function Labels(LabelsService) {
          return LabelsService.getData();
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/notes');

    // Api
    msApiProvider.register('notes.notes', ['app/data/notes/notes.json']);
    msApiProvider.register('notes.labels', ['app/data/notes/labels.json']);

    // Navigation
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.notes').controller('msNoteItemController', msNoteItemController).directive('msNoteItem', msNoteItemDirective);

  /** @ngInject */
  function msNoteItemController($document) {
    var vm = this;
    var fontSizes = {
      '1': {
        fontSize: 14,
        lineHeight: 19
      },
      '2': {
        fontSize: 18,
        lineHeight: 28
      },
      '3': {
        fontSize: 24,
        lineHeight: 36
      },
      '4': {
        fontSize: 36,
        lineHeight: 48
      },
      '5': {
        fontSize: 48,
        lineHeight: 60
      }
    };
    vm.element = [];
    vm.noFontResize = false;

    // Methods
    vm.updateDescriptionFontSize = updateDescriptionFontSize;

    //////

    function updateDescriptionFontSize() {
      if (vm.noFontResize || !vm.note.description || vm.note.description === '') {
        return;
      }
      var fontSize = '';
      var descWidth = Math.floor(vm.columnWidth - 52); // 48px paddings, + 4px tolerance
      var tmp = angular.element('<div style="visibility:hidden; font-size:10px;line-height: 10px;position:absolute;z-index:-1;white-space:pre-wrap;word-wrap: break-word;"></div>');
      tmp.appendTo($document.find('body'));
      fontSize = checkLineCount(sizeFromMaxWordCount());
      angular.element(vm.element).find('md-description').attr('font-size', fontSize);
      tmp.remove();
      function sizeFromMaxWordCount() {
        var words = vm.note.description.split(' ');
        var wordLengths = words.map(function (word) {
          return tmp.text(word)[0].clientWidth;
        });
        var maxWordLength = Math.max.apply(Math, wordLengths);
        var maxPx = Math.floor(descWidth * 10 / maxWordLength);
        if (maxPx < 18) {
          fontSize = 1;
        } else if (18 <= maxPx && maxPx < 24) {
          fontSize = 2;
        } else if (24 <= maxPx && maxPx < 36) {
          fontSize = 3;
        } else if (36 <= maxPx && maxPx < 48) {
          fontSize = 4;
        } else if (maxPx >= 48) {
          fontSize = 5;
        }
        return fontSize;
      }
      function checkLineCount(sizeFromMaxWord) {
        var size = fontSizes[sizeFromMaxWord];
        var result;
        tmp.text(vm.note.description);
        tmp.width(descWidth);
        tmp.css({
          'line-height': size.lineHeight + 'px',
          'font-size': size.fontSize + 'px'
        });
        var lineCount = tmp[0].clientHeight / size.lineHeight;
        if (4 < lineCount && lineCount < 6) {
          result = 4;
        } else if (6 <= lineCount && lineCount < 9) {
          result = 3;
        } else if (9 <= lineCount && lineCount < 11) {
          result = 2;
        } else if (11 <= lineCount) {
          result = 1;
        } else {
          result = sizeFromMaxWord;
        }
        return result;
      }
    }
  }

  /** @ngInject */
  function msNoteItemDirective() {
    return {
      restrict: 'A',
      controller: 'msNoteItemController as MsNoteItem',
      templateUrl: 'app/main/scc/components/notes/directives/ms-note-item/ms-note-item.html',
      require: ['msNoteItem', '^msMasonry'],
      bindToController: {
        msNoteItem: '='
      },
      link: function link(scope, element, attributes, controllers) {
        var MsNoteItem = controllers[0];
        var msMasonry = controllers[1];
        MsNoteItem.element = element;
        MsNoteItem.note = MsNoteItem.msNoteItem;
        if (angular.isDefined(attributes.noFontResize)) {
          MsNoteItem.noFontResize = true;
        }
        scope.$watch('MsNoteItem.msNoteItem', function (newVal, oldVal) {
          if (newVal !== oldVal) {
            MsNoteItem.note = newVal;
          }
        });
        scope.$on('msMasonryItem:startReLayout', function () {
          if (MsNoteItem.noFontResize || MsNoteItem.columnWidth === msMasonry.columnWidth) {
            return;
          }
          MsNoteItem.columnWidth = msMasonry.columnWidth;
          MsNoteItem.updateDescriptionFontSize();
        });
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.notes').controller('msNoteFormController', msNoteFormController).directive('msNoteForm', msNoteFormDirective);

  /** @ngInject */
  function msNoteFormController($scope, NotesService, msUtils, $mdDialog, $timeout, LabelsService) {
    var MsNoteForm = this;
    var notes = NotesService.data;

    //Data
    MsNoteForm.type = '';
    MsNoteForm.defaultNote = {
      'id': '',
      'title': '',
      'description': '',
      'archive': false,
      'image': '',
      'color': '',
      'time': new Date(),
      'reminder': null,
      'checklist': [],
      'labels': []
    };
    MsNoteForm.noteId = '';
    MsNoteForm.editNode = {};
    MsNoteForm.newCheckListItem = '';
    MsNoteForm.checkListForm = false;
    MsNoteForm.labels = LabelsService.data;
    MsNoteForm.ngFlowOptions = {
      singleFile: true
      // You can configure the ngFlow from here
      /*target                   : 'api/media/image',
       chunkSize                : 15 * 1024 * 1024,
       maxChunkRetries          : 1,
       simultaneousUploads      : 1,
       testChunks               : false,
       progressCallbacksInterval: 1000*/
    };
    MsNoteForm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };

    //Methods
    MsNoteForm.init = init;
    MsNoteForm.submit = submit;
    MsNoteForm.isNotValid = isNotValid;
    MsNoteForm.deleteNote = deleteNote;
    MsNoteForm.deleteImage = deleteImage;
    MsNoteForm.addChecklistItem = addChecklistItem;
    MsNoteForm.checklistFormToggle = checklistFormToggle;
    MsNoteForm.deleteCheckItem = deleteCheckItem;
    MsNoteForm.toggleArchive = toggleArchive;
    MsNoteForm.toggleInArray = msUtils.toggleInArray;
    MsNoteForm.exists = msUtils.exists;
    MsNoteForm.upload = upload;
    MsNoteForm.imageSuccess = imageSuccess;

    //////

    /**
     * Initialize
     */
    function init() {
      // If form type edit
      if (MsNoteForm.type === 'edit') {
        MsNoteForm.editNode = notes.getById(MsNoteForm.noteId);
        MsNoteForm.note = angular.copy(MsNoteForm.editNode);
      }
      // If form type new
      else {
        resetForm();
      }
    }

    /**
     * Watch New Note Form, reset form if it is closed
     */
    $scope.$on('MsNewNote:closed', function () {
      resetForm();
    });

    /**
     * Reset Form
     */
    function resetForm() {
      $scope.$evalAsync(function () {
        MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
        MsNoteForm.checkListForm = false;
      });
    }

    /**
     * Submit Form
     */
    function submit() {
      if (MsNoteForm.type === 'new') {
        add();
      } else if (MsNoteForm.type === 'edit') {
        save();
      }
    }

    /**
     * Add new note
     */
    function add() {
      if (isNotValid()) {
        return;
      }

      // Set default values
      MsNoteForm.note.id = msUtils.guidGenerator();
      MsNoteForm.note.time = new Date();

      // Add the note
      NotesService.addNote(angular.copy(MsNoteForm.note));

      // Reset the current note to an empty one
      MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
      $scope.$emit('MsNewNote:close');
    }

    /**
     * Save Note
     */
    function save() {
      if (isNotValid()) {
        return;
      }

      // Update the note
      NotesService.updateNote(MsNoteForm.note);

      // Hide the dialog
      $mdDialog.hide();
    }

    /**
     * Delete Note Image
     */
    function deleteImage() {
      MsNoteForm.note.image = '';
    }

    /**
     * Toggle Archive State
     */
    function toggleArchive() {
      if (MsNoteForm.type === 'new') {
        MsNoteForm.note.archive = true;
        submit();
      } else if (MsNoteForm.type === 'edit') {
        MsNoteForm.note.archive = !MsNoteForm.note.archive;
        save();
      }
    }

    /**
     * One of the image, title, description, checklist inputs are should be exist.
     * @returns {boolean}
     */
    function isNotValid() {
      return MsNoteForm.note.image === '' && MsNoteForm.note.title === '' && MsNoteForm.note.description === '' && MsNoteForm.note.checklist.length === 0;
    }

    /**
     * Delete Note
     * @param ev
     */
    function deleteNote(ev) {
      var confirm = $mdDialog.confirm().title('Are you sure want to delete the note?').htmlContent('the note will be deleted permanently.').ariaLabel('delete note').targetEvent(ev).ok('OK').cancel('CANCEL');
      $mdDialog.show(confirm).then(function () {
        NotesService.deleteNote(MsNoteForm.note);
      });
    }

    /**
     * Add Checklist Item
     */
    function addChecklistItem() {
      if (MsNoteForm.newCheckListItem === '') {
        return;
      }
      MsNoteForm.note.checklist.push({
        checked: false,
        text: MsNoteForm.newCheckListItem
      });
      MsNoteForm.newCheckListItem = '';
      focusChecklistInput();
    }

    /**
     * Checklist form toggle
     */
    function checklistFormToggle() {
      $scope.$evalAsync(function () {
        MsNoteForm.checkListForm = !MsNoteForm.checkListForm;
        $timeout(function () {
          focusChecklistInput();
        });
      });
    }

    /**
     * Delete check item
     * @param item
     */
    function deleteCheckItem(item) {
      MsNoteForm.note.checklist.splice(MsNoteForm.note.checklist.indexOf(item), 1);
      focusChecklistInput();
    }

    /**
     * Focus checklist input
     */
    function focusChecklistInput() {
      angular.element('#new-checklist-item-input').focus();
    }

    /**
     * Upload
     */
    function upload() {
      // Set headers
      MsNoteForm.ngFlow.flow.opts.headers = {
        'X-Requested-With': 'XMLHttpRequest'
        //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
      };
      MsNoteForm.ngFlow.flow.upload();
    }

    /**
     * Image Success
     * @param file
     * @param message
     */
    function imageSuccess(file, message) {
      var fileReader = new FileReader();
      fileReader.readAsDataURL(file.file);
      fileReader.onload = function (event) {
        file.url = event.target.result;
        $scope.$evalAsync(function () {
          MsNoteForm.note.image = file.url;
        });
      };
      file.type = 'image';
    }

    /**
     * Array prototype
     *
     * Get by id
     *
     * @param value
     * @returns {T}
     */
    Array.prototype.getById = function (value) {
      return this.filter(function (x) {
        return x.id === value;
      })[0];
    };
  }

  /** @ngInject */
  function msNoteFormDirective() {
    return {
      restrict: 'EA',
      controller: 'msNoteFormController',
      controllerAs: 'MsNoteForm',
      scope: {
        noteType: '=',
        noteId: '='
      },
      templateUrl: 'app/main/scc/components/notes/directives/ms-note-form/ms-note-form.html',
      link: function link(scope, element, attributes, MsNoteForm) {
        // Type
        MsNoteForm.type = scope.noteType;

        // Note id
        if (angular.isDefined(scope.noteId)) {
          MsNoteForm.noteId = scope.noteId;
        }
        MsNoteForm.init();
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.notes').controller('msNewNoteController', msNewNoteController).directive('msNewNoteButton', msNewNoteButtonDirective).directive('msNewNote', msNewNoteDirective);

  /** @ngInject */
  function msNewNoteController($scope, $document) {
    var MsNewNote = this;

    //Data
    MsNewNote.formVisible = false;
    MsNewNote.form = {
      title: '',
      description: ''
    };

    //Methods
    MsNewNote.open = open;
    MsNewNote.close = close;
    MsNewNote.element = [];

    //////

    /**
     * Close Trigger
     */
    $scope.$on('MsNewNote:close', function () {
      close();
    });

    /**
     * Open new note form
     */
    function open() {
      MsNewNote.element.addClass('form-visible');
      MsNewNote.element.find('textarea').focus();
      $document.on('click', outSideClick);
    }

    /**
     * Close new note form
     */
    function close() {
      MsNewNote.element.removeClass('form-visible');
      $scope.$broadcast('MsNewNote:closed');
      $document.off('click', outSideClick);
    }

    /**
     * Click Outside Event Handler
     * @param event
     */
    function outSideClick(event) {
      var isChild = MsNewNote.element.has(event.target).length > 0;
      var isSelf = MsNewNote.element[0] === event.target;
      var isMenu = angular.element(event.target).closest('md-menu-content').length > 0;
      var isCalendar = angular.element(event.target).closest('md-calendar').length > 0 || angular.element(event.target).closest('.md-datepicker-calendar-pane').length > 0 || angular.element(event.target).hasClass('md-scroll-mask');
      var isInside = isChild || isSelf || isMenu || isCalendar;
      if (!isInside) {
        close();
      }
    }
  }

  /** @ngInject */
  function msNewNoteDirective() {
    return {
      restrict: 'E',
      controller: 'msNewNoteController',
      controllerAs: 'MsNewNote',
      templateUrl: 'app/main/scc/components/notes/directives/ms-new-note/ms-new-note.html',
      link: function link(scope, element, attributes, MsNewNote) {
        MsNewNote.element = element;
      }
    };
  }

  /** @ngInject */
  function msNewNoteButtonDirective() {
    return {
      restrict: 'EA',
      require: '^msNewNote',
      link: function link(scope, element, attributes, msNewNote) {
        element.on('click', function () {
          msNewNote.open();
        });
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.notes').factory('NotesService', NotesService);

  /** @ngInject */
  function NotesService(msApi, $q) {
    var service = {
      data: [],
      addNote: addNote,
      updateNote: updateNote,
      deleteNote: deleteNote,
      getData: getData
    };

    /**
     * Add Note
     * @param note
     */
    function addNote(note) {
      service.data.push(note);
    }

    /**
     * Update Note
     * @param note
     */
    function updateNote(note) {
      for (var i = 0; i < service.data.length; i++) {
        if (service.data[i].id === note.id) {
          service.data[i] = note;
        }
      }
    }

    /**
     * Delete Note
     * @param note
     */
    function deleteNote(note) {
      for (var i = 0; i < service.data.length; i++) {
        if (service.data[i].id === note.id) {
          service.data.splice(i, 1);
        }
      }
    }

    /**
     * Get service data
     * @returns {Array}
     */
    function getData() {
      // Create a new deferred object
      var deferred = $q.defer();
      msApi.request('notes.notes@get', {},
      // SUCCESS
      function (response) {
        // Attach the data
        service.data = response.data;

        // Resolve the promise
        deferred.resolve(response);
      },
      // ERROR
      function (response) {
        // Reject the promise
        deferred.reject(response);
      });
      return deferred.promise;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.notes').factory('LabelsService', LabelsService);

  /** @ngInject */
  function LabelsService(msUtils, NotesService, msApi, $q) {
    var service = {
      data: [],
      addLabel: addLabel,
      updateLabel: updateLabel,
      deleteLabel: deleteLabel,
      getData: getData
    };

    /**
     * Add label
     * @param newLabel
     */
    function addLabel(newLabel) {
      if (newLabel.name === '') {
        return;
      }
      service.data.push({
        id: msUtils.guidGenerator(),
        name: newLabel.name,
        color: newLabel.color || ''
      });
    }

    /**
     * Update Label
     * @param note
     */
    function updateLabel(note) {
      for (var i = 0; i < service.data.length; i++) {
        if (service.data[i].id === note.id) {
          service.data[i] = note;
        }
      }
    }

    /**
     * Delete Label
     * @param label
     */
    function deleteLabel(label) {
      var notes = NotesService.data;

      // Look for all notes if they have the labels
      for (var j = 0; j < notes.length; j++) {
        if (notes[j].labels.indexOf(label.id) > -1) {
          notes[j].labels.splice(notes[j].labels.indexOf(label.id), 1);
        }
      }

      // Delete label from service data
      for (var i = 0; i < service.data.length; i++) {
        if (service.data[i].id === label.id) {
          service.data.splice(i, 1);
        }
      }
    }

    /**
     * Get service data
     * @returns {Array}
     */
    function getData() {
      // Create a new deferred object
      var deferred = $q.defer();
      msApi.request('notes.labels@get', {},
      // SUCCESS
      function (response) {
        // Attach the data
        service.data = response.data;

        // Resolve the promise
        deferred.resolve(response);
      },
      // ERROR
      function (response) {
        // Reject the promise
        deferred.reject(response);
      });
      return deferred.promise;
    }
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc', ['app.scc.data-set', 'app.scc.login', 'app.scc.register', 'app.scc.errors-container', 'app.scc.local-date-picker', 'app.scc.duration-picker', 'app.scc.activate-account', 'app.scc.forgot-password', 'app.scc.reset-password', 'app.scc.school', 'app.scc.teacher', 'app.scc.student', 'app.scc.lesson', 'app.scc.classroom', 'app.scc.students-group', 'app.scc.offers-table', 'app.scc.billing-info', 'app.scc.monitoring', 'app.scc.availability', 'app.scc.scheduler', 'app.scc.lesson-delivery', 'app.scc.notes', 'app.scc.buy']).config(config).run(run);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, $mdDateLocaleProvider) {
    $stateProvider.state('app.scc', {});
    $stateProvider.state('app.scc.public', {});
    $stateProvider.state('app.scc.private', {});
    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc');
    $mdDateLocaleProvider.formatDate = function (date) {
      var m = moment(date);
      return m.isValid() ? m.format('DD/MM/YYYY') : '';
    };
  }

  /** @ngInject */
  function run($rootScope, schools, dataSets, $state, authentication, $timeout) {
    $rootScope.$on('$stateChangeStart', function (e, toState, toParams, fromState, fromParams) {
      var isPublic = toState.name.startsWith("app.scc.public");
      if (isPublic) {
        return; // no need to redirect 
      }

      // now, redirect only not authenticated
      /* FIXME: This need to be uncommented but gives strange redirect behavior*/
      if (!authentication.loggedIn()) {
        e.preventDefault(); // stop current execution
        $state.go("app.scc.public.login", {
          redirectState: toState.name,
          redirectParams: JSON.stringify(toParams)
        });
      }

      //Warn that unsaved changes will be lost.
      //				if($rootScope.isDirty && !confirm("You have unsaved changes. Continue?")){
      //					e.preventDefault(); // stop current execution
      //					$timeout(function ()
      //		            {
      //		                $rootScope.loadingProgress = false;
      //		            });
      //				}
    });
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').controller('SimplePageController', SimplePageController);
  angular.module('app.scc').component("simplePage", {
    transclude: true,
    templateUrl: 'app/main/scc/page-templates/simple-page/simple-page.html',
    bindings: {
      translationScope: '@',
      icon: '@',
      svgIcon: '@'
    },
    controller: 'SimplePageController'
  });

  /** @ngInject */
  function SimplePageController($scope) {}
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').controller('CardedTableController', CardedTableController);
  angular.module('app.scc').component("cardedTable", {
    transclude: true,
    templateUrl: 'app/main/scc/page-templates/carded-table/carded-table.html',
    bindings: {
      translationScope: '@',
      filter: '=',
      searchFocused: '=?',
      recordsNumber: '=',
      icon: '@',
      svgIcon: '@'
    },
    controller: 'CardedTableController'
  });

  /** @ngInject */
  function CardedTableController($scope) {}
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').controller('CardedSimpleController', CardedSimpleController);
  angular.module('app.scc').component("cardedSimple", {
    transclude: true,
    templateUrl: 'app/main/scc/page-templates/carded-simple/carded-simple.html',
    bindings: {
      title: '@',
      icon: '@',
      svgIcon: '@'
    },
    controller: 'CardedSimpleController'
  });

  /** @ngInject */
  function CardedSimpleController($scope) {}
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').directive('ngTranscludeReplace', ['$log', function ($log) {
    return {
      terminal: true,
      restrict: 'EA',
      link: function link($scope, $element, $attr, ctrl, transclude) {
        if (!transclude) {
          $log.error('orphan', 'Illegal use of ngTranscludeReplace directive in the template! ' + 'No parent directive that requires a transclusion found. ');
          return;
        }
        transclude(function (clone) {
          if (clone.length) {
            $element.replaceWith(clone);
          } else {
            $element.remove();
          }
        });
      }
    };
  }]);
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').directive('sccTimeSlotInput', ['$document', '$timeout', 'utils', function ($document, $timeout, utils) {
    return {
      scope: {
        sccModel: '='
      },
      controller: function controller($scope, $element, utils) {},
      link: function link(scope, element, attr) {
        element.val(utils.timeSlotToHour(scope.sccModel));
        scope.$watch('sccModel', function (ld) {
          var ts = scope.sccModel;
          if (!angular.isNumber(ts)) {
            ts = 0;
          }
          if (element.val() != utils.timeSlotToHour(ts)) {
            var ss = element[0].selectionStart;
            var se = element[0].selectionEnd;
            element.val(utils.timeSlotToHour(ts));
            element[0].selectionStart = ss;
            element[0].selectionEnd = se;
          }
        });
        element.on('keypress', function (e) {
          console.log('keypres');
          console.log(e);
          if (e.which !== 0 && !e.ctrlKey && !e.metaKey && !e.altKey) {
            e.preventDefault();
          }
          if ((e.keyCode >= 48 && e.keyCode <= 57 || e.which >= 48 && e.which <= 57) && element[0].selectionStart < 5) {
            //the last digit should be a multiply of the time slot duration
            if (element[0].selectionStart == 4 && e.key % utils.TIMESLOT_DURATION_IN_MIN != 0) {
              return;
            }
            var cp;
            if (element[0].selectionStart == 2) {
              cp = 3;
            } else {
              cp = element[0].selectionStart;
            }
            element.val(utils.setCharAt(element.val(), cp, e.key));
            element[0].selectionStart = cp + 1;
            element[0].selectionEnd = cp + 1;
            var ts = utils.hourToTimeSlot(element.val());
            scope.$apply(function () {
              scope.sccModel = ts;
            });
          }
        });
        element.on('keydown', function (e) {
          console.log(element[0].selectionStart);
          console.log(e);

          //Arrow up
          if (e.keyCode == 38) {
            if (element[0].selectionStart <= 2) {
              scope.$apply(function () {
                scope.sccModel = scope.sccModel + Math.floor(60 / utils.TIMESLOT_DURATION_IN_MIN);
              });
            } else {
              scope.$apply(function () {
                scope.sccModel = scope.sccModel + 1;
              });
            }
            e.preventDefault();
          }
          //Arrow down
          if (e.keyCode == 40) {
            if (element[0].selectionStart <= 2 && scope.sccModel >= Math.floor(60 / utils.TIMESLOT_DURATION_IN_MIN)) {
              scope.$apply(function () {
                scope.sccModel = scope.sccModel - Math.floor(60 / utils.TIMESLOT_DURATION_IN_MIN);
              });
            }
            if (element[0].selectionStart > 2 && scope.sccModel >= 1) {
              scope.$apply(function () {
                scope.sccModel = scope.sccModel - 1;
              });
            }
            e.preventDefault();
          }
          //Backspace
          if (e.keyCode == 8) {
            if (element[0].selectionStart > 0) {
              var cp;
              if (element[0].selectionStart == 3) {
                cp = 1;
              } else {
                cp = element[0].selectionStart - 1;
              }
              element.val(utils.setCharAt(element.val(), cp, '0'));
              element[0].selectionStart = cp;
              element[0].selectionEnd = cp;
            }
            var ts = utils.hourToTimeSlot(element.val());
            scope.$apply(function () {
              scope.sccModel = ts;
            });
            e.preventDefault();
          }
          //Delete
          else if (e.keyCode == 46 && element[0].selectionStart < 5) {
            var cp;
            if (element[0].selectionStart == 2) {
              cp = 3;
            } else {
              cp = element[0].selectionStart;
            }
            element.val(utils.setCharAt(element.val(), cp, '0'));
            element[0].selectionStart = cp + 1;
            element[0].selectionEnd = cp + 1;
            var ts = utils.hourToTimeSlot(element.val());
            scope.$apply(function () {
              scope.sccModel = ts;
            });
            e.preventDefault();
          }
        });
      }
    };
  }]);
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').directive('sccTeachingNeed', sccTeachingNeed);

  /** @ngInject */
  function sccTeachingNeed($document, $timeout, $rootScope, scc) {
    function mouseupForDrag(scope, element, teachingNeed, mousemoveCallback) {
      var _ret = function ret(event) {
        $document.off('mousemove', mousemoveCallback);
        $document.off('mouseup', _ret);
        $rootScope.$emit('scc.teachingNeed.dragEnd');
        var rect = element[0].getBoundingClientRect();
        element.css({
          left: element.data('startLeft') + 'px',
          top: element.data('startTop') + 'px',
          'pointer-events': 'auto'
        });
        var scCtrl = angular.element(document.elementFromPoint(rect.left + rect.width / 2, rect.top + 5)).controller('sccScheduleSlot');
        var ssCtrl = element.controller('sccSchedule');
        if (ssCtrl) {
          ssCtrl.clearHighlighted();
          ssCtrl.clearBlockedSlots();
        }
        if (scCtrl) {
          scCtrl.addNewLessonDeliveryFromTeachingNeed(teachingNeed);
        }
        //element.on('mousedown', mousedown(scope, element));
      };
      return _ret;
    }
    function mousemoveForDrag(element, teachingNeed) {
      return function (event) {
        element.css({
          left: element.data('startLeft') + event.pageX - element.data('startX') + 'px',
          top: element.data('startTop') + event.pageY - element.data('startY') + 'px'
        });
        var rect = element[0].getBoundingClientRect();
        var scCtrl = angular.element(document.elementFromPoint(rect.left + rect.width / 2, rect.top + 5)).controller('sccScheduleSlot');
        var ssCtrl = element.controller('sccSchedule');
        if (scCtrl && ssCtrl) {
          if (ssCtrl) {
            ssCtrl.highlight(scCtrl.getDay(), scCtrl.getTimeSlot(), Math.min(teachingNeed.remainingTimeSlots, ssCtrl.mostUsedDuration()));
          }
        }
      };
    }
    function mousedown(scope, element) {
      var ret = function ret(event) {
        event.preventDefault();
        if (scope.sccModel.remainingTimeSlots > 0) {
          element.css({
            'pointer-events': 'none'
          });
          element.data('startX', event.pageX);
          element.data('startY', event.pageY);
          element.data('startLeft', parseInt(window.getComputedStyle(element[0]).getPropertyValue('left'), 10));
          element.data('startTop', parseInt(window.getComputedStyle(element[0]).getPropertyValue('top'), 10));
          $rootScope.$emit('scc.teachingNeed.dragStart', scope.sccModel);

          // Fetch and mark blocked slots for this teaching need
          var ssCtrl = element.controller('sccSchedule');
          if (ssCtrl && scope.sccModel.id) {
            scc.request(scc.PRIVATE_MODE, 'GetBlockedSlotsForTeachingNeed', {
              teachingNeedId: scope.sccModel.id
            }, function (response) {
              if (response.data && response.data.blockedSlots) {
                ssCtrl.markBlockedSlots(response.data.blockedSlots);
              }
            }, function (error) {
              console.error('Failed to fetch blocked slots:', error);
            });
          }
          var dragCallback = mousemoveForDrag(element, scope.sccModel);
          $document.on('mousemove', dragCallback);
          $document.on('mouseup', mouseupForDrag(scope, element, scope.sccModel, dragCallback));
        }
      };
      return ret;
    }
    return {
      scope: {
        sccModel: '='
      },
      link: function link(scope, element, attr) {
        element.addClass('scc-teaching-need');
        element.on('mousedown', mousedown(scope, element));
      }
    };
  }
})();
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  'use strict';

  angular.module('app.scc').directive('sccSchedule', sccSchedule);

  /** @ngInject */
  function sccSchedule($document, $timeout) {
    return {
      scope: {
        sccTeachingNeeds: '=',
        sccLessonDeliveries: '=',
        sccScheduleChange: '&'
      },
      controller: function controller($scope, $element) {
        var ctrl = this;
        this.highlightedArea = null;
        this.scheduleChanged = function () {
          if ($scope.sccScheduleChange) {
            $scope.sccScheduleChange();
          }
        }, this.addNewLessonDeliveryFromTeachingNeed = function (tn, day, timeSlot) {
          var preferredDuration = ctrl.mostUsedDuration();
          var duration = Math.min(tn.remainingTimeSlots, preferredDuration);
          if (ctrl.periodIsAvailable(day, timeSlot, duration)) {
            $timeout(function () {
              $scope.sccLessonDeliveries.push({
                teachingNeed: tn,
                day: day,
                timeSlot: timeSlot,
                duration: duration
              });
              tn.remainingTimeSlots = tn.remainingTimeSlots - 1;
              ctrl.scheduleChanged();
            });
          }
        };
        this.getScheduleSlotElement = function (day, timeSlot) {
          var el = $element[0].querySelector('.scc-schedule-slot[data-scc-day="' + day + '"][data-scc-time-slot="' + timeSlot + '"]');
          if (el) {
            return angular.element(el);
          } else {
            return null;
          }
        };
        this.clearHighlighted = function () {
          var ha = ctrl.highlightedArea;
          if (!ha) {
            return;
          }
          for (var i = 0; i < ha.duration; i++) {
            var ts = ctrl.getScheduleSlotElement(ha.day, ha.timeSlot + i);
            ts.removeClass("highlighted");
            ts.removeClass("blocked");
          }
        };
        this.markBlockedSlots = function (blockedSlots) {
          ctrl.blockedSlots = blockedSlots;
          if (!blockedSlots || blockedSlots.length === 0) {
            return;
          }
          for (var i = 0; i < blockedSlots.length; i++) {
            var slot = blockedSlots[i];
            for (var j = 0; j < slot.duration; j++) {
              var ts = ctrl.getScheduleSlotElement(slot.day, slot.timeSlot + j);
              if (ts) {
                ts.addClass("blocked-for-teaching-need");
              }
            }
          }
        };
        this.clearBlockedSlots = function () {
          if (!ctrl.blockedSlots || ctrl.blockedSlots.length === 0) {
            return;
          }
          for (var i = 0; i < ctrl.blockedSlots.length; i++) {
            var slot = ctrl.blockedSlots[i];
            for (var j = 0; j < slot.duration; j++) {
              var ts = ctrl.getScheduleSlotElement(slot.day, slot.timeSlot + j);
              if (ts) {
                ts.removeClass("blocked-for-teaching-need");
              }
            }
          }
          ctrl.blockedSlots = [];
        };
        this.highlight = function (day, timeSlot, duration, excludedLessonDelivery) {
          var slots = [];
          var periodIsAvailable = true;
          var ha = ctrl.highlightedArea;
          if (ha && ha.day == day && ha.timeSlot == timeSlot && ha.duration == duration) {
            return;
          }
          ctrl.clearHighlighted();
          for (var i = 0; i < duration; i++) {
            var ts = ctrl.getScheduleSlotElement(day, timeSlot + i);
            if (!ts || !ts.controller('sccScheduleSlot').available(excludedLessonDelivery)) {
              periodIsAvailable = false;
            }
            slots.push(ts);
          }
          var classToBeAdded = periodIsAvailable ? "highlighted" : "blocked";
          for (var i = 0; i < duration; i++) {
            slots[i].addClass(classToBeAdded);
          }
          ctrl.highlightedArea = {
            day: day,
            timeSlot: timeSlot,
            duration: duration
          };
        };
        this.getScheduleElement = function () {
          return $element;
        };
        this.periodIsAvailable = function (day, timeSlot, duration, excludedLessonDelivery) {
          for (var i = 0; i < duration; i++) {
            var ts = ctrl.getScheduleSlotElement(day, timeSlot + i);
            if (!ts || !ts.controller('sccScheduleSlot').available(excludedLessonDelivery)) {
              return false;
            }
          }
          return true;
        };
        this.mostUsedDuration = function () {
          if ($scope.sccLessonDeliveries.length == 0) {
            return 12;
          }
          var counts = {};

          // Count each duration
          var _iterator = _createForOfIteratorHelper($scope.sccLessonDeliveries),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var lesson = _step.value;
              counts[lesson.duration] = (counts[lesson.duration] || 0) + 1;
            }

            // Find the duration with the max count
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          var maxCount = 0;
          var mostFrequent = null;
          for (var _i = 0, _Object$entries = Object.entries(counts); _i < _Object$entries.length; _i++) {
            var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
              duration = _Object$entries$_i[0],
              count = _Object$entries$_i[1];
            if (count > maxCount) {
              maxCount = count;
              mostFrequent = duration;
            }
          }
          return mostFrequent;
        };
        this.lessonDeliveryExists = function (day, timeSlot, excludedLessonDelivery) {
          for (var i = 0; i < $scope.sccLessonDeliveries.length; i++) {
            var ld = $scope.sccLessonDeliveries[i];
            if (excludedLessonDelivery && excludedLessonDelivery == ld) {
              continue;
            }
            if (ld.day == day && timeSlot >= ld.timeSlot && timeSlot <= ld.timeSlot + ld.duration - 1) {
              return true;
            }
          }
          return false;
        };
        this.removeLessonDelivery = function (lessonDelivery) {
          for (var i = 0; i < $scope.sccLessonDeliveries.length; i++) {
            var ld = $scope.sccLessonDeliveries[i];
            if (lessonDelivery == ld) {
              $timeout(function () {
                $scope.sccLessonDeliveries.splice(i, 1);
                lessonDelivery.teachingNeed.remainingTimeSlots = lessonDelivery.teachingNeed.remainingTimeSlots + lessonDelivery.duration;
                ctrl.scheduleChanged();
              });
              return;
            }
          }
        };
      },
      link: function link(scope, element, attr) {
        element.addClass('scc-schedule');
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').directive('sccScheduleSlot', sccScheduleSlot);

  /** @ngInject */
  function sccScheduleSlot($document, $timeout, utils) {
    return {
      scope: {
        sccDay: '<',
        sccTimeSlot: '<',
        sccDisabled: '<'
      },
      controller: function controller($scope, $element) {
        var schedule = $element.parent().controller('sccSchedule');
        this.addNewLessonDeliveryFromTeachingNeed = function (tn) {
          schedule.addNewLessonDeliveryFromTeachingNeed(tn, $scope.sccDay, $scope.sccTimeSlot);
        };
        this.getTimeSlot = function () {
          return $scope.sccTimeSlot;
        };
        this.getDay = function () {
          return $scope.sccDay;
        };
        this.available = function (excludedLessonDelivery) {
          return !$scope.sccDisabled && !schedule.lessonDeliveryExists($scope.sccDay, $scope.sccTimeSlot, excludedLessonDelivery);
        };
      },
      link: function link(scope, element, attr) {
        element.addClass('scc-schedule-slot');
        element.attr('data-scc-day', scope.sccDay);
        element.attr('data-scc-time-slot', scope.sccTimeSlot);
        element.attr('data-scc-disabled', scope.sccDisabled);
        element.css({
          'z-index': 1440 / utils.TIMESLOT_DURATION_IN_MIN - scope.sccTimeSlot,
          'background-color': scope.sccDisabled ? 'lightgrey' : 'default'
        });
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').directive('sccLessonDelivery', sccLessonDelivery);

  /** @ngInject */
  function sccLessonDelivery($document, $timeout, $rootScope, scc) {
    function linkMoveHandler(schedule, scope, element, handleElement, attr) {
      var startY, startX, startDay, startTimeSlot, startLessonDeliveryContainer, startLessonDeliveryContainerZIndex;
      var dragActive = false;
      function mousemoveForMove(event) {
        var rect = element[0].getBoundingClientRect();
        var target = document.elementFromPoint(rect.left + rect.width / 2, rect.top + 5);
        element.css({
          top: event.pageY - startY + 'px',
          left: event.pageX - startX + 'px'
        });
        var ssCtrl = angular.element(target).controller('sccScheduleSlot');
        var lddCtrl = angular.element(target).controller('sccLessonDeliveryDisposer');
        var scCtrl = angular.element(target).controller('sccSchedule');
        var ld = scope.sccModel;
        console.log("moved" + event.pageY);
        if (ssCtrl && scCtrl) {
          scCtrl.highlight(ssCtrl.getDay(), ssCtrl.getTimeSlot(), scope.sccModel.duration, scope.sccModel);
          if (ld.timeSlot != ssCtrl.getTimeSlot() || ld.day != ssCtrl.getDay()) {
            $timeout(function () {
              ld.timeSlot = ssCtrl.getTimeSlot();
              ld.day = ssCtrl.getDay();
            });
          }
        }
      }
      function mouseupForMove(event) {
        dragActive = false;
        $document.off('mousemove', mousemoveForMove);
        $document.off('mouseup', mouseupForMove);
        $rootScope.$emit('scc.teachingNeed.dragEnd');
        var rect = element[0].getBoundingClientRect();
        var target = document.elementFromPoint(rect.left + rect.width / 2, rect.top + 5);
        var ssCtrl = angular.element(target).controller('sccScheduleSlot');
        var lddCtrl = angular.element(target).controller('sccLessonDeliveryDisposer');
        var scCtrl = angular.element(target).controller('sccSchedule');
        var ld = scope.sccModel;
        element.controller('sccSchedule').clearHighlighted();
        element.controller('sccSchedule').clearBlockedSlots();
        if (ssCtrl && scCtrl && scCtrl.periodIsAvailable(ssCtrl.getDay(), ssCtrl.getTimeSlot(), scope.sccModel.duration, scope.sccModel)) {
          if (ld.timeSlot != startTimeSlot || ld.day != startDay) {
            $timeout(function () {
              scCtrl.scheduleChanged();
            });
          }
          /**/
          target.appendChild(element[0]);
          element.css({
            left: '0px',
            top: '0px',
            'pointer-events': 'auto'
          });
        } else if (lddCtrl) {
          lddCtrl.removeLessonDelivery(ld);
        } else {
          element.css({
            left: '0px',
            top: '0px',
            'pointer-events': 'auto'
          });
          $timeout(function () {
            ld.timeSlot = startTimeSlot;
            ld.day = startDay;
          });
        }
        //Revert initial schedule slot in normal stack position
        startLessonDeliveryContainer.css({
          'z-index': startLessonDeliveryContainerZIndex
        });
      }
      handleElement.on('mousedown', function (event) {
        event.preventDefault();
        dragActive = true;
        startX = event.pageX;
        startY = event.pageY;
        startDay = scope.sccModel.day;
        startTimeSlot = scope.sccModel.timeSlot;
        startLessonDeliveryContainer = element.parent();
        startLessonDeliveryContainerZIndex = startLessonDeliveryContainer.css('z-index');
        element.css({
          'pointer-events': 'none'
        });
        //Push moving lesson delivery in front of everything
        element.parent().css({
          'z-index': 99999999
        });
        $rootScope.$emit('scc.teachingNeed.dragStart', scope.sccModel.teachingNeed);

        // Fetch and mark blocked slots for this lesson delivery's teaching need
        var scCtrl = element.controller('sccSchedule');
        if (scCtrl && scope.sccModel.teachingNeed && scope.sccModel.teachingNeed.id) {
          scc.request(scc.PRIVATE_MODE, 'GetBlockedSlotsForTeachingNeed', {
            teachingNeedId: scope.sccModel.teachingNeed.id
          }, function (response) {
            if (!dragActive) {
              return;
            }
            if (response.data && response.data.blockedSlots) {
              scCtrl.markBlockedSlots(response.data.blockedSlots);
            }
          }, function (error) {
            console.error('Failed to fetch blocked slots:', error);
          });
        }
        $document.on('mousemove', mousemoveForMove);
        $document.on('mouseup', mouseupForMove);
      });
    }
    function linkResizeHandler(scope, element, handleElement, attr) {
      var startY, startHeight, maxDuration, startDuration;
      function mousemoveForResize(event) {
        var ssCtrl = angular.element(event.target).controller('sccScheduleSlot');
        var scCtrl = angular.element(event.target).controller('sccSchedule');
        if (ssCtrl && scCtrl) {
          var oldDuration = scope.sccModel.duration;
          var newDuration = ssCtrl.getTimeSlot() - scope.sccModel.timeSlot + 1;
          var ld = scope.sccModel;
          var tn = scope.sccModel.teachingNeed;
          if (newDuration != oldDuration && newDuration <= maxDuration && scCtrl.periodIsAvailable(ld.day, ld.timeSlot, newDuration, ld)) {
            $timeout(function () {
              tn.remainingTimeSlots = maxDuration - newDuration;
              ld.duration = newDuration;
              element.css({
                height: event.pageY - startY + startHeight + 'px'
              });
            });
          }
        }
      }
      function mouseupForResize(event) {
        $document.off('mousemove', mousemoveForResize);
        $document.off('mouseup', mouseupForResize);
        $rootScope.$emit('scc.teachingNeed.dragEnd');
        var scCtrl = element.controller('sccSchedule');
        var ld = scope.sccModel;
        if (ld.duration != startDuration) {
          scCtrl.scheduleChanged();
        }
        element.css({
          'pointer-events': 'auto'
        });
      }
      handleElement.on('mousedown', function (event) {
        event.preventDefault();
        event.stopPropagation();
        startY = event.pageY;
        startHeight = parseInt(window.getComputedStyle(element[0]).getPropertyValue('height'), 10);
        startDuration = scope.sccModel.duration;
        maxDuration = scope.sccModel.teachingNeed.remainingTimeSlots + scope.sccModel.duration;
        console.log("Max duration: " + maxDuration);
        element.css({
          'pointer-events': 'none'
        });
        $rootScope.$emit('scc.teachingNeed.dragStart', scope.sccModel.teachingNeed);
        $document.on('mousemove', mousemoveForResize);
        $document.on('mouseup', mouseupForResize);
      });
    }
    return {
      scope: {
        sccModel: '='
      },
      link: function link(scope, element, attr) {
        var schedule = element.parent().controller('sccSchedule');
        scope.$watch('sccModel', function (ld) {
          var ld = scope.sccModel;
          var st = schedule.getScheduleElement()[0].getBoundingClientRect();
          var sts = schedule.getScheduleSlotElement(ld.day, ld.timeSlot)[0];
          var stsr = sts.getBoundingClientRect();
          var etsr = schedule.getScheduleSlotElement(ld.day, ld.timeSlot + ld.duration - 1)[0].getBoundingClientRect();
          sts.appendChild(element[0]);
          element.css({
            top: '0px',
            left: '0px',
            height: etsr.bottom - stsr.top + 'px'
          });
        });
        element.addClass('scc-lesson-delivery');
        var resizeHandle = angular.element(element[0].querySelector('.scc-lesson-delivery-resize-handle'));
        linkResizeHandler(scope, element, resizeHandle, attr);
        var moveHandle = angular.element(element[0].querySelector('.scc-lesson-delivery-move-handle'));
        linkMoveHandler(schedule, scope, element, moveHandle, attr);
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').directive('sccLessonDeliveryDisposer', sccLessonDeliveryDisposer);

  /** @ngInject */
  function sccLessonDeliveryDisposer($document, $timeout, utils) {
    return {
      controller: function controller($element) {
        this.removeLessonDelivery = function (teachingNeed) {
          var scCtrl = $element.controller('sccSchedule');
          scCtrl.removeLessonDelivery(teachingNeed);
        };
      },
      link: function link(scope, element, attr) {
        element.addClass('scc-lesson-delivery-disposer');
        element.css({
          position: 'relative',
          'z-index': utils.TIMESLOTS_PER_DAY + 1
        });
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').directive('sccEnter', function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.sccEnter);
          });
          event.preventDefault();
        }
      });
    };
  });
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.teacher', ['md.data.table']).config(config).run(run);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.scc.private.teacher', {
      url: '/teacher',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/teacher/teacher-list.html',
          controller: 'TeacherListController as $ctrl'
        }
      }
    });

    // State
    $stateProvider.state('app.scc.private.teacher.details', {
      url: '/:teacherId?tab',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/teacher/teacher-details.html',
          controller: 'TeacherDetailsController as $ctrl'
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/teacher');
    msNavigationServiceProvider.saveItem('teacher', {
      title: 'SCC',
      svgIcon: 'teacher',
      state: 'app.scc.private.teacher',
      /*stateParams: {
          'param1': 'page'
       },*/
      translate: 'SCC.TEACHER.NAV',
      weight: 10000
    });
  }

  /** @ngInject */
  function run($rootScope, teachers) {
    $rootScope.$on('scc.school.selected', teachers.init);
    $rootScope.$on('scc.logout', teachers.cleanup);
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.teacher').factory('teachers', teachersService);

  /** @ngInject */
  function teachersService(daoFactory) {
    return daoFactory.createDao('teacher', 'Teacher');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.teacher').controller('TeacherListController', TeacherListController).controller('TeacherDetailsController', TeacherDetailsController);

  /** @ngInject */
  function TeacherDetailsController($state, $timeout, $scope, $controller, teachers, schools, $filter, $mdDialog, notifications, $stateParams, checkState, utils, dataSets) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;
    ctrl.teacherId = $stateParams.teacherId;
    ctrl.tab = $stateParams.tab;
    ctrl.tabsCaptions = {
      generalInfo: $filter('translate')('SCC.TEACHER.GENERAL_INFO_TAB'),
      salaryInfo: $filter('translate')('SCC.TEACHER.SALARY_DETAILS_TAB'),
      availability: $filter('translate')('SCC.TEACHER.AVAILABILITY_TAB')
    };
    if (!ctrl.tab) {
      ctrl.tab = "generalInfo";
    }
    ctrl.selectedTab = ctrl.tab;
    ctrl.$onInit = function () {
      ctrl.teacher = teachers.get(ctrl.teacherId);
    };
    ctrl.getSelectedDataSet = function () {
      return dataSets.getSelected();
    };
    $scope.$watch("$ctrl.tab", function (newVal, oldVal) {
      if (newVal != ctrl.selectedTab && angular.isDefined(ctrl.dirty) && ctrl.dirty() && !checkState.confirmUserAction()) {
        ctrl.tab = oldVal;
      } else {
        ctrl.selectedTab = newVal;
      }
    });
  }

  /** @ngInject */
  function TeacherListController($scope, $controller, teachers, schools, $mdDialog, notifications) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;

    //The selected teachers
    this.selectedEntities = [];

    //The teacher to be created
    this.teacher = {};
    this.getAllEntities = function () {
      return teachers.getAll();
    };
    this.createEntity = function () {
      this.teacher.school = schools.getSelectedSchool();
      teachers.create({
        teacher: this.teacher
      }, $scope, function () {
        notifications.push('Η καθηγητής καταχωρήθηκε επιτυχώς', notifications.INFO);
        ctrl.teacher = {};
        ctrl.setFocusByName("teacher.name");
      }, function () {
        ctrl.setFocusByName("teacher.name");
      });
    };
    this.deleteEntity = function (ev, teacher) {
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση διαγραφής').textContent('Θέλετε σίγουρα να διαγράψετε τον καθηγητή \"' + teacher.name + '\";').ariaLabel('Επιβεβαίωση διαγραφής').targetEvent(ev).ok('ΔΙΑΓΡΑΦΗ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        teachers.deleteListed({
          teachersIds: [teacher.id]
        }, $scope, function () {
          ctrl.selectedEntities = [];
          notifications.push('Ο καθηγητής \"' + teacher.name + '\" διαγράφηκε.', notifications.INFO);
        });
      });
    };
    this.deleteSelected = function (ev) {
      var confirmText;
      if (ctrl.selectedEntities.length == 1) {
        confirmText = 'Θέλετε σίγουρα να διαγράψετε τον καθηγητή \"' + ctrl.selectedEntities[0].name + '\";';
      } else {
        confirmText = 'Θέλετε σίγουρα να διαγράψετε τους ' + ctrl.selectedEntities.length + ' επιλεγμένους καθηγητές;';
      }
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση διαγραφής').textContent(confirmText).ariaLabel('Επιβεβαίωση διαγραφής').targetEvent(ev).ok('ΔΙΑΓΡΑΦΗ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        var ids = ctrl.selectedEntities.map(function (l) {
          return l.id;
        });
        teachers.deleteListed({
          teachersIds: ids
        }, $scope, function () {
          var responseText;
          if (ctrl.selectedEntities.length == 1) {
            responseText = 'Ο καθηγητής \"' + ctrl.selectedEntities[0].name + '\" διαγράφηκε.';
          } else {
            responseText = 'Οι ' + ctrl.selectedEntities.length + ' επιλεγμένοι καθηγητές διαγράφηκαν.';
          }
          notifications.push(responseText, notifications.INFO);
          ctrl.selectedEntities = [];
        });
      });
    };
    this.showEditPanel = function (ev, t) {
      $mdDialog.show({
        controller: function controller($scope, teacher, $mdDialog) {
          var panelCtrl = this;
          this.teacher = angular.extend({}, teacher);
          this.oldTeacherName = teacher.name;
          this.close = function () {
            $mdDialog.cancel();
          };
          this.submit = function () {
            this.teacher.school = schools.getSelectedSchool();
            teachers.update({
              teacher: this.teacher
            }, $scope.form, function () {
              var msg = 'Τα στοιχεία του καθηγητή ' + panelCtrl.oldTeacherName + ' ενημερώθηκαν επιτυχώς';
              notifications.push(msg, notifications.INFO);
              $mdDialog.hide();
              ctrl.selectedEntities = [];
            });
          };
        },
        controllerAs: '$ctrl',
        templateUrl: 'app/main/scc/components/teacher/edit-teacher-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          teacher: t
        }
      });
    };
    this.setFocusByName("teacher.name");
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.teacher').controller('TeacherSalaryInfoController', TeacherSalaryInfoController);
  angular.module('app.scc.teacher').component("teacherSalaryInfo", {
    templateUrl: 'app/main/scc/components/teacher/teacher-salary-info.html',
    bindings: {
      teacherId: '<',
      dirty: '='
    },
    controller: 'TeacherSalaryInfoController'
  });

  /** @ngInject */
  function TeacherSalaryInfoController($scope, scc, checkState) {
    var ctrl = this;
    ctrl.salaryAgreements = [{}];
    ctrl.editable = false;
    ctrl.$onInit = function () {
      scc.execute(scc.PRIVATE_MODE, "GetSalaryAgreements", {
        teacherId: ctrl.teacherId
      }, $scope.form, function (response) {
        if (response.data.salaryAgreements.length) {
          ctrl.salaryAgreements = response.data.salaryAgreements;
        } else {
          ctrl.salaryAgreements = [{}];
        }
      });
    };
    ctrl.startEditing = function () {
      ctrl.editable = true;
      checkState.checkFormOnStateChange($scope, $scope.form);
    };
    ctrl.save = function () {
      scc.execute(scc.PRIVATE_MODE, "UpdateSalaryAgreements", {
        teacherId: ctrl.teacherId,
        salaryAgreements: ctrl.salaryAgreements
      }, $scope.form, function (response) {
        if (response.data.salaryAgreements.length) {
          ctrl.salaryAgreements = response.data.salaryAgreements;
        } else {
          ctrl.salaryAgreements = [{}];
        }
        ctrl.editable = false;
        $scope.form.$setPristine();
      });
    };
    ctrl.cancelEditing = function () {
      ctrl.$onInit();
      ctrl.editable = false;
      $scope.form.$setPristine();
    };
    ctrl.dirty = function () {
      return angular.isDefined($scope.form) && !$scope.form.$pristine;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.teacher').controller('TeacherPaymentsController', TeacherPaymentsController);
  angular.module('app.scc.teacher').component("teacherPayments", {
    templateUrl: 'app/main/scc/components/teacher/teacher-payments.html',
    bindings: {
      teacherId: '<'
    },
    controller: 'TeacherPaymentsController'
  });

  /** @ngInject */
  function TeacherPaymentsController($scope, scc, checkState, $mdDialog, notifications, $mdMedia, revenuecat) {
    $scope.$mdMedia = $mdMedia;
    var ctrl = this;
    ctrl.salaryPayments = [];
    ctrl.selectedEntities = [];
    ctrl.proEntitled = null;
    ctrl.dataTable = {
      page: 1,
      order: 'amount',
      limit: 5,
      limitOptions: [5, 10, 15]
    };
    ctrl.$onInit = function () {
      revenuecat.isProEntitled().then(function (entitled) {
        ctrl.proEntitled = entitled;
        if (entitled) {
          scc.execute(scc.PRIVATE_MODE, "GetSalaryPayments", {
            teacherId: ctrl.teacherId
          }, $scope.form, function (response) {
            ctrl.salaryPayments = response.data.salaryPayments;
          });
        }
      });
    };
    ctrl.showPaywall = function () {
      revenuecat.showPaywall().then(function (nowEntitled) {
        if (nowEntitled) {
          ctrl.proEntitled = true;
          scc.execute(scc.PRIVATE_MODE, "GetSalaryPayments", {
            teacherId: ctrl.teacherId
          }, $scope.form, function (response) {
            ctrl.salaryPayments = response.data.salaryPayments;
          });
        }
      });
    };
    ctrl.getAllEntities = function () {
      return ctrl.salaryPayments;
    };
    ctrl.showEditPanel = function (ev, p) {
      $mdDialog.show({
        controller: function controller($scope, payment, $mdDialog) {
          var panelCtrl = this;
          this.payment = angular.extend({}, payment);
          this.close = function () {
            $mdDialog.cancel();
          };
          this.submit = function () {
            scc.execute(scc.PRIVATE_MODE, "UpdateSalaryPayment", {
              payment: panelCtrl.payment
            }, $scope.form, function (response) {
              angular.extend(payment, response.data.payment);
              $mdDialog.hide();
            });
          };
        },
        controllerAs: '$ctrl',
        templateUrl: 'app/main/scc/components/teacher/edit-payment-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          payment: p
        }
      });
    };
    ctrl.showPaymentDialog = function (ev) {
      $mdDialog.show({
        controller: function controller($scope, $mdDialog) {
          var panelCtrl = this;
          $scope.$watch("$ctrl.req.normalizePayments", function (newVal, oldVal) {
            if (newVal == true) {
              panelCtrl.req.communicatedSum = panelCtrl.precalculation.amountWithNormalization;
            } else {
              panelCtrl.req.communicatedSum = panelCtrl.precalculation.amount;
            }
          });
          panelCtrl.close = function () {
            $mdDialog.cancel();
          };
          panelCtrl.submit = function () {
            scc.execute(scc.PRIVATE_MODE, "PayOffSalaries", panelCtrl.req, {}, function () {
              notifications.push("Οι πληρωμές εκπληρώθηκαν", notifications.INFO);
              ctrl.selectedEntities = [];
              ctrl.$onInit();
              $mdDialog.cancel();
            });
          };
          scc.execute(scc.PRIVATE_MODE, "PrecalculateSalariesPayment", {
            payments: ctrl.selectedEntities
          }, $scope.form, function (response) {
            panelCtrl.precalculation = response.data;
            panelCtrl.req = {
              payments: ctrl.selectedEntities,
              normalizePayments: false,
              communicatedSum: panelCtrl.precalculation.amount
            };
          });
        },
        controllerAs: '$ctrl',
        templateUrl: 'app/main/scc/components/teacher/confirm-payment-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      });
    };
    ctrl.paySelected = function (ev) {
      scc.execute(scc.PRIVATE_MODE, "PayOffSalaries", {
        payments: ctrl.selectedEntities
      }, {}, function () {
        notifications.push("Οι πληρωμές εκπληρώθηκαν", notifications.INFO);
        ctrl.selectedEntities = [];
        ctrl.$onInit();
      });
    };
    ctrl.pay = function (ev, payent) {
      scc.execute(scc.PRIVATE_MODE, "PayOffSalaries", {
        payments: [payent]
      }, {}, function () {
        notifications.push("Οι πληρωμές εκπληρώθηκαν", notifications.INFO);
        ctrl.$onInit();
      });
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.teacher').controller('TeacherGeneralInfoController', TeacherGeneralInfoController);
  angular.module('app.scc.teacher').component("teacherGeneralInfo", {
    templateUrl: 'app/main/scc/components/teacher/teacher-general-info.html',
    bindings: {
      teacherId: '<',
      dirty: '='
    },
    controller: 'TeacherGeneralInfoController'
  });

  /** @ngInject */
  function TeacherGeneralInfoController($scope, teachers, checkState) {
    var ctrl = this;
    ctrl.teacher = {};
    ctrl.editable = false;
    ctrl.$onInit = function () {
      ctrl.teacher = teachers.get(ctrl.teacherId);
    };
    ctrl.startEditing = function () {
      ctrl.editable = true;
      checkState.checkFormOnStateChange($scope, $scope.form);
    };
    ctrl.save = function () {
      teachers.update({
        teacher: ctrl.teacher
      }, $scope.form, function () {
        var msg = 'Τα στοιχεία του καθηγητή ενημερώθηκαν επιτυχώς';
        ctrl.editable = false;
        $scope.form.$setPristine();
      });
    };
    ctrl.cancelEditing = function () {
      ctrl.teacher = teachers.get(ctrl.teacherId);
      ctrl.editable = false;
      $scope.form.$setPristine();
    };
    ctrl.dirty = function () {
      return angular.isDefined($scope.form) && !$scope.form.$pristine;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.students-group', ['md.data.table']).config(config).run(run);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.scc.private.students-group', {
      url: '/students-group',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/students-group/students-group-list.html',
          controller: 'StudentsGroupListController as $ctrl'
        }
      }
    });

    // State
    $stateProvider.state('app.scc.private.students-group.details', {
      url: '/:studentsGroupId?tab',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/students-group/students-group-details.html',
          controller: 'StudentsGroupDetailsController as $ctrl'
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/students-group');
    msNavigationServiceProvider.saveItem('students-group', {
      title: 'SCC',
      svgIcon: 'students-group',
      state: 'app.scc.private.students-group',
      /*stateParams: {
          'param1': 'page'
       },*/
      translate: 'SCC.STUDENTS_GROUP.NAV',
      weight: 30000
    });
  }

  /** @ngInject */
  function run($rootScope, studentsGroups) {
    $rootScope.$on('scc.dataSet.selected', studentsGroups.init);
    $rootScope.$on('scc.logout', studentsGroups.cleanup);
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.students-group').factory('studentsGroups', studentsGroupsService);

  /** @ngInject */
  function studentsGroupsService($rootScope, daoFactory, dataSets, scc) {
    var service = daoFactory.createDao('studentsGroup', 'StudentsGroup');
    service.init = function () {
      service.cleanup();
      if (dataSets.getSelected()) {
        scc.request(scc.PRIVATE_MODE, 'GetAllStudentsGroups', {
          dataSetId: dataSets.getSelected().id
        }, function (response) {
          service.entities = response.data.studentsGroups;
          console.log('Students groups loaded');
          $rootScope.$emit('scc.studentsGroup.loaded');
        });
      }
    };
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.students-group').controller('StudentsGroupListController', StudentsGroupListController).controller('StudentsGroupDetailsController', StudentsGroupDetailsController);

  /** @ngInject */
  function StudentsGroupDetailsController($state, $timeout, $scope, $rootScope, $controller, studentsGroups, schools, $filter, $mdDialog, notifications, $stateParams, checkState, utils) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;
    ctrl.studentsGroupId = $stateParams.studentsGroupId;
    var studentsGroupLoadedDeregister = null;
    ctrl.tab = $stateParams.tab;
    ctrl.tabsCaptions = {
      generalInfo: $filter('translate')('SCC.STUDENT.GENERAL_INFO_TAB'),
      feesInfo: $filter('translate')('SCC.STUDENT.FEES_DETAILS_TAB')
    };
    if (!ctrl.tab) {
      ctrl.tab = "generalInfo";
    }
    ctrl.selectedTab = ctrl.tab;
    function loadStudent() {
      ctrl.studentsGroup = studentsGroups.get(ctrl.studentsGroupId);
    }
    ctrl.$onInit = function () {
      loadStudent();
      studentsGroupLoadedDeregister = $rootScope.$on('scc.studentsGroup.loaded', function () {
        loadStudent();
      });
      $scope.$on('$destroy', function () {
        if (studentsGroupLoadedDeregister) {
          studentsGroupLoadedDeregister();
        }
      });
    };
    $scope.$watch("$ctrl.tab", function (newVal, oldVal) {
      if (newVal != ctrl.selectedTab && angular.isDefined(ctrl.dirty) && ctrl.dirty() && !checkState.confirmUserAction()) {
        ctrl.tab = oldVal;
      } else {
        ctrl.selectedTab = newVal;
      }
    });
  }

  /** @ngInject */
  function StudentsGroupListController($scope, $controller, studentsGroups, dataSets, $mdDialog, notifications) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;

    //The selected students-groups
    this.selectedEntities = [];

    //The students-group to be created
    this.studentsGroup = {};
    this.getAllEntities = function () {
      return studentsGroups.getAll();
    };
    this.createEntity = function () {
      this.studentsGroup.dataSet = dataSets.getSelected();
      studentsGroups.create({
        studentsGroup: this.studentsGroup
      }, $scope, function () {
        notifications.push('Το τμήμα καταχωρήθηκε επιτυχώς', notifications.INFO);
        ctrl.studentsGroup = {};
        ctrl.setFocusByName("studentsGroup.name");
      }, function () {
        ctrl.setFocusByName("studentsGroup.name");
      });
    };
    this.isDatasetSelected = function () {
      if (dataSets.getSelected()) {
        return true;
      }
      return false;
    };
    this.deleteEntity = function (ev, studentsGroup) {
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση διαγραφής').textContent('Θέλετε σίγουρα να διαγράψετε το διδακτικό τμήμα \"' + studentsGroup.name + '\";').ariaLabel('Επιβεβαίωση διαγραφής').targetEvent(ev).ok('ΔΙΑΓΡΑΦΗ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        studentsGroups.deleteListed({
          studentsGroupsIds: [studentsGroup.id]
        }, $scope, function () {
          ctrl.selectedEntities = [];
          notifications.push('Το τμήμα \"' + studentsGroup.name + '\" διαγράφηκε.', notifications.INFO);
        });
      });
    };
    this.deleteSelected = function (ev) {
      var confirmText;
      if (ctrl.selectedEntities.length == 1) {
        confirmText = 'Θέλετε σίγουρα να διαγράψετε το τμήμα \"' + ctrl.selectedEntities[0].name + '\";';
      } else {
        confirmText = 'Θέλετε σίγουρα να διαγράψετε τα ' + ctrl.selectedEntities.length + ' επιλεγμένα διδακτικά τμήματα;';
      }
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση διαγραφής').textContent(confirmText).ariaLabel('Επιβεβαίωση διαγραφής').targetEvent(ev).ok('ΔΙΑΓΡΑΦΗ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        var ids = ctrl.selectedEntities.map(function (l) {
          return l.id;
        });
        studentsGroups.deleteListed({
          studentsGroupsIds: ids
        }, $scope, function () {
          var responseText;
          if (ctrl.selectedEntities.length == 1) {
            responseText = 'Το διδακτικό τμήμα \"' + ctrl.selectedEntities[0].name + '\" διαγράφηκε.';
          } else {
            responseText = 'Τα ' + ctrl.selectedEntities.length + ' επιλεγμένα διδακτικά τμήματα διαγράφηκαν.';
          }
          notifications.push(responseText, notifications.INFO);
          ctrl.selectedEntities = [];
        });
      });
    };
    this.setFocusByName("studentsGroup.name");
  }
})();
"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  "use strict";

  angular.module("app.scc.students-group").controller("StudentsGroupTeachingNeedsController", StudentsGroupTeachingNeedsController);
  angular.module("app.scc.students-group").component("studentsGroupTeachingNeeds", {
    templateUrl: "app/main/scc/components/students-group/students-group-teaching-needs.html",
    bindings: {
      studentsGroupId: "<"
    },
    controller: "StudentsGroupTeachingNeedsController"
  });

  /** @ngInject */
  function StudentsGroupTeachingNeedsController($scope, $controller, teachingNeedsServiceFactory, dataSets, $mdDialog, notifications) {
    var ctrl = this;
    var teachingNeeds = teachingNeedsServiceFactory.createService(this.studentsGroupId);
    var crud_ctrl = $controller("GenericCrudController", {
      $scope: $scope
    });
    angular.extend(crud_ctrl, {
      service: teachingNeeds,
      editDialogTemplateUrl: "app/main/scc/components/students-group/edit-students-group-teaching-need-dialog.html",
      entityType: "teachingNeed",
      translationNameSpace: "SCC.STUDENTS_GROUP.TEACHING_NEEDS",
      teachingNeed: {}
    });
    angular.extend(ctrl, crud_ctrl);
    ctrl.createEntity = function () {
      teachingNeeds.create({
        teachingNeed: this.teachingNeed
      }, $scope, function () {
        notifications.push("Το τμήμα καταχωρήθηκε επιτυχώς", notifications.INFO);
        ctrl.teachingNeed = {};
        //ctrl.setFocusByName("teachingNeed.teacher");
      });
    };
    ctrl.showCopyFromOtherGroupDialog = function (ev, e) {
      var templateUrl = "app/main/scc/components/students-group/copy-students-group-teaching-needs-dialog.html";
      $mdDialog.show({
        controller: function controller($scope, entity, $mdDialog) {
          angular.extend(this, $controller("BaseSccController", {
            $scope: $scope
          }));
          var panelCtrl = this;
          panelCtrl.studentsGroup = null;
          panelCtrl.teachingNeeds = [];
          panelCtrl.reloadTeachingNeeds = function () {
            var teachingNeeds = teachingNeedsServiceFactory.createService(panelCtrl.studentsGroup.id);
            panelCtrl.teachingNeeds = teachingNeeds.getAll().map(function (tn) {
              return JSON.parse(JSON.stringify(tn));
            });
          };
          panelCtrl.close = function () {
            $mdDialog.cancel();
          };
          panelCtrl.copy = function () {
            var _iterator = _createForOfIteratorHelper(panelCtrl.teachingNeeds),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var tn = _step.value;
                tn.id = null;
                tn.studentsGroup.id = ctrl.studentsGroupId;
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            var request = {
              teachingNeeds: panelCtrl.teachingNeeds
            };
            ctrl.service.createAll(request, $scope.form, function () {
              //$translate(ctrl.translationNameSpace+".NOTIFICATIONS.ENTITY_UPDATED", {entity:panelCtrl[ctrl.entityType]}).then(function(text){
              //	  notifications.push(text,notifications.INFO);
              //});
              $mdDialog.hide();
              ctrl.selectedEntities = [];
            });
          };
        },
        controllerAs: "$ctrl",
        templateUrl: templateUrl,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          entity: e
        }
      });
    };
    return ctrl;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.students-group').factory('teachingNeedsServiceFactory', teachingNeedsServiceFactory);

  /** @ngInject */
  function teachingNeedsServiceFactory(daoFactory, studentsGroups) {
    var factory = {};
    factory.createService = function (studentsGroupId) {
      var service = daoFactory.createDao('teachingNeed', 'TeachingNeed');
      service.init = function () {
        service.cleanup();
        service.entities = studentsGroups.get(studentsGroupId).teachingNeeds;
      };
      var createMethod = service.create;
      service.create = function (req, scope, onSuccess, onFailure) {
        req.teachingNeed.studentsGroup = {
          id: studentsGroupId
        };
        createMethod(req, scope, onSuccess, onFailure);
      };
      service.init();
      return service;
    };
    return factory;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.students-group').controller('StudentsGroupMembersController', StudentsGroupMembersController);
  angular.module('app.scc.students-group').component("studentsGroupMembers", {
    templateUrl: 'app/main/scc/components/students-group/students-group-members.html',
    bindings: {
      studentsGroupId: '<'
    },
    controller: 'StudentsGroupMembersController'
  });

  /** @ngInject */
  function StudentsGroupMembersController($scope, $controller, studentsGroupMembersServiceFactory, dataSets, $mdDialog, notifications) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;
    var students = studentsGroupMembersServiceFactory.createService(ctrl.studentsGroupId);

    //The selected students groups members
    ctrl.selectedEntities = [];

    //The student
    ctrl.student = null;
    ctrl.setStudent = function (student) {
      ctrl.student = student;
    };
    this.getAllEntities = function () {
      return students.getAll();
    };
    this.createEntity = function () {
      students.create({
        student: ctrl.student
      }, $scope, function () {
        notifications.push('Ο μαθητής καταχωρήθηκε επιτυχώς', notifications.INFO);
        ctrl.student = null;
        //ctrl.setFocusByName("student");
      });
    };
    this.deleteEntity = function (ev, student) {
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση διαγραφής').textContent('Θέλετε σίγουρα να αφαιρέσετε τον μαθητή \"' + student.name + '\" από το τμήμα;').ariaLabel('Επιβεβαίωση διαγραφής').targetEvent(ev).ok('ΔΙΑΓΡΑΦΗ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        students.deleteListed({
          studentsIds: [student.id]
        }, $scope, function () {
          ctrl.selectedEntities = [];
          notifications.push('Ο μαθητής \"' + student.name + '\" διαγράφηκε.', notifications.INFO);
        });
      });
    };
    this.deleteSelected = function (ev) {
      var confirmText;
      if (ctrl.selectedEntities.length == 1) {
        confirmText = 'Θέλετε σίγουρα να αφαιρέσετε τον μαθητή \"' + ctrl.selectedEntities[0].name + '\" απο το τμήμα;';
      } else {
        confirmText = 'Θέλετε σίγουρα να αφαιρέσετε τους ' + ctrl.selectedEntities.length + ' επιλεγμένους μαθητές από το τμήμα;';
      }
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση διαγραφής').textContent(confirmText).ariaLabel('Επιβεβαίωση διαγραφής').targetEvent(ev).ok('ΔΙΑΓΡΑΦΗ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        var ids = ctrl.selectedEntities.map(function (l) {
          return l.id;
        });
        students.deleteListed({
          studentsIds: ids
        }, $scope, function () {
          var responseText;
          if (ctrl.selectedEntities.length == 1) {
            responseText = 'Η διδακτική ανάγκη \"' + ctrl.selectedEntities[0] + '\" διαγράφηκε.';
          } else {
            responseText = 'Οι ' + ctrl.selectedEntities.length + ' επιλεγμένες διδακτικές ανάγκες διαγράφηκαν.';
          }
          notifications.push(responseText, notifications.INFO);
          ctrl.selectedEntities = [];
        });
      });
    };
    this.setFocusByName("student");
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.students-group').factory('studentsGroupMembersServiceFactory', MembersServiceFactory);

  /** @ngInject */
  function MembersServiceFactory(daoFactory, studentsGroups) {
    var factory = {};
    factory.createService = function (studentsGroupId) {
      var service = daoFactory.createDao('student', 'StudentToStudentsGroupRelationship');
      service.init = function () {
        service.cleanup();
        service.entities = studentsGroups.get(studentsGroupId).students;
      };
      var createMethod = service.create;
      var deleteListedMethod = service.deleteListed;
      service.create = function (req, scope, onSuccess, onFailure) {
        req.studentsGroup = {
          id: studentsGroupId
        };
        createMethod(req, scope, onSuccess, onFailure);
      };
      service.deleteListed = function (req, scope, onSuccess, onFailure) {
        req.studentsGroupId = studentsGroupId;
        deleteListedMethod(req, scope, onSuccess, onFailure);
      };
      service.init();
      return service;
    };
    return factory;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.students-group').controller('StudentsGroupGeneralInfoController', StudentsGroupGeneralInfoController);
  angular.module('app.scc.students-group').component("studentsGroupGeneralInfo", {
    templateUrl: 'app/main/scc/components/students-group/students-group-general-info.html',
    bindings: {
      studentsGroupId: '<',
      dirty: '='
    },
    controller: 'StudentsGroupGeneralInfoController'
  });

  /** @ngInject */
  function StudentsGroupGeneralInfoController($scope, studentsGroups, checkState) {
    var ctrl = this;
    ctrl.studentsGroup = {};
    ctrl.editable = false;
    ctrl.$onInit = function () {
      ctrl.studentsGroup = studentsGroups.get(ctrl.studentsGroupId);
    };
    ctrl.startEditing = function () {
      ctrl.editable = true;
      checkState.checkFormOnStateChange($scope, $scope.form);
    };
    ctrl.save = function () {
      studentsGroups.update({
        studentsGroup: ctrl.studentsGroup
      }, $scope.form, function () {
        var msg = 'Τα στοιχεία του μαθητή ενημερώθηκαν επιτυχώς';
        ctrl.editable = false;
        $scope.form.$setPristine();
      });
    };
    ctrl.cancelEditing = function () {
      ctrl.studentsGroup = studentsGroups.get(ctrl.studentsGroupId);
      ctrl.editable = false;
      $scope.form.$setPristine();
    };
    ctrl.dirty = function () {
      return angular.isDefined($scope.form) && !$scope.form.$pristine;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.student', ['md.data.table']).config(config).run(run);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.scc.private.student', {
      url: '/student',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/student/student-list.html',
          controller: 'StudentListController as $ctrl'
        }
      }
    });

    // State
    $stateProvider.state('app.scc.private.student.details', {
      url: '/:studentId?tab',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/student/student-details.html',
          controller: 'StudentDetailsController as $ctrl'
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/student');
    msNavigationServiceProvider.saveItem('student', {
      title: 'SCC',
      svgIcon: 'student',
      state: 'app.scc.private.student',
      /*stateParams: {
          'param1': 'page'
       },*/
      translate: 'SCC.STUDENT.NAV',
      weight: 50000
    });
  }

  /** @ngInject */
  function run($rootScope, students) {
    $rootScope.$on('scc.school.selected', students.init);
    $rootScope.$on('scc.logout', students.cleanup);
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.student').factory('students', studentsService);

  /** @ngInject */
  function studentsService(daoFactory) {
    return daoFactory.createDao('student', 'Student');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.student').controller('StudentListController', StudentListController).controller('StudentDetailsController', StudentDetailsController);

  /** @ngInject */
  function StudentDetailsController($state, $timeout, $scope, $rootScope, $controller, students, schools, $filter, $mdDialog, notifications, $stateParams, checkState, utils, dataSets) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;
    var studentsLoadedDeregister = null;
    ctrl.studentId = $stateParams.studentId;
    ctrl.tab = $stateParams.tab;
    ctrl.tabsCaptions = {
      generalInfo: $filter('translate')('SCC.STUDENT.GENERAL_INFO_TAB'),
      feesInfo: $filter('translate')('SCC.STUDENT.FEES_DETAILS_TAB'),
      availability: $filter('translate')('SCC.STUDENT.AVAILABILITY_TAB')
    };
    ctrl.getSelectedDataSet = function () {
      return dataSets.getSelected();
    };
    if (!ctrl.tab) {
      ctrl.tab = "generalInfo";
    }
    ctrl.selectedTab = ctrl.tab;
    function loadStudent() {
      ctrl.student = students.get(ctrl.studentId);
    }
    ctrl.$onInit = function () {
      loadStudent();
      studentsLoadedDeregister = $rootScope.$on('scc.student.loaded', function () {
        loadStudent();
      });
      $scope.$on('$destroy', function () {
        if (studentsLoadedDeregister) {
          studentsLoadedDeregister();
        }
      });
    };
    $scope.$watch("$ctrl.tab", function (newVal, oldVal) {
      if (newVal != ctrl.selectedTab && angular.isDefined(ctrl.dirty) && ctrl.dirty() && !checkState.confirmUserAction()) {
        ctrl.tab = oldVal;
      } else {
        ctrl.selectedTab = newVal;
      }
    });
  }

  /** @ngInject */
  function StudentListController($scope, $controller, students, schools, $mdDialog, notifications, dataSets, studentsGroupMembersServiceFactory) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;

    //The selected students
    this.selectedEntities = [];

    //The student to be created
    this.student = {};

    //The selected students group to assign the new student to
    this.selectedStudentsGroup = null;
    this.isDatasetSelected = function () {
      return !!dataSets.getSelected();
    };
    this.getAllEntities = function () {
      return students.getAll();
    };
    this.createEntity = function () {
      this.student.school = schools.getSelectedSchool();
      var selectedGroup = ctrl.selectedStudentsGroup;
      students.create({
        student: this.student
      }, $scope, function (response) {
        notifications.push('Ο μαθητής καταχωρήθηκε επιτυχώς', notifications.INFO);
        if (selectedGroup) {
          var createdStudent = response.data.student;
          var membersService = studentsGroupMembersServiceFactory.createService(selectedGroup.id);
          membersService.create({
            student: {
              id: createdStudent.id
            }
          }, $scope, function () {
            notifications.push('Ο μαθητής αντιστοιχίθηκε στο τμήμα "' + selectedGroup.name + '"', notifications.INFO);
          });
        }
        ctrl.student = {};
        ctrl.selectedStudentsGroup = null;
        ctrl.setFocusByName("student.name");
      }, function () {
        ctrl.setFocusByName("student.name");
      });
    };
    this.deleteEntity = function (ev, student) {
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση διαγραφής').textContent('Θέλετε σίγουρα να διαγράψετε τον μαθητή \"' + student.name + '\";').ariaLabel('Επιβεβαίωση διαγραφής').targetEvent(ev).ok('ΔΙΑΓΡΑΦΗ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        students.deleteListed({
          studentsIds: [student.id]
        }, $scope, function () {
          ctrl.selectedEntities = [];
          notifications.push('Ο μαθητής \"' + student.name + '\" διαγράφηκε.', notifications.INFO);
        });
      });
    };
    this.deleteSelected = function (ev) {
      var confirmText;
      if (ctrl.selectedEntities.length == 1) {
        confirmText = 'Θέλετε σίγουρα να διαγράψετε τον μαθητή \"' + ctrl.selectedEntities[0].name + '\";';
      } else {
        confirmText = 'Θέλετε σίγουρα να διαγράψετε τους ' + ctrl.selectedEntities.length + ' επιλεγμένους μαθητές;';
      }
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση διαγραφής').textContent(confirmText).ariaLabel('Επιβεβαίωση διαγραφής').targetEvent(ev).ok('ΔΙΑΓΡΑΦΗ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        var ids = ctrl.selectedEntities.map(function (l) {
          return l.id;
        });
        students.deleteListed({
          studentsIds: ids
        }, $scope, function () {
          var responseText;
          if (ctrl.selectedEntities.length == 1) {
            responseText = 'Ο μαθητής \"' + ctrl.selectedEntities[0].name + '\" διαγράφηκε.';
          } else {
            responseText = 'Οι ' + ctrl.selectedEntities.length + ' επιλεγμένοι μαθητές διαγράφηκαν.';
          }
          notifications.push(responseText, notifications.INFO);
          ctrl.selectedEntities = [];
        });
      });
    };
    this.setFocusByName("student.name");
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.student').controller('StudentPaymentsController', StudentPaymentsController);
  angular.module('app.scc.student').component("studentPayments", {
    templateUrl: 'app/main/scc/components/student/student-payments.html',
    bindings: {
      studentId: '<'
    },
    controller: 'StudentPaymentsController'
  });

  /** @ngInject */
  function StudentPaymentsController($scope, scc, checkState, $mdDialog, notifications, $mdMedia, revenuecat) {
    $scope.$mdMedia = $mdMedia;
    var ctrl = this;
    ctrl.feesPayments = [];
    ctrl.selectedEntities = [];
    ctrl.proEntitled = null;
    ctrl.dataTable = {
      page: 1,
      order: 'amount',
      limit: 5,
      limitOptions: [5, 10, 15]
    };
    ctrl.$onInit = function () {
      revenuecat.isProEntitled().then(function (entitled) {
        ctrl.proEntitled = entitled;
        if (entitled) {
          scc.execute(scc.PRIVATE_MODE, "GetFeesPayments", {
            studentId: ctrl.studentId
          }, $scope.form, function (response) {
            ctrl.feesPayments = response.data.feesPayments;
          });
        }
      });
    };
    ctrl.showPaywall = function () {
      revenuecat.showPaywall().then(function (nowEntitled) {
        if (nowEntitled) {
          ctrl.proEntitled = true;
          scc.execute(scc.PRIVATE_MODE, "GetFeesPayments", {
            studentId: ctrl.studentId
          }, $scope.form, function (response) {
            ctrl.feesPayments = response.data.feesPayments;
          });
        }
      });
    };
    ctrl.getAllEntities = function () {
      return ctrl.feesPayments;
    };
    ctrl.showEditPanel = function (ev, p) {
      $mdDialog.show({
        controller: function controller($scope, payment, $mdDialog) {
          var panelCtrl = this;
          this.payment = angular.extend({}, payment);
          this.close = function () {
            $mdDialog.cancel();
          };
          this.submit = function () {
            scc.execute(scc.PRIVATE_MODE, "UpdateFeesPayment", {
              payment: panelCtrl.payment
            }, $scope.form, function (response) {
              angular.extend(payment, response.data.payment);
              $mdDialog.hide();
            });
          };
        },
        controllerAs: '$ctrl',
        templateUrl: 'app/main/scc/components/student/edit-payment-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          payment: p
        }
      });
    };
    ctrl.showPaymentDialog = function (ev) {
      $mdDialog.show({
        controller: function controller($scope, $mdDialog) {
          var panelCtrl = this;
          $scope.$watch("$ctrl.req.normalizePayments", function (newVal, oldVal) {
            if (newVal == true) {
              panelCtrl.req.communicatedSum = panelCtrl.precalculation.amountWithNormalization;
            } else {
              panelCtrl.req.communicatedSum = panelCtrl.precalculation.amount;
            }
          });
          panelCtrl.close = function () {
            $mdDialog.cancel();
          };
          panelCtrl.submit = function () {
            scc.execute(scc.PRIVATE_MODE, "PayOffFees", panelCtrl.req, {}, function () {
              notifications.push("Οι πληρωμές εκπληρώθηκαν", notifications.INFO);
              ctrl.selectedEntities = [];
              ctrl.$onInit();
              $mdDialog.cancel();
            });
          };
          scc.execute(scc.PRIVATE_MODE, "PrecalculateFeesPayment", {
            payments: ctrl.selectedEntities
          }, $scope.form, function (response) {
            panelCtrl.precalculation = response.data;
            panelCtrl.req = {
              payments: ctrl.selectedEntities,
              normalizePayments: false,
              communicatedSum: panelCtrl.precalculation.amount
            };
          });
        },
        controllerAs: '$ctrl',
        templateUrl: 'app/main/scc/components/student/confirm-payment-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      });
    };
    ctrl.paySelected = function (ev) {
      scc.execute(scc.PRIVATE_MODE, "PayOffFees", {
        payments: ctrl.selectedEntities
      }, {}, function () {
        notifications.push("Οι πληρωμές εκπληρώθηκαν", notifications.INFO);
        ctrl.selectedEntities = [];
        ctrl.$onInit();
      });
    };
    ctrl.pay = function (ev, payent) {
      scc.execute(scc.PRIVATE_MODE, "PayOffFees", {
        payments: [payent]
      }, {}, function () {
        notifications.push("Οι πληρωμές εκπληρώθηκαν", notifications.INFO);
        ctrl.$onInit();
      });
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.student').controller('StudentGroupsInfoController', StudentGroupsInfoController);
  angular.module('app.scc.student').component("studentGroupsInfo", {
    templateUrl: 'app/main/scc/components/student/student-groups-info.html',
    bindings: {
      studentId: '<'
    },
    controller: 'StudentGroupsInfoController'
  });

  /** @ngInject */
  function StudentGroupsInfoController($scope, $controller, students, dataSets, studentsGroups, studentsGroupMembersServiceFactory, $mdDialog, notifications) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;
    ctrl.selectedStudentsGroup = null;
    ctrl.groupsByDataSet = {};
    ctrl.dataSetIds = [];
    ctrl.$onInit = function () {
      ctrl.reloadGroups();
    };
    ctrl.reloadGroups = function () {
      var grouped = {};

      // For the selected dataset: derive from studentsGroups cache (always up-to-date via members service)
      var selected = dataSets.getSelected();
      if (selected) {
        grouped[selected.id] = {
          dataSet: selected,
          groups: []
        };
        var allGroups = studentsGroups.getAll();
        for (var i = 0; i < allGroups.length; i++) {
          var group = allGroups[i];
          if (group.students) {
            for (var j = 0; j < group.students.length; j++) {
              if (group.students[j].id == ctrl.studentId) {
                grouped[selected.id].groups.push(group);
                break;
              }
            }
          }
        }
      }

      // For other datasets: read from student's cached studentsGroups (read-only)
      var student = students.get(ctrl.studentId);
      if (student && student.studentsGroups) {
        for (var i = 0; i < student.studentsGroups.length; i++) {
          var group = student.studentsGroups[i];
          if (group.dataSet) {
            var dsId = group.dataSet.id;
            if (selected && dsId == selected.id) {
              continue; // Skip selected dataset, already handled above
            }
            if (!grouped[dsId]) {
              grouped[dsId] = {
                dataSet: group.dataSet,
                groups: []
              };
            }
            grouped[dsId].groups.push(group);
          }
        }
      }
      ctrl.groupsByDataSet = grouped;
      ctrl.dataSetIds = Object.keys(grouped);
    };
    ctrl.isSelectedDataSet = function (dataSetId) {
      var selected = dataSets.getSelected();
      return selected && selected.id == dataSetId;
    };
    ctrl.addGroup = function () {
      if (!ctrl.selectedStudentsGroup) {
        return;
      }
      var groupId = ctrl.selectedStudentsGroup.id;
      var groupName = ctrl.selectedStudentsGroup.name;
      var membersService = studentsGroupMembersServiceFactory.createService(groupId);
      membersService.create({
        student: {
          id: ctrl.studentId
        }
      }, $scope, function () {
        notifications.push('Ο μαθητής αντιστοιχίθηκε στο τμήμα "' + groupName + '"', notifications.INFO);
        ctrl.selectedStudentsGroup = null;
        ctrl.reloadGroups();
      });
    };
    ctrl.removeGroup = function (ev, group) {
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση αφαίρεσης').textContent('Θέλετε σίγουρα να αφαιρέσετε τον μαθητή από το τμήμα "' + group.name + '";').ariaLabel('Επιβεβαίωση αφαίρεσης').targetEvent(ev).ok('ΑΦΑΙΡΕΣΗ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        var membersService = studentsGroupMembersServiceFactory.createService(group.id);
        membersService.deleteListed({
          studentsIds: [ctrl.studentId]
        }, $scope, function () {
          notifications.push('Ο μαθητής αφαιρέθηκε από το τμήμα "' + group.name + '"', notifications.INFO);
          ctrl.reloadGroups();
        });
      });
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.student').controller('StudentGeneralInfoController', StudentGeneralInfoController);
  angular.module('app.scc.student').component("studentGeneralInfo", {
    templateUrl: 'app/main/scc/components/student/student-general-info.html',
    bindings: {
      studentId: '<',
      dirty: '='
    },
    controller: 'StudentGeneralInfoController'
  });

  /** @ngInject */
  function StudentGeneralInfoController($scope, students, checkState, errorsHelper) {
    var ctrl = this;
    ctrl.student = {};
    ctrl.editable = false;
    ctrl.$onInit = function () {
      ctrl.student = students.get(ctrl.studentId);
    };
    ctrl.startEditing = function () {
      ctrl.editable = true;
      checkState.checkFormOnStateChange($scope, $scope.form);
    };
    ctrl.save = function () {
      students.update({
        student: ctrl.student
      }, $scope.form, function () {
        var msg = 'Τα στοιχεία του μαθητή ενημερώθηκαν επιτυχώς';
        ctrl.editable = false;
        $scope.form.$setPristine();
      });
    };
    ctrl.cancelEditing = function () {
      ctrl.student = students.get(ctrl.studentId);
      ctrl.editable = false;
      errorsHelper.cleanFormErrors($scope.form);
      $scope.form.$setPristine();
    };
    ctrl.dirty = function () {
      return angular.isDefined($scope.form) && !$scope.form.$pristine;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.student').controller('StudentFinderController', StudentFinderController);
  angular.module('app.scc.student').component("studentFinder", {
    templateUrl: 'app/main/scc/components/student/student-finder.html',
    bindings: {
      errors: '<',
      inputName: '<',
      onStudentSelected: '&',
      student: '='
    },
    controller: 'StudentFinderController'
  });

  /** @ngInject */
  function StudentFinderController($controller, $scope, students) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;
    ctrl.selectedItemChanged = function (item) {
      if (ctrl.onStudentSelected) {
        ctrl.onStudentSelected({
          student: item
        });
      }
    };
    ctrl.getAllItems = function () {
      return students.getAll();
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.student').controller('StudentFeesInfoController', StudentFeesInfoController);
  angular.module('app.scc.student').component("studentFeesInfo", {
    templateUrl: 'app/main/scc/components/student/student-fees-info.html',
    bindings: {
      studentId: '<',
      dirty: '='
    },
    controller: 'StudentFeesInfoController'
  });

  /** @ngInject */
  function StudentFeesInfoController($scope, scc, checkState) {
    var ctrl = this;
    ctrl.feesAgreements = [{}];
    ctrl.editable = false;
    ctrl.$onInit = function () {
      scc.execute(scc.PRIVATE_MODE, "GetFeesAgreements", {
        studentId: ctrl.studentId
      }, $scope.form, function (response) {
        if (response.data.feesAgreements.length) {
          ctrl.feesAgreements = response.data.feesAgreements;
        } else {
          ctrl.feesAgreements = [{}];
        }
      });
    };
    ctrl.startEditing = function () {
      ctrl.editable = true;
      checkState.checkFormOnStateChange($scope, $scope.form);
    };
    ctrl.save = function () {
      scc.execute(scc.PRIVATE_MODE, "UpdateFeesAgreements", {
        studentId: ctrl.studentId,
        feesAgreements: ctrl.feesAgreements
      }, $scope.form, function (response) {
        if (response.data.feesAgreements.length) {
          ctrl.feesAgreements = response.data.feesAgreements;
        } else {
          ctrl.feesAgreements = [{}];
        }
        ctrl.editable = false;
        $scope.form.$setPristine();
      });
    };
    ctrl.cancelEditing = function () {
      ctrl.$onInit();
      ctrl.editable = false;
      $scope.form.$setPristine();
    };
    ctrl.dirty = function () {
      return angular.isDefined($scope.form) && !$scope.form.$pristine;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.school', ['md.data.table', 'app.scc.offers-table']).config(config).run(run);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.scc.private.school', {
      url: '/school',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/school/school.html',
          controller: 'SchoolController as $ctrl'
        }
      }
    });

    // State
    $stateProvider.state('app.scc.private.create-school', {
      url: '/school/create',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/school/create-school.html',
          controller: 'CreateSchoolController as vm'
        }
      }
    });

    // State
    $stateProvider.state('app.scc.private.create-school.success', {
      url: '/school/create',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/school/create-school-success.html',
          controller: 'CreateSchoolController as vm'
        }
      }
    });

    // State
    $stateProvider.state('app.scc.private.upgrade-subscription', {
      url: '/school/upgrade-subscription/:subscriptionId',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/school/upgrade-subscription.html',
          controller: 'UpgradeSubscriptionController as vm'
        }
      }
    });

    // State
    $stateProvider.state('app.scc.private.upgrade-subscription.success', {
      url: '/school/upgrade-subscription/:subscriptionId',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/school/upgrade-subscription-success.html',
          controller: 'UpgradeSubscriptionController as vm'
        }
      }
    });

    // State
    $stateProvider.state('app.scc.private.create-subscription', {
      url: '/school/create-subscription/:schoolId',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/school/create-subscription.html',
          controller: 'CreateSubscriptionController as vm'
        }
      }
    });

    // State
    $stateProvider.state('app.scc.private.create-subscription.success', {
      url: '/school/create-subscription/:schoolId',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/school/create-subscription-success.html',
          controller: 'CreateSubscriptionController as vm'
        }
      }
    });

    // State
    $stateProvider.state('app.scc.private.extend-subscription', {
      url: '/school/extend-subscription/:subscriptionId',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/school/extend-subscription.html',
          controller: 'ExtendSubscriptionController as vm'
        }
      }
    });

    // State
    $stateProvider.state('app.scc.private.extend-subscription.success', {
      url: '/school/extend-subscription/:subscriptionId',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/school/extend-subscription-success.html',
          controller: 'ExtendSubscriptionController as vm'
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/school');
    msNavigationServiceProvider.saveItem('school', {
      title: 'SCC',
      svgIcon: 'school',
      state: 'app.scc.private.school',
      /*stateParams: {
          'param1': 'page'
       },*/
      translate: 'SCC.SCHOOL.NAV',
      weight: 10
    });
  }

  /** @ngInject */
  function run($rootScope, schools, authentication) {
    $rootScope.$on('scc.login', schools.init);
    $rootScope.$on('scc.logout', schools.cleanup);
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.school').factory('schools', schoolsService);

  /** @ngInject */
  function schoolsService(scc, authentication, $window, $rootScope) {
    var SELECTED_SCHOOL_ID_KEY = 'sccSelectedSchoolId';
    function userScopedKey() {
      var user = authentication.getUser();
      return user ? SELECTED_SCHOOL_ID_KEY + '.' + user.id : null;
    }
    function readSelectedSchoolId() {
      var key = userScopedKey();
      if (!key) {
        return null;
      }
      var raw = $window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    }
    function writeSelectedSchoolId(id) {
      var key = userScopedKey();
      if (!key) {
        return;
      }
      if (id == null) {
        $window.localStorage.removeItem(key);
      } else {
        $window.localStorage.setItem(key, JSON.stringify(id));
      }
    }
    var schools = [];
    // var selectedSchool = null;
    var service = {};
    service.selectedSchool = null;
    service.init = function init() {
      var roles = authentication.getUser().roles;
      var sList = [];
      for (var i = 0; i < roles.length; i++) {
        sList.push(roles[i].school);
      }
      schools = sList;
      if (schools.length == 1) {
        service.selectedSchool = schools[0];
        writeSelectedSchoolId(service.selectedSchool.id);
        $rootScope.$emit('scc.school.selected');
      } else {
        var storedId = readSelectedSchoolId();
        if (storedId) {
          service.selectedSchool = service.getSchool(storedId);
          $rootScope.$emit('scc.school.selected');
        }
      }
      console.log('Schools initialized');
    };
    service.cleanup = function cleanup() {
      service.selectedSchool = null;
      schools = [];
    };
    service.selectSchool = function (school) {
      service.selectedSchool = school;
      writeSelectedSchoolId(service.selectedSchool ? school.id : null);
      $rootScope.$emit('scc.school.selected');
    };
    service.getSelectedSchool = function () {
      return service.selectedSchool;
    };
    service.getAllSchools = function () {
      return schools;
    };
    service.getSchool = function (id) {
      var l = schools.length;
      for (var i = 0; i < l; i++) {
        if (schools[i].id == id) {
          return schools[i];
        }
      }
      return null;
    };
    service.createSchool = function (req, scope, onSuccess, onFailure) {
      scc.execute(scc.PRIVATE_MODE, 'CreateSchool', req, scope.form, function (response) {
        schools.push(response.data.school);
        if (onSuccess) {
          onSuccess(response);
        }
      }, onFailure);
    };
    service.updateSchool = function (req, scope, onSuccess) {
      scc.execute(scc.PRIVATE_MODE, 'UpdateSchool', req, scope.form, function (response) {
        for (var i = 0; i < schools.length; i++) {
          if (schools[i].id == response.data.school.id) {
            schools[i] = response.data.school;
          }
          if (service.selectedSchool.id = response.data.school.id) {
            service.selectedSchool = response.data.school;
          }
        }
        if (onSuccess) {
          onSuccess();
        }
      });
    };
    service.upgradeProductSubscription = function (req, scope, onSuccess) {
      scc.execute(scc.PRIVATE_MODE, 'UpgradeProductSubscription', req, scope.form, function (response) {
        for (var i = 0; i < schools.length; i++) {
          if (schools[i].id == response.data.school.id) {
            schools[i] = response.data.school;
          }
        }
        if (onSuccess) {
          onSuccess();
        }
      });
    };
    service.extendProductSubscription = function (req, scope, onSuccess) {
      scc.execute(scc.PRIVATE_MODE, 'ExtendProductSubscription', req, scope.form, function (response) {
        for (var i = 0; i < schools.length; i++) {
          if (schools[i].id == response.data.school.id) {
            schools[i] = response.data.school;
          }
        }
        if (onSuccess) {
          onSuccess();
        }
      });
    };
    service.createProductSubscription = function (req, scope, onSuccess) {
      scc.execute(scc.PRIVATE_MODE, 'CreateProductSubscription', req, scope.form, function (response) {
        for (var i = 0; i < schools.length; i++) {
          if (schools[i].id == response.data.school.id) {
            schools[i] = response.data.school;
          }
        }
        if (onSuccess) {
          onSuccess();
        }
      });
    };
    service.deleteSchools = function (req, scope, onSuccess) {
      scc.execute(scc.PRIVATE_MODE, 'DeleteSchools', req, scope.form, function (response) {
        var i = schools.length;
        while (i--) {
          if (response.data.schoolsIds.indexOf(schools[i].id) >= 0) {
            schools.splice(i, 1);
          }
        }
        if (onSuccess) {
          onSuccess();
        }
      });
    };
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.school').controller('SchoolController', SchoolController).controller('CreateSchoolController', CreateSchoolController).controller('CreateSubscriptionController', CreateSubscriptionController).controller('ExtendSubscriptionController', ExtendSubscriptionController).controller('UpgradeSubscriptionController', UpgradeSubscriptionController);
  function localizeDate(date) {
    if (date) {
      var m = moment(date);
      return m.isValid() ? m.format('YYYY-MM-DD') : null;
    }
    return null;
  }

  /** @ngInject */
  function CreateSubscriptionController($state, $stateParams, scc, schools, $scope, $rootScope) {
    var ctrl = this;
    ctrl.schoolId = $stateParams.schoolId;
    ctrl.req = {
      cancelOverlappingPendingPurchases: false,
      schoolId: ctrl.schoolId,
      billingInfo: {},
      paymentMethod: 'MOCK'
    };
    ctrl.offers = [];
    scc.request(scc.PRIVATE_MODE, 'GetAvailableProductOffers', {
      schoolId: ctrl.schoolId
    }, function (response) {
      ctrl.offers = response.data.offers;
    });
    ctrl.submit = function () {
      schools.createProductSubscription(ctrl.req, $scope, function (response) {
        $state.go('app.scc.private.create-subscription.success');
      });
    };
  }

  /** @ngInject */
  function UpgradeSubscriptionController($stateParams, scc, schools, $scope, $state) {
    var ctrl = this;
    var id = $stateParams.subscriptionId;
    ctrl.req = {
      productSubscriptionId: id,
      billingInfo: {},
      paymentMethod: "PAYPAL_INVOICE",
      cancelOverlappingPendingPurchases: false
    };
    ctrl.offers = [];
    scc.request(scc.PRIVATE_MODE, 'GetProductUpgradeOffers', {
      productSubdcriptionsId: id
    }, function (response) {
      ctrl.offers = response.data.offers;
    });
    ctrl.submit = function () {
      schools.upgradeProductSubscription(ctrl.req, $scope, function (response) {
        $state.go('app.scc.private.upgrade-subscription.success');
      });
    };
  }

  /** @ngInject */
  function ExtendSubscriptionController($stateParams, scc, schools, $scope, $state) {
    var ctrl = this;
    var id = $stateParams.subscriptionId;
    ctrl.req = {
      productSubscriptionId: id,
      billingInfo: {},
      paymentMethod: "PAYPAL_INVOICE",
      cancelOverlappingPendingPurchases: false
    };
    ctrl.offers = [];
    scc.request(scc.PRIVATE_MODE, 'GetSubscriptionExtensionOffers', {
      productSubdcriptionsId: id
    }, function (response) {
      ctrl.offers = response.data.offers;
    });
    ctrl.submit = function () {
      schools.extendProductSubscription(ctrl.req, $scope, function (response) {
        $state.go('app.scc.private.extend-subscription.success');
      });
    };
  }

  /** @ngInject */
  function CreateSchoolController($scope, schools, scc, $state) {
    var ctrl = this;
    ctrl.offers = [];
    ctrl.billingInfo = {};
    ctrl.req = {
      school: {
        name: "TEST",
        productSubscriptions: []
      },
      paymentMethod: "PAYPAL_INVOICE",
      billingInfo: ctrl.billingInfo,
      cancelOverlappingPendingPurchases: false
    };
    scc.request(scc.PUBLIC_MODE, "GetAvailableProductOffers", {}, function (response) {
      ctrl.offers = response.data.offers;
    });
    ctrl.createSchool = function () {
      schools.createSchool(ctrl.req, $scope, function (response) {
        $state.go('app.scc.private.create-school.success');
      });
    };
  }

  /** @ngInject */
  function SchoolController($scope, $controller, schools, $mdDialog, notifications) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;

    //The selected schools
    this.selected = [];

    //The school to be created
    this.school = {
      name: ""
    };
    this.getAllEntities = function () {
      return schools.getAllSchools();
    };
    this.createEntity = function () {
      schools.createSchool(ctrl.school, $scope, function () {
        notifications.push('Το νέο σχολείο δημιουργήθηκε επιτυχώς', notifications.INFO);
        ctrl.setFocusByName("school.name");
      }, function () {
        ctrl.setFocusByName("school.name");
      });
    };
    this.deleteEntity = function (ev, school) {
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση διαγραφής').textContent('Θέλετε σίγουρα να διαγράψετε το σχολείο \"' + school.name + '\";').ariaLabel('Επιβεβαίωση διαγραφής').targetEvent(ev).ok('ΔΙΑΓΡΑΦΗ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        schools.deleteSchools({
          schoolsIds: [school.id]
        }, $scope, function () {
          ctrl.selected = [];
          notifications.push('Το σχολείο \"' + school.name + '\" διαγράφηκε.', notifications.INFO);
        });
      });
    };
    this.isSelectedSchool = function (school) {
      var selectedSchool = schools.getSelectedSchool();
      return selectedSchool && school && selectedSchool.id == school.id;
    };
    this.selectSchool = function (school) {
      schools.selectSchool(school);
    };
    this.deleteSelected = function (ev) {
      var confirmText;
      if (ctrl.selected.length == 1) {
        confirmText = 'Θέλετε σίγουρα να διαγράψετε το σχολείο \"' + ctrl.selected[0].name + '\";';
      } else {
        confirmText = 'Θέλετε σίγουρα να διαγράψετε τα ' + ctrl.selected.length + ' επιλεγμένα σχολεία;';
      }
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση διαγραφής').textContent(confirmText).ariaLabel('Επιβεβαίωση διαγραφής').targetEvent(ev).ok('ΔΙΑΓΡΑΦΗ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        var ids = ctrl.selected.map(function (l) {
          return l.id;
        });
        schools.deleteSchools({
          schoolsIds: ids
        }, $scope, function () {
          var responseText;
          if (ctrl.selected.length == 1) {
            responseText = 'Το σχολείο \"' + ctrl.selected[0].name + '\" διαγράφηκε.';
          } else {
            responseText = 'Τα ' + ctrl.selected.length + ' επιλεγμένα σχολεία διαγράφηκαν.';
          }
          notifications.push(responseText, notifications.INFO);
          ctrl.selected = [];
        });
      });
    };
    function schoolDialogController($scope, school, $mdDialog, mode) {
      var panelCtrl = this;
      this.mode = mode;
      this.school = angular.extend({}, school);
      this.oldSchoolName = school.name;
      this.close = function () {
        $mdDialog.cancel();
      };
      this.submit = function () {
        if (panelCtrl.mode && panelCtrl.mode == 'edit') {
          schools.updateSchool({
            school: this.school
          }, $scope, function () {
            var msg = 'Το σχολείο ' + panelCtrl.oldSchoolName + ' ενημερώθηκε επιτυχώς';
            notifications.push(msg, notifications.INFO);
            $mdDialog.hide();
            ctrl.selectedEntities = [];
          });
        } else {
          schools.createSchool({
            school: this.school
          }, $scope, function () {
            var msg = 'Το σχολείο ' + panelCtrl.school.name + ' δημιουργήθηκε επιτυχώς';
            notifications.push(msg, notifications.INFO);
            $mdDialog.hide();
            ctrl.selectedEntities = [];
          });
        }
      };
    }
    this.showEditPanel = function (ev, sc, mode) {
      $mdDialog.show({
        controller: schoolDialogController,
        controllerAs: '$ctrl',
        templateUrl: 'app/main/scc/components/school/edit-school-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          school: sc,
          mode: mode
        }
      });
    };
    this.setFocusByName("school.name");
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.scheduler', ['md.data.table']).config(config).run(run);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.scc.private.scheduler', {
      url: '/scheduler?aspect&entityId',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/scheduler/scheduler.html',
          controller: 'SchedulerController as $ctrl'
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/scheduler');
    msNavigationServiceProvider.saveItem('scheduler', {
      title: 'SCC',
      svgIcon: 'scheduler',
      state: 'app.scc.private.scheduler',
      /*stateParams: {
          'param1': 'page'
       },*/
      translate: 'SCC.SCHEDULER.NAV',
      weight: 40000
    });
  }

  /** @ngInject */
  function run($rootScope, lessons) {}
})();
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
(function () {
  'use strict';

  angular.module('app.scc.scheduler').controller('SchedulerController', SchedulerController);

  /** @ngInject */
  function SchedulerController($controller, $scope, $rootScope, $window, utils, scc, notifications, $mdDialog, $stateParams, $location, reports, dataSets, classrooms, studentsGroups, teachers, revenuecat) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;
    this.teachingNeeds = [];
    this.lessonDeliveries = [];
    this.draggedTeachingNeed = null;
    var dragStartUnsub = $rootScope.$on('scc.teachingNeed.dragStart', function (_, tn) {
      ctrl.draggedTeachingNeed = tn;
      $scope.$applyAsync();
    });
    var dragEndUnsub = $rootScope.$on('scc.teachingNeed.dragEnd', function () {
      ctrl.draggedTeachingNeed = null;
      $scope.$applyAsync();
    });
    $scope.$on('$destroy', function () {
      dragStartUnsub();
      dragEndUnsub();
    });
    var d, ts;
    function initSlots() {
      ctrl.scheduleSlots = [];
      var selectedDataSet = dataSets.getSelected();
      if (!selectedDataSet) {
        return;
      }
      var WeeklyScheduleHelper = /*#__PURE__*/function () {
        function WeeklyScheduleHelper(data) {
          _classCallCheck(this, WeeklyScheduleHelper);
          this.data = data || {};
        }

        // Return the minimum start slot across all days
        return _createClass(WeeklyScheduleHelper, [{
          key: "minStartDate",
          value: function minStartDate() {
            var min = null;
            for (var day = 0; day <= 6; day++) {
              var daySlots = this.data[day].slots || [];
              var _iterator = _createForOfIteratorHelper(daySlots),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var slot = _step.value;
                  if (min === null || slot.start < min) {
                    min = slot.start;
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
            return min;
          }

          // Return the maximum end slot across all days
        }, {
          key: "maxEndDate",
          value: function maxEndDate() {
            var max = null;
            for (var day = 0; day <= 6; day++) {
              var daySlots = this.data[day].slots || [];
              var _iterator2 = _createForOfIteratorHelper(daySlots),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var slot = _step2.value;
                  if (max === null || slot.end > max) {
                    max = slot.end;
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
            return max;
          }

          // Check if a slot is active (falls within any start-end range on that day)
        }, {
          key: "activeSlot",
          value: function activeSlot(day, slotNumber) {
            var slots = this.data[day].slots || [];
            return slots.some(function (range) {
              return slotNumber >= range.start && slotNumber < range.end;
            });
          }
        }]);
      }();
      var scheduleHelper = new WeeklyScheduleHelper(selectedDataSet.scheduleTable);
      var firstSlot = scheduleHelper.minStartDate();
      var lastSlot = scheduleHelper.maxEndDate();
      if (!firstSlot || !lastSlot) {
        return;
      }
      for (ts = firstSlot; ts < lastSlot; ts++) {
        ctrl.scheduleSlots[ts - firstSlot] = [];
        var i = 0;
        for (d = 0; d < 7; d++) {
          if (utils.isEmptyArray(selectedDataSet.scheduleTable[d].slots)) {
            continue;
          }
          ctrl.scheduleSlots[ts - firstSlot][i] = {
            day: d,
            timeSlot: ts,
            disabled: !scheduleHelper.activeSlot(d, ts)
          };
          i++;
        }
      }
    }
    initSlots();
    this.conflicts = [];
    function getEntity() {
      if (!ctrl.entityId) {
        return null;
      }
      if (ctrl.aspect == 'TEACHER') {
        return teachers.get(ctrl.entityId);
      } else if (ctrl.aspect == 'STUDENTS_GROUP') {
        var sg = studentsGroups.get(ctrl.entityId);
        return sg;
      } else if (ctrl.aspect == 'CLASSROOM') {
        return classrooms.get(ctrl.entityId);
      } else {
        return null;
      }
    }
    function lessonDeliveryDtoToWebModel(ld) {
      var conflictsRaw = ctrl.conflicts.filter(function (c) {
        return c.lessonDelivery1.id == ld.id || c.lessonDelivery2.id == ld.id;
      });
      var conflicts = conflictsRaw.map(function (c) {
        var ldInConflict = null;
        if (c.lessonDelivery1.id == ld.id) {
          ldInConflict = c.lessonDelivery2;
        } else {
          ldInConflict = c.lessonDelivery1;
        }
        return {
          entityType: c.entityType,
          entityId: c.entityId,
          lessonDeliveryInConflict: ldInConflict
        };
      });
      var teachingNeed = ctrl.teachingNeeds.find(function (tn) {
        return tn.id == ld.teachingNeed.id;
      });
      teachingNeed.remainingTimeSlots -= ld.duration;
      return {
        id: ld.id,
        day: ld.day,
        timeSlot: ld.timeSlot,
        duration: ld.duration,
        teachingNeed: teachingNeed,
        conflicts: conflicts
      };
    }
    function teacherById(id) {
      if (!ctrl.unavailability) return null;
      var list = ctrl.unavailability.teacherUnavailabilities || [];
      for (var i = 0; i < list.length; i++) {
        if (list[i].teacherId == id) return list[i];
      }
      return null;
    }
    function groupAvailabilityById(id) {
      if (!ctrl.unavailability) return null;
      var list = ctrl.unavailability.studentsGroupAvailabilities || [];
      for (var i = 0; i < list.length; i++) {
        if (list[i].studentsGroupId == id) return list[i];
      }
      return null;
    }
    function teacherBlockedAtSlot(teacher, day, timeSlot) {
      if (!teacher || !teacher.blocks) return false;
      for (var i = 0; i < teacher.blocks.length; i++) {
        var b = teacher.blocks[i];
        if (b.day == day && timeSlot >= b.timeSlot && timeSlot < b.timeSlot + b.duration) {
          return true;
        }
      }
      return false;
    }
    function groupUnavailableCountAtSlot(group, day, timeSlot) {
      if (!group || !group.perDay || !group.perDay[day]) return 0;
      return (group.perDay[day].counts || {})[timeSlot] || 0;
    }
    function annotateUnavailabilityIssues() {
      if (!ctrl.unavailability) {
        return;
      }
      // Lesson delivery tints are always based on the LD's own teacher and
      // students group (not the view), so they reflect what would actually
      // disrupt this specific lesson.
      ctrl.lessonDeliveries.forEach(function (ld) {
        var teacherId = ld.teachingNeed && ld.teachingNeed.teacher && ld.teachingNeed.teacher.id;
        var groupId = ld.teachingNeed && ld.teachingNeed.studentsGroup && ld.teachingNeed.studentsGroup.id;
        var teacher = teacherId ? teacherById(teacherId) : null;
        var group = groupId ? groupAvailabilityById(groupId) : null;
        var teacherIssue = null;
        if (teacher) {
          var blocks = (teacher.blocks || []).filter(function (b) {
            return blockOverlapsLd(b, ld);
          });
          if (blocks.length) {
            teacherIssue = {
              teacherName: teacher.teacherName,
              blocks: blocks
            };
          }
        }
        var studentsIssue = null;
        if (group && group.totalStudents > 0) {
          var max = 0;
          for (var ts = ld.timeSlot; ts < ld.timeSlot + ld.duration; ts++) {
            var c = groupUnavailableCountAtSlot(group, ld.day, ts);
            if (c > max) max = c;
          }
          if (max > 0) {
            studentsIssue = {
              peakCount: max,
              totalStudents: group.totalStudents,
              studentsGroupId: groupId
            };
          }
        }
        ld.teacherUnavailability = teacherIssue;
        ld.studentsUnavailability = studentsIssue;
        ld.hasIssues = ld.conflicts.length > 0 || !!teacherIssue || !!studentsIssue;
      });
    }
    function blockOverlapsLd(block, ld) {
      if (block.day != ld.day) return false;
      var bStart = block.timeSlot;
      var bEnd = block.timeSlot + block.duration;
      var lStart = ld.timeSlot;
      var lEnd = ld.timeSlot + ld.duration;
      return bStart < lEnd && bEnd > lStart;
    }
    function reloadUnavailability() {
      if (!ctrl.aspect || !ctrl.entityId) {
        ctrl.unavailability = null;
        return;
      }
      scc.request(scc.PRIVATE_MODE, 'GetSchedulerUnavailability', {
        dataSetId: dataSets.getSelected().id,
        viewEntityType: ctrl.aspect,
        viewEntityId: ctrl.entityId
      }, function (response) {
        ctrl.unavailability = response.data || null;
        annotateUnavailabilityIssues();
      });
    }

    // Returns the StudentsGroup id whose orange shading should be applied to
    // empty cells at this moment, or null if no orange should be shown.
    //   STUDENTS_GROUP view -> the viewed group (always)
    //   TEACHER / CLASSROOM view -> the currently-dragged TN's group (only
    //   while grabbing a teaching need)
    function currentOrangeGroupId() {
      if (ctrl.aspect == 'STUDENTS_GROUP') return ctrl.entityId;
      if (ctrl.draggedTeachingNeed && ctrl.draggedTeachingNeed.studentsGroup) {
        return ctrl.draggedTeachingNeed.studentsGroup.id;
      }
      return null;
    }

    // Returns the Teacher id whose purple shading should be applied to
    // empty cells at this moment, or null if no purple should be shown.
    //   TEACHER view -> the viewed teacher (always)
    //   STUDENTS_GROUP / CLASSROOM view -> the dragged TN's teacher (only
    //   while grabbing)
    function currentPurpleTeacherId() {
      if (ctrl.aspect == 'TEACHER') return ctrl.entityId;
      if (ctrl.draggedTeachingNeed && ctrl.draggedTeachingNeed.teacher) {
        return ctrl.draggedTeachingNeed.teacher.id;
      }
      return null;
    }
    ctrl.getSlotStyle = function (ts) {
      if (!ctrl.unavailability) return {};

      // Purple takes priority over orange (matches the LD tint priority:
      // conflicts > teacher unavailable > students unavailable).
      var teacherId = currentPurpleTeacherId();
      if (teacherId) {
        var teacher = teacherById(teacherId);
        if (teacherBlockedAtSlot(teacher, ts.day, ts.timeSlot)) {
          return {
            'background-color': 'rgba(206, 147, 216, 0.6)'
          };
        }
      }
      var groupId = currentOrangeGroupId();
      if (groupId) {
        var group = groupAvailabilityById(groupId);
        if (group && group.totalStudents > 0) {
          var c = groupUnavailableCountAtSlot(group, ts.day, ts.timeSlot);
          if (c > 0) {
            var alpha = Math.min(1, c / group.totalStudents).toFixed(2);
            return {
              'background-color': 'rgba(255, 152, 0, ' + alpha + ')'
            };
          }
        }
      }
      return {};
    };
    ctrl.getSlotUnavailableCount = function (ts) {
      var groupId = currentOrangeGroupId();
      if (!groupId) return 0;
      var group = groupAvailabilityById(groupId);
      return groupUnavailableCountAtSlot(group, ts.day, ts.timeSlot);
    };
    function lessonDeliveryWebModelToDto(ld) {
      return {
        day: ld.day,
        timeSlot: ld.timeSlot,
        duration: ld.duration,
        teachingNeed: {
          id: ld.teachingNeed.id
        },
        comments: 'dummy'
      };
    }
    function teachingNeedDtoToWebModel(tn) {
      return {
        id: tn.id,
        studentsGroup: tn.studentsGroup,
        lesson: tn.lesson,
        teacher: tn.teacher,
        classroom: tn.classroom,
        timeSlotsPerWeek: tn.timeSlotsPerWeek,
        remainingTimeSlots: tn.timeSlotsPerWeek
      };
    }
    function downloadReport(openInNewTab) {
      reports.downloadReport('ScheduleTable', {
        outputType: 'PDF',
        teachersIds: ctrl.aspect == 'TEACHER' ? [ctrl.entityId] : [],
        studentsGroupsIds: ctrl.aspect == 'STUDENTS_GROUP' ? [ctrl.entityId] : [],
        classroomsIds: ctrl.aspect == 'CLASSROOM' ? [ctrl.entityId] : []
      }, $scope, openInNewTab);
    }
    function sendScheduleController($scope, $mdDialog) {
      var panelCtrl = this;
      panelCtrl.teachersSelection = 'ALL';
      panelCtrl.studentsSelection = 'ALL';
      panelCtrl.aspect = ctrl.aspect;
      panelCtrl.entityId = ctrl.entityId;
      panelCtrl.entity = getEntity();
      panelCtrl.emailSubject = "Ωρολόγιο πρόγραμμα";
      panelCtrl.emailText = "Σας αποστέλλω το ωρολόγιο πρόγραμμα. \n\nΜε εκτίμηση,";
      panelCtrl.closeDialog = function () {
        $mdDialog.cancel();
      };
      panelCtrl.sendPersonalizedSchedule = function () {
        revenuecat.requirePro(function () {
          var teacherIds = [];
          if (panelCtrl.teachersSelection == 'ALL') {
            teacherIds = ctrl.getAllTeachers().map(function (t) {
              return t.id;
            });
          } else if (panelCtrl.teachersSelection == 'SELECTED') {
            teacherIds = ctrl.lessonDeliveries.map(function (ld) {
              return ld.teachingNeed.teacher.id;
            });
            teacherIds = Array.from(new Set(teacherIds));
          }
          var studentsGroupsIds = [];
          if (panelCtrl.studentsSelection == 'ALL') {
            studentsGroupsIds = ctrl.getAllStudentsGroups().map(function (sg) {
              return sg.id;
            });
          } else if (panelCtrl.studentsSelection == 'SELECTED') {
            studentsGroupsIds = ctrl.lessonDeliveries.map(function (ld) {
              return ld.teachingNeed.studentsGroup.id;
            });
            studentsGroupsIds = Array.from(new Set(studentsGroupsIds));
          }
          reports.sendPersonalizedSchedule({
            emailSubject: panelCtrl.emailSubject,
            emailText: panelCtrl.emailText,
            reportType: 'PDF',
            teachersIds: teacherIds,
            studentsGroupsIds: studentsGroupsIds,
            classroomsIds: [],
            dataSetId: dataSets.getSelected().id
          }, $scope);
        });
      };
    }
    function smartScheduleController($scope, $mdDialog) {
      var panelCtrl = this;
      panelCtrl.lessonDeliveryDuration = 12;
      panelCtrl.schedulingScope = 'CURRENT_ENTITY';
      panelCtrl.getDataSetName = function () {
        return dataSets.getSelected().name;
      };
      panelCtrl.hasEntity = function () {
        return ctrl.aspect && ctrl.entityId;
      };
      panelCtrl.getEntityTypeLabel = function () {
        if (ctrl.aspect == 'TEACHER') {
          return 'του καθηγητή';
        } else if (ctrl.aspect == 'STUDENTS_GROUP') {
          return 'του διδακτικού τμήματος';
        } else if (ctrl.aspect == 'CLASSROOM') {
          return 'της αίθουσας';
        }
        return '';
      };
      panelCtrl.getEntityName = function () {
        var entity = getEntity();
        return entity ? entity.name : '';
      };
      panelCtrl.createSmartSchedule = function (ev) {
        var selectedDataSet = dataSets.getSelected();
        if (!selectedDataSet) {
          notifications.push("Επιλέξτε διδακτική περίοδο", notifications.ERROR);
          return;
        }
        var request = {
          dataSetId: selectedDataSet.id,
          lessonDeliveryDuration: panelCtrl.lessonDeliveryDuration
        };
        if (panelCtrl.schedulingScope == 'CURRENT_ENTITY' && panelCtrl.hasEntity()) {
          request.entityType = ctrl.aspect;
          request.entityId = ctrl.entityId;
        }
        scc.execute(scc.PRIVATE_MODE, "CreateAutomaticSchedule", request, $scope.form, function (response) {
          ctrl.reloadSchedule();
          notifications.push("Το ωρολόγιο πρόγραμμα συμπληρώθηκε", notifications.INFO);
          $mdDialog.hide();
        }, function (response) {
          notifications.push("Απρόσμενο σφάλμα", notifications.ERROR);
        });
      };
      panelCtrl.closeDialog = function () {
        $mdDialog.cancel();
      };
    }
    function aiScheduleController($scope, $mdDialog) {
      var panelCtrl = this;
      panelCtrl.lessonDeliveryDuration = 12;
      panelCtrl.schedulingScope = 'CURRENT_ENTITY';
      panelCtrl.userPreferences = '';
      panelCtrl.rules = [];
      panelCtrl.rulesParsed = false;
      panelCtrl.parsing = false;
      panelCtrl.scheduling = false;
      panelCtrl.busy = false;
      panelCtrl.getDataSetName = function () {
        return dataSets.getSelected().name;
      };
      panelCtrl.hasEntity = function () {
        return ctrl.aspect && ctrl.entityId;
      };
      panelCtrl.getEntityTypeLabel = function () {
        if (ctrl.aspect == 'TEACHER') {
          return 'του καθηγητή';
        } else if (ctrl.aspect == 'STUDENTS_GROUP') {
          return 'του διδακτικού τμήματος';
        } else if (ctrl.aspect == 'CLASSROOM') {
          return 'της αίθουσας';
        }
        return '';
      };
      panelCtrl.getEntityName = function () {
        var entity = getEntity();
        return entity ? entity.name : '';
      };
      function lessonName(rule) {
        return rule.lessonName || 'του μαθήματος';
      }
      function formatDuration(slots) {
        var totalMinutes = Math.max(0, Math.floor(Number(slots) || 0)) * 5;
        var hours = Math.floor(totalMinutes / 60);
        var minutes = totalMinutes % 60;
        if (hours === 0) {
          return minutes + ' λεπτά';
        }
        var hoursLabel = hours === 1 ? '1 ώρα' : hours + ' ώρες';
        if (minutes === 0) {
          return hoursLabel;
        }
        return hoursLabel + ' και ' + minutes + ' λεπτά';
      }
      function formatDays(n) {
        return n === 1 ? '1 ημέρα' : n + ' ημέρες';
      }
      panelCtrl.ruleLabel = function (rule) {
        if (!rule || !rule.type) return '';
        switch (rule.type) {
          case 'LESSON_EARLY_IN_WEEK':
            return 'Τα μαθήματα ' + lessonName(rule) + ' να γίνονται νωρίς στην εβδομάδα.';
          case 'LESSON_LATE_IN_WEEK':
            return 'Τα μαθήματα ' + lessonName(rule) + ' να γίνονται αργά στην εβδομάδα.';
          case 'MAX_DAILY_SLOTS_PER_TEACHER':
            if (rule.teacherId) {
              return 'Ο καθηγητής ' + (rule.teacherName || '') + ' να μην διδάσκει πάνω από ' + formatDuration(rule.maxSlots) + ' την ημέρα.';
            }
            return 'Κάθε καθηγητής να μην διδάσκει πάνω από ' + formatDuration(rule.maxSlots) + ' την ημέρα.';
          case 'MAX_DAILY_SLOTS_PER_GROUP':
            if (rule.studentsGroupId) {
              return 'Το τμήμα ' + (rule.studentsGroupName || '') + ' να μην παρακολουθεί πάνω από ' + formatDuration(rule.maxSlots) + ' μαθήματα την ημέρα.';
            }
            return 'Κάθε τμήμα να μην παρακολουθεί πάνω από ' + formatDuration(rule.maxSlots) + ' μαθήματα την ημέρα.';
          case 'MIN_DAYS_BETWEEN_LESSON_DELIVERIES':
            return 'Μεταξύ δύο μαθημάτων ' + lessonName(rule) + ' να μεσολαβεί τουλάχιστον ' + formatDays(rule.minDays) + (rule.studentsGroupId ? ' για το τμήμα ' + (rule.studentsGroupName || '') + '.' : '.');
          case 'FIRST_LESSON_OF_DAY_FOR_GROUP':
            return 'Το μάθημα ' + lessonName(rule) + ' να είναι το πρώτο της ημέρας' + (rule.studentsGroupId ? ' για το τμήμα ' + (rule.studentsGroupName || '') + '.' : '.');
          case 'LESSON_DELIVERY_BLOCK_SIZE':
            return 'Κάθε μάθημα ' + lessonName(rule) + ' να διαρκεί ' + formatDuration(rule.blockSize) + '.';
          default:
            return rule.description || '';
        }
      };
      panelCtrl.removeRule = function (index) {
        panelCtrl.rules.splice(index, 1);
      };
      panelCtrl.parseRules = function () {
        var selectedDataSet = dataSets.getSelected();
        if (!selectedDataSet) {
          notifications.push("Επιλέξτε διδακτική περίοδο", notifications.ERROR);
          return;
        }
        revenuecat.requirePro(function () {
          panelCtrl.parsing = true;
          panelCtrl.busy = true;
          scc.execute(scc.PRIVATE_MODE, "ParseSchedulePreferences", {
            dataSetId: selectedDataSet.id,
            userPreferences: panelCtrl.userPreferences
          }, $scope.form, function (response) {
            panelCtrl.parsing = false;
            panelCtrl.busy = false;
            panelCtrl.rules = response.data && response.data.rules || [];
            panelCtrl.rulesParsed = true;
          }, function (response) {
            panelCtrl.parsing = false;
            panelCtrl.busy = false;
            notifications.push("Δεν ήταν δυνατή η ανάλυση των προτιμήσεων", notifications.ERROR);
          });
        });
      };
      panelCtrl.createSchedule = function () {
        var selectedDataSet = dataSets.getSelected();
        if (!selectedDataSet) {
          notifications.push("Επιλέξτε διδακτική περίοδο", notifications.ERROR);
          return;
        }
        var request = {
          dataSetId: selectedDataSet.id,
          lessonDeliveryDuration: panelCtrl.lessonDeliveryDuration,
          rules: panelCtrl.rules
        };
        if (panelCtrl.schedulingScope == 'CURRENT_ENTITY' && panelCtrl.hasEntity()) {
          request.entityType = ctrl.aspect;
          request.entityId = ctrl.entityId;
        }
        panelCtrl.scheduling = true;
        panelCtrl.busy = true;
        scc.execute(scc.PRIVATE_MODE, "CreateRuleBasedSchedule", request, $scope.form, function (response) {
          panelCtrl.scheduling = false;
          panelCtrl.busy = false;
          ctrl.reloadSchedule();
          notifications.push("Το ωρολόγιο πρόγραμμα συμπληρώθηκε", notifications.INFO);
          $mdDialog.hide();
        }, function (response) {
          panelCtrl.scheduling = false;
          panelCtrl.busy = false;
          notifications.push("Απρόσμενο σφάλμα", notifications.ERROR);
        });
      };
      panelCtrl.closeDialog = function () {
        $mdDialog.cancel();
      };
    }
    function downloadScheduleController($scope, $mdDialog) {
      var panelCtrl = this;
      panelCtrl.teachersSelection = 'ALL';
      panelCtrl.studentsSelection = 'ALL';
      panelCtrl.classroomsSelection = 'ALL';
      panelCtrl.aspect = ctrl.aspect;
      panelCtrl.entityId = ctrl.entityId;
      panelCtrl.format = 'PDF';
      panelCtrl.entity = getEntity();
      panelCtrl.closeDialog = function () {
        $mdDialog.cancel();
      };
      panelCtrl.downloadPersonalizedSchedule = function () {
        revenuecat.requirePro(function () {
          var teacherIds = [];
          if (panelCtrl.teachersSelection == 'ALL') {
            teacherIds = ctrl.getAllTeachers().map(function (t) {
              return t.id;
            });
          } else if (panelCtrl.teachersSelection == 'SELECTED') {
            teacherIds = ctrl.lessonDeliveries.map(function (ld) {
              return ld.teachingNeed.teacher.id;
            });
            teacherIds = Array.from(new Set(teacherIds));
          }
          var studentsGroupsIds = [];
          if (panelCtrl.studentsSelection == 'ALL') {
            studentsGroupsIds = ctrl.getAllStudentsGroups().map(function (sg) {
              return sg.id;
            });
          } else if (panelCtrl.studentsSelection == 'SELECTED') {
            studentsGroupsIds = ctrl.lessonDeliveries.map(function (ld) {
              return ld.teachingNeed.studentsGroup.id;
            });
            studentsGroupsIds = Array.from(new Set(studentsGroupsIds));
          }
          var classroomsIds = [];
          if (panelCtrl.classroomsSelection == 'ALL') {
            classroomsIds = ctrl.getAllClassrooms().map(function (sg) {
              return sg.id;
            });
          } else if (panelCtrl.classroomsSelection == 'SELECTED') {
            classroomsIds = ctrl.lessonDeliveries.map(function (ld) {
              return ld.teachingNeed.classroom.id;
            });
            classroomsIds = Array.from(new Set(classroomsIds));
          }
          reports.downloadReport('ScheduleTable', {
            outputType: panelCtrl.format,
            teachersIds: teacherIds,
            studentsGroupsIds: studentsGroupsIds,
            classroomsIds: classroomsIds,
            dataSetId: dataSets.getSelected().id
          }, $scope, false);
        });
      };
    }
    ctrl.isDatasetSelected = function () {
      if (dataSets.getSelected()) {
        return true;
      }
      return false;
    };
    ctrl.reloadSchedule = function () {
      var req = {
        dataSetId: dataSets.getSelected().id,
        aspect: ctrl.aspect,
        entityId: ctrl.entityId
      };
      scc.execute(scc.PRIVATE_MODE, "GetSchedule", req, $scope.form, function (response) {
        ctrl.conflicts = response.data.conflicts;
        ctrl.teachingNeeds = response.data.teachingNeeds.map(teachingNeedDtoToWebModel);
        ctrl.lessonDeliveries = response.data.lessonDeliveries.map(lessonDeliveryDtoToWebModel);
        reloadUnavailability();
      }, function (response) {
        notifications.push("Απρόσμενο σφάλμα", notifications.ERROR);
      });
    };
    ctrl.updateSchedule = function () {
      var req = {
        dataSetId: dataSets.getSelected().id,
        aspect: ctrl.aspect,
        entityId: ctrl.entityId,
        lessonDeliveries: ctrl.lessonDeliveries.map(lessonDeliveryWebModelToDto)
      };
      scc.execute(scc.PRIVATE_MODE, "UpdateSchedule", req, $scope.form, function (response) {
        ctrl.conflicts = response.data.conflicts;
        ctrl.teachingNeeds = response.data.teachingNeeds.map(teachingNeedDtoToWebModel);
        ctrl.lessonDeliveries = response.data.lessonDeliveries.map(lessonDeliveryDtoToWebModel);
        annotateUnavailabilityIssues();
      }, function (response) {
        notifications.push("Απρόσμενο σφάλμα", notifications.ERROR);
      });
    };
    ctrl.getSelectedAspectEntities = function () {
      if ("TEACHER" == ctrl.selectedAspect) {
        return ctrl.getAllTeachers();
      } else if ("CLASSROOM" == ctrl.selectedAspect) {
        return ctrl.getAllClassrooms();
      } else {
        return ctrl.getAllStudentsGroups();
      }
    };
    ctrl.showScheduleForEntity = function (aspect, id) {
      $location.path('scheduler').search({
        entityId: id,
        aspect: aspect
      });
    };
    ctrl.showConflicts = function (ev, ld) {
      ctrl.showLessonDeliveryIssues(ev, ld);
    };
    ctrl.showLessonDeliveryIssues = function (ev, ld) {
      if (!ld.hasIssues) {
        return;
      }
      $mdDialog.show({
        targetEvent: ev,
        templateUrl: 'app/main/scc/components/scheduler/unavailabilityDialog.html',
        controller: function controller($mdDialog, lessonDelivery) {
          var dialogCtrl = this;
          this.lessonDelivery = lessonDelivery;
          this.teacherConflicts = [];
          this.classroomConflicts = [];
          this.studentsGroupConflicts = [];
          (lessonDelivery.conflicts || []).forEach(function (c) {
            if (c.entityType == 'TEACHER') dialogCtrl.teacherConflicts.push(c);else if (c.entityType == 'CLASSROOM') dialogCtrl.classroomConflicts.push(c);else if (c.entityType == 'STUDENTS_GROUP') dialogCtrl.studentsGroupConflicts.push(c);
          });
          this.teacherUnavailability = lessonDelivery.teacherUnavailability;
          this.studentsUnavailability = lessonDelivery.studentsUnavailability;
          this.unavailableStudents = null;
          if (this.studentsUnavailability) {
            scc.request(scc.PRIVATE_MODE, 'GetSlotUnavailableStudents', {
              dataSetId: dataSets.getSelected().id,
              day: lessonDelivery.day,
              timeSlot: lessonDelivery.timeSlot,
              duration: lessonDelivery.duration,
              studentsGroupId: lessonDelivery.teachingNeed.studentsGroup.id
            }, function (response) {
              dialogCtrl.unavailableStudents = response.data && response.data.students || [];
            });
          }
          this.closeDialog = function () {
            $mdDialog.hide();
          };
          this.showScheduleForEntity = function (entityType, entityId) {
            $mdDialog.hide();
            ctrl.showScheduleForEntity(entityType, entityId);
          };
        },
        controllerAs: '$ctrl',
        locals: {
          lessonDelivery: ld
        }
      });
    };
    ctrl.showSlotUnavailability = function (ev, ts) {
      if (ctrl.getSlotUnavailableCount(ts) <= 0) return;
      ev.stopPropagation();
      var groupId = currentOrangeGroupId();
      $mdDialog.show({
        targetEvent: ev,
        templateUrl: 'app/main/scc/components/scheduler/slotUnavailabilityDialog.html',
        controller: function controller($mdDialog) {
          var dialogCtrl = this;
          this.day = ts.day;
          this.timeSlot = ts.timeSlot;
          this.students = null;
          scc.request(scc.PRIVATE_MODE, 'GetSlotUnavailableStudents', {
            dataSetId: dataSets.getSelected().id,
            day: ts.day,
            timeSlot: ts.timeSlot,
            studentsGroupId: groupId
          }, function (response) {
            dialogCtrl.students = response.data && response.data.students || [];
          });
          this.closeDialog = function () {
            $mdDialog.hide();
          };
        },
        controllerAs: '$ctrl'
      });
    };
    ctrl.downloadReport = function () {
      downloadReport(false);
    };
    ctrl.printReport = function () {
      downloadReport(true);
    };
    ctrl.clearSchedule = function () {
      var confirmText = 'Είστε βέβαιοι ότι θέλετε να κάνετε εκκαθάριση του το ωρολόγιου προγράμματος ';
      if (ctrl.aspect == 'TEACHER') confirmText += "του καθηγητή ";else if (ctrl.aspect == 'STUDENTS_GROUP') confirmText += "του διδακτικού τμήματος ";else if (ctrl.aspect == 'CLASSROOM') confirmText += "της αίθουσας ";
      confirmText += getEntity().name + ';';
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση καθαρισμού').textContent(confirmText).ariaLabel('Επιβεβαίωση καθαρισμού')
      //.targetEvent(ev)
      .ok('ΚΑΘΑΡΙΣΜΟΣ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        ctrl.lessonDeliveries;
        var req = {
          dataSetId: dataSets.getSelected().id,
          aspect: ctrl.aspect,
          entityId: ctrl.entityId,
          lessonDeliveries: []
        };
        scc.execute(scc.PRIVATE_MODE, "UpdateSchedule", req, $scope.form, function (response) {
          ctrl.conflicts = response.data.conflicts;
          ctrl.teachingNeeds = response.data.teachingNeeds.map(teachingNeedDtoToWebModel);
          ctrl.lessonDeliveries = response.data.lessonDeliveries.map(lessonDeliveryDtoToWebModel);
          notifications.push("Έγινε εκκαθάριση", notifications.INFO);
        }, function (response) {
          notifications.push("Απρόσμενο σφάλμα", notifications.ERROR);
        });
      });
    };
    this.showEditPanel = function (ev, sc, mode) {
      $mdDialog.show({
        controller: schoolDialogController,
        controllerAs: '$ctrl',
        templateUrl: 'app/main/scc/components/school/edit-school-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          school: sc,
          mode: mode
        }
      });
    };
    this.showSendSchedulePanel = function (ev) {
      $mdDialog.show({
        controller: sendScheduleController,
        controllerAs: '$ctrl',
        templateUrl: 'app/main/scc/components/scheduler/sendScheduleDialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {}
      });
    };
    this.showSmartSchedulingPanel = function (ev) {
      $mdDialog.show({
        controller: smartScheduleController,
        controllerAs: '$ctrl',
        templateUrl: 'app/main/scc/components/scheduler/smartScheduleDialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {}
      });
    };
    this.showAiSchedulingPanel = function (ev) {
      $mdDialog.show({
        controller: aiScheduleController,
        controllerAs: '$ctrl',
        templateUrl: 'app/main/scc/components/scheduler/aiScheduleDialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {}
      });
    };
    this.showDownloadSchedulePanel = function (ev) {
      $mdDialog.show({
        controller: downloadScheduleController,
        controllerAs: '$ctrl',
        templateUrl: 'app/main/scc/components/scheduler/downloadScheduleDialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {}
      });
    };
    ctrl.aspect = $stateParams.aspect;
    ctrl.entityId = $stateParams.entityId;
    ctrl.selectedAspect = ctrl.aspect;
    ctrl.selectedEntityId = ctrl.entityId;
    if (ctrl.aspect != null && ctrl.entityId != null) {
      ctrl.reloadSchedule();
    }
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.reset-password', []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.scc.public.reset-password', {
      url: '/reset-password',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.scc.public.reset-password': {
          templateUrl: 'app/main/scc/components/reset-password/reset-password.html',
          controller: 'ResetPasswordController as vm'
        }
      },
      bodyClass: 'reset-password'
    });

    // State
    $stateProvider.state('app.scc.public.reset-password-success', {
      url: '/reset-password-success',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.scc.public.reset-password-success': {
          templateUrl: 'app/main/scc/components/reset-password/reset-password-success.html',
          controller: 'ResetPasswordController as vm'
        }
      },
      bodyClass: 'reset-password-success'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/reset-password');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.reset-password').controller('ResetPasswordController', ResetPasswordController);

  /** @ngInject */
  function ResetPasswordController($location, scc, $scope, $state) {
    // Data
    var ctrl = this;
    ctrl.req = {
      passwordResetMac: $location.search().mac,
      password: null,
      passwordConfirmation: null
    };
    //ctrl.mac = $location.search().mac;

    ctrl.resetPassword = function () {
      scc.execute(scc.PUBLIC_MODE, 'ResetPassword', ctrl.req, $scope.form, function () {
        $state.go('app.scc.public.reset-password-success');
      });
    };

    // Methods

    //////////
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.register', []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.scc.public.register', {
      url: '/register',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.scc.public.register': {
          templateUrl: 'app/main/scc/components/register/register.html',
          controller: 'RegisterController as vm'
        }
      },
      bodyClass: 'register'
    });

    // State
    $stateProvider.state('app.scc.public.register-success', {
      url: '/register-success',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.scc.public.register-success': {
          templateUrl: 'app/main/scc/components/register/register-success.html',
          controller: 'RegisterController as vm'
        }
      },
      bodyClass: 'register-success'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/register');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.register').controller('RegisterController', RegisterController);

  /** @ngInject */
  function RegisterController($scope, scc, $state) {
    var ctrl = this;
    ctrl.req = {
      user: {
        languageCode: 'en'
      }
    };
    this.register = function () {
      scc.execute(scc.PUBLIC_MODE, 'Register', ctrl.req, $scope.form, function () {
        $state.go('app.scc.public.register-success');
      });
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.offers-table', []).component('offersTable', {
    templateUrl: 'app/main/scc/components/offers-table/offers-table.html',
    bindings: {
      selectedProduct: '=',
      selectedDuration: '=',
      selectedCost: '=',
      offersList: '<'
    },
    controller: 'OffersTableController'
  }).config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider) {
    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/offers-table');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.offers-table').controller('OffersTableController', OffersTableController);

  /** @ngInject */
  function OffersTableController($scope) {
    var ctrl = this;
    $scope.$watch('$ctrl.offersList', function (offersList) {
      var i;
      for (i = 0; i < offersList.length; i++) {
        if (offersList[i].allPriceOptions) {
          var options = offersList[i].allPriceOptions;
          offersList[i].options = [];
          var j;
          for (j = 0; j < Object.keys(options).length; j++) {
            var duration = Object.keys(options)[j];
            var option = {
              duration: duration,
              cost: options[duration],
              product: offersList[i].product
            };
            offersList[i].options.push(option);
          }
        }
      }
    });
    var offersList = this.offersList;
    this.select = function (option) {
      ctrl.selectedProduct = option.product;
      ctrl.selectedDuration = option.duration;
      ctrl.selectedCost = option.cost;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.notes').controller('NotesController', NotesController);

  /** @ngInject */
  function NotesController($document, $timeout, $scope, $mdSidenav, NotesService, LabelsService, $mdDialog) {
    var vm = this;

    // Data
    vm.notes = NotesService.data;
    vm.labels = LabelsService.data;
    vm.search = '';
    vm.searchToolbar = false;
    vm.filters = {
      archive: false
    };
    vm.labelFilterIds = [];
    vm.noteListType = 'notes';

    // Methods
    vm.filterChange = filterChange;
    vm.openSearchToolbar = openSearchToolbar;
    vm.closeSearchToolbar = closeSearchToolbar;
    vm.editNote = editNote;
    vm.deleteLabel = deleteLabel;
    vm.toggleSidenav = toggleSidenav;
    vm.addNewLabel = LabelsService.addLabel;

    //////////

    /**
     * Change Notes Filter
     * @param type
     */
    function filterChange(type) {
      vm.noteListType = type;
      if (type === 'notes') {
        vm.labelFilterIds = [];
        vm.filters = {
          archive: false
        };
      } else if (type === 'archive') {
        vm.labelFilterIds = [];
        vm.filters = {
          archive: true
        };
      } else if (type === 'reminders') {
        vm.labelFilterIds = [];
        vm.filters = {
          reminder: '',
          archive: false
        };
      } else if (angular.isObject(type)) {
        vm.labelFilterIds = [];
        vm.labelFilterIds.push(type.id);
      }
      $mdSidenav('main-sidenav').close();
    }

    /**
     * Edit Note
     * @param ev
     * @param noteId
     */
    function editNote(ev, noteId) {
      $mdDialog.show({
        template: '<md-dialog ms-scroll><ms-note-form note-type="\'edit\'" note-id="\'' + noteId + '\'"></ms-note-form></md-dialog>',
        parent: $document.find('#notes'),
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true
      });
    }

    /**
     * Delete Label
     * @param ev
     * @param label
     */
    function deleteLabel(ev, label) {
      var confirm = $mdDialog.confirm().title('Are you sure want to delete the label?').htmlContent('The "' + label.name + '" label will be deleted permanently.').ariaLabel('delete label').targetEvent(ev).ok('OK').cancel('CANCEL');
      $mdDialog.show(confirm).then(function () {
        LabelsService.deleteLabel(label);
      });
    }

    /**
     * Open Search Toolbar
     */
    function openSearchToolbar() {
      vm.searchToolbar = true;
      $timeout(function () {
        angular.element($document.find('#search-notes-input')).trigger('focus');
      });
      $document.on('keyup', escKeyEvent);
    }

    /**
     * Close Search Toolbar
     */
    function closeSearchToolbar() {
      $scope.$evalAsync(function () {
        vm.searchToolbar = false;
        vm.search = '';
      });
      $document.off('keyup', escKeyEvent);
    }

    /**
     * Escape key event
     */
    function escKeyEvent(e) {
      if (e.keyCode === 27) {
        closeSearchToolbar();
      }
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Array prototype
     *
     * Get by id
     *
     * @param value
     * @returns {T}
     */
    Array.prototype.getById = function (value) {
      return this.filter(function (x) {
        return x.id === value;
      })[0];
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.monitoring', ['md.data.table']).config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    $stateProvider.state('app.scc.private.monitoring', {
      url: '/monitoring',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/monitoring/monitoring.html',
          controller: 'MonitoringController as $ctrl'
        }
      }
    });
    $translatePartialLoaderProvider.addPart('app/main/scc/components/monitoring');
    msNavigationServiceProvider.saveItem('monitoring', {
      title: 'SCC',
      svgIcon: 'monitoring',
      state: 'app.scc.private.monitoring',
      translate: 'SCC.MONITORING.NAV',
      weight: 200
    });
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.monitoring').controller('MonitoringController', MonitoringController);

  /** @ngInject */
  function MonitoringController($scope, $rootScope, scc, schools, $interval, $timeout) {
    var ctrl = this;
    ctrl.numberOfActiveTeachers = 0;
    ctrl.numberOfActiveStudentsGroups = 0;
    ctrl.numberOfActiveStudents = 0;
    ctrl.currentSessions = [];
    ctrl.previousSessions = [];
    ctrl.upcomingSessions = [];
    ctrl.loaded = false;
    ctrl.schoolClock = '';
    ctrl.schoolName = '';
    var clockInterval = null;
    var refreshTimeout = null;
    var schoolSelectedDeregister = null;
    ctrl.hasSchool = function () {
      return !!schools.getSelectedSchool();
    };
    ctrl.$onInit = function () {
      ctrl.loadData();
      startClock();
      scheduleNextRefresh();
      schoolSelectedDeregister = $rootScope.$on('scc.school.selected', function () {
        ctrl.loaded = false;
        ctrl.loadData();
      });
      $scope.$on('$destroy', function () {
        if (clockInterval) {
          $interval.cancel(clockInterval);
        }
        if (refreshTimeout) {
          $timeout.cancel(refreshTimeout);
        }
        if (schoolSelectedDeregister) {
          schoolSelectedDeregister();
        }
      });
    };
    ctrl.loadData = function () {
      var selectedSchool = schools.getSelectedSchool();
      if (!selectedSchool) {
        return;
      }
      ctrl.schoolName = selectedSchool.name;
      scc.request(scc.PRIVATE_MODE, 'GetSchoolMonitoring', {
        schoolId: selectedSchool.id
      }, function (response) {
        ctrl.numberOfActiveTeachers = response.data.numberOfActiveTeachers;
        ctrl.numberOfActiveStudentsGroups = response.data.numberOfActiveStudentsGroups;
        ctrl.numberOfActiveStudents = response.data.numberOfActiveStudents;
        ctrl.currentSessions = response.data.currentSessions;
        ctrl.previousSessions = response.data.previousSessions;
        ctrl.upcomingSessions = response.data.upcomingSessions;
        ctrl.loaded = true;
      });
    };
    function startClock() {
      updateClock();
      clockInterval = $interval(updateClock, 1000);
    }
    function updateClock() {
      var selectedSchool = schools.getSelectedSchool();
      var tz = selectedSchool && selectedSchool.timezone ? selectedSchool.timezone : 'Europe/Athens';
      var now = new Date();
      ctrl.schoolClock = now.toLocaleTimeString('el-GR', {
        timeZone: tz,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    }
    function scheduleNextRefresh() {
      var now = new Date();
      var minutes = now.getMinutes();
      var nextMinute = Math.ceil((minutes + 1) / 5) * 5;
      var next = new Date(now);
      next.setMinutes(nextMinute, 1, 0);
      if (next <= now) {
        next.setMinutes(next.getMinutes() + 5);
      }
      var delay = next.getTime() - now.getTime();
      refreshTimeout = $timeout(function () {
        ctrl.loadData();
        scheduleNextRefresh();
      }, delay);
    }
    ctrl.formatTime = function (timeSlot) {
      var totalMinutes = timeSlot * 5;
      var hours = Math.floor(totalMinutes / 60);
      var mins = totalMinutes % 60;
      return (hours < 10 ? '0' : '') + hours + ':' + (mins < 10 ? '0' : '') + mins;
    };
    function getCurrentMinutes() {
      var selectedSchool = schools.getSelectedSchool();
      var tz = selectedSchool && selectedSchool.timezone ? selectedSchool.timezone : 'Europe/Athens';
      var now = new Date();
      var timeStr = now.toLocaleTimeString('en-US', {
        timeZone: tz,
        hour12: false,
        hour: '2-digit',
        minute: '2-digit'
      });
      var parts = timeStr.split(':');
      return parseInt(parts[0]) * 60 + parseInt(parts[1]);
    }
    function formatDuration(minutes) {
      if (minutes < 60) {
        return minutes + ' λεπτά';
      }
      var hours = Math.floor(minutes / 60);
      var mins = minutes % 60;
      if (mins === 0) {
        return hours + (hours === 1 ? ' ώρα' : ' ώρες');
      }
      return hours + (hours === 1 ? ' ώρα' : ' ώρες') + ' ' + mins + ' λεπτά';
    }
    ctrl.finishedAgo = function (session) {
      var endMinutes = (session.timeSlot + session.duration) * 5;
      var diff = getCurrentMinutes() - endMinutes;
      if (diff < 0) {
        diff = 0;
      }
      return formatDuration(diff);
    };
    ctrl.startsIn = function (session) {
      var startMinutes = session.timeSlot * 5;
      var diff = startMinutes - getCurrentMinutes();
      if (diff < 0) {
        diff = 0;
      }
      return formatDuration(diff);
    };
    ctrl.sessionProgress = function (session) {
      var currentMinutes = getCurrentMinutes();
      var startMinutes = session.timeSlot * 5;
      var durationMinutes = session.duration * 5;
      var elapsed = currentMinutes - startMinutes;
      if (elapsed < 0) {
        return 0;
      }
      if (elapsed >= durationMinutes) {
        return 100;
      }
      return Math.round(elapsed / durationMinutes * 100);
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.login', []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.scc.public.login', {
      url: '/login?redirectState&redirectParams',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.scc.public.login': {
          templateUrl: 'app/main/scc/components/login/login.html',
          controller: 'LoginController as vm'
        }
      },
      bodyClass: 'login'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/login');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.login').controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($location, authentication, notifications, $scope, $controller, $state, $stateParams) {
    this.req = {
      email: "",
      password: ""
    };
    var redirectState = $stateParams.redirectState;
    var redirectParams = $stateParams.redirectParams ? JSON.parse($stateParams.redirectParams) : null;
    this.login = function () {
      authentication.login(this.req, $scope, function () {
        notifications.push('Συνδεθήκατε επιτυχώς', notifications.INFO);
        if (redirectState) {
          $state.go(redirectState, redirectParams);
        } else {
          $state.go('app.scc.private.data-set');
        }
      });
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.lesson-delivery', ['md.data.table']).config(config).run(run);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.scc.private.lesson-delivery', {
      url: '/lesson-delivery',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/lesson-delivery/lesson-delivery.html',
          controller: 'LessonDeliveryController as $ctrl'
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/lesson-delivery');

    //        msNavigationServiceProvider.saveItem('lesson-delivery', {
    //            title    : 'SCC',
    //            svgIcon  : 'lesson-delivery',
    //            state    : 'app.scc.private.lesson-delivery',
    //            /*stateParams: {
    //                'param1': 'page'
    //             },*/
    //            translate: 'SCC.LESSON_DELIVERY.NAV',
    //            weight   : 1
    //        });
  }

  /** @ngInject */
  function run($rootScope, teachers) {
    //    	$rootScope.$on('scc.school.selected', teachers.init);
    //    	$rootScope.$on('scc.logout', teachers.cleanup);	
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.lesson-delivery').controller('LessonDeliveryController', LessonDeliveryController);

  /** @ngInject */
  function LessonDeliveryController($state, $timeout, $scope, $controller, teachers, schools, $filter, $mdDialog, notifications, $stateParams, checkState, utils) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;
    ctrl.tab = $stateParams.tab;
    ctrl.tabsCaptions = {
      notes: $filter('translate')('SCC.LESSON_DELIVERY.NOTES_TAB'),
      absences: $filter('translate')('SCC.LESSON_DELIVERY.ABSENCES_TAB')
    };
    if (!ctrl.tab) {
      ctrl.tab = "notes";
    }
    ctrl.selectedTab = ctrl.tab;
    ctrl.$onInit = function () {
      //			ctrl.teacher = teachers.get(ctrl.teacherId);
    };
    $scope.$watch("$ctrl.tab", function (newVal, oldVal) {
      if (newVal != ctrl.selectedTab && angular.isDefined(ctrl.dirty) && ctrl.dirty() && !checkState.confirmUserAction()) {
        ctrl.tab = oldVal;
      } else {
        ctrl.selectedTab = newVal;
      }
    });
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.lesson-delivery').controller('LessonDeliveryNotesController', LessonDeliveryNotesController);
  angular.module('app.scc.lesson-delivery').component("lessonDeliveryNotes", {
    templateUrl: 'app/main/scc/components/lesson-delivery/lesson-delivery-notes.html',
    bindings: {
      dirty: '='
    },
    controller: 'LessonDeliveryNotesController'
  });

  /** @ngInject */
  function LessonDeliveryNotesController($scope, scc, checkState) {
    var ctrl = this;
    ctrl.notes = [{
      concernsStudent: null,
      title: "Homework",
      content: "Ασκήσεις 1,2 και 3",
      access: "ALL",
      lastEditDate: "14/03/2017"
    }, {
      concernsStudent: null,
      title: "TODO",
      content: "Μη ξεχάσω να προετοιμάσω το μάθημα",
      access: "TEACHER"
    }, {
      concernsStudent: 12,
      title: "Καλή απόδοση",
      content: "Καλή απόδοση σήμερα",
      access: "TEACHER_ADMIN_STUDENT"
    }];
    ctrl.editable = false;
    ctrl.$onInit = function () {};
    ctrl.startEditing = function () {
      ctrl.editable = true;
      checkState.checkFormOnStateChange($scope, $scope.form);
    };
    ctrl.save = function () {
      ctrl.editable = false;
      $scope.form.$setPristine();
    };
    ctrl.cancelEditing = function () {
      ctrl.$onInit();
      ctrl.editable = false;
      $scope.form.$setPristine();
    };
    ctrl.dirty = function () {
      return angular.isDefined($scope.form) && !$scope.form.$pristine;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.local-date-picker', []).config(config);

  /** @ngInject */
  function config() {}
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.local-date-picker').controller('LocalDatePickerController', LocalDatePickerController);
  angular.module('app.scc.local-date-picker').component('localDatePicker', {
    templateUrl: 'app/main/scc/components/local-date-picker/local-date-picker.html',
    controller: 'LocalDatePickerController',
    bindings: {
      localDate: '=',
      disabled: '<',
      inputName: '<',
      errors: '<'
    }
  });

  /** @ngInject */
  function LocalDatePickerController($scope, utils) {
    var ctrl = this;
    ctrl.date = utils.delocalizeDate(ctrl.localDate);
    $scope.$watch("$ctrl.date", function (newValue, oldValue) {
      var newLocaleDate = utils.localizeDate(newValue);
      if (newLocaleDate != ctrl.localDate) {
        ctrl.localDate = newLocaleDate;
      }
    });
    $scope.$watch("$ctrl.localDate", function (newValue, oldValue) {
      var oldLocaleDate = utils.localizeDate(ctrl.date);
      if (newValue != oldLocaleDate) {
        ctrl.date = utils.delocalizeDate(newValue);
      }
    });
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.lesson', ['md.data.table']).config(config).run(run);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.scc.private.lesson', {
      url: '/lesson',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/lesson/lesson.html',
          controller: 'LessonController as $ctrl'
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/lesson');
    msNavigationServiceProvider.saveItem('lesson', {
      title: 'SCC',
      svgIcon: 'lesson',
      state: 'app.scc.private.lesson',
      /*stateParams: {
          'param1': 'page'
       },*/
      translate: 'SCC.LESSON.NAV',
      weight: 500
    });
  }

  /** @ngInject */
  function run($rootScope, lessons) {
    $rootScope.$on('scc.school.selected', lessons.init);
    $rootScope.$on('scc.logout', lessons.cleanup);
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.lesson').factory('lessons', lessonsService);

  /** @ngInject */
  function lessonsService(daoFactory) {
    return daoFactory.createDao('lesson', 'Lesson');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.lesson').controller('LessonController', LessonController);

  /** @ngInject */
  function LessonController($scope, $controller, lessons) {
    var ctrl = $controller('GenericCrudController', {
      $scope: $scope
    });
    angular.extend(ctrl, {
      service: lessons,
      entityType: "lesson",
      translationNameSpace: "SCC.LESSON",
      lesson: {}
    });
    return ctrl;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.forgot-password', []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.scc.public.forgot-password', {
      url: '/forgot-password',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.scc.public.forgot-password': {
          templateUrl: 'app/main/scc/components/forgot-password/forgot-password.html',
          controller: 'ForgotPasswordController as vm'
        }
      },
      bodyClass: 'forgot-password'
    });

    // State
    $stateProvider.state('app.scc.public.forgot-password-mail-sent', {
      url: '/forgot-password-mail-sent',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.scc.public.forgot-password-mail-sent': {
          templateUrl: 'app/main/scc/components/forgot-password/forgot-password-mail-sent.html',
          controller: 'RegisterController as vm'
        }
      },
      bodyClass: 'forgot-password-mail-sent'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/forgot-password');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.forgot-password').controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController(scc, $scope, $state) {
    var ctrl = this;
    ctrl.req = {
      email: ""
    };
    ctrl.demandPasswordReset = function () {
      scc.execute(scc.PUBLIC_MODE, 'DemandPasswordReset', ctrl.req, $scope.form, function () {
        $state.go('app.scc.public.forgot-password-mail-sent');
      });
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.errors-container', []).config(config);

  /** @ngInject */
  function config() {}
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.errors-container').component('formErrorsContainer', {
    templateUrl: 'app/main/scc/components/errors-container/form-errors-container.html',
    controller: function FormErrorsContainerController() {},
    bindings: {
      form: '<',
      translationScope: '@'
    }
  });

  /** @ngInject */
  function FormErrorsContainerController() {}
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.errors-container').component('errorsContainer', {
    templateUrl: 'app/main/scc/components/errors-container/errors-container.html',
    controller: function ErrorsContainerController() {},
    bindings: {
      errors: '<',
      translationScope: '@'
    }
  });

  /** @ngInject */
  function ErrorsContainerController() {}
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.duration-picker', [/*'ngMaterial', 'ngMessages'*/]).config(config);

  /** @ngInject */
  function config() {}
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.duration-picker').component('durationPicker', {
    bindings: {
      minSlots: '<?',
      maxSlots: '<?',
      maxHours: '<?',
      label: '@?',
      required: '<?',
      errors: '<?',
      name: '<?',
      readonly: '<?'
    },
    require: {
      ngModelCtrl: 'ngModel'
    },
    controller: DurationPickerCtrl,
    templateUrl: 'app/main/scc/components/duration-picker/duration-picker.html' // <-- extracted here
  });
  function DurationPickerCtrl() {
    'ngInject';

    var $ctrl = this;
    $ctrl.minutesOptions = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
    $ctrl.hourOptions = Array.from({
      length: 169
    }, function (_, i) {
      return i;
    });
    $ctrl.hours = 0;
    $ctrl.minutes = 0;
    $ctrl.totalSlots = null;
    $ctrl.$onInit = function () {
      $ctrl.ngModelCtrl.$render = function () {
        applyModelToParts($ctrl.ngModelCtrl.$viewValue); // <-- not $ctrl.ngModel
      };
      $ctrl.ngModelCtrl.$validators.slotRange = function (modelValue) {
        if ($ctrl.required && (modelValue === null || modelValue === undefined)) return false;
        if (!angular.isNumber(modelValue)) return true;
        if (angular.isNumber($ctrl.minSlots) && modelValue < $ctrl.minSlots) return false;
        if (angular.isNumber($ctrl.maxSlots) && modelValue > $ctrl.maxSlots) return false;
        return true;
      };
      if (angular.isNumber($ctrl.maxHours)) {
        $ctrl.effectiveMaxHours = Math.max(0, Math.floor($ctrl.maxHours));
      } else if (angular.isNumber($ctrl.maxSlots)) {
        $ctrl.effectiveMaxHours = Math.floor($ctrl.maxSlots / 12);
      } else {
        $ctrl.effectiveMaxHours = null;
      }
      applyModelToParts($ctrl.ngModelCtrl.$viewValue);
    };
    $ctrl.$onChanges = function (changes) {
      if (changes.maxSlots && !changes.maxSlots.isFirstChange() || changes.maxHours && !changes.maxHours.isFirstChange()) {
        if (angular.isNumber($ctrl.maxHours)) {
          $ctrl.effectiveMaxHours = Math.max(0, Math.floor($ctrl.maxHours));
        } else if (angular.isNumber($ctrl.maxSlots)) {
          $ctrl.effectiveMaxHours = Math.floor($ctrl.maxSlots / 12);
        } else {
          $ctrl.effectiveMaxHours = null;
        }
      }
    };
    $ctrl.hasErrors = function () {
      return !!$ctrl.errors && Object.keys($ctrl.errors).length > 0;
    };
    $ctrl.onPartsChanged = function () {
      var h = Math.max(0, Math.floor(Number($ctrl.hours) || 0));
      if ($ctrl.effectiveMaxHours !== null) {
        h = Math.min(h, $ctrl.effectiveMaxHours);
      }
      var m = Number($ctrl.minutes) || 0;
      var slots = h * 12 + Math.floor(m / 5);
      if (angular.isNumber($ctrl.maxSlots) && slots > $ctrl.maxSlots) {
        slots = $ctrl.maxSlots;
      }
      if (angular.isNumber($ctrl.minSlots) && slots < $ctrl.minSlots) {
        slots = $ctrl.minSlots;
      }
      var totalMinutes = slots * 5;
      h = Math.floor(totalMinutes / 60);
      m = totalMinutes % 60;
      if ($ctrl.effectiveMaxHours !== null) {
        h = Math.min(h, $ctrl.effectiveMaxHours);
      }
      $ctrl.hours = h;
      $ctrl.minutes = m;
      $ctrl.totalSlots = slots;
      $ctrl.ngModelCtrl.$setViewValue(slots);
      $ctrl.ngModelCtrl.$validate();
    };
    function applyModelToParts(slots) {
      if (!angular.isNumber(slots)) {
        $ctrl.hours = 0;
        $ctrl.minutes = 0;
        $ctrl.totalSlots = null;
        return;
      }
      var totalMinutes = Math.max(0, Math.floor(slots)) * 5;
      var h = Math.floor(totalMinutes / 60);
      var m = totalMinutes % 60;
      if ($ctrl.effectiveMaxHours !== null) {
        h = Math.min(h, $ctrl.effectiveMaxHours);
      }
      $ctrl.hours = h;
      $ctrl.minutes = m;
      $ctrl.totalSlots = Math.floor(slots);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.data-set', ['md.data.table']).config(config).run(run);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.scc.private.data-set', {
      url: '/data-set',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/data-set/data-set-list.html',
          controller: 'DataSetListController as $ctrl'
        }
      }
    });

    // State
    $stateProvider.state('app.scc.private.data-set.details', {
      url: '/:dataSetId?tab',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/data-set/data-set-details.html',
          controller: 'DataSetDetailsController as $ctrl'
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/data-set');
    msNavigationServiceProvider.saveItem('data-set', {
      title: 'SCC',
      //icon     : 'icon-calendar-blank',
      svgIcon: 'data-set',
      state: 'app.scc.private.data-set',
      /*stateParams: {
          'param1': 'page'
       },*/
      translate: 'SCC.DATA_SET.NAV',
      weight: 100
    });
  }

  /** @ngInject */
  function run($rootScope, dataSets) {
    $rootScope.$on('scc.school.selected', dataSets.init);
    $rootScope.$on('scc.logout', dataSets.cleanup);
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.data-set').factory('dataSets', dataSetsService);

  /** @ngInject */
  function dataSetsService(daoFactory) {
    return daoFactory.createDao('dataSet', 'DataSet');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.student').controller('DataSetListController', DataSetListController).controller('DataSetDetailsController', DataSetDetailsController);

  /** @ngInject */
  function DataSetDetailsController($state, $timeout, $scope, $controller, dataSets, schools, $filter, $mdDialog, notifications, $stateParams, checkState, utils) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;
    ctrl.dataSetId = $stateParams.dataSetId;
    ctrl.tab = $stateParams.tab;
    ctrl.tabsCaptions = {
      generalInfo: $filter('translate')('SCC.DATA_SET.GENERAL_INFO_TAB'),
      feesInfo: $filter('translate')('SCC.DATA_SET.WORKING_HOURS_TAB')
    };
    if (!ctrl.tab) {
      ctrl.tab = "generalInfo";
    }
    ctrl.selectedTab = ctrl.tab;
    ctrl.$onInit = function () {
      ctrl.dataSet = dataSets.get(ctrl.dataSetId);
    };
    $scope.$watch("$ctrl.tab", function (newVal, oldVal) {
      if (newVal != ctrl.selectedTab && angular.isDefined(ctrl.dirty) && ctrl.dirty() && !checkState.confirmUserAction()) {
        ctrl.tab = oldVal;
      } else {
        ctrl.selectedTab = newVal;
      }
    });
  }

  /** @ngInject */
  function DataSetListController($scope, $controller, dataSets, utils, schools, $mdDialog, notifications) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;

    //The selected students
    this.selectedEntities = [];
    this.dataSet = {
      scheduleTable: [{
        slots: [{
          start: 108,
          end: 180
        }]
      }, {
        slots: [{
          start: 108,
          end: 180
        }]
      }, {
        slots: [{
          start: 108,
          end: 180
        }]
      }, {
        slots: [{
          start: 108,
          end: 180
        }]
      }, {
        slots: [{
          start: 108,
          end: 180
        }]
      }, {
        slots: []
      }, {
        slots: []
      }]
    };
    this.getAllEntities = function () {
      return dataSets.getAll();
    };
    this.isSelectedDataSet = function (dataset) {
      var selectedDataset = dataSets.getSelected();
      return selectedDataset && dataset && dataset.id == dataSets.getSelected().id;
    };
    this.selectDataSet = function (dataset) {
      dataSets.select(dataset);
    };
    this.createEntity = function () {
      ctrl.dataSet.school = {
        id: schools.getSelectedSchool().id
      };
      dataSets.create({
        dataSet: ctrl.dataSet
      }, $scope, function () {
        notifications.push('Η νέα διδακτική περίοδος δημιουργήθηκε επιτυχώς', notifications.INFO);
        ctrl.dataSet = {};
        ctrl.setFocusByName("dataSet.name");
      }, function () {
        ctrl.setFocusByName("dataSet.name");
      });
    };
    this.deleteEntity = function (ev, dataSet) {
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση διαγραφής').textContent('Θέλετε σίγουρα να διαγράψετε τη διδακτική περίοδο \"' + dataSet.name + '\";').ariaLabel('Επιβεβαίωση διαγραφής').targetEvent(ev).ok('ΔΙΑΓΡΑΦΗ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        dataSets.deleteListed({
          dataSetsIds: [dataSet.id]
        }, $scope, function () {
          ctrl.selectedEntities = [];
          notifications.push('Η διδακτική περίοδος \"' + dataSet.name + '\" διαγράφηκε.', notifications.INFO);
        });
      });
    };
    this.deleteSelected = function (ev) {
      var confirmText;
      if (ctrl.selectedEntities.length == 1) {
        confirmText = 'Θέλετε σίγουρα να διαγράψετε τη διδακτική περίοδο \"' + ctrl.selectedEntities[0].name + '\";';
      } else {
        confirmText = 'Θέλετε σίγουρα να διαγράψετε τις ' + ctrl.selectedEntities.length + ' επιλεγμένες διδακτικές περίοδους;';
      }
      var confirm = $mdDialog.confirm().title('Επιβεβαίωση διαγραφής').textContent(confirmText).ariaLabel('Επιβεβαίωση διαγραφής').targetEvent(ev).ok('ΔΙΑΓΡΑΦΗ').cancel('ΑΚΥΡΩΣΗ');
      $mdDialog.show(confirm).then(function () {
        var ids = ctrl.selectedEntities.map(function (l) {
          return l.id;
        });
        dataSets.deleteListed({
          dataSetsIds: ids
        }, $scope, function () {
          var responseText;
          if (ctrl.selectedEntities.length == 1) {
            responseText = 'Η διδακτική περίοδος \"' + ctrl.selectedEntities[0].name + '\" διαγράφηκε.';
          } else {
            responseText = 'Οι ' + ctrl.selectedEntities.length + ' επιλεγμένες διδακτικές περίοδοι διαγράφηκαν.';
          }
          notifications.push(responseText, notifications.INFO);
          ctrl.selectedEntities = [];
        });
      });
    };
    this.setFocusByName("dataSet.name");
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.data-set').controller('DataSetWorkingHoursController', DataSetWorkingHoursController);
  angular.module('app.scc.data-set').component("datasetWorkingHours", {
    templateUrl: 'app/main/scc/components/data-set/data-set-working-hours.html',
    bindings: {
      //Cannot used camel case name because data- prefix is ignored in html
      datasetId: '<',
      dirty: '='
    },
    controller: 'DataSetWorkingHoursController'
  });

  /** @ngInject */
  function DataSetWorkingHoursController($rootScope, $scope, dataSets, checkState, schools) {
    var ctrl = this;
    ctrl.dataSet = {};
    ctrl.editable = false;
    ctrl.dataSetId = this.datasetId;
    ctrl.daysOfWeek = [0, 1, 2, 3, 4, 5, 6];
    ctrl.schedule = [];
    ctrl.daysOfWeek.forEach(function (day) {
      ctrl.schedule[day] = {
        slots: []
      };
    });
    ctrl.addSlot = function (day) {
      if (ctrl.schedule[day].slots.length < 4) {
        ctrl.schedule[day].slots.push({
          start: '',
          end: ''
        });
      }
    };
    ctrl.removeSlot = function (day, index) {
      ctrl.schedule[day].slots.splice(index, 1);
    };
    function convertSlotsToSchedulePanel(schedule, referenceDateStr) {
      var result = [];
      var slotToDate = function slotToDate(slotIndex, referenceDate) {
        var minutes = slotIndex * 5;
        var hours = Math.floor(minutes / 60);
        var mins = minutes % 60;
        var date = new Date(referenceDate);
        date.setHours(hours, mins, 0, 0); // Set local time
        return date;
      };

      // Use today's date if no reference provided
      var todayStr = new Date().toISOString().split('T')[0];
      var referenceDate = new Date(referenceDateStr || todayStr);
      var d;
      for (d = 0; d < 7; d++) {
        var slots = schedule[d].slots.map(function (slot) {
          return {
            start: slotToDate(slot.start, referenceDate),
            end: slotToDate(slot.end, referenceDate)
          };
        });
        result[d] = {
          slots: slots
        };
      }
      return result;
    }
    ;
    $scope.$watch("$ctrl.dataSet", function () {
      ctrl.schedule = [];
      if (ctrl.dataSet && ctrl.dataSet.scheduleTable) {
        ctrl.schedule = convertSlotsToSchedulePanel(ctrl.dataSet.scheduleTable);
      }
    });
    function convertSchedulePanelToSlots() {
      var result = [];
      var convertToSlot = function convertToSlot(dateString) {
        var date = new Date(dateString);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var totalMinutes = hours * 60 + minutes;
        return Math.floor(totalMinutes / 5);
      };
      var d;
      for (d = 0; d < 7; d++) {
        var slots = ctrl.schedule[d].slots.map(function (slot) {
          return {
            start: convertToSlot(slot.start),
            end: convertToSlot(slot.end)
          };
        });
        result[d] = {
          slots: slots
        };
      }
      return result;
    }
    ctrl.$onInit = function () {
      ctrl.dataSet = dataSets.get(ctrl.dataSetId);
    };
    ctrl.startEditing = function () {
      ctrl.editable = true;
      checkState.checkFormOnStateChange($scope, $scope.form);
    };
    ctrl.save = function () {
      ctrl.dataSet.school = {
        id: schools.getSelectedSchool().id
      };
      ctrl.dataSet.scheduleTable = convertSchedulePanelToSlots();
      dataSets.update({
        dataSet: ctrl.dataSet
      }, $scope.form, function () {
        var msg = 'Τα στοιχεία της διδακτικής περιόδου ενημερώθηκαν επιτυχώς';
        ctrl.editable = false;
        $scope.form.$setPristine();
      });
    };
    ctrl.cancelEditing = function () {
      ctrl.dataSet = dataSets.get(ctrl.dataSetId);
      ctrl.editable = false;
      $scope.form.$setPristine();
    };
    ctrl.dirty = function () {
      return angular.isDefined($scope.form) && !$scope.form.$pristine;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.data-set').controller('DataSetGeneralInfoController', DataSetGeneralInfoController);
  angular.module('app.scc.data-set').component("datasetGeneralInfo", {
    templateUrl: 'app/main/scc/components/data-set/data-set-general-info.html',
    bindings: {
      datasetId: '<',
      dirty: '='
    },
    controller: 'DataSetGeneralInfoController'
  });

  /** @ngInject */
  function DataSetGeneralInfoController($scope, dataSets, schools, utils, checkState) {
    var ctrl = this;
    ctrl.dataSet = {};
    ctrl.editable = false;
    ctrl.$onInit = function () {
      ctrl.dataSet = dataSets.get(ctrl.datasetId);
    };
    ctrl.startEditing = function () {
      ctrl.editable = true;
      checkState.checkFormOnStateChange($scope, $scope.form);
    };
    ctrl.save = function () {
      ctrl.dataSet.school = {
        id: schools.getSelectedSchool().id
      };
      dataSets.update({
        dataSet: ctrl.dataSet
      }, $scope.form, function () {
        var msg = 'Τα στοιχεία της διδακτικής περιόδου ενημερώθηκαν επιτυχώς';
        ctrl.editable = false;
        $scope.form.$setPristine();
      });
    };
    ctrl.cancelEditing = function () {
      ctrl.dataSet = dataSets.get(ctrl.datasetId);
      ctrl.editable = false;
      $scope.form.$setPristine();
    };
    ctrl.dirty = function () {
      return angular.isDefined($scope.form) && !$scope.form.$pristine;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.classroom', ['md.data.table']).config(config).run(run);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.scc.private.classroom', {
      url: '/classroom',
      views: {
        'content@app': {
          templateUrl: 'app/main/scc/components/classroom/classroom.html',
          controller: 'ClassroomController as $ctrl'
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/classroom');
    msNavigationServiceProvider.saveItem('classroom', {
      title: 'SCC',
      svgIcon: 'classroom',
      state: 'app.scc.private.classroom',
      /*stateParams: {
          'param1': 'page'
       },*/
      translate: 'SCC.CLASSROOM.NAV',
      weight: 20000
    });
  }

  /** @ngInject */
  function run($rootScope, classrooms) {
    $rootScope.$on('scc.school.selected', classrooms.init);
    $rootScope.$on('scc.logout', classrooms.cleanup);
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.classroom').factory('classrooms', classroomsService);

  /** @ngInject */
  function classroomsService(daoFactory) {
    return daoFactory.createDao('classroom', 'Classroom');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.classroom').controller('ClassroomController', ClassroomController);

  /** @ngInject */
  function ClassroomController($scope, $controller, classrooms) {
    var ctrl = $controller('GenericCrudController', {
      $scope: $scope
    });
    angular.extend(ctrl, {
      service: classrooms,
      entityType: "classroom",
      translationNameSpace: "SCC.CLASSROOM",
      classroom: {}
    });
    return ctrl;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.buy', []).config(config);

  /** @ngInject */
  function config($stateProvider) {
    $stateProvider.state('app.scc.private.buy', {
      url: '/buy?plan',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.scc.private.buy': {
          templateUrl: 'app/main/scc/components/buy/buy.html',
          controller: 'BuyController as vm'
        }
      },
      bodyClass: 'buy'
    });
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.buy').controller('BuyController', BuyController);

  /** @ngInject */
  function BuyController($stateParams, $state, revenuecat) {
    var PLAN_OFFERINGS = {
      'monthly': 'default_monthly_highlighted',
      'annual': 'default_annual_highlighted'
    };
    var plan = $stateParams.plan;
    var offeringId = PLAN_OFFERINGS[plan] || null;
    revenuecat.showPaywall(offeringId).then(function () {
      $state.go('app.scc.private.data-set');
    });
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.billing-info', []).config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider) {
    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/billing-info');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.billing-info').controller('BillingfInfoController', BillingfInfoController);

  /** @ngInject */
  function BillingfInfoController($scope) {}
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.billing-info').component('billingInfo', {
    templateUrl: 'app/main/scc/components/billing-info/billing-info.html',
    bindings: {
      billingInfo: '=',
      form: '='
    },
    controller: 'BillingfInfoController'
  });
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.availability', []).config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('app/main/scc/components/availability');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.availability').directive('sccUnavailabilityBlock', sccUnavailabilityBlock);

  /** @ngInject */
  function sccUnavailabilityBlock($document, $timeout) {
    function reposition(grid, scope, element) {
      var block = scope.sccModel;
      if (!block) return;
      var startSlot = grid.getScheduleSlotElement(block.day, block.timeSlot);
      var endSlot = grid.getScheduleSlotElement(block.day, block.timeSlot + block.duration - 1);
      if (!startSlot || !endSlot) {
        console.warn('sccUnavailabilityBlock: slot not found for block', block);
        return;
      }
      var gridEl = grid.getScheduleElement()[0];
      var gridRect = gridEl.getBoundingClientRect();
      var stsr = startSlot[0].getBoundingClientRect();
      var etsr = endSlot[0].getBoundingClientRect();
      // Account for the grid container's own scroll so coordinates are
      // anchored to its content box, not its scroll viewport.
      var scrollLeft = gridEl.scrollLeft || 0;
      var scrollTop = gridEl.scrollTop || 0;
      element.css({
        position: 'absolute',
        top: stsr.top - gridRect.top + scrollTop + 'px',
        left: stsr.left - gridRect.left + scrollLeft + 'px',
        width: stsr.width + 'px',
        height: etsr.bottom - stsr.top + 'px'
      });
    }
    function linkMoveHandler(grid, scope, element, handleElement) {
      var startMouseX, startMouseY, startElemTop, startElemLeft;
      var startDay, startTimeSlot;
      function onMouseMove(event) {
        element.css({
          top: startElemTop + event.pageY - startMouseY + 'px',
          left: startElemLeft + event.pageX - startMouseX + 'px'
        });
        var rect = element[0].getBoundingClientRect();
        var target = document.elementFromPoint(rect.left + rect.width / 2, rect.top + 5);
        var ssCtrl = angular.element(target).controller('sccAvailabilitySlot');
        var block = scope.sccModel;
        if (ssCtrl) {
          if (block.timeSlot !== ssCtrl.getTimeSlot() || block.day !== ssCtrl.getDay()) {
            $timeout(function () {
              block.day = ssCtrl.getDay();
              block.timeSlot = ssCtrl.getTimeSlot();
            });
          }
        }
      }
      function onMouseUp() {
        $document.off('mousemove', onMouseMove);
        $document.off('mouseup', onMouseUp);
        var rect = element[0].getBoundingClientRect();
        var target = document.elementFromPoint(rect.left + rect.width / 2, rect.top + 5);
        var ssCtrl = angular.element(target).controller('sccAvailabilitySlot');
        var block = scope.sccModel;
        var landed = ssCtrl && grid.periodIsFree(ssCtrl.getDay(), ssCtrl.getTimeSlot(), block.duration, block);
        element.css({
          'pointer-events': 'auto'
        });
        $timeout(function () {
          if (landed) {
            if (block.day !== startDay || block.timeSlot !== startTimeSlot) {
              grid.scheduleChanged();
            }
          } else {
            block.day = startDay;
            block.timeSlot = startTimeSlot;
          }
          reposition(grid, scope, element);
        });
      }
      handleElement.on('mousedown', function (event) {
        if (event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        startMouseX = event.pageX;
        startMouseY = event.pageY;
        startElemTop = parseFloat(element.css('top')) || 0;
        startElemLeft = parseFloat(element.css('left')) || 0;
        startDay = scope.sccModel.day;
        startTimeSlot = scope.sccModel.timeSlot;
        element.css({
          'pointer-events': 'none'
        });
        $document.on('mousemove', onMouseMove);
        $document.on('mouseup', onMouseUp);
      });
    }
    function linkResizeHandler(grid, scope, element, handleElement) {
      var startMouseY, startHeight, startDuration, maxDuration;
      function onMouseMove(event) {
        var newHeight = startHeight + event.pageY - startMouseY;
        if (newHeight < 7) newHeight = 7;
        element.css({
          height: newHeight + 'px'
        });
        var ssCtrl = angular.element(event.target).controller('sccAvailabilitySlot');
        if (!ssCtrl) return;
        var block = scope.sccModel;
        if (ssCtrl.getDay() !== block.day) return;
        var newDuration = ssCtrl.getTimeSlot() - block.timeSlot + 1;
        if (newDuration < 1) newDuration = 1;
        if (newDuration > maxDuration) newDuration = maxDuration;
        if (newDuration !== block.duration && grid.periodIsFree(block.day, block.timeSlot, newDuration, block)) {
          $timeout(function () {
            block.duration = newDuration;
          });
        }
      }
      function onMouseUp() {
        $document.off('mousemove', onMouseMove);
        $document.off('mouseup', onMouseUp);
        element.css({
          'pointer-events': 'auto'
        });
        $timeout(function () {
          if (scope.sccModel.duration !== startDuration) {
            grid.scheduleChanged();
          }
          reposition(grid, scope, element);
        });
      }
      handleElement.on('mousedown', function (event) {
        if (event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        startMouseY = event.pageY;
        startHeight = parseInt(window.getComputedStyle(element[0]).getPropertyValue('height'), 10);
        startDuration = scope.sccModel.duration;
        maxDuration = grid.computeMaxDurationAt(scope.sccModel.day, scope.sccModel.timeSlot, scope.sccModel);
        element.css({
          'pointer-events': 'none'
        });
        $document.on('mousemove', onMouseMove);
        $document.on('mouseup', onMouseUp);
      });
    }
    return {
      scope: {
        sccModel: '='
      },
      link: function link(scope, element) {
        var grid = element.controller('sccAvailabilityGrid');
        if (!grid) {
          console.error('sccUnavailabilityBlock: could not resolve sccAvailabilityGrid controller');
          return;
        }
        element.addClass('scc-unavailability-block');

        // Reposition whenever the model reference changes (initial render,
        // or when the parent component replaces the blocks array from a
        // server response). Drag/resize handlers call reposition()
        // directly on mouseup since in-place mutations of day/timeSlot/
        // duration don't change the reference.
        scope.$watch('sccModel', function () {
          reposition(grid, scope, element);
        });
        var moveHandle = angular.element(element[0].querySelector('.scc-unavailability-block-move-handle'));
        if (moveHandle.length) linkMoveHandler(grid, scope, element, moveHandle);
        var resizeHandle = angular.element(element[0].querySelector('.scc-unavailability-block-resize-handle'));
        if (resizeHandle.length) linkResizeHandler(grid, scope, element, resizeHandle);
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.availability').component('sccAvailability', {
    templateUrl: 'app/main/scc/components/availability/availability.html',
    bindings: {
      entityType: '<',
      entityId: '<',
      selectedDataSet: '<'
    },
    controller: AvailabilityController
  });

  /** @ngInject */
  function AvailabilityController($scope, $timeout, $mdDialog, scc, utils) {
    var ctrl = this;
    ctrl.scheduleSlots = [];
    ctrl.blocks = [];

    // Bumped by every load and by every optimistic user write so stale
    // responses can be discarded (prevents an in-flight GET from wiping
    // a block the user just added).
    var loadRequestToken = 0;
    ctrl.$onInit = function () {
      rebuildSlots();
      loadAvailability();
    };
    ctrl.$onChanges = function (changes) {
      // Skip the initial $onChanges fire — $onInit handles initial load.
      // Reload only when bindings actually change after init (e.g., user
      // switched the selected dataset while the tab is open).
      var meaningful = changes.selectedDataSet && !changes.selectedDataSet.isFirstChange() || changes.entityId && !changes.entityId.isFirstChange() || changes.entityType && !changes.entityType.isFirstChange();
      if (meaningful) {
        rebuildSlots();
        loadAvailability();
      }
    };
    ctrl.persist = function () {
      if (!ctrl.entityId || !ctrl.selectedDataSet) {
        return;
      }
      var requestName = ctrl.entityType === 'teacher' ? 'UpdateTeacherAvailability' : 'UpdateStudentAvailability';
      scc.request(scc.PRIVATE_MODE, requestName, {
        availability: {
          entityId: ctrl.entityId,
          dataSetId: ctrl.selectedDataSet.id,
          blocks: ctrl.blocks.map(function (b) {
            return {
              day: b.day,
              timeSlot: b.timeSlot,
              duration: b.duration,
              comment: b.comment || null
            };
          })
        }
      });
    };
    ctrl.addBlock = function (day, timeSlot, duration) {
      loadRequestToken++;
      ctrl.blocks.push({
        day: day,
        timeSlot: timeSlot,
        duration: duration,
        comment: null
      });
      ctrl.persist();
    };
    ctrl.removeBlock = function (ev, block) {
      ev.stopPropagation();
      loadRequestToken++;
      var index = ctrl.blocks.indexOf(block);
      if (index >= 0) {
        ctrl.blocks.splice(index, 1);
        ctrl.persist();
      }
    };
    ctrl.editComment = function (ev, block) {
      ev.stopPropagation();
      $mdDialog.show({
        controller: function controller($mdDialog, currentComment) {
          var dialogCtrl = this;
          dialogCtrl.comment = currentComment || '';
          dialogCtrl.save = function () {
            $mdDialog.hide(dialogCtrl.comment);
          };
          dialogCtrl.cancel = function () {
            $mdDialog.cancel();
          };
        },
        controllerAs: '$ctrl',
        templateUrl: 'app/main/scc/components/availability/availability-comment-dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          currentComment: block.comment
        }
      }).then(function (newComment) {
        loadRequestToken++;
        block.comment = newComment;
        ctrl.persist();
      }, function () {});
    };
    function rebuildSlots() {
      ctrl.scheduleSlots = [];
      if (!ctrl.selectedDataSet || !ctrl.selectedDataSet.scheduleTable) {
        return;
      }
      var st = ctrl.selectedDataSet.scheduleTable;
      var firstSlot = null,
        lastSlot = null;
      for (var d = 0; d <= 6; d++) {
        var slots = st[d] && st[d].slots || [];
        for (var i = 0; i < slots.length; i++) {
          if (firstSlot === null || slots[i].start < firstSlot) firstSlot = slots[i].start;
          if (lastSlot === null || slots[i].end > lastSlot) lastSlot = slots[i].end;
        }
      }
      if (firstSlot === null || lastSlot === null) {
        return;
      }
      for (var ts = firstSlot; ts < lastSlot; ts++) {
        var row = [];
        for (var day = 0; day < 7; day++) {
          if (utils.isEmptyArray(st[day] && st[day].slots)) {
            continue;
          }
          var disabled = !activeSlot(st[day].slots, ts);
          row.push({
            day: day,
            timeSlot: ts,
            disabled: disabled
          });
        }
        ctrl.scheduleSlots.push(row);
      }
    }
    function activeSlot(slots, ts) {
      for (var i = 0; i < slots.length; i++) {
        if (ts >= slots[i].start && ts < slots[i].end) {
          return true;
        }
      }
      return false;
    }
    function loadAvailability() {
      if (!ctrl.entityId || !ctrl.selectedDataSet) {
        ctrl.blocks = [];
        return;
      }
      var thisToken = ++loadRequestToken;
      var requestName = ctrl.entityType === 'teacher' ? 'GetTeacherAvailability' : 'GetStudentAvailability';
      var payloadKey = ctrl.entityType === 'teacher' ? 'teacherId' : 'studentId';
      var payload = {
        dataSetId: ctrl.selectedDataSet.id
      };
      payload[payloadKey] = ctrl.entityId;
      scc.request(scc.PRIVATE_MODE, requestName, payload, function (resp) {
        if (thisToken !== loadRequestToken) return; // a newer load/write happened
        if (resp.data && resp.data.availability) {
          ctrl.blocks = (resp.data.availability.blocks || []).map(function (b) {
            return {
              day: b.day,
              timeSlot: b.timeSlot,
              duration: b.duration,
              comment: b.comment
            };
          });
        } else {
          ctrl.blocks = [];
        }
      });
    }
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.availability').directive('sccAvailabilityGrid', sccAvailabilityGrid).directive('sccAvailabilitySlot', sccAvailabilitySlot);

  /** @ngInject */
  function sccAvailabilityGrid($document, $timeout) {
    return {
      scope: {
        sccEntityType: '<',
        sccEntityId: '<',
        sccDataSet: '<'
      },
      controller: function controller($scope, $element) {
        var ctrl = this;
        var availabilityCtrl = null;
        this.setAvailabilityController = function (c) {
          availabilityCtrl = c;
        };
        this.getScheduleSlotElement = function (day, timeSlot) {
          var el = $element[0].querySelector('.scc-schedule-slot[data-scc-day="' + day + '"][data-scc-time-slot="' + timeSlot + '"]');
          return el ? angular.element(el) : null;
        };
        this.getScheduleElement = function () {
          return $element;
        };
        this.blockExists = function (day, timeSlot, excludedBlock) {
          if (!availabilityCtrl) return false;
          for (var i = 0; i < availabilityCtrl.blocks.length; i++) {
            var b = availabilityCtrl.blocks[i];
            if (excludedBlock && b === excludedBlock) continue;
            if (b.day === day && timeSlot >= b.timeSlot && timeSlot <= b.timeSlot + b.duration - 1) {
              return true;
            }
          }
          return false;
        };
        this.periodIsFree = function (day, timeSlot, duration, excludedBlock) {
          for (var i = 0; i < duration; i++) {
            var slot = ctrl.getScheduleSlotElement(day, timeSlot + i);
            if (!slot) return false;
            if (slot.attr('data-scc-disabled') === 'true') return false;
            if (ctrl.blockExists(day, timeSlot + i, excludedBlock)) return false;
          }
          return true;
        };
        this.scheduleChanged = function () {
          if (availabilityCtrl) {
            availabilityCtrl.persist();
          }
        };
        this.startDraw = function (day, timeSlot) {
          var maxDuration = computeMaxDuration(day, timeSlot, null);
          if (maxDuration <= 0) return;
          var draftSlots = [];
          var currentDuration = 1;
          markDraft(day, timeSlot, currentDuration);
          function onMove(e) {
            var target = document.elementFromPoint(e.pageX - window.scrollX, e.pageY - window.scrollY);
            var ssCtrl = angular.element(target).controller('sccAvailabilitySlot');
            if (!ssCtrl || ssCtrl.getDay() !== day) return;
            var newEnd = ssCtrl.getTimeSlot();
            if (newEnd < timeSlot) return;
            var newDuration = newEnd - timeSlot + 1;
            if (newDuration > maxDuration) newDuration = maxDuration;
            if (newDuration !== currentDuration) {
              clearDraft();
              currentDuration = newDuration;
              markDraft(day, timeSlot, currentDuration);
            }
          }
          function onUp() {
            $document.off('mousemove', onMove);
            $document.off('mouseup', onUp);
            clearDraft();
            if (currentDuration > 0 && availabilityCtrl) {
              $timeout(function () {
                availabilityCtrl.addBlock(day, timeSlot, currentDuration);
              });
            }
          }
          function markDraft(d, ts, dur) {
            draftSlots = [];
            for (var i = 0; i < dur; i++) {
              var el = ctrl.getScheduleSlotElement(d, ts + i);
              if (el) {
                el.addClass('drawing');
                draftSlots.push(el);
              }
            }
          }
          function clearDraft() {
            draftSlots.forEach(function (el) {
              el.removeClass('drawing');
            });
            draftSlots = [];
          }
          function computeMaxDuration(d, ts, excluded) {
            var max = 0;
            var slot;
            do {
              slot = ctrl.getScheduleSlotElement(d, ts + max);
              if (!slot) break;
              if (slot.attr('data-scc-disabled') === 'true') break;
              if (ctrl.blockExists(d, ts + max, excluded)) break;
              max++;
            } while (true);
            return max;
          }
          $document.on('mousemove', onMove);
          $document.on('mouseup', onUp);
        };
        this.computeMaxDurationAt = function (day, timeSlot, excluded) {
          var max = 0;
          var slot;
          do {
            slot = ctrl.getScheduleSlotElement(day, timeSlot + max);
            if (!slot) break;
            if (slot.attr('data-scc-disabled') === 'true') break;
            if (ctrl.blockExists(day, timeSlot + max, excluded)) break;
            max++;
          } while (true);
          return max;
        };
      },
      link: function link(scope, element) {
        element.addClass('scc-schedule');
        var availabilityCtrl = element.controller('sccAvailability');
        if (availabilityCtrl) {
          element.controller('sccAvailabilityGrid').setAvailabilityController(availabilityCtrl);
        }
      }
    };
  }

  /** @ngInject */
  function sccAvailabilitySlot(utils) {
    return {
      scope: {
        sccDay: '<',
        sccTimeSlot: '<',
        sccDisabled: '<'
      },
      controller: function controller($scope, $element) {
        this.getDay = function () {
          return $scope.sccDay;
        };
        this.getTimeSlot = function () {
          return $scope.sccTimeSlot;
        };
        $element.on('mousedown', function (e) {
          if ($scope.sccDisabled) return;
          if (e.button !== 0) return;
          e.preventDefault();
          var grid = $element.controller('sccAvailabilityGrid');
          if (grid) {
            grid.startDraw($scope.sccDay, $scope.sccTimeSlot);
          }
        });
      },
      link: function link(scope, element) {
        element.addClass('scc-schedule-slot');
        element.attr('data-scc-day', scope.sccDay);
        element.attr('data-scc-time-slot', scope.sccTimeSlot);
        element.attr('data-scc-disabled', scope.sccDisabled);
        element.css({
          'z-index': 1440 / utils.TIMESLOT_DURATION_IN_MIN - scope.sccTimeSlot,
          'background-color': scope.sccDisabled ? 'lightgrey' : 'default'
        });
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.activate-account', []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.scc.public.activate-account', {
      url: '/activate-account',
      views: {
        'main@': {
          templateUrl: 'app/core/layouts/content-only.html',
          controller: 'MainController as vm'
        },
        'content@app.scc.public.activate-account': {
          templateUrl: 'app/main/scc/components/activate-account/activate-account.html',
          controller: 'ActivateAccountController as vm'
        }
      },
      bodyClass: 'activate-account'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/scc/components/activate-account');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc.activate-account').controller('ActivateAccountController', ActivateAccountController);

  /** @ngInject */
  function ActivateAccountController($scope, scc, $location) {
    var ctrl = this;
    ctrl.mac = $location.search().mac;
    if (ctrl.mac) {
      ctrl.result = 'pending';
      scc.execute(scc.PUBLIC_MODE, 'ActivateUser', {
        activationMac: ctrl.mac
      }, $scope.form, function () {
        ctrl.result = 'success';
      }, function () {
        ctrl.result = 'failure';
      });
    } else {
      ctrl.result = 'failure';
    }
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.chat', []).config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.chat', {
      url: '/chat',
      views: {
        'content@app': {
          templateUrl: 'app/main/apps/chat/chat.html',
          controller: 'ChatController as vm'
        }
      },
      resolve: {
        Contacts: function Contacts(msApi) {
          return msApi.resolve('chat.contacts@get');
        },
        User: function User(msApi) {
          return msApi.resolve('chat.user@get');
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/apps/chat');

    // Api
    // Contacts data must be alphabatically ordered.
    msApiProvider.register('chat.contacts', ['app/data/chat/contacts.json']);
    msApiProvider.register('chat.chats', ['app/data/chat/chats/:id.json']);
    msApiProvider.register('chat.user', ['app/data/chat/user.json']);

    // Navigation
    //REMOVED SAMPLE
    //msNavigationServiceProvider.saveItem('chat', {
    //    title : 'Chat',
    //    icon  : 'icon-hangouts',
    //    state : 'app.chat',
    //    badge : {
    //        content: 13,
    //        color  : '#09d261'
    //    },
    //    weight: 5
    //});
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.chat').factory('ChatsService', ChatsService);

  /** @ngInject */
  function ChatsService($q, msApi) {
    var service = {
      chats: {},
      contacts: [],
      getContactChat: getContactChat
    };

    /**
     * Get contact chat from the server
     *
     * @param contactId
     * @returns {*}
     */
    function getContactChat(contactId) {
      // Create a new deferred object
      var deferred = $q.defer();

      // If contact doesn't have lastMessage, create a new chat
      if (!service.contacts.getById(contactId).lastMessage) {
        service.chats[contactId] = [];
        deferred.resolve(service.chats[contactId]);
      }

      // If the chat exist in the service data, do not request
      if (service.chats[contactId]) {
        deferred.resolve(service.chats[contactId]);
        return deferred.promise;
      }

      // Request the chat with the contactId
      msApi.request('chat.chats@get', {
        id: contactId
      },
      // SUCCESS
      function (response) {
        // Attach the chats
        service.chats[contactId] = response.data;

        // Resolve the promise
        deferred.resolve(service.chats[contactId]);
      },
      // ERROR
      function (response) {
        deferred.reject(response);
      });
      return deferred.promise;
    }

    /**
     * Array prototype
     *
     * Get by id
     *
     * @param value
     * @returns {T}
     */
    Array.prototype.getById = function (value) {
      return this.filter(function (x) {
        return x.id === value;
      })[0];
    };
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.quick-panel', []).config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider, msApiProvider) {
    // Translation
    $translatePartialLoaderProvider.addPart('app/quick-panel');

    // Api
    msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
    msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
    msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
    msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.quick-panel').controller('ChatTabController', ChatTabController);

  /** @ngInject */
  function ChatTabController(msApi, $timeout) {
    var vm = this;

    // Data
    vm.chat = {};
    vm.chatActive = false;
    vm.replyMessage = '';
    msApi.request('quickPanel.contacts@get', {},
    // Success
    function (response) {
      vm.contacts = response.data;
    });

    // Methods
    vm.toggleChat = toggleChat;
    vm.reply = reply;

    //////////

    function toggleChat(contact) {
      vm.chatActive = !vm.chatActive;
      if (vm.chatActive) {
        vm.replyMessage = '';
        vm.chat.contact = contact;
        scrollToBottomOfChat(0);
      }
    }
    function reply() {
      if (vm.replyMessage === '') {
        return;
      }
      if (!vm.chat.contact.dialog) {
        vm.chat.contact.dialog = [];
      }
      vm.chat.contact.dialog.push({
        who: 'user',
        message: vm.replyMessage,
        time: 'Just now'
      });
      vm.replyMessage = '';
      scrollToBottomOfChat(400);
    }
    function scrollToBottomOfChat(speed) {
      var chatDialog = angular.element('#chat-dialog');
      $timeout(function () {
        chatDialog.animate({
          scrollTop: chatDialog[0].scrollHeight
        }, speed);
      }, 0);
    }
  }
})();
"use strict";

(function () {
  angular.module('app.scc').factory('utils', UtilsService);

  /** @ngInject */
  function UtilsService() {
    var service = this;
    service.DEFAULT_LANGUAGE_CODE = 'en';
    service.TIMESLOT_DURATION_IN_MIN = 5;
    service.TIMESLOTS_PER_DAY = 24 * 60 / 5;
    service.DAYS = ['ΔΕΥΤΕΡΑ', 'ΤΡΙΤΗ', 'ΤΕΤΑΡΤΗ', 'ΠΕΜΠΤΗ', 'ΠΑΡΑΣΚΕΥΗ', 'ΣΑΒΒΑΤΟ', 'ΚΥΡΙΑΚΗ'];
    service.pad = function (n, width, z) {
      z = z || '0';
      n = n + '';
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    };
    service.dayNumToDayName = function (dayNum) {
      return service.DAYS[dayNum % 7];
    };
    service.timeSlotToHour = function (timeSlot) {
      var hour = Math.floor(timeSlot * service.TIMESLOT_DURATION_IN_MIN / 60);
      var minute = timeSlot * service.TIMESLOT_DURATION_IN_MIN - 60 * hour;
      return service.pad(hour, 2) + ':' + service.pad(minute, 2);
    };
    service.hourToTimeSlot = function (hour) {
      var re = /(\d\d):(\d\d)/;
      var match = re.exec(hour);
      var mins = 60 * parseInt(match[1]) + parseInt(match[2]);
      return Math.floor(mins / service.TIMESLOT_DURATION_IN_MIN);
    };
    service.base64ToBlob = function (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);
        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        var byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      var blob = new Blob(byteArrays, {
        type: contentType
      });
      return blob;
    };
    service.setCharAt = function (str, index, chr) {
      if (index > str.length - 1) return str;
      return str.substr(0, index) + chr + str.substr(index + 1);
    };
    service.clear = function (arg) {
      for (var variableKey in arg) {
        if (arg.hasOwnProperty(variableKey)) {
          delete arg[variableKey];
        }
      }
    };
    service.findChildScopeWithAttribute = function (scope, attributeName) {
      var s = scope.$$childHead;
      while (s) {
        if (s[attributeName]) {
          return s;
        }
        s = s.$$nextSibling;
      }
    };
    service.localizeDate = function localizeDate(date) {
      if (date) {
        var m = moment(date);
        return m.isValid() ? m.format('YYYY-MM-DD') : null;
      }
      return null;
    };
    service.delocalizeDate = function localizeDate(date) {
      if (date) {
        return moment(date, 'YYYY-MM-DD').toDate();
      }
      return null;
    };
    service.isEmptyArray = function (array) {
      return !Array.isArray(array) || array.length === 0;
    };
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').factory('scc', sccService);

  /** @ngInject */
  function sccService($rootScope, $timeout, $http, notifications, errorsHelper) {
    var service = {};
    service.PUBLIC_MODE = 'public';
    service.PRIVATE_MODE = 'private';
    service.pendingBlockingRequests = 0;
    service.getPendingBlockingRequests = function () {
      return service.pendingBlockingRequests;
    };
    service.request = function (mode, requestType, input, onSuccess, onFailure) {
      service.pendingBlockingRequests = service.pendingBlockingRequests + 1;
      if (service.pendingBlockingRequests == 1) {
        service.loadingProgressPromise = $timeout(function () {
          $rootScope.loadingProgress = true;
        }, 300);
      }

      // Determine backend URL based on current hostname
      var isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
      var baseUrl = isLocalhost ? 'http://localhost:9090/scc/rest/' : 'https://app.schooloncloud.gr/api/scc/rest/';
      $http({
        method: 'POST',
        url: baseUrl + mode + '/request/' + requestType,
        data: input //,
        //withCredentials: true
      }).then(function successCallback(response) {
        service.pendingBlockingRequests = service.pendingBlockingRequests - 1;
        if (service.pendingBlockingRequests == 0) {
          $timeout.cancel(service.loadingProgressPromise);
          $rootScope.loadingProgress = false;
        }
        if (onSuccess) {
          onSuccess(response);
        }
      }, function errorCallback(response) {
        service.pendingBlockingRequests = service.pendingBlockingRequests - 1;
        if (service.pendingBlockingRequests == 0) {
          $timeout.cancel(service.loadingProgressPromise);
          $rootScope.loadingProgress = false;
        }
        if (response.status === 401) {
          $rootScope.$emit('scc.auth.unauthorized');
        }
        if (onFailure) {
          onFailure(response);
        }
      });
    };
    service.execute = function (mode, requestType, input, form, onSuccess, onFailure) {
      var field;
      var error;
      if (form) {
        errorsHelper.cleanFormErrors(form);
      }
      service.request(mode, requestType, input, onSuccess, function (response) {
        if (response.status == 403) {
          notifications.push('Δεν έχετε διακαιώματα για τη συγγεκριμένη λειτουργία', notifications.ERROR);
        } else if (response.status == 401) {
          notifications.push('Παρακαλούμε συνδεθείτε', notifications.ERROR);
        } else if (response.status == 400 && response.data.errors) {
          response.data.errors.forEach(function (error) {
            if (!error.path) {
              //form.$setValidity('server.' + error.constraint, false);
              if (!form.$sccFormError) {
                form.$sccFormError = {};
              }
              form.$sccFormError['server.' + error.messageTemplate] = error;
            } else if (form && form[error.path]) {
              form[error.path].$setValidity('server.' + error.messageTemplate, false);
              form[error.path].$error['server.' + error.messageTemplate] = error;
            } else if (form) {
              if (!form.$sccImplicitFieldsErrors) {
                form.$sccImplicitFieldsErrors = {};
              }
              if (!form.$sccImplicitFieldsErrors[error.path]) {
                form.$sccImplicitFieldsErrors[error.path] = {};
              }
              form.$sccImplicitFieldsErrors[error.path]['server.' + error.messageTemplate] = error;
              notifications.push('Λάθος στο πεδίο ' + error.path, notifications.ERROR);
            }
          });
          if (onFailure) {
            onFailure(response);
          }
        } else {
          notifications.push('Απρόσμενο σφάλμα', 'error');
        }
      });
    };
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').factory('revenuecat', revenuecatService);

  /** @ngInject */
  function revenuecatService($q, $rootScope, authentication, $mdDialog, notifications) {
    var RC = window.Purchases;
    var API_KEY = 'pdl_pGXOYfAjgwTHeEdRiCMeybwlmDrY';
    var PRO_ENTITLEMENT = 'School on Cloud Pro';
    var instance = null;
    var customerInfoCache = null;
    var service = {};
    function getInstance() {
      if (instance) {
        return instance;
      }
      instance = RC.Purchases.configure(API_KEY, authentication.getUser().revenuecatId);
      return instance;
    }
    service.isProEntitled = function () {
      var deferred = $q.defer();
      try {
        var purchases = getInstance();
        purchases.getCustomerInfo().then(function (customerInfo) {
          customerInfoCache = customerInfo;
          var entitled = !!(customerInfo.entitlements.active && customerInfo.entitlements.active[PRO_ENTITLEMENT]);
          deferred.resolve(entitled);
        })['catch'](function (err) {
          console.error('RevenueCat: error checking entitlement', err);
          deferred.resolve(true);
        });
      } catch (err) {
        console.error('RevenueCat: error initializing', err);
        deferred.resolve(true);
      }
      return deferred.promise;
    };
    service.showPaywall = function (offeringId) {
      var deferred = $q.defer();
      try {
        var purchases = getInstance();
        purchases.getOfferings().then(function (offerings) {
          var offering = null;
          if (offeringId && offerings.all && offerings.all[offeringId]) {
            offering = offerings.all[offeringId];
          } else {
            offering = offerings.current;
          }
          if (!offering) {
            console.error('RevenueCat: no offering found');
            deferred.reject('No offerings available');
            return;
          }
          return purchases.presentPaywall({
            offering: offering
          });
        }).then(function (result) {
          if (result && result.customerInfo) {
            customerInfoCache = result.customerInfo;
            var entitled = !!(result.customerInfo.entitlements.active && result.customerInfo.entitlements.active[PRO_ENTITLEMENT]);
            deferred.resolve(entitled);
          } else {
            deferred.resolve(false);
          }
        })['catch'](function (err) {
          console.log('RevenueCat: paywall dismissed or error', err);
          deferred.resolve(false);
        });
      } catch (err) {
        console.error('RevenueCat: error showing paywall', err);
        deferred.reject(err);
      }
      return deferred.promise;
    };
    service.requirePro = function (onEntitled) {
      service.isProEntitled().then(function (entitled) {
        if (entitled) {
          onEntitled();
        } else {
          service.showPaywall().then(function (nowEntitled) {
            if (nowEntitled) {
              notifications.push('Η συνδρομή σας είναι ενεργή', notifications.INFO);
            }
          });
        }
      });
    };
    $rootScope.$on('scc.login', function () {
      if (instance) {
        instance.changeUser(authentication.getUser().revenuecatId);
      }
      customerInfoCache = null;
    });
    return service;
  }
})();
"use strict";

(function () {
  angular.module('app.scc').factory('reports', ReportsService);

  /** @ngInject */
  function ReportsService(scc, utils, notifications) {
    var service = {};
    service.downloadReport = function (reportType, input, scope, openInNewTab) {
      scc.execute(scc.PRIVATE_MODE, 'Get' + reportType + 'Report', input, scope.form, function (response) {
        var blob = utils.base64ToBlob(response.data.reportInBase64, response.data.contentType);
        var url = URL.createObjectURL(blob);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.href = url;
        a.target = '_blank';
        if (!openInNewTab) {
          a.download = response.data.filename;
        }
        a.click();
        document.body.removeChild(a);
      });
    };
    service.sendPersonalizedSchedule = function (input, scope) {
      scc.execute(scc.PRIVATE_MODE, 'SendPersonalizedSchedule', input, scope.form, function (response) {
        notifications.push('Τα email στάλθηκαν επιτυχώς', notifications.INFO);
      });
    };
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').factory('notifications', notificationsService);

  /** @ngInject */
  function notificationsService($timeout, $mdToast) {
    var errorTimeoutLimit = 3000;
    var notifications = [];
    var service = {};
    var timeout;
    service.SYSTEM_ERROR = 'system-error';
    service.ERROR = 'error';
    service.WARNING = 'warning';
    service.INFO = 'info';
    service.getAll = function () {
      return notifications;
    };
    service.clear = function () {
      notifications = [];
    };
    service.push = function (message, type) {
      var toastPromise = $mdToast.show({
        template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
        hideDelay: 3000,
        position: 'top right',
        parent: '#content'
      });
      var dismissHandler = function dismissHandler() {
        $mdToast.hide();
      };

      // Defer registration so the click that triggered the toast doesn't dismiss it
      $timeout(function () {
        document.addEventListener('click', dismissHandler, true);
      }, 100);
      toastPromise.finally(function () {
        document.removeEventListener('click', dismissHandler, true);
      });
    };
    return service;
  }
})();
"use strict";

(function () {
  angular.module('app.scc').factory('errorsHelper', ErrorsHelperService);

  /** @ngInject */
  function ErrorsHelperService() {
    var service = this;
    service.cleanFormErrors = function (form) {
      form.$sccFormError = null;
      form.$sccImplicitFieldsErrors = null;
      var field = null;
      for (field in form) {
        if (field.indexOf('$') == 0) {
          continue;
        }
        form[field].$setTouched();
        var error = null;
        for (error in form[field].$error) {
          if (error.indexOf('server.') != 0) {
            continue;
          }
          form[field].$setValidity(error, true);
        }
      }
    };
    return service;
  }
})();
"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
(function () {
  'use strict';

  angular.module('app.scc').factory('daoFactory', daoFactory);

  /** @ngInject */
  function daoFactory(scc, notifications, schools, authentication, $window, $rootScope) {
    var factory = {};
    factory.createDao = function (entityType, entityTypeCapitalized) {
      var selectedEntityIdKey = 'scc.' + entityType + '.selected.id';
      function userScopedKey() {
        var user = authentication.getUser();
        return user ? selectedEntityIdKey + '.' + user.id : null;
      }
      function readSelectedId() {
        var key = userScopedKey();
        if (!key) {
          return null;
        }
        var raw = $window.localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
      }
      function writeSelectedId(id) {
        var key = userScopedKey();
        if (!key) {
          return;
        }
        if (id == null) {
          $window.localStorage.removeItem(key);
        } else {
          $window.localStorage.setItem(key, JSON.stringify(id));
        }
      }
      var dao = {
        entities: [],
        selectedEntity: null
      };
      dao.cleanup = function () {
        dao.entities = [];
        dao.selectedEntity = null;
      };
      dao.init = function () {
        var req = {
          schoolId: schools.getSelectedSchool().id
        };
        req[entityType + "s"] = true;
        scc.request(scc.PRIVATE_MODE, 'GetAllResources', req, function (response) {
          dao.entities = response.data[entityType + "s"];
          var storedId = readSelectedId();
          if (storedId) {
            dao.selectedEntity = dao.get(storedId);
          } else {
            dao.selectedEntity = null;
            writeSelectedId(null);
          }
          $rootScope.$emit('scc.' + entityType + '.selected');
          console.log(entityType + 's loaded');
          $rootScope.$emit('scc.' + entityType + '.loaded');
        }, function (response) {
          console.log(entityType + 's could not be loaded');
        });
      };
      dao.select = function (entity) {
        dao.selectedEntity = entity;
        writeSelectedId(dao.selectedEntity ? dao.selectedEntity.id : null);
        $rootScope.$emit('scc.' + entityType + '.selected');
        console.log(entityType + ' ' + entity + 'selected');
      };
      dao.getSelected = function () {
        return dao.selectedEntity;
      };
      dao.getAll = function () {
        return dao.entities.slice();
      };
      dao.create = function (req, scope, onSuccess, onFailure) {
        scc.execute(scc.PRIVATE_MODE, 'Create' + entityTypeCapitalized, req, scope.form, function (response) {
          dao.entities.push(response.data[entityType]);
          if (onSuccess) {
            onSuccess(response);
          }
        }, onFailure);
      };
      dao.createAll = function (req, scope, onSuccess, onFailure) {
        scc.execute(scc.PRIVATE_MODE, 'Create' + entityTypeCapitalized + 's', req, scope.form, function (response) {
          var _dao$entities;
          (_dao$entities = dao.entities).push.apply(_dao$entities, _toConsumableArray(response.data[entityType + "s"]));
          if (onSuccess) {
            onSuccess(response);
          }
        }, onFailure);
      };
      dao.update = function (req, form, onSuccess) {
        scc.execute(scc.PRIVATE_MODE, 'Update' + entityTypeCapitalized, req, form, function (response) {
          for (var i = 0; i < dao.entities.length; i++) {
            if (dao.entities[i].id == response.data[entityType].id) {
              dao.entities[i] = response.data[entityType];
              break;
            }
          }
          if (dao.selectedEntity && dao.selectedEntity.id == response.data[entityType].id) {
            dao.selectedEntity = response.data[entityType];
          }
          if (onSuccess) {
            onSuccess();
          }
        });
      };
      dao.deleteListed = function (req, scope, onSuccess) {
        scc.execute(scc.PRIVATE_MODE, 'Delete' + entityTypeCapitalized + 's', req, scope.form, function (response) {
          var i = dao.entities.length;
          while (i--) {
            if (response.data[entityType + 'sIds'].indexOf(dao.entities[i].id) >= 0) {
              if (dao.selectedEntity && dao.selectedEntity.id == dao.entities[i].id) {
                dao.selectedEntity = null;
              }
              dao.entities.splice(i, 1);
            }
          }
          if (onSuccess) {
            onSuccess();
          }
        });
      };
      dao.get = function (id) {
        var l = dao.entities.length;
        for (var i = 0; i < l; i++) {
          if (dao.entities[i].id == id) {
            return angular.extend({}, dao.entities[i]);
          }
        }
        return null;
      };
      return dao;
    };
    return factory;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').factory('checkState', checkState);

  /** @ngInject */
  function checkState($rootScope, $timeout) {
    var addCheck = function addCheck($scope, form) {
      var removeListener = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
        if (form.$pristine) {
          return;
        }
        var shouldContinue = confirmUserAction();
        if (shouldContinue) {
          return;
        }
        $timeout(function () {
          $rootScope.loadingProgress = false;
        });
        event.preventDefault();
      });
      $scope.$on("$destroy", removeListener);
    };
    var confirmUserAction = function confirmUserAction() {
      return confirm("The form has changed" + ", do you want to continue without saving?");
    };
    return {
      checkFormOnStateChange: addCheck,
      confirmUserAction: confirmUserAction
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').factory('authentication', authenticationService);
  var TOKEN_KEY = 'sccAuthToken';
  var TOKEN_EXPIRES_AT_KEY = 'sccAuthTokenExpiresAt';
  var USER_KEY = 'sccAuthUser';

  /** @ngInject */
  function authenticationService($http, scc, $window, $rootScope, $timeout) {
    var service = {
      user: null
    };
    service.init = function () {
      var token = $window.localStorage.getItem(TOKEN_KEY);
      if (!token) {
        return;
      }
      var expiresAt = $window.localStorage.getItem(TOKEN_EXPIRES_AT_KEY);
      if (expiresAt && new Date(expiresAt) <= new Date()) {
        service.clearLocalAuth();
        return;
      }
      $http.defaults.headers.common.Authorization = 'Bearer ' + token;
      var userJson = $window.localStorage.getItem(USER_KEY);
      if (userJson) {
        try {
          service.user = JSON.parse(userJson);
        } catch (e) {
          service.user = null;
        }
      }
      // Defer to let module run blocks finish registering 'scc.login' listeners.
      // This factory is constructed during dependency resolution of a run block,
      // so emitting synchronously would fire before any $on(...) has been wired.
      $timeout(function () {
        $rootScope.$emit('scc.login');
      });
      console.log('Restored session from token');
    };
    service.login = function (request, scope, onSuccess, onFailure) {
      scc.execute(scc.PUBLIC_MODE, 'Login', request, scope.form, function (response) {
        var token = response.data.token;
        $window.localStorage.setItem(TOKEN_KEY, token);
        if (response.data.tokenExpiresAt) {
          $window.localStorage.setItem(TOKEN_EXPIRES_AT_KEY, response.data.tokenExpiresAt);
        }
        $window.localStorage.setItem(USER_KEY, JSON.stringify(response.data.user));
        $http.defaults.headers.common.Authorization = 'Bearer ' + token;
        service.user = response.data.user;
        $rootScope.$emit('scc.login');
        if (onSuccess) {
          onSuccess();
        }
      }, onFailure);
    };
    service.logout = function () {
      var finish = function finish() {
        service.clearLocalAuth();
        $window.location.reload();
      };
      scc.request(scc.PRIVATE_MODE, 'Logout', {}, finish, finish);
    };
    service.clearLocalAuth = function () {
      $window.localStorage.removeItem(TOKEN_KEY);
      $window.localStorage.removeItem(TOKEN_EXPIRES_AT_KEY);
      $window.localStorage.removeItem(USER_KEY);
      delete $http.defaults.headers.common.Authorization;
      service.user = null;
    };
    service.loggedIn = function () {
      return !!$window.localStorage.getItem(TOKEN_KEY);
    };
    service.getUser = function () {
      return service.user;
    };

    // If any request comes back 401, the token is no longer valid (revoked,
    // expired, or rotated). Drop local state so the user is bounced to the
    // login screen on the next route change.
    $rootScope.$on('scc.auth.unauthorized', function () {
      service.clearLocalAuth();
    });
    service.init();
    return service;
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').filter('sccTimeSlot', sccTimeSlot);

  /** @ngInject */
  function sccTimeSlot(utils) {
    return function (input) {
      return utils.timeSlotToHour(input);
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').filter('sccDay', sccDay);

  /** @ngInject */
  function sccDay(utils) {
    return function (input) {
      return utils.dayNumToDayName(input);
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.chat').controller('ChatController', ChatController);

  /** @ngInject */
  function ChatController(Contacts, ChatsService, $mdSidenav, User, $timeout, $document, $mdMedia) {
    var vm = this;

    // Data
    vm.contacts = ChatsService.contacts = Contacts.data;
    vm.chats = ChatsService.chats;
    vm.user = User.data;
    vm.leftSidenavView = false;
    vm.chat = undefined;

    // Methods
    vm.getChat = getChat;
    vm.toggleSidenav = toggleSidenav;
    vm.toggleLeftSidenavView = toggleLeftSidenavView;
    vm.reply = reply;
    vm.setUserStatus = setUserStatus;
    vm.clearMessages = clearMessages;

    //////////

    /**
     * Get Chat by Contact id
     * @param contactId
     */
    function getChat(contactId) {
      ChatsService.getContactChat(contactId).then(function (response) {
        vm.chatContactId = contactId;
        vm.chat = response;

        // Reset the reply textarea
        resetReplyTextarea();

        // Scroll to the last message
        scrollToBottomOfChat();
        if (!$mdMedia('gt-md')) {
          $mdSidenav('left-sidenav').close();
        }

        // Reset Left Sidenav View
        vm.toggleLeftSidenavView(false);
      });
    }

    /**
     * Reply
     */
    function reply($event) {
      // If "shift + enter" pressed, grow the reply textarea
      if ($event && $event.keyCode === 13 && $event.shiftKey) {
        vm.textareaGrow = true;
        return;
      }

      // Prevent the reply() for key presses rather than the"enter" key.
      if ($event && $event.keyCode !== 13) {
        return;
      }

      // Check for empty messages
      if (vm.replyMessage === '') {
        resetReplyTextarea();
        return;
      }

      // Message
      var message = {
        who: 'user',
        message: vm.replyMessage,
        time: new Date().toISOString()
      };

      // Add the message to the chat
      vm.chat.push(message);

      // Update Contact's lastMessage
      vm.contacts.getById(vm.chatContactId).lastMessage = message;

      // Reset the reply textarea
      resetReplyTextarea();

      // Scroll to the new message
      scrollToBottomOfChat();
    }

    /**
     * Clear Chat Messages
     */
    function clearMessages() {
      vm.chats[vm.chatContactId] = vm.chat = [];
      vm.contacts.getById(vm.chatContactId).lastMessage = null;
    }

    /**
     * Reset reply textarea
     */
    function resetReplyTextarea() {
      vm.replyMessage = '';
      vm.textareaGrow = false;
    }

    /**
     * Scroll Chat Content to the bottom
     * @param speed
     */
    function scrollToBottomOfChat() {
      $timeout(function () {
        var chatContent = angular.element($document.find('#chat-content'));
        chatContent.animate({
          scrollTop: chatContent[0].scrollHeight
        }, 400);
      }, 0);
    }

    /**
     * Set User Status
     */
    function setUserStatus(status) {
      vm.user.status = status;
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Toggle Left Sidenav View
     *
     * @param view id
     */
    function toggleLeftSidenavView(id) {
      vm.leftSidenavView = id;
    }

    /**
     * Array prototype
     *
     * Get by id
     *
     * @param value
     * @returns {T}
     */
    Array.prototype.getById = function (value) {
      return this.filter(function (x) {
        return x.id === value;
      })[0];
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core', ['ngAnimate', 'ngAria', 'ngCookies', 'ngMessages', 'ngResource', 'ngSanitize', 'ngMaterial', 'pascalprecht.translate', 'ui.router', 'mdPickers']);
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').controller('MsWidgetController', MsWidgetController).directive('msWidget', msWidgetDirective).directive('msWidgetFront', msWidgetFrontDirective).directive('msWidgetBack', msWidgetBackDirective);

  /** @ngInject */
  function MsWidgetController($scope, $element) {
    var vm = this;

    // Data
    vm.flipped = false;

    // Methods
    vm.flip = flip;

    //////////

    /**
     * Flip the widget
     */
    function flip() {
      if (!isFlippable()) {
        return;
      }

      // Toggle flipped status
      vm.flipped = !vm.flipped;

      // Toggle the 'flipped' class
      $element.toggleClass('flipped', vm.flipped);
    }

    /**
     * Check if widget is flippable
     *
     * @returns {boolean}
     */
    function isFlippable() {
      return angular.isDefined($scope.flippable) && $scope.flippable === true;
    }
  }

  /** @ngInject */
  function msWidgetDirective() {
    return {
      restrict: 'E',
      scope: {
        flippable: '=?'
      },
      controller: 'MsWidgetController',
      transclude: true,
      compile: function compile(tElement) {
        tElement.addClass('ms-widget');
        return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
          // Custom transclusion
          transcludeFn(function (clone) {
            iElement.empty();
            iElement.append(clone);
          });

          //////////
        };
      }
    };
  }

  /** @ngInject */
  function msWidgetFrontDirective() {
    return {
      restrict: 'E',
      require: '^msWidget',
      transclude: true,
      compile: function compile(tElement) {
        tElement.addClass('ms-widget-front');
        return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
          // Custom transclusion
          transcludeFn(function (clone) {
            iElement.empty();
            iElement.append(clone);
          });

          // Methods
          scope.flipWidget = MsWidgetCtrl.flip;
        };
      }
    };
  }

  /** @ngInject */
  function msWidgetBackDirective() {
    return {
      restrict: 'E',
      require: '^msWidget',
      transclude: true,
      compile: function compile(tElement) {
        tElement.addClass('ms-widget-back');
        return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn) {
          // Custom transclusion
          transcludeFn(function (clone) {
            iElement.empty();
            iElement.append(clone);
          });

          // Methods
          scope.flipWidget = MsWidgetCtrl.flip;
        };
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').controller('MsTimelineController', MsTimelineController).directive('msTimeline', msTimelineDirective).directive('msTimelineItem', msTimelineItemDirective);

  /** @ngInject */
  function MsTimelineController() {
    var vm = this;

    // Data
    vm.scrollEl = undefined;

    // Methods
    vm.setScrollEl = setScrollEl;
    vm.getScrollEl = getScrollEl;

    //////////

    /**
     * Set scroll element
     *
     * @param scrollEl
     */
    function setScrollEl(scrollEl) {
      vm.scrollEl = scrollEl;
    }

    /**
     * Get scroll element
     *
     * @returns {undefined|*}
     */
    function getScrollEl() {
      return vm.scrollEl;
    }
  }

  /** @ngInject */
  function msTimelineDirective() {
    return {
      scope: {
        msTimeline: '=?',
        loadMore: '&?msTimelineLoadMore'
      },
      controller: 'MsTimelineController',
      compile: function compile(tElement) {
        tElement.addClass('ms-timeline');
        return function postLink(scope, iElement, iAttrs, MsTimelineCtrl) {
          // Create an element for triggering the load more action and append it
          var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
          iElement.append(loadMoreEl);

          // Default config
          var config = {
            scrollEl: '#content'
          };

          // Extend the configuration
          config = angular.extend(config, scope.msTimeline, {});

          // Grab the scrollable element and store it in the controller for general use
          var scrollEl = angular.element(config.scrollEl);
          MsTimelineCtrl.setScrollEl(scrollEl);

          // Threshold
          var threshold = 144;

          // Register onScroll event for the first time
          registerOnScroll();

          /**
           * onScroll Event
           */
          function onScroll() {
            if (scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top) {
              // Show the loader
              loadMoreEl.addClass('show');

              // Unregister scroll event to prevent triggering the function over and over again
              unregisterOnScroll();

              // Trigger load more event
              scope.loadMore().then(
              // Success
              function () {
                // Hide the loader
                loadMoreEl.removeClass('show');

                // Register the onScroll event again
                registerOnScroll();
              },
              // Error
              function () {
                // Remove the loader completely
                loadMoreEl.remove();
              });
            }
          }

          /**
           * onScroll event registerer
           */
          function registerOnScroll() {
            scrollEl.on('scroll', onScroll);
          }

          /**
           * onScroll event unregisterer
           */
          function unregisterOnScroll() {
            scrollEl.off('scroll', onScroll);
          }

          // Cleanup
          scope.$on('$destroy', function () {
            unregisterOnScroll();
          });
        };
      }
    };
  }

  /** @ngInject */
  function msTimelineItemDirective($timeout, $q) {
    return {
      scope: true,
      require: '^msTimeline',
      compile: function compile(tElement) {
        tElement.addClass('ms-timeline-item').addClass('hidden');
        return function postLink(scope, iElement, iAttrs, MsTimelineCtrl) {
          var threshold = 72,
            itemLoaded = false,
            itemInViewport = false,
            scrollEl = MsTimelineCtrl.getScrollEl();

          //////////

          init();

          /**
           * Initialize
           */
          function init() {
            // Check if the timeline item has ms-card
            if (iElement.find('ms-card')) {
              // If the ms-card template loaded...
              scope.$on('msCard::cardTemplateLoaded', function (event, args) {
                var cardEl = angular.element(args[0]);

                // Test the card to see if there is any image on it
                testForImage(cardEl).then(function () {
                  $timeout(function () {
                    itemLoaded = true;
                  });
                });
              });
            } else {
              // Test the element to see if there is any image on it
              testForImage(iElement).then(function () {
                $timeout(function () {
                  itemLoaded = true;
                });
              });
            }

            // Check if the loaded element also in the viewport
            scrollEl.on('scroll', testForVisibility);

            // Test for visibility for the first time without waiting for the scroll event
            testForVisibility();
          }

          // Item ready watcher
          var itemReadyWatcher = scope.$watch(function () {
            return itemLoaded && itemInViewport;
          }, function (current, old) {
            if (angular.equals(current, old)) {
              return;
            }
            if (current) {
              iElement.removeClass('hidden').addClass('animate');

              // Unbind itemReadyWatcher
              itemReadyWatcher();
            }
          }, true);

          /**
           * Test the given element for image
           *
           * @param element
           * @returns promise
           */
          function testForImage(element) {
            var deferred = $q.defer(),
              imgEl = element.find('img');
            if (imgEl.length > 0) {
              imgEl.on('load', function () {
                deferred.resolve('Image is loaded');
              });
            } else {
              deferred.resolve('No images');
            }
            return deferred.promise;
          }

          /**
           * Test the element for visibility
           */
          function testForVisibility() {
            if (scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold) {
              $timeout(function () {
                itemInViewport = true;
              });

              // Unbind the scroll event
              scrollEl.off('scroll', testForVisibility);
            }
          }
        };
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').controller('MsStepperController', MsStepperController).directive('msHorizontalStepper', msHorizontalStepperDirective).directive('msHorizontalStepperStep', msHorizontalStepperStepDirective).directive('msVerticalStepper', msVerticalStepperDirective).directive('msVerticalStepperStep', msVerticalStepperStepDirective);

  /** @ngInject */
  function MsStepperController($timeout) {
    var vm = this;

    // Data
    vm.mainForm = undefined;
    vm.orientation = 'horizontal';
    vm.steps = [];
    vm.currentStep = undefined;
    vm.currentStepNumber = 1;

    // Methods
    vm.setOrientation = setOrientation;
    vm.registerMainForm = registerMainForm;
    vm.registerStep = registerStep;
    vm.setupSteps = setupSteps;
    vm.resetForm = resetForm;
    vm.setCurrentStep = setCurrentStep;
    vm.gotoStep = gotoStep;
    vm.gotoPreviousStep = gotoPreviousStep;
    vm.gotoNextStep = gotoNextStep;
    vm.gotoFirstStep = gotoFirstStep;
    vm.gotoLastStep = gotoLastStep;
    vm.isFirstStep = isFirstStep;
    vm.isLastStep = isLastStep;
    vm.isStepCurrent = isStepCurrent;
    vm.isStepDisabled = isStepDisabled;
    vm.isStepOptional = isStepOptional;
    vm.isStepHidden = isStepHidden;
    vm.filterHiddenStep = filterHiddenStep;
    vm.isStepValid = isStepValid;
    vm.isStepNumberValid = isStepNumberValid;
    vm.isFormValid = isFormValid;

    //////////

    /**
     * Set the orientation of the stepper
     *
     * @param orientation
     */
    function setOrientation(orientation) {
      vm.orientation = orientation || 'horizontal';
    }

    /**
     * Register the main form
     *
     * @param form
     */
    function registerMainForm(form) {
      vm.mainForm = form;
    }

    /**
     * Register a step
     *
     * @param element
     * @param scope
     * @param form
     */
    function registerStep(element, scope, form) {
      var step = {
        element: element,
        scope: scope,
        form: form,
        stepNumber: scope.step || vm.steps.length + 1,
        stepTitle: scope.stepTitle,
        stepTitleTranslate: scope.stepTitleTranslate
      };

      // Push the step into steps array
      vm.steps.push(step);

      // Sort steps by stepNumber
      vm.steps.sort(function (a, b) {
        return a.stepNumber - b.stepNumber;
      });
      return step;
    }

    /**
     * Setup steps for the first time
     */
    function setupSteps() {
      vm.setCurrentStep(vm.currentStepNumber);
    }

    /**
     * Reset steps and the main form
     */
    function resetForm() {
      // Timeout is required here because we need to
      // let form model to reset before setting the
      // statuses
      $timeout(function () {
        // Reset all the steps
        for (var x = 0; x < vm.steps.length; x++) {
          vm.steps[x].form.$setPristine();
          vm.steps[x].form.$setUntouched();
        }

        // Reset the main form
        vm.mainForm.$setPristine();
        vm.mainForm.$setUntouched();

        // Go to first step
        gotoFirstStep();
      });
    }

    /**
     * Set current step
     *
     * @param stepNumber
     */
    function setCurrentStep(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return;
      }

      // Update the current step number
      vm.currentStepNumber = stepNumber;
      if (vm.orientation === 'horizontal') {
        // Hide all steps
        for (var i = 0; i < vm.steps.length; i++) {
          vm.steps[i].element.hide();
        }

        // Show the current step
        vm.steps[vm.currentStepNumber - 1].element.show();
      } else if (vm.orientation === 'vertical') {
        // Hide all step content
        for (var j = 0; j < vm.steps.length; j++) {
          vm.steps[j].element.find('.ms-stepper-step-content').hide();
        }

        // Show the current step content
        vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
      }
    }

    /**
     * Go to a step
     *
     * @param stepNumber
     */
    function gotoStep(stepNumber) {
      // If the step we are about to go
      // is hidden, bail...
      if (isStepHidden(stepNumber)) {
        return;
      }
      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the previous step
     */
    function gotoPreviousStep() {
      var stepNumber = vm.currentStepNumber - 1;

      // Test the previous steps and make sure we
      // will land to the one that is not hidden
      for (var s = stepNumber; s >= 1; s--) {
        if (!isStepHidden(s)) {
          stepNumber = s;
          break;
        }
      }
      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the next step
     */
    function gotoNextStep() {
      var stepNumber = vm.currentStepNumber + 1;

      // Test the following steps and make sure we
      // will land to the one that is not hidden
      for (var s = stepNumber; s <= vm.steps.length; s++) {
        if (!isStepHidden(s)) {
          stepNumber = s;
          break;
        }
      }
      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the first step
     */
    function gotoFirstStep() {
      vm.setCurrentStep(1);
    }

    /**
     * Go to the last step
     */
    function gotoLastStep() {
      vm.setCurrentStep(vm.steps.length);
    }

    /**
     * Check if the current step is the first step
     *
     * @returns {boolean}
     */
    function isFirstStep() {
      return vm.currentStepNumber === 1;
    }

    /**
     * Check if the current step is the last step
     *
     * @returns {boolean}
     */
    function isLastStep() {
      return vm.currentStepNumber === vm.steps.length;
    }

    /**
     * Check if the given step is the current one
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepCurrent(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }
      return vm.currentStepNumber === stepNumber;
    }

    /**
     * Check if the given step should be disabled
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepDisabled(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }
      var disabled = false;
      for (var i = 1; i < stepNumber; i++) {
        if (!isStepValid(i)) {
          disabled = true;
          break;
        }
      }
      return disabled;
    }

    /**
     * Check if the given step is optional
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepOptional(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }
      return vm.steps[stepNumber - 1].scope.optionalStep;
    }

    /**
     * Check if the given step is hidden
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepHidden(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }
      return !!vm.steps[stepNumber - 1].scope.hideStep;
    }

    /**
     * Check if the given step is hidden as a filter
     *
     * @param step
     * @returns {boolean}
     */
    function filterHiddenStep(step) {
      return !isStepHidden(step.stepNumber);
    }

    /**
     * Check if the given step is valid
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepValid(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      // If the step is optional, always return true
      if (isStepOptional(stepNumber)) {
        return true;
      }
      return vm.steps[stepNumber - 1].form.$valid;
    }

    /**
     * Check if the given step number is a valid step number
     *
     * @param stepNumber
     * @returns {boolean}
     */
    function isStepNumberValid(stepNumber) {
      return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
    }

    /**
     * Check if the entire form is valid
     *
     * @returns {boolean}
     */
    function isFormValid() {
      return vm.mainForm.$valid;
    }
  }

  /** @ngInject */
  function msHorizontalStepperDirective() {
    return {
      restrict: 'A',
      scope: {},
      require: ['form', 'msHorizontalStepper'],
      priority: 1001,
      controller: 'MsStepperController as MsStepper',
      bindToController: {
        model: '=ngModel'
      },
      transclude: true,
      templateUrl: 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
      compile: function compile(tElement) {
        tElement.addClass('ms-stepper');
        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Register the main form and setup
          // the steps for the first time
          MsStepperCtrl.setOrientation('horizontal');
          MsStepperCtrl.registerMainForm(FormCtrl);
          MsStepperCtrl.setupSteps();
        };
      }
    };
  }

  /** @ngInject */
  function msHorizontalStepperStepDirective() {
    return {
      restrict: 'E',
      require: ['form', '^msHorizontalStepper'],
      priority: 1000,
      scope: {
        step: '=?',
        stepTitle: '=?',
        stepTitleTranslate: '=?',
        optionalStep: '=?',
        hideStep: '=?'
      },
      compile: function compile(tElement) {
        tElement.addClass('ms-stepper-step');
        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Is it an optional step?
          scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

          // Register the step
          MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

          // Hide the step by default
          iElement.hide();
        };
      }
    };
  }

  /** @ngInject */
  function msVerticalStepperDirective($timeout) {
    return {
      restrict: 'A',
      scope: {},
      require: ['form', 'msVerticalStepper'],
      priority: 1001,
      controller: 'MsStepperController as MsStepper',
      bindToController: {
        model: '=ngModel'
      },
      transclude: true,
      templateUrl: 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
      compile: function compile(tElement) {
        tElement.addClass('ms-stepper');
        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Register the main form and setup
          // the steps for the first time

          // Timeout is required in vertical stepper
          // as we are using transclusion in steps.
          // We have to wait for them to be transcluded
          // and registered to the controller
          $timeout(function () {
            MsStepperCtrl.setOrientation('vertical');
            MsStepperCtrl.registerMainForm(FormCtrl);
            MsStepperCtrl.setupSteps();
          });
        };
      }
    };
  }

  /** @ngInject */
  function msVerticalStepperStepDirective() {
    return {
      restrict: 'E',
      require: ['form', '^msVerticalStepper'],
      priority: 1000,
      scope: {
        step: '=?',
        stepTitle: '=?',
        stepTitleTranslate: '=?',
        optionalStep: '=?',
        hideStep: '=?'
      },
      transclude: true,
      templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
      compile: function compile(tElement) {
        tElement.addClass('ms-stepper-step');
        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsStepperCtrl = ctrls[1];

          // Is it an optional step?
          scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

          // Register the step
          scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

          // Expose the controller to the scope
          scope.MsStepper = MsStepperCtrl;

          // Hide the step content by default
          iElement.find('.ms-stepper-step-content').hide();
        };
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').directive('msSplashScreen', msSplashScreenDirective);

  /** @ngInject */
  function msSplashScreenDirective($animate) {
    return {
      restrict: 'E',
      link: function link(scope, iElement) {
        var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function () {
          $animate.leave(iElement).then(function () {
            // De-register scope event
            splashScreenRemoveEvent();

            // Null-ify everything else
            scope = iElement = null;
          });
        });
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').directive('msSidenavHelper', msSidenavHelperDirective);

  /** @ngInject */
  function msSidenavHelperDirective() {
    return {
      restrict: 'A',
      require: '^mdSidenav',
      link: function link(scope, iElement, iAttrs, MdSidenavCtrl) {
        // Watch md-sidenav open & locked open statuses
        // and add class to the ".page-layout" if only
        // the sidenav open and NOT locked open
        scope.$watch(function () {
          return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
        }, function (current) {
          if (angular.isUndefined(current)) {
            return;
          }
          iElement.parent().toggleClass('full-height', current);
          angular.element('html').toggleClass('sidenav-open', current);
        });
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').controller('MsShortcutsController', MsShortcutsController).directive('msShortcuts', msShortcutsDirective);

  /** @ngInject */
  function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService) {
    var vm = this;

    // Data
    vm.query = '';
    vm.queryOptions = {
      debounce: 300
    };
    vm.resultsLoading = false;
    vm.selectedResultIndex = 0;
    vm.ignoreMouseEvents = false;
    vm.mobileBarActive = false;
    vm.results = null;
    vm.shortcuts = [];
    vm.sortableOptions = {
      ghostClass: 'ghost',
      forceFallback: true,
      fallbackClass: 'dragging',
      onSort: function onSort() {
        vm.saveShortcuts();
      }
    };

    // Methods
    vm.populateResults = populateResults;
    vm.loadShortcuts = loadShortcuts;
    vm.saveShortcuts = saveShortcuts;
    vm.addShortcut = addShortcut;
    vm.removeShortcut = removeShortcut;
    vm.handleResultClick = handleResultClick;
    vm.absorbEvent = absorbEvent;
    vm.handleKeydown = handleKeydown;
    vm.handleMouseenter = handleMouseenter;
    vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
    vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
    vm.toggleMobileBar = toggleMobileBar;

    //////////

    init();
    function init() {
      // Load the shortcuts
      vm.loadShortcuts().then(
      // Success
      function (response) {
        vm.shortcuts = response;

        // Add shortcuts as results by default
        if (vm.shortcuts.length > 0) {
          vm.results = response;
        }
      });

      // Watch the model changes to trigger the search
      $scope.$watch('MsShortcuts.query', function (current, old) {
        if (angular.isUndefined(current)) {
          return;
        }
        if (angular.equals(current, old)) {
          return;
        }

        // Show the loader
        vm.resultsLoading = true;

        // Populate the results
        vm.populateResults().then(
        // Success
        function (response) {
          vm.results = response;
        },
        // Error
        function () {
          vm.results = [];
        }).finally(function () {
          // Hide the loader
          vm.resultsLoading = false;
        });
      });
    }

    /**
     * Populate the results
     */
    function populateResults() {
      var results = [],
        flatNavigation = msNavigationService.getFlatNavigation(),
        deferred = $q.defer();

      // Iterate through the navigation array and
      // make sure it doesn't have any groups or
      // none ui-sref items
      for (var x = 0; x < flatNavigation.length; x++) {
        if (flatNavigation[x].uisref) {
          results.push(flatNavigation[x]);
        }
      }

      // If there is a query, filter the results
      if (vm.query) {
        results = results.filter(function (item) {
          if (angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1) {
            return true;
          }
        });

        // Iterate through one last time and
        // add required properties to items
        for (var i = 0; i < results.length; i++) {
          // Add false to hasShortcut by default
          results[i].hasShortcut = false;

          // Test if the item is in the shortcuts list
          for (var y = 0; y < vm.shortcuts.length; y++) {
            if (vm.shortcuts[y]._id === results[i]._id) {
              results[i].hasShortcut = true;
              break;
            }
          }
        }
      } else {
        // If the query is empty, that means
        // there is nothing to search for so
        // we will populate the results with
        // current shortcuts if there is any
        if (vm.shortcuts.length > 0) {
          results = vm.shortcuts;
        }
      }

      // Reset the selected result
      vm.selectedResultIndex = 0;

      // Fake the service delay
      $timeout(function () {
        // Resolve the promise
        deferred.resolve(results);
      }, 250);

      // Return a promise
      return deferred.promise;
    }

    /**
     * Load shortcuts
     */
    function loadShortcuts() {
      var deferred = $q.defer();

      // For the demo purposes, we will
      // load the shortcuts from the cookies.
      // But here you can make an API call
      // to load them from the DB.
      var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

      // No cookie available. Generate one
      // for the demo purposes...
      if (angular.isUndefined(shortcuts)) {
        shortcuts = [{
          'title': 'Sample',
          'icon': 'icon-tile-four',
          'state': 'app.sample',
          'weight': 1,
          'children': [],
          '_id': 'sample',
          '_path': 'apps.sample',
          'uisref': 'app.sample',
          'hasShortcut': true
        }];
        $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
      }

      // Resolve the promise
      deferred.resolve(shortcuts);
      return deferred.promise;
    }

    /**
     * Save the shortcuts
     */
    function saveShortcuts() {
      var deferred = $q.defer();

      // For the demo purposes, we will
      // keep the shortcuts in the cookies.
      // But here you can make an API call
      // to save them to the DB.
      $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

      // Fake the service delay
      $timeout(function () {
        deferred.resolve({
          'success': true
        });
      }, 250);
      return deferred.promise;
    }

    /**
     * Add item as shortcut
     *
     * @param item
     */
    function addShortcut(item) {
      // Update the hasShortcut status
      item.hasShortcut = true;

      // Add as a shortcut
      vm.shortcuts.push(item);

      // Save the shortcuts
      vm.saveShortcuts();
    }

    /**
     * Remove item from shortcuts
     *
     * @param item
     */
    function removeShortcut(item) {
      // Update the hasShortcut status
      item.hasShortcut = false;

      // Remove the shortcut
      for (var x = 0; x < vm.shortcuts.length; x++) {
        if (vm.shortcuts[x]._id === item._id) {
          // Remove the x-th item from the array
          vm.shortcuts.splice(x, 1);

          // If we aren't searching for anything...
          if (!vm.query) {
            // If all the shortcuts have been removed,
            // null-ify the results
            if (vm.shortcuts.length === 0) {
              vm.results = null;
            }
            // Otherwise update the selected index
            else {
              if (x >= vm.shortcuts.length) {
                vm.selectedResultIndex = vm.shortcuts.length - 1;
              }
            }
          }
        }
      }

      // Save the shortcuts
      vm.saveShortcuts();
    }

    /**
     * Handle the result click
     *
     * @param item
     */
    function handleResultClick(item) {
      // Add or remove the shortcut
      if (item.hasShortcut) {
        vm.removeShortcut(item);
      } else {
        vm.addShortcut(item);
      }
    }

    /**
     * Absorb the given event
     *
     * @param event
     */
    function absorbEvent(event) {
      event.preventDefault();
    }

    /**
     * Handle keydown
     *
     * @param event
     */
    function handleKeydown(event) {
      var keyCode = event.keyCode,
        keys = [38, 40];

      // Prevent the default action if
      // one of the keys are pressed that
      // we are listening
      if (keys.indexOf(keyCode) > -1) {
        event.preventDefault();
      }
      switch (keyCode) {
        // Enter
        case 13:
          // Trigger result click
          vm.handleResultClick(vm.results[vm.selectedResultIndex]);
          break;

        // Up Arrow
        case 38:
          // Decrease the selected result index
          if (vm.selectedResultIndex - 1 >= 0) {
            // Decrease the selected index
            vm.selectedResultIndex--;

            // Make sure the selected result is in the view
            vm.ensureSelectedResultIsVisible();
          }
          break;

        // Down Arrow
        case 40:
          // Increase the selected result index
          if (vm.selectedResultIndex + 1 < vm.results.length) {
            // Increase the selected index
            vm.selectedResultIndex++;

            // Make sure the selected result is in the view
            vm.ensureSelectedResultIsVisible();
          }
          break;
        default:
          break;
      }
    }

    /**
     * Handle mouseenter
     *
     * @param index
     */
    function handleMouseenter(index) {
      if (vm.ignoreMouseEvents) {
        return;
      }

      // Update the selected result index
      // with the given index
      vm.selectedResultIndex = index;
    }

    /**
     * Set a variable for a limited time
     * to make other functions to ignore
     * the mouse events
     */
    function temporarilyIgnoreMouseEvents() {
      // Set the variable
      vm.ignoreMouseEvents = true;

      // Cancel the previous timeout
      $timeout.cancel(vm.mouseEventIgnoreTimeout);

      // Set the timeout
      vm.mouseEventIgnoreTimeout = $timeout(function () {
        vm.ignoreMouseEvents = false;
      }, 250);
    }

    /**
     * Ensure the selected result will
     * always be visible on the results
     * area
     */
    function ensureSelectedResultIsVisible() {
      var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
        selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);
      if (resultsEl && selectedItemEl) {
        var top = selectedItemEl.position().top - 8,
          bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

        // Start ignoring mouse events
        vm.temporarilyIgnoreMouseEvents();
        if (resultsEl.scrollTop() > top) {
          resultsEl.scrollTop(top);
        }
        if (bottom > resultsEl.height() + resultsEl.scrollTop()) {
          resultsEl.scrollTop(bottom - resultsEl.height());
        }
      }
    }

    /**
     * Toggle mobile bar
     */
    function toggleMobileBar() {
      vm.mobileBarActive = !vm.mobileBarActive;
    }
  }

  /** @ngInject */
  function msShortcutsDirective() {
    return {
      restrict: 'E',
      scope: {},
      require: 'msShortcuts',
      controller: 'MsShortcutsController as MsShortcuts',
      bindToController: {},
      templateUrl: 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
      compile: function compile(tElement) {
        // Add class
        tElement.addClass('ms-shortcuts');
        return function postLink(scope, iElement) {
          // Data
        };
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').controller('MsSearchBarController', MsSearchBarController).directive('msSearchBar', msSearchBarDirective);

  /** @ngInject */
  function MsSearchBarController($scope, $element, $timeout) {
    var vm = this;

    // Data
    vm.collapsed = true;
    vm.query = '';
    vm.queryOptions = {
      debounce: vm.debounce || 0
    };
    vm.resultsLoading = false;
    vm.results = null;
    vm.selectedResultIndex = 0;
    vm.ignoreMouseEvents = false;

    // Methods
    vm.populateResults = populateResults;
    vm.expand = expand;
    vm.collapse = collapse;
    vm.absorbEvent = absorbEvent;
    vm.handleKeydown = handleKeydown;
    vm.handleMouseenter = handleMouseenter;
    vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
    vm.handleResultClick = handleResultClick;
    vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

    //////////

    init();
    function init() {
      // Watch the model changes to trigger the search
      $scope.$watch('MsSearchBar.query', function (current, old) {
        if (angular.isUndefined(current)) {
          return;
        }
        if (angular.equals(current, old)) {
          return;
        }
        if (vm.collapsed) {
          return;
        }

        // Evaluate the onSearch function to access the
        // function itself
        var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {
            query: current
          }),
          isArray = angular.isArray(onSearchEvaluated),
          isPromise = onSearchEvaluated && !!onSearchEvaluated.then;
        if (isArray) {
          // Populate the results
          vm.populateResults(onSearchEvaluated);
        }
        if (isPromise) {
          // Show the loader
          vm.resultsLoading = true;
          onSearchEvaluated.then(
          // Success
          function (response) {
            // Populate the results
            vm.populateResults(response);
          },
          // Error
          function () {
            // Assign an empty array to show
            // the no-results screen
            vm.populateResults([]);
          }).finally(function () {
            // Hide the loader
            vm.resultsLoading = false;
          });
        }
      });
    }

    /**
     * Populate the results
     *
     * @param results
     */
    function populateResults(results) {
      // Before doing anything,
      // make sure the search bar is expanded
      if (vm.collapsed) {
        return;
      }
      var isArray = angular.isArray(results),
        isNull = results === null;

      // Only accept arrays and null values
      if (!isArray && !isNull) {
        return;
      }

      // Reset the selected result
      vm.selectedResultIndex = 0;

      // Populate the results
      vm.results = results;
    }

    /**
     * Expand
     */
    function expand() {
      // Set collapsed status
      vm.collapsed = false;

      // Call expand on scope
      $scope.expand();

      // Callback
      if (vm.onExpand && angular.isFunction(vm.onExpand)) {
        vm.onExpand();
      }
    }

    /**
     * Collapse
     */
    function collapse() {
      // Empty the query
      vm.query = '';

      // Empty results to hide the results view
      vm.populateResults(null);

      // Set collapsed status
      vm.collapsed = true;

      // Call collapse on scope
      $scope.collapse();

      // Callback
      if (vm.onCollapse && angular.isFunction(vm.onCollapse)) {
        vm.onCollapse();
      }
    }

    /**
     * Absorb the given event
     *
     * @param event
     */
    function absorbEvent(event) {
      event.preventDefault();
    }

    /**
     * Handle keydown
     *
     * @param event
     */
    function handleKeydown(event) {
      var keyCode = event.keyCode,
        keys = [27, 38, 40];

      // Prevent the default action if
      // one of the keys are pressed that
      // we are listening
      if (keys.indexOf(keyCode) > -1) {
        event.preventDefault();
      }
      switch (keyCode) {
        // Enter
        case 13:
          // Trigger result click
          vm.handleResultClick(vm.results[vm.selectedResultIndex]);
          break;

        // Escape
        case 27:
          // Collapse the search bar
          vm.collapse();
          break;

        // Up Arrow
        case 38:
          // Decrease the selected result index
          if (vm.selectedResultIndex - 1 >= 0) {
            // Decrease the selected index
            vm.selectedResultIndex--;

            // Make sure the selected result is in the view
            vm.ensureSelectedResultIsVisible();
          }
          break;

        // Down Arrow
        case 40:
          if (!vm.results) {
            return;
          }

          // Increase the selected result index
          if (vm.selectedResultIndex + 1 < vm.results.length) {
            // Increase the selected index
            vm.selectedResultIndex++;

            // Make sure the selected result is in the view
            vm.ensureSelectedResultIsVisible();
          }
          break;
        default:
          break;
      }
    }

    /**
     * Handle mouseenter
     *
     * @param index
     */
    function handleMouseenter(index) {
      if (vm.ignoreMouseEvents) {
        return;
      }

      // Update the selected result index
      // with the given index
      vm.selectedResultIndex = index;
    }

    /**
     * Set a variable for a limited time
     * to make other functions to ignore
     * the mouse events
     */
    function temporarilyIgnoreMouseEvents() {
      // Set the variable
      vm.ignoreMouseEvents = true;

      // Cancel the previous timeout
      $timeout.cancel(vm.mouseEventIgnoreTimeout);

      // Set the timeout
      vm.mouseEventIgnoreTimeout = $timeout(function () {
        vm.ignoreMouseEvents = false;
      }, 250);
    }

    /**
     * Handle the result click
     *
     * @param item
     */
    function handleResultClick(item) {
      if (vm.onResultClick) {
        vm.onResultClick({
          item: item
        });
      }

      // Collapse the search bar
      vm.collapse();
    }

    /**
     * Ensure the selected result will
     * always be visible on the results
     * area
     */
    function ensureSelectedResultIsVisible() {
      var resultsEl = $element.find('.ms-search-bar-results'),
        selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);
      if (resultsEl && selectedItemEl) {
        var top = selectedItemEl.position().top - 8,
          bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

        // Start ignoring mouse events
        vm.temporarilyIgnoreMouseEvents();
        if (resultsEl.scrollTop() > top) {
          resultsEl.scrollTop(top);
        }
        if (bottom > resultsEl.height() + resultsEl.scrollTop()) {
          resultsEl.scrollTop(bottom - resultsEl.height());
        }
      }
    }
  }

  /** @ngInject */
  function msSearchBarDirective($document) {
    return {
      restrict: 'E',
      scope: {},
      require: 'msSearchBar',
      controller: 'MsSearchBarController as MsSearchBar',
      bindToController: {
        debounce: '=?',
        onSearch: '@',
        onResultClick: '&?',
        onExpand: '&?',
        onCollapse: '&?'
      },
      templateUrl: 'app/core/directives/ms-search-bar/ms-search-bar.html',
      compile: function compile(tElement) {
        // Add class
        tElement.addClass('ms-search-bar');
        return function postLink(scope, iElement) {
          // Data
          var inputEl,
            bodyEl = $document.find('body');

          // Methods
          scope.collapse = collapse;
          scope.expand = expand;

          //////////

          // Initialize
          init();

          /**
           * Initialize
           */
          function init() {
            // Grab the input element
            inputEl = iElement.find('#ms-search-bar-input');
          }

          /**
           * Expand action
           */
          function expand() {
            // Add expanded class
            iElement.addClass('expanded');

            // Add helper class to the body
            bodyEl.addClass('ms-search-bar-expanded');

            // Focus on the input
            inputEl.focus();
          }

          /**
           * Collapse action
           */
          function collapse() {
            // Remove expanded class
            iElement.removeClass('expanded');

            // Remove helper class from the body
            bodyEl.removeClass('ms-search-bar-expanded');
          }
        };
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').provider('msScrollConfig', msScrollConfigProvider).directive('msScroll', msScrollDirective);

  /** @ngInject */
  function msScrollConfigProvider() {
    // Default configuration
    var defaultConfiguration = {
      wheelSpeed: 1,
      wheelPropagation: false,
      swipePropagation: true,
      minScrollbarLength: null,
      maxScrollbarLength: null,
      useBothWheelAxes: false,
      useKeyboard: true,
      suppressScrollX: false,
      suppressScrollY: false,
      scrollXMarginOffset: 0,
      scrollYMarginOffset: 0,
      stopPropagationOnClick: true
    };

    // Methods
    this.config = config;

    //////////

    /**
     * Extend default configuration with the given one
     *
     * @param configuration
     */
    function config(configuration) {
      defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
    }

    /**
     * Service
     */
    this.$get = function () {
      var service = {
        getConfig: getConfig
      };
      return service;

      //////////

      /**
       * Return the config
       */
      function getConfig() {
        return defaultConfiguration;
      }
    };
  }

  /** @ngInject */
  function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig) {
    return {
      restrict: 'AE',
      compile: function compile(tElement) {
        // Do not replace scrollbars if
        // 'disableCustomScrollbars' config enabled
        if (fuseConfig.getConfig('disableCustomScrollbars')) {
          return;
        }

        // Do not replace scrollbars on mobile devices
        // if 'disableCustomScrollbarsOnMobile' config enabled
        if (fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile()) {
          return;
        }

        // Add class
        tElement.addClass('ms-scroll');
        return function postLink(scope, iElement, iAttrs) {
          var options = {};

          // If options supplied, evaluate the given
          // value. This is because we don't want to
          // have an isolated scope but still be able
          // to use scope variables.
          // We don't want an isolated scope because
          // we should be able to use this everywhere
          // especially with other directives
          if (iAttrs.msScroll) {
            options = scope.$eval(iAttrs.msScroll);
          }

          // Extend the given config with the ones from provider
          options = angular.extend({}, msScrollConfig.getConfig(), options);

          // Initialize the scrollbar
          $timeout(function () {
            PerfectScrollbar.initialize(iElement[0], options);
          }, 0);

          // Update the scrollbar on element mouseenter
          iElement.on('mouseenter', updateScrollbar);

          // Watch scrollHeight and update
          // the scrollbar if it changes
          scope.$watch(function () {
            return iElement.prop('scrollHeight');
          }, function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }
            updateScrollbar();
          });

          // Watch scrollWidth and update
          // the scrollbar if it changes
          scope.$watch(function () {
            return iElement.prop('scrollWidth');
          }, function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }
            updateScrollbar();
          });

          /**
           * Update the scrollbar
           */
          function updateScrollbar() {
            PerfectScrollbar.update(iElement[0]);
          }

          // Cleanup on destroy
          scope.$on('$destroy', function () {
            iElement.off('mouseenter');
            PerfectScrollbar.destroy(iElement[0]);
          });
        };
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').directive('msResponsiveTable', msResponsiveTableDirective);

  /** @ngInject */
  function msResponsiveTableDirective() {
    return {
      restrict: 'A',
      link: function link(scope, iElement) {
        // Wrap the table
        var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
        iElement.after(wrapper);
        wrapper.append(iElement);

        //////////
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').directive('msRandomClass', msRandomClassDirective);

  /** @ngInject */
  function msRandomClassDirective() {
    return {
      restrict: 'A',
      scope: {
        msRandomClass: '='
      },
      link: function link(scope, iElement) {
        var randomClass = scope.msRandomClass[Math.floor(Math.random() * scope.msRandomClass.length)];
        iElement.addClass(randomClass);
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').provider('msNavigationService', msNavigationServiceProvider).controller('MsNavigationController', MsNavigationController)
  // Vertical
  .directive('msNavigation', msNavigationDirective).controller('MsNavigationNodeController', MsNavigationNodeController).directive('msNavigationNode', msNavigationNodeDirective).directive('msNavigationItem', msNavigationItemDirective)
  //Horizontal
  .directive('msNavigationHorizontal', msNavigationHorizontalDirective).controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController).directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective).directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

  /** @ngInject */
  function msNavigationServiceProvider() {
    // Inject $log service
    var $log = angular.injector(['ng']).get('$log');

    // Navigation array
    var navigation = [];
    var service = this;

    // Methods
    service.saveItem = saveItem;
    service.deleteItem = deleteItem;
    service.sortByWeight = sortByWeight;

    //////////

    /**
     * Create or update the navigation item
     *
     * @param path
     * @param item
     */
    function saveItem(path, item) {
      if (!angular.isString(path)) {
        $log.error('path must be a string (eg. `dashboard.project`)');
        return;
      }
      var parts = path.split('.');

      // Generate the object id from the parts
      var id = parts[parts.length - 1];

      // Get the parent item from the parts
      var parent = _findOrCreateParent(parts);

      // Decide if we are going to update or create
      var updateItem = false;
      for (var i = 0; i < parent.length; i++) {
        if (parent[i]._id === id) {
          updateItem = parent[i];
          break;
        }
      }

      // Update
      if (updateItem) {
        angular.extend(updateItem, item);

        // Add proper ui-sref
        updateItem.uisref = _getUiSref(updateItem);
      }
      // Create
      else {
        // Create an empty children array in the item
        item.children = [];

        // Add the default weight if not provided or if it's not a number
        if (angular.isUndefined(item.weight) || !angular.isNumber(item.weight)) {
          item.weight = 1;
        }

        // Add the item id
        item._id = id;

        // Add the item path
        item._path = path;

        // Add proper ui-sref
        item.uisref = _getUiSref(item);

        // Push the item into the array
        parent.push(item);
      }
    }

    /**
     * Delete navigation item
     *
     * @param path
     */
    function deleteItem(path) {
      if (!angular.isString(path)) {
        $log.error('path must be a string (eg. `dashboard.project`)');
        return;
      }

      // Locate the item by using given path
      var item = navigation,
        parts = path.split('.');
      for (var p = 0; p < parts.length; p++) {
        var id = parts[p];
        for (var i = 0; i < item.length; i++) {
          if (item[i]._id === id) {
            // If we have a matching path,
            // we have found our object:
            // remove it.
            if (item[i]._path === path) {
              item.splice(i, 1);
              return true;
            }

            // Otherwise grab the children of
            // the current item and continue
            item = item[i].children;
            break;
          }
        }
      }
      return false;
    }

    /**
     * Sort the navigation items by their weights
     *
     * @param parent
     */
    function sortByWeight(parent) {
      // If parent not provided, sort the root items
      if (!parent) {
        parent = navigation;
        parent.sort(_byWeight);
      }

      // Sort the children
      for (var i = 0; i < parent.length; i++) {
        var children = parent[i].children;
        if (children.length > 1) {
          children.sort(_byWeight);
        }
        if (children.length > 0) {
          sortByWeight(children);
        }
      }
    }

    /* ----------------- */
    /* Private Functions */
    /* ----------------- */

    /**
     * Find or create parent
     *
     * @param parts
     * @returns {Array|Boolean}
     * @private
     */
    function _findOrCreateParent(parts) {
      // Store the main navigation
      var parent = navigation;

      // If it's going to be a root item
      // return the navigation itself
      if (parts.length === 1) {
        return parent;
      }

      // Remove the last element from the parts as
      // we don't need that to figure out the parent
      parts.pop();

      // Find and return the parent
      for (var i = 0; i < parts.length; i++) {
        var _id = parts[i],
          createParent = true;
        for (var p = 0; p < parent.length; p++) {
          if (parent[p]._id === _id) {
            parent = parent[p].children;
            createParent = false;
            break;
          }
        }

        // If there is no parent found, create one, push
        // it into the current parent and assign it as a
        // new parent
        if (createParent) {
          var item = {
            _id: _id,
            _path: parts.join('.'),
            title: _id,
            weight: 1,
            children: []
          };
          parent.push(item);
          parent = item.children;
        }
      }
      return parent;
    }

    /**
     * Sort by weight
     *
     * @param x
     * @param y
     * @returns {number}
     * @private
     */
    function _byWeight(x, y) {
      return parseInt(x.weight) - parseInt(y.weight);
    }

    /**
     * Setup the ui-sref using state & state parameters
     *
     * @param item
     * @returns {string}
     * @private
     */
    function _getUiSref(item) {
      var uisref = '';
      if (angular.isDefined(item.state)) {
        uisref = item.state;
        if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
          uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
        }
      }
      return uisref;
    }

    /* ----------------- */
    /* Service           */
    /* ----------------- */

    this.$get = function () {
      var activeItem = null,
        navigationScope = null,
        folded = null,
        foldedOpen = null;
      var service = {
        saveItem: saveItem,
        deleteItem: deleteItem,
        sort: sortByWeight,
        clearNavigation: clearNavigation,
        setActiveItem: setActiveItem,
        getActiveItem: getActiveItem,
        getNavigation: getNavigation,
        getFlatNavigation: getFlatNavigation,
        setNavigationScope: setNavigationScope,
        setFolded: setFolded,
        getFolded: getFolded,
        setFoldedOpen: setFoldedOpen,
        getFoldedOpen: getFoldedOpen,
        toggleFolded: toggleFolded
      };
      return service;

      //////////

      /**
       * Clear the entire navigation
       */
      function clearNavigation() {
        // Clear the navigation array
        navigation = [];

        // Clear the vm.navigation from main controller
        if (navigationScope) {
          navigationScope.vm.navigation = navigation;
        }
      }

      /**
       * Set active item
       *
       * @param node
       * @param scope
       */
      function setActiveItem(node, scope) {
        activeItem = {
          node: node,
          scope: scope
        };
      }

      /**
       * Return active item
       */
      function getActiveItem() {
        return activeItem;
      }

      /**
       * Return navigation array
       *
       * @param root
       * @returns Array
       */
      function getNavigation(root) {
        if (root) {
          for (var i = 0; i < navigation.length; i++) {
            if (navigation[i]._id === root) {
              return [navigation[i]];
            }
          }
          return null;
        }
        return navigation;
      }

      /**
       * Return flat navigation array
       *
       * @param root
       * @returns Array
       */
      function getFlatNavigation(root) {
        // Get the correct navigation array
        var navigation = getNavigation(root);

        // Flatten the navigation object
        return _flattenNavigation(navigation);
      }

      /**
       * Store navigation's scope for later use
       *
       * @param scope
       */
      function setNavigationScope(scope) {
        navigationScope = scope;
      }

      /**
       * Set folded status
       *
       * @param status
       */
      function setFolded(status) {
        folded = status;
      }

      /**
       * Return folded status
       *
       * @returns {*}
       */
      function getFolded() {
        return folded;
      }

      /**
       * Set folded open status
       *
       * @param status
       */
      function setFoldedOpen(status) {
        foldedOpen = status;
      }

      /**
       * Return folded open status
       *
       * @returns {*}
       */
      function getFoldedOpen() {
        return foldedOpen;
      }

      /**
       * Toggle fold on stored navigation's scope
       */
      function toggleFolded() {
        navigationScope.toggleFolded();
      }

      /**
       * Flatten the given navigation
       *
       * @param navigation
       * @private
       */
      function _flattenNavigation(navigation) {
        var flatNav = [];
        for (var x = 0; x < navigation.length; x++) {
          // Copy and clear the children of the
          // navigation that we want to push
          var navToPush = angular.copy(navigation[x]);
          navToPush.children = [];

          // Push the item
          flatNav.push(navToPush);

          // If there are child items in this navigation,
          // do some nested function magic
          if (navigation[x].children.length > 0) {
            flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
          }
        }
        return flatNav;
      }
    };
  }

  /** @ngInject */
  function MsNavigationController($scope, msNavigationService) {
    var vm = this;

    // Data
    if ($scope.root) {
      vm.navigation = msNavigationService.getNavigation($scope.root);
    } else {
      vm.navigation = msNavigationService.getNavigation();
    }

    // Methods
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Sort the navigation before doing anything else
      msNavigationService.sort();
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }
  }

  /** @ngInject */
  function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService) {
    return {
      restrict: 'E',
      scope: {
        folded: '=',
        root: '@'
      },
      controller: 'MsNavigationController as vm',
      templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
      transclude: true,
      compile: function compile(tElement) {
        tElement.addClass('ms-navigation');
        return function postLink(scope, iElement) {
          var bodyEl = angular.element('body'),
            foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
            foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
            sidenav = $mdSidenav('navigation');

          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);

          // Initialize
          init();

          /**
           * Initialize
           */
          function init() {
            // Set the folded status for the first time.
            // First, we have to check if we have a folded
            // status available in the service already. This
            // will prevent navigation to act weird if we already
            // set the fold status, remove the navigation and
            // then re-initialize it, which happens if we
            // change to a view without a navigation and then
            // come back with history.back() function.

            // If the service didn't initialize before, set
            // the folded status from scope, otherwise we
            // won't touch anything because the folded status
            // already set in the service...
            if (msNavigationService.getFolded() === null) {
              msNavigationService.setFolded(scope.folded);
            }
            if (msNavigationService.getFolded()) {
              // Collapse everything.
              // This must be inside a $timeout because by the
              // time we call this, the 'msNavigation::collapse'
              // event listener is not registered yet. $timeout
              // will ensure that it will be called after it is
              // registered.
              $timeout(function () {
                $rootScope.$broadcast('msNavigation::collapse');
              });

              // Add class to the body
              bodyEl.addClass('ms-navigation-folded');

              // Set fold expander
              setFoldExpander();
            }
          }

          // Sidenav locked open status watcher
          scope.$watch(function () {
            return sidenav.isLockedOpen();
          }, function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }
            var folded = msNavigationService.getFolded();
            if (folded) {
              if (current) {
                // Collapse everything
                $rootScope.$broadcast('msNavigation::collapse');
              } else {
                // Expand the active one and its parents
                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                  activeItem.scope.$emit('msNavigation::stateMatched');
                }
              }
            }
          });

          // Folded status watcher
          scope.$watch('folded', function (current, old) {
            if (angular.isUndefined(current) || angular.equals(current, old)) {
              return;
            }
            setFolded(current);
          });

          /**
           * Set folded status
           *
           * @param folded
           */
          function setFolded(folded) {
            // Store folded status on the service for global access
            msNavigationService.setFolded(folded);
            if (folded) {
              // Collapse everything
              $rootScope.$broadcast('msNavigation::collapse');

              // Add class to the body
              bodyEl.addClass('ms-navigation-folded');

              // Set fold expander
              setFoldExpander();
            } else {
              // Expand the active one and its parents
              var activeItem = msNavigationService.getActiveItem();
              if (activeItem) {
                activeItem.scope.$emit('msNavigation::stateMatched');
              }

              // Remove body class
              bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

              // Remove fold collapser
              removeFoldCollapser();
            }
          }

          /**
           * Set fold expander
           */
          function setFoldExpander() {
            iElement.parent().append(foldExpanderEl);

            // Let everything settle for a moment
            // before registering the event listener
            $timeout(function () {
              foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
            });
          }

          /**
           * Set fold collapser
           */
          function setFoldCollapser() {
            bodyEl.find('#main').append(foldCollapserEl);
            foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
          }

          /**
           * Remove fold collapser
           */
          function removeFoldCollapser() {
            foldCollapserEl.remove();
          }

          /**
           * onHover event of foldExpander
           */
          function onFoldExpanderHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(true);

            // Expand the active one and its parents
            var activeItem = msNavigationService.getActiveItem();
            if (activeItem) {
              activeItem.scope.$emit('msNavigation::stateMatched');
            }

            // Add class to the body
            bodyEl.addClass('ms-navigation-folded-open');

            // Remove the fold opener
            foldExpanderEl.remove();

            // Set fold collapser
            setFoldCollapser();
          }

          /**
           * onHover event of foldCollapser
           */
          function onFoldCollapserHover(event) {
            if (event) {
              event.preventDefault();
            }

            // Set folded open status
            msNavigationService.setFoldedOpen(false);

            // Collapse everything
            $rootScope.$broadcast('msNavigation::collapse');

            // Remove body class
            bodyEl.removeClass('ms-navigation-folded-open');

            // Remove the fold collapser
            foldCollapserEl.remove();

            // Set fold expander
            setFoldExpander();
          }

          /**
           * Public access for toggling folded status externally
           */
          scope.toggleFolded = function () {
            var folded = msNavigationService.getFolded();
            setFolded(!folded);
          };

          /**
           * On $stateChangeStart
           */
          scope.$on('$stateChangeStart', function () {
            // Close the sidenav
            sidenav.close();
          });

          // Cleanup
          scope.$on('$destroy', function () {
            foldCollapserEl.off('mouseenter touchstart');
            foldExpanderEl.off('mouseenter touchstart');
          });
        };
      }
    };
  }

  /** @ngInject */
  function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.collapsed = undefined;
    vm.collapsable = undefined;
    vm.group = undefined;
    vm.animateHeightClass = 'animate-height';

    // Methods
    vm.toggleCollapsed = toggleCollapsed;
    vm.collapse = collapse;
    vm.expand = expand;
    vm.getClass = getClass;
    vm.isHidden = isHidden;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values

      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Is collapsable?
      if (!vm.hasChildren || vm.group) {
        vm.collapsable = false;
      } else {
        vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
      }

      // Is collapsed?
      if (!vm.collapsable) {
        vm.collapsed = false;
      } else {
        vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
      }

      // Expand all parents if we have a matching state or
      // the current state is a child of the node's state
      if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
          return;
        }
        $scope.$emit('msNavigation::stateMatched');

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }
      $scope.$on('msNavigation::stateMatched', function () {
        // Expand if the current scope is collapsable and is collapsed
        if (vm.collapsable && vm.collapsed) {
          $scope.$evalAsync(function () {
            vm.collapsed = false;
          });
        }
      });

      // Listen for collapse event
      $scope.$on('msNavigation::collapse', function (event, path) {
        if (vm.collapsed || !vm.collapsable) {
          return;
        }

        // If there is no path defined, collapse
        if (angular.isUndefined(path)) {
          vm.collapse();
        }
        // If there is a path defined, do not collapse
        // the items that are inside that path. This will
        // prevent parent items from collapsing
        else {
          var givenPathParts = path.split('.'),
            activePathParts = [];
          var activeItem = msNavigationService.getActiveItem();
          if (activeItem) {
            activePathParts = activeItem.node._path.split('.');
          }

          // Test for given path
          if (givenPathParts.indexOf(vm.node._id) > -1) {
            return;
          }

          // Test for active path
          if (activePathParts.indexOf(vm.node._id) > -1) {
            return;
          }
          vm.collapse();
        }
      });

      // Listen for $stateChangeSuccess event
      $scope.$on('$stateChangeSuccess', function () {
        if (vm.node.state === $state.current.name) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Collapse everything except the one we're using
          $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
        }

        // Expand the parents if we the current
        // state is a child of the node's state
        if ($state.includes(vm.node.state)) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Emit the stateMatched
          $scope.$emit('msNavigation::stateMatched');
        }
      });
    }

    /**
     * Toggle collapsed
     */
    function toggleCollapsed() {
      if (vm.collapsed) {
        vm.expand();
      } else {
        vm.collapse();
      }
    }

    /**
     * Collapse
     */
    function collapse() {
      // Grab the element that we are going to collapse
      var collapseEl = vm.element.children('ul');

      // Grab the height
      var height = collapseEl[0].offsetHeight;
      $scope.$evalAsync(function () {
        // Set collapsed status
        vm.collapsed = true;

        // Add collapsing class to the node
        vm.element.addClass('collapsing');

        // Animate the height
        $animate.animate(collapseEl, {
          'display': 'block',
          'height': height + 'px'
        }, {
          'height': '0px'
        }, vm.animateHeightClass).then(function () {
          // Clear the inline styles after animation done
          collapseEl.css({
            'display': '',
            'height': ''
          });

          // Clear collapsing class from the node
          vm.element.removeClass('collapsing');
        });

        // Broadcast the collapse event so child items can also be collapsed
        $scope.$broadcast('msNavigation::collapse');
      });
    }

    /**
     * Expand
     */
    function expand() {
      // Grab the element that we are going to expand
      var expandEl = vm.element.children('ul');

      // Move the element out of the dom flow and
      // make it block so we can get its height
      expandEl.css({
        'position': 'absolute',
        'visibility': 'hidden',
        'display': 'block',
        'height': 'auto'
      });

      // Grab the height
      var height = expandEl[0].offsetHeight;

      // Reset the style modifications
      expandEl.css({
        'position': '',
        'visibility': '',
        'display': '',
        'height': ''
      });
      $scope.$evalAsync(function () {
        // Set collapsed status
        vm.collapsed = false;

        // Add expanding class to the node
        vm.element.addClass('expanding');

        // Animate the height
        $animate.animate(expandEl, {
          'display': 'block',
          'height': '0px'
        }, {
          'height': height + 'px'
        }, vm.animateHeightClass).then(function () {
          // Clear the inline styles after animation done
          expandEl.css({
            'height': ''
          });

          // Clear expanding class from the node
          vm.element.removeClass('expanding');
        });

        // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
        // can be collapsed. This is necessary for keeping only one parent expanded at any time
        $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }

    /**
     * Check if node should be hidden
     *
     * @returns {boolean}
     */
    function isHidden() {
      if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
        return vm.node.hidden();
      }
      return false;
    }
  }

  /** @ngInject */
  function msNavigationNodeDirective() {
    return {
      restrict: 'A',
      bindToController: {
        node: '=msNavigationNode'
      },
      controller: 'MsNavigationNodeController as vm',
      compile: function compile(tElement) {
        tElement.addClass('ms-navigation-node');
        return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
          // Add custom classes
          iElement.addClass(MsNavigationNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationNodeCtrl.group) {
            iElement.addClass('group');
          }
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationItemDirective() {
    return {
      restrict: 'A',
      require: '^msNavigationNode',
      compile: function compile(tElement) {
        tElement.addClass('ms-navigation-item');
        return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
          // If the item is collapsable...
          if (MsNavigationNodeCtrl.collapsable) {
            iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.off('click');
          });
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationHorizontalDirective(msNavigationService) {
    return {
      restrict: 'E',
      scope: {
        root: '@'
      },
      controller: 'MsNavigationController as vm',
      templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
      transclude: true,
      compile: function compile(tElement) {
        tElement.addClass('ms-navigation-horizontal');
        return function postLink(scope) {
          // Store the navigation in the service for public access
          msNavigationService.setNavigationScope(scope);
        };
      }
    };
  }

  /** @ngInject */
  function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
    var vm = this;

    // Data
    vm.element = $element;
    vm.node = $scope.node;
    vm.hasChildren = undefined;
    vm.group = undefined;

    // Methods
    vm.getClass = getClass;

    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Setup the initial values

      // Is active
      vm.isActive = false;

      // Has children?
      vm.hasChildren = vm.node.children.length > 0;

      // Is group?
      vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

      // Mark all parents as active if we have a matching state
      // or the current state is a child of the node's state
      if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
        // If state params are defined, make sure they are
        // equal, otherwise do not set the active item
        if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
          return;
        }
        $scope.$emit('msNavigation::stateMatched');

        // Also store the current active menu item
        msNavigationService.setActiveItem(vm.node, $scope);
      }
      $scope.$on('msNavigation::stateMatched', function () {
        // Mark as active if has children
        if (vm.hasChildren) {
          $scope.$evalAsync(function () {
            vm.isActive = true;
          });
        }
      });

      // Listen for clearActive event
      $scope.$on('msNavigation::clearActive', function () {
        if (!vm.hasChildren) {
          return;
        }
        var activePathParts = [];
        var activeItem = msNavigationService.getActiveItem();
        if (activeItem) {
          activePathParts = activeItem.node._path.split('.');
        }

        // Test for active path
        if (activePathParts.indexOf(vm.node._id) > -1) {
          $scope.$evalAsync(function () {
            vm.isActive = true;
          });
        } else {
          $scope.$evalAsync(function () {
            vm.isActive = false;
          });
        }
      });

      // Listen for $stateChangeSuccess event
      $scope.$on('$stateChangeSuccess', function () {
        if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
          // If state params are defined, make sure they are
          // equal, otherwise do not set the active item
          if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
            return;
          }

          // Update active item on state change
          msNavigationService.setActiveItem(vm.node, $scope);

          // Clear all active states except the one we're using
          $rootScope.$broadcast('msNavigation::clearActive');
        }
      });
    }

    /**
     * Return the class
     *
     * @returns {*}
     */
    function getClass() {
      return vm.node.class;
    }
  }

  /** @ngInject */
  function msNavigationHorizontalNodeDirective() {
    return {
      restrict: 'A',
      bindToController: {
        node: '=msNavigationHorizontalNode'
      },
      controller: 'MsNavigationHorizontalNodeController as vm',
      compile: function compile(tElement) {
        tElement.addClass('ms-navigation-horizontal-node');
        return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
          // Add custom classes
          iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

          // Add group class if it's a group
          if (MsNavigationHorizontalNodeCtrl.group) {
            iElement.addClass('group');
          }
        };
      }
    };
  }

  /** @ngInject */
  function msNavigationHorizontalItemDirective($mdMedia) {
    return {
      restrict: 'A',
      require: '^msNavigationHorizontalNode',
      compile: function compile(tElement) {
        tElement.addClass('ms-navigation-horizontal-item');
        return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
          iElement.on('click', onClick);
          function onClick() {
            if (!MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md')) {
              return;
            }
            iElement.toggleClass('expanded');
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.off('click');
          });
        };
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').factory('msNavFoldService', msNavFoldService).directive('msNavIsFolded', msNavIsFoldedDirective).controller('MsNavController', MsNavController).directive('msNav', msNavDirective).directive('msNavTitle', msNavTitleDirective).directive('msNavButton', msNavButtonDirective).directive('msNavToggle', msNavToggleDirective);

  /** @ngInject */
  function msNavFoldService() {
    var foldable = {};
    var service = {
      setFoldable: setFoldable,
      isNavFoldedOpen: isNavFoldedOpen,
      toggleFold: toggleFold,
      openFolded: openFolded,
      closeFolded: closeFolded
    };
    return service;

    //////////

    /**
     * Set the foldable
     *
     * @param scope
     * @param element
     */
    function setFoldable(scope, element) {
      foldable = {
        'scope': scope,
        'element': element
      };
    }

    /**
     * Is folded open
     */
    function isNavFoldedOpen() {
      return foldable.scope.isNavFoldedOpen();
    }

    /**
     * Toggle fold
     */
    function toggleFold() {
      foldable.scope.toggleFold();
    }

    /**
     * Open folded navigation
     */
    function openFolded() {
      foldable.scope.openFolded();
    }

    /**
     * Close folded navigation
     */
    function closeFolded() {
      foldable.scope.closeFolded();
    }
  }

  /** @ngInject */
  function msNavIsFoldedDirective($document, $rootScope, msNavFoldService) {
    return {
      restrict: 'A',
      link: function link(scope, iElement, iAttrs) {
        var isFolded = iAttrs.msNavIsFolded === 'true',
          isFoldedOpen = false,
          body = angular.element($document[0].body),
          openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
          closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
          sidenavEl = iElement.parent();

        // Initialize the service
        msNavFoldService.setFoldable(scope, iElement, isFolded);

        // Set the fold status for the first time
        if (isFolded) {
          fold();
        } else {
          unfold();
        }

        /**
         * Is nav folded open
         */
        function isNavFoldedOpen() {
          return isFoldedOpen;
        }

        /**
         * Toggle fold
         */
        function toggleFold() {
          isFolded = !isFolded;
          if (isFolded) {
            fold();
          } else {
            unfold();
          }
        }

        /**
         * Fold the navigation
         */
        function fold() {
          // Add classes
          body.addClass('ms-nav-folded');

          // Collapse everything and scroll to the top
          $rootScope.$broadcast('msNav::forceCollapse');
          iElement.scrollTop(0);

          // Append the openOverlay to the element
          sidenavEl.append(openOverlay);

          // Event listeners
          openOverlay.on('mouseenter touchstart', function (event) {
            openFolded(event);
            isFoldedOpen = true;
          });
        }

        /**
         * Open folded navigation
         */
        function openFolded(event) {
          if (angular.isDefined(event)) {
            event.preventDefault();
          }
          body.addClass('ms-nav-folded-open');

          // Update the location
          $rootScope.$broadcast('msNav::expandMatchingToggles');

          // Remove open overlay
          sidenavEl.find(openOverlay).remove();

          // Append close overlay and bind its events
          sidenavEl.parent().append(closeOverlay);
          closeOverlay.on('mouseenter touchstart', function (event) {
            closeFolded(event);
            isFoldedOpen = false;
          });
        }

        /**
         * Close folded navigation
         */
        function closeFolded(event) {
          if (angular.isDefined(event)) {
            event.preventDefault();
          }

          // Collapse everything and scroll to the top
          $rootScope.$broadcast('msNav::forceCollapse');
          iElement.scrollTop(0);
          body.removeClass('ms-nav-folded-open');

          // Remove close overlay
          sidenavEl.parent().find(closeOverlay).remove();

          // Append open overlay and bind its events
          sidenavEl.append(openOverlay);
          openOverlay.on('mouseenter touchstart', function (event) {
            openFolded(event);
            isFoldedOpen = true;
          });
        }

        /**
         * Unfold the navigation
         */
        function unfold() {
          body.removeClass('ms-nav-folded ms-nav-folded-open');

          // Update the location
          $rootScope.$broadcast('msNav::expandMatchingToggles');
          iElement.off('mouseenter mouseleave');
        }

        // Expose functions to the scope
        scope.toggleFold = toggleFold;
        scope.openFolded = openFolded;
        scope.closeFolded = closeFolded;
        scope.isNavFoldedOpen = isNavFoldedOpen;

        // Cleanup
        scope.$on('$destroy', function () {
          openOverlay.off('mouseenter touchstart');
          closeOverlay.off('mouseenter touchstart');
          iElement.off('mouseenter mouseleave');
        });
      }
    };
  }

  /** @ngInject */
  function MsNavController() {
    var vm = this,
      disabled = false,
      toggleItems = [],
      lockedItems = [];

    // Data

    // Methods
    vm.isDisabled = isDisabled;
    vm.enable = enable;
    vm.disable = disable;
    vm.setToggleItem = setToggleItem;
    vm.getLockedItems = getLockedItems;
    vm.setLockedItem = setLockedItem;
    vm.clearLockedItems = clearLockedItems;

    //////////

    /**
     * Is navigation disabled
     *
     * @returns {boolean}
     */
    function isDisabled() {
      return disabled;
    }

    /**
     * Disable the navigation
     */
    function disable() {
      disabled = true;
    }

    /**
     * Enable the navigation
     */
    function enable() {
      disabled = false;
    }

    /**
     * Set toggle item
     *
     * @param element
     * @param scope
     */
    function setToggleItem(element, scope) {
      toggleItems.push({
        'element': element,
        'scope': scope
      });
    }

    /**
     * Get locked items
     *
     * @returns {Array}
     */
    function getLockedItems() {
      return lockedItems;
    }

    /**
     * Set locked item
     *
     * @param element
     * @param scope
     */
    function setLockedItem(element, scope) {
      lockedItems.push({
        'element': element,
        'scope': scope
      });
    }

    /**
     * Clear locked items list
     */
    function clearLockedItems() {
      lockedItems = [];
    }
  }

  /** @ngInject */
  function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService) {
    return {
      restrict: 'E',
      scope: {},
      controller: 'MsNavController',
      compile: function compile(tElement) {
        tElement.addClass('ms-nav');
        return function postLink(scope) {
          // Update toggle status according to the ui-router current state
          $rootScope.$broadcast('msNav::expandMatchingToggles');

          // Update toggles on state changes
          var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
            $rootScope.$broadcast('msNav::expandMatchingToggles');

            // Close navigation sidenav on stateChangeSuccess
            $mdComponentRegistry.when('navigation').then(function (navigation) {
              navigation.close();
              if (msNavFoldService.isNavFoldedOpen()) {
                msNavFoldService.closeFolded();
              }
            });
          });

          // Cleanup
          scope.$on('$destroy', function () {
            stateChangeSuccessEvent();
          });
        };
      }
    };
  }

  /** @ngInject */
  function msNavTitleDirective() {
    return {
      restrict: 'A',
      compile: function compile(tElement) {
        tElement.addClass('ms-nav-title');
        return function postLink() {};
      }
    };
  }

  /** @ngInject */
  function msNavButtonDirective() {
    return {
      restrict: 'AE',
      compile: function compile(tElement) {
        tElement.addClass('ms-nav-button');
        return function postLink() {};
      }
    };
  }

  /** @ngInject */
  function msNavToggleDirective($rootScope, $q, $animate, $state) {
    return {
      restrict: 'A',
      require: '^msNav',
      scope: true,
      compile: function compile(tElement, tAttrs) {
        tElement.addClass('ms-nav-toggle');

        // Add collapsed attr
        if (angular.isUndefined(tAttrs.collapsed)) {
          tAttrs.collapsed = true;
        }
        tElement.attr('collapsed', tAttrs.collapsed);
        return function postLink(scope, iElement, iAttrs, MsNavCtrl) {
          var classes = {
            expanded: 'expanded',
            expandAnimation: 'expand-animation',
            collapseAnimation: 'collapse-animation'
          };

          // Store all related states
          var links = iElement.find('a');
          var states = [];
          var regExp = /\(.*\)/g;
          angular.forEach(links, function (link) {
            var state = angular.element(link).attr('ui-sref');
            if (angular.isUndefined(state)) {
              return;
            }

            // Remove any parameter definition from the state name before storing it
            state = state.replace(regExp, '');
            states.push(state);
          });

          // Store toggle-able element and its scope in the main nav controller
          MsNavCtrl.setToggleItem(iElement, scope);

          // Click handler
          iElement.children('.ms-nav-button').on('click', toggle);

          // Toggle function
          function toggle() {
            // If navigation is disabled, do nothing...
            if (MsNavCtrl.isDisabled()) {
              return;
            }

            // Disable the entire navigation to prevent spamming
            MsNavCtrl.disable();
            if (isCollapsed()) {
              // Clear the locked items list
              MsNavCtrl.clearLockedItems();

              // Emit pushToLockedList event
              scope.$emit('msNav::pushToLockedList');

              // Collapse everything but locked items
              $rootScope.$broadcast('msNav::collapse');

              // Expand and then...
              expand().then(function () {
                // Enable the entire navigation after animations completed
                MsNavCtrl.enable();
              });
            } else {
              // Collapse with all children
              scope.$broadcast('msNav::forceCollapse');
            }
          }

          // Cleanup
          scope.$on('$destroy', function () {
            iElement.children('.ms-nav-button').off('click');
          });

          /*---------------------*/
          /* Scope Events        */
          /*---------------------*/

          /**
           * Collapse everything but locked items
           */
          scope.$on('msNav::collapse', function () {
            // Only collapse toggles that are not locked
            var lockedItems = MsNavCtrl.getLockedItems();
            var locked = false;
            angular.forEach(lockedItems, function (lockedItem) {
              if (angular.equals(lockedItem.scope, scope)) {
                locked = true;
              }
            });
            if (locked) {
              return;
            }

            // Collapse and then...
            collapse().then(function () {
              // Enable the entire navigation after animations completed
              MsNavCtrl.enable();
            });
          });

          /**
           * Collapse everything
           */
          scope.$on('msNav::forceCollapse', function () {
            // Collapse and then...
            collapse().then(function () {
              // Enable the entire navigation after animations completed
              MsNavCtrl.enable();
            });
          });

          /**
           * Expand toggles that match with the current states
           */
          scope.$on('msNav::expandMatchingToggles', function () {
            var currentState = $state.current.name;
            var shouldExpand = false;
            angular.forEach(states, function (state) {
              if (currentState === state) {
                shouldExpand = true;
              }
            });
            if (shouldExpand) {
              expand();
            } else {
              collapse();
            }
          });

          /**
           * Add toggle to the locked list
           */
          scope.$on('msNav::pushToLockedList', function () {
            // Set expanded item on main nav controller
            MsNavCtrl.setLockedItem(iElement, scope);
          });

          /*---------------------*/
          /* Internal functions  */
          /*---------------------*/

          /**
           * Is element collapsed
           *
           * @returns {bool}
           */
          function isCollapsed() {
            return iElement.attr('collapsed') === 'true';
          }

          /**
           * Is element expanded
           *
           * @returns {bool}
           */
          function isExpanded() {
            return !isCollapsed();
          }

          /**
           * Expand the toggle
           *
           * @returns $promise
           */
          function expand() {
            // Create a new deferred object
            var deferred = $q.defer();

            // If the menu item is already expanded, do nothing..
            if (isExpanded()) {
              // Reject the deferred object
              deferred.reject({
                'error': true
              });

              // Return the promise
              return deferred.promise;
            }

            // Set element attr
            iElement.attr('collapsed', false);

            // Grab the element to expand
            var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

            // Move the element out of the dom flow and
            // make it block so we can get its height
            elementToExpand.css({
              'position': 'absolute',
              'visibility': 'hidden',
              'display': 'block',
              'height': 'auto'
            });

            // Grab the height
            var height = elementToExpand[0].offsetHeight;

            // Reset the style modifications
            elementToExpand.css({
              'position': '',
              'visibility': '',
              'display': '',
              'height': ''
            });

            // Animate the height
            scope.$evalAsync(function () {
              $animate.animate(elementToExpand, {
                'display': 'block',
                'height': '0px'
              }, {
                'height': height + 'px'
              }, classes.expandAnimation).then(function () {
                // Add expanded class
                elementToExpand.addClass(classes.expanded);

                // Clear the inline styles after animation done
                elementToExpand.css({
                  'height': ''
                });

                // Resolve the deferred object
                deferred.resolve({
                  'success': true
                });
              });
            });

            // Return the promise
            return deferred.promise;
          }

          /**
           * Collapse the toggle
           *
           * @returns $promise
           */
          function collapse() {
            // Create a new deferred object
            var deferred = $q.defer();

            // If the menu item is already collapsed, do nothing..
            if (isCollapsed()) {
              // Reject the deferred object
              deferred.reject({
                'error': true
              });

              // Return the promise
              return deferred.promise;
            }

            // Set element attr
            iElement.attr('collapsed', true);

            // Grab the element to collapse
            var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

            // Grab the height
            var height = elementToCollapse[0].offsetHeight;

            // Animate the height
            scope.$evalAsync(function () {
              $animate.animate(elementToCollapse, {
                'height': height + 'px'
              }, {
                'height': '0px'
              }, classes.collapseAnimation).then(function () {
                // Remove expanded class
                elementToCollapse.removeClass(classes.expanded);

                // Clear the inline styles after animation done
                elementToCollapse.css({
                  'display': '',
                  'height': ''
                });

                // Resolve the deferred object
                deferred.resolve({
                  'success': true
                });
              });
            });

            // Return the promise
            return deferred.promise;
          }
        };
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').controller('msMaterialColorPickerController', msMaterialColorPickerController).directive('msMaterialColorPicker', msMaterialColorPicker);

  /** @ngInject */
  function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator) {
    var vm = this;
    vm.palettes = $mdColorPalette; // Material Color Palette
    vm.selectedPalette = false;
    vm.selectedHues = false;
    $scope.$selectedColor = {};

    // Methods
    vm.activateHueSelection = activateHueSelection;
    vm.selectColor = selectColor;
    vm.removeColor = removeColor;

    /**
     * Initialize / Watch model changes
     */
    $scope.$watch('ngModel', setSelectedColor);

    /**
     * Activate Hue Selection
     * @param palette
     * @param hues
     */
    function activateHueSelection(palette, hues) {
      vm.selectedPalette = palette;
      vm.selectedHues = hues;
    }

    /**
     * Select Color
     * @type {selectColor}
     */
    function selectColor(palette, hue) {
      // Update Selected Color
      updateSelectedColor(palette, hue);

      // Update Model Value
      updateModel();

      // Hide The picker
      $mdMenu.hide();
    }
    function removeColor() {
      vm.selectedColor = {
        palette: '',
        hue: '',
        class: ''
      };
      activateHueSelection(false, false);
      updateModel();
    }

    /**
     * Set SelectedColor by model type
     */
    function setSelectedColor() {
      if (!vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '') {
        removeColor();
        return;
      }
      var palette, hue;

      // If ModelType Class
      if (vm.msModelType === 'class') {
        var color = vm.modelCtrl.$viewValue.split('-');
        if (color.length >= 5) {
          palette = color[1] + '-' + color[2];
          hue = color[3];
        } else {
          palette = color[1];
          hue = color[2];
        }
      }

      // If ModelType Object
      else if (vm.msModelType === 'obj') {
        palette = vm.modelCtrl.$viewValue.palette;
        hue = vm.modelCtrl.$viewValue.hue || 500;
      }

      // Update Selected Color
      updateSelectedColor(palette, hue);
    }

    /**
     * Update Selected Color
     * @param palette
     * @param hue
     */
    function updateSelectedColor(palette, hue) {
      vm.selectedColor = {
        palette: palette,
        hue: hue,
        class: 'md-' + palette + '-' + hue + '-bg',
        bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
        fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
      };

      // If Model object not Equals the selectedColor update it
      // it can be happen when the model only have pallete and hue values
      if (vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue)) {
        // Update Model Value
        updateModel();
      }
      activateHueSelection(palette, vm.palettes[palette]);
      $scope.$selectedColor = vm.selectedColor;
    }

    /**
     * Update Model Value by model type
     */
    function updateModel() {
      if (vm.msModelType === 'class') {
        vm.modelCtrl.$setViewValue(vm.selectedColor.class);
      } else if (vm.msModelType === 'obj') {
        vm.modelCtrl.$setViewValue(vm.selectedColor);
      }
    }
  }

  /** @ngInject */
  function msMaterialColorPicker() {
    return {
      require: ['msMaterialColorPicker', 'ngModel'],
      restrict: 'E',
      scope: {
        ngModel: '=',
        msModelType: '@?'
      },
      controller: 'msMaterialColorPickerController as vm',
      transclude: true,
      templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
      link: function link(scope, element, attrs, controllers, transclude) {
        var ctrl = controllers[0];

        /**
         *  Pass model controller to directive controller
         */
        ctrl.modelCtrl = controllers[1];

        /**
         * ModelType: 'obj', 'class'(default)
         * @type {string|string}
         */
        ctrl.msModelType = scope.msModelType || 'class';
        transclude(scope, function (clone) {
          clone = clone.filter(function (i, el) {
            return el.nodeType === 1 ? true : false;
          });
          if (clone.length) {
            element.find('ms-color-picker-button').replaceWith(clone);
          }
        });
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').controller('msMasonryController', msMasonryController).directive('msMasonry', msMasonry).directive('msMasonryItem', msMasonryItem);

  /** @ngInject */
  function msMasonryController($scope, $window, $mdMedia, $timeout) {
    var vm = this,
      defaultOpts = {
        columnCount: 5,
        respectItemOrder: false,
        reLayoutDebounce: 400,
        responsive: {
          md: 3,
          sm: 2,
          xs: 1
        }
      },
      reLayoutTimeout = true;
    vm.options = null;
    vm.container = [];
    vm.containerPos = '';
    vm.columnWidth = '';
    vm.items = [];

    // Methods
    vm.reLayout = reLayout;
    vm.initialize = initialize;
    vm.waitImagesLoaded = waitImagesLoaded;
    function initialize() {
      vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);
      watchContainerResize();
    }
    $scope.$on('msMasonry:relayout', function () {
      reLayout();
    });
    function waitImagesLoaded(element, callback) {
      if (typeof imagesLoaded !== 'undefined') {
        var imgLoad = $window.imagesLoaded(element);
        imgLoad.on('done', function () {
          callback();
        });
      } else {
        callback();
      }
    }
    function watchContainerResize() {
      $scope.$watch(function () {
        return vm.container.width();
      }, function (newValue, oldValue) {
        if (newValue !== oldValue) {
          reLayout();
        }
      });
    }
    function reLayout() {
      // Debounce for relayout
      if (reLayoutTimeout) {
        $timeout.cancel(reLayoutTimeout);
      }
      reLayoutTimeout = $timeout(function () {
        start();
        $scope.$broadcast('msMasonry:relayoutFinished');
      }, vm.options.reLayoutDebounce);

      // Start relayout
      function start() {
        vm.containerPos = vm.container[0].getBoundingClientRect();
        updateColumnOptions();
        $scope.$broadcast('msMasonry:relayoutStarted');
        vm.items = vm.container.find('ms-masonry-item');

        //initialize lastRowBottomArr
        var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function () {
          return 0;
        });

        // set item positions
        for (var i = 0; i < vm.items.length; i++) {
          var item = vm.items[i],
            xPos,
            yPos,
            column,
            refTop;
          item = angular.element(item);
          if (item.scope()) {
            item.scope().$broadcast('msMasonryItem:startReLayout');
          }
          item.css({
            'width': vm.columnWidth
          });
          if (vm.options.respectItemOrder) {
            column = i % vm.columnCount;
            refTop = referenceArr[column];
          } else {
            refTop = Math.min.apply(Math, referenceArr);
            column = referenceArr.indexOf(refTop);
          }
          referenceArr[column] = refTop + item[0].getBoundingClientRect().height;
          xPos = Math.round(column * vm.columnWidth);
          yPos = refTop;
          item.css({
            'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'
          });
          item.addClass('placed');
          if (item.scope()) {
            item.scope().$broadcast('msMasonryItem:finishReLayout');
          }
        }
      }
    }
    function updateColumnOptions() {
      vm.columnCount = vm.options.columnCount;
      if ($mdMedia('gt-md')) {
        vm.columnCount = vm.options.columnCount;
      } else if ($mdMedia('md')) {
        vm.columnCount = vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount;
      } else if ($mdMedia('sm')) {
        vm.columnCount = vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount;
      } else {
        vm.columnCount = vm.options.responsive.xs;
      }
      vm.columnWidth = vm.containerPos.width / vm.columnCount;
    }
  }

  /** @ngInject */
  function msMasonry($timeout) {
    return {
      restrict: 'AEC',
      controller: 'msMasonryController',
      compile: compile
    };
    function compile(element, attributes) {
      return {
        pre: function preLink(scope, iElement, iAttrs, controller) {
          controller.options = angular.fromJson(attributes.options || '{}');
          controller.container = element;
        },
        post: function postLink(scope, iElement, iAttrs, controller) {
          $timeout(function () {
            controller.initialize();
          });
        }
      };
    }
  }

  /** @ngInject */
  function msMasonryItem() {
    return {
      restrict: 'AEC',
      require: '^msMasonry',
      priority: 1,
      link: link
    };
    function link(scope, element, attributes, controller) {
      controller.waitImagesLoaded(element, function () {
        controller.reLayout();
      });
      scope.$on('msMasonryItem:finishReLayout', function () {
        scope.$watch(function () {
          return element.height();
        }, function (newVal, oldVal) {
          if (newVal !== oldVal) {
            controller.reLayout();
          }
        });
      });
      element.on('$destroy', function () {
        controller.reLayout();
      });
    }
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').directive('msInfoBar', msInfoBarDirective);

  /** @ngInject */
  function msInfoBarDirective($document) {
    return {
      restrict: 'E',
      scope: {},
      transclude: true,
      templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
      link: function link(scope, iElement) {
        var body = $document.find('body'),
          bodyClass = 'ms-info-bar-active';

        // Add body class
        body.addClass(bodyClass);

        /**
         * Remove the info bar
         */
        function removeInfoBar() {
          body.removeClass(bodyClass);
          iElement.remove();
          scope.$destroy();
        }

        // Expose functions
        scope.removeInfoBar = removeInfoBar;
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').controller('MsFormWizardController', MsFormWizardController).directive('msFormWizard', msFormWizardDirective).directive('msFormWizardForm', msFormWizardFormDirective);

  /** @ngInject */
  function MsFormWizardController($element, $timeout) {
    var vm = this;

    // Data
    vm.forms = [];
    vm.selectedIndex = 0;

    // Methods
    vm.registerForm = registerForm;
    vm.previousStep = previousStep;
    vm.nextStep = nextStep;
    vm.firstStep = firstStep;
    vm.lastStep = lastStep;
    vm.totalSteps = totalSteps;
    vm.isFirstStep = isFirstStep;
    vm.isLastStep = isLastStep;
    vm.currentStepInvalid = currentStepInvalid;
    vm.previousStepInvalid = previousStepInvalid;
    vm.formsIncomplete = formsIncomplete;
    vm.resetForm = resetForm;

    //////////

    /**
     * Register form
     *
     * @param form
     */
    function registerForm(form) {
      vm.forms.push(form);
    }

    /**
     * Go to previous step
     */
    function previousStep() {
      if (isFirstStep()) {
        return;
      }
      vm.selectedIndex--;
      scrollToTop();
    }

    /**
     * Go to next step
     */
    function nextStep() {
      if (isLastStep()) {
        return;
      }
      vm.selectedIndex++;
      scrollToTop();
    }

    /**
     * Go to first step
     */
    function firstStep() {
      vm.selectedIndex = 0;
      scrollToTop();
    }

    /**
     * Go to last step
     */
    function lastStep() {
      vm.selectedIndex = totalSteps() - 1;
      scrollToTop();
    }

    /**
     * Return total steps
     *
     * @returns {int}
     */
    function totalSteps() {
      return vm.forms.length;
    }

    /**
     * Is first step?
     *
     * @returns {boolean}
     */
    function isFirstStep() {
      return vm.selectedIndex === 0;
    }

    /**
     * Is last step?
     *
     * @returns {boolean}
     */
    function isLastStep() {
      return vm.selectedIndex === totalSteps() - 1;
    }

    /**
     * Is current step invalid?
     *
     * @returns {boolean}
     */
    function currentStepInvalid() {
      return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
    }

    /**
     * Is previous step invalid?
     *
     * @returns {boolean}
     */
    function previousStepInvalid() {
      return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
    }

    /**
     * Check if there is any incomplete forms
     *
     * @returns {boolean}
     */
    function formsIncomplete() {
      for (var x = 0; x < vm.forms.length; x++) {
        if (vm.forms[x].$invalid) {
          return true;
        }
      }
      return false;
    }

    /**
     * Reset form
     */
    function resetForm() {
      // Go back to the first step
      vm.selectedIndex = 0;

      // Make sure all the forms are back in the $pristine & $untouched status
      for (var x = 0; x < vm.forms.length; x++) {
        vm.forms[x].$setPristine();
        vm.forms[x].$setUntouched();
      }
    }
    function scrollToTop() {
      $element[0].scrollIntoView();
    }
  }

  /** @ngInject */
  function msFormWizardDirective() {
    return {
      restrict: 'E',
      scope: true,
      controller: 'MsFormWizardController as msWizard',
      compile: function compile(tElement) {
        tElement.addClass('ms-form-wizard');
        return function postLink() {};
      }
    };
  }

  /** @ngInject */
  function msFormWizardFormDirective() {
    return {
      restrict: 'A',
      require: ['form', '^msFormWizard'],
      compile: function compile(tElement) {
        tElement.addClass('ms-form-wizard-form');
        return function postLink(scope, iElement, iAttrs, ctrls) {
          var formCtrl = ctrls[0],
            MsFormWizardCtrl = ctrls[1];
          MsFormWizardCtrl.registerForm(formCtrl);
        };
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').provider('msDatepickerFixConfig', msDatepickerFixConfigProvider).directive('msDatepickerFix', msDatepickerFix);

  /** @ngInject */
  function msDatepickerFixConfigProvider() {
    var service = this;

    // Default configuration
    var defaultConfig = {
      // To view
      formatter: function formatter(val) {
        if (!val) {
          return '';
        }
        return val === '' ? val : new Date(val);
      },
      // To model
      parser: function parser(val) {
        if (!val) {
          return '';
        }
        return moment(val).add(moment(val).utcOffset(), 'm').toDate();
      }
    };

    // Methods
    service.config = config;

    //////////

    /**
     * Extend default configuration with the given one
     *
     * @param configuration
     */
    function config(configuration) {
      defaultConfig = angular.extend({}, defaultConfig, configuration);
    }

    /**
     * Service
     */
    service.$get = function () {
      return defaultConfig;
    };
  }

  /** @ngInject */
  function msDatepickerFix(msDatepickerFixConfig) {
    return {
      require: 'ngModel',
      priority: 1,
      link: function link(scope, elem, attrs, ngModel) {
        ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
        ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').directive('msCard', msCardDirective);

  /** @ngInject */
  function msCardDirective() {
    return {
      restrict: 'E',
      scope: {
        templatePath: '=template',
        card: '=ngModel',
        vm: '=viewModel'
      },
      template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
      compile: function compile(tElement) {
        // Add class
        tElement.addClass('ms-card');
        return function postLink(scope, iElement) {
          // Methods
          scope.cardTemplateLoaded = cardTemplateLoaded;

          //////////

          /**
           * Emit cardTemplateLoaded event
           */
          function cardTemplateLoaded() {
            scope.$emit('msCard::cardTemplateLoaded', iElement);
          }
        };
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.scc').controller('BaseSccController', BaseSccController).controller('GenericCrudController', GenericCrudController);

  /** @ngInject */
  function BaseSccController($scope, $location, scc, authentication, notifications, $mdSidenav, teachers, students, classrooms, studentsGroups, lessons, $window, $translate, utils, $mdMedia) {
    $scope.$mdMedia = $mdMedia;
    $scope.paginationLabels = {
      page: 'Σελίδα',
      // page caption
      rowsPerPage: "Γραμμές ανά σελίδα",
      // caption
      of: "από" // off title
    };
    //Data table configuration
    this.dataTable = {
      page: 1,
      order: 'name',
      limit: 50,
      limitOptions: [10, 20, 50, 200],
      labels: {
        page: 'Σελίδα',
        // page caption
        rowsPerPage: "Γραμμές",
        // caption
        of: "Από" // off title
      }
    };
    /*
    $scope.$watch(
    		function(){
    			if(authentication.getUser()){
    				return authentication.getUser().languageCode;
    			}
    			return utils.DEFAULT_LANGUAGE_CODE;
    		}, 
    		function(){
    			if(authentication.getUser()){
    				$translate.use(authentication.getUser().languageCode);
    			}
    		}
    );
    */

    this.getUser = function () {
      return authentication.getUser();
    };
    this.loggedIn = function () {
      return authentication.loggedIn();
    };
    this.logout = function () {
      authentication.logout();
      notifications.push('Αποσυνδεθήκατε επιτυχώς', notifications.INFO);
      $location.path('login');
    };
    this.toggleSideNav = function () {
      $mdSidenav('left').toggle();
    };
    this.getAllTeachers = function () {
      return teachers.getAll();
    };
    this.getAllStudents = function () {
      return students.getAll();
    };
    this.getAllLessons = function () {
      return lessons.getAll();
    };
    this.getAllClassrooms = function () {
      return classrooms.getAll();
    };
    this.getAllStudentsGroups = function () {
      return studentsGroups.getAll();
    };
    this.redirect = function (url) {
      $location.url(url);
    };
    this.tableRowFilter = function (fields, filter) {
      return function (actual, index, array) {
        if (!filter || !filter.trim()) {
          return true;
        }
        if (!actual) {
          return true;
        }
        var i;
        for (i = 0; i < fields.length; i++) {
          var f = fields[i];
          if (actual[f] && actual[f].toString().toLowerCase().indexOf(filter.toLowerCase()) != -1) {
            return true;
          }
        }
        return false;
      };
    };
    this.setFocusById = function (id) {
      var el = $window.document.getElementById(name);
      if (el) {
        el.focus();
      }
    };
    this.setFocusByName = function (name) {
      var el = $window.document.getElementsByName(name)[0];
      if (el) {
        el.focus();
      }
    };
  }

  /** @ngInject */
  function GenericCrudController($scope, $controller, schools, $mdDialog, notifications, $translate) {
    angular.extend(this, $controller('BaseSccController', {
      $scope: $scope
    }));
    var ctrl = this;
    //The selected lessons
    this.selectedEntities = [];

    //Data table configuration
    this.dataTable = {
      page: 1,
      order: 'name',
      limit: 50,
      limitOptions: [10, 20, 50, 200]
    };
    this.getAllEntities = function () {
      return ctrl.service.getAll();
    };
    this.createEntity = function () {
      ctrl[ctrl.entityType].school = schools.getSelectedSchool();
      var request = {};
      request[ctrl.entityType] = ctrl[ctrl.entityType];
      ctrl.service.create(request, $scope, function (response) {
        ctrl[ctrl.entityType] = {};
        ctrl.setFocusByName(ctrl.entityType + ".name");
        $translate(ctrl.translationNameSpace + ".NOTIFICATIONS.NEW_ENTITY_CREATED", {
          entity: response.data[ctrl.entityType]
        }).then(function (text) {
          notifications.push(text, notifications.INFO);
        });
      }, function () {
        ctrl.setFocusByName(ctrl.entityType + ".name");
      });
    };
    this.showDeletionConfirmationDialog = function (ev, entities, callback) {
      $translate([ctrl.translationNameSpace + ".CONFIRMATIONS.CONFIRM_DELETION_TITLE", ctrl.translationNameSpace + ".CONFIRMATIONS.CONFIRM_DELETION_MESSAGE", ctrl.translationNameSpace + ".CONFIRMATIONS.CONFIRM_DELETION_ACCEPT", ctrl.translationNameSpace + ".CONFIRMATIONS.CONFIRM_DELETION_DENY"], {
        entities: entities
      }).then(function (texts) {
        var confirm = $mdDialog.confirm().title(texts[ctrl.translationNameSpace + ".CONFIRMATIONS.CONFIRM_DELETION_TITLE"]).htmlContent(texts[ctrl.translationNameSpace + ".CONFIRMATIONS.CONFIRM_DELETION_MESSAGE"]).ariaLabel(texts[ctrl.translationNameSpace + ".CONFIRMATIONS.CONFIRM_DELETION_TITLE"]).targetEvent(ev).ok(texts[ctrl.translationNameSpace + ".CONFIRMATIONS.CONFIRM_DELETION_ACCEPT"]).cancel(texts[ctrl.translationNameSpace + ".CONFIRMATIONS.CONFIRM_DELETION_DENY"]);
        $mdDialog.show(confirm).then(callback);
      });
    };
    this.deleteEntities = function (ev, entities) {
      ctrl.showDeletionConfirmationDialog(ev, entities, function () {
        var request = {};
        request[ctrl.entityType + "sIds"] = entities.map(function (l) {
          return l.id;
        });
        ;
        ctrl.service.deleteListed(request, $scope, function () {
          $translate(ctrl.translationNameSpace + ".NOTIFICATIONS.ENTITIES_DELETED", {
            entities: entities
          }).then(function (text) {
            notifications.push(text, notifications.INFO);
          });
          ctrl.selectedEntities = [];
        });
      });
    };
    this.deleteEntity = function (ev, entity) {
      ctrl.deleteEntities(ev, [entity]);
    };
    this.deleteSelected = function (ev) {
      ctrl.deleteEntities(ev, ctrl.selectedEntities);
    };
    this.showEditPanel = function (ev, e) {
      var templateUrl = 'app/main/scc/components/' + ctrl.entityType + '/edit-' + ctrl.entityType + '-dialog.html';
      if (ctrl.editDialogTemplateUrl) {
        templateUrl = ctrl.editDialogTemplateUrl;
      }
      $mdDialog.show({
        controller: function controller($scope, entity, $mdDialog) {
          angular.extend(this, $controller('BaseSccController', {
            $scope: $scope
          }));
          var panelCtrl = this;
          panelCtrl[ctrl.entityType] = angular.extend({}, entity);
          if (entity.name) {
            this.oldEntityName = entity.name;
          }
          this.close = function () {
            $mdDialog.cancel();
          };
          this.submit = function () {
            panelCtrl[ctrl.entityType].school = schools.getSelectedSchool();
            var request = {};
            request[ctrl.entityType] = panelCtrl[ctrl.entityType];
            ctrl.service.update(request, $scope.form, function () {
              $translate(ctrl.translationNameSpace + ".NOTIFICATIONS.ENTITY_UPDATED", {
                entity: panelCtrl[ctrl.entityType]
              }).then(function (text) {
                notifications.push(text, notifications.INFO);
              });
              $mdDialog.hide();
              ctrl.selectedEntities = [];
            });
          };
        },
        controllerAs: '$ctrl',
        templateUrl: templateUrl,
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          entity: e
        }
      });
    };
    this.setFocusByName(ctrl.entityType + ".name");
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').service('fuseTheming', fuseThemingService);

  /** @ngInject */
  function fuseThemingService($cookies, $log, $mdTheming) {
    var service = {
      getRegisteredPalettes: getRegisteredPalettes,
      getRegisteredThemes: getRegisteredThemes,
      setActiveTheme: setActiveTheme,
      setThemesList: setThemesList,
      themes: {
        list: {},
        active: {
          'name': '',
          'theme': {}
        }
      }
    };
    return service;

    //////////

    /**
     * Get registered palettes
     *
     * @returns {*}
     */
    function getRegisteredPalettes() {
      return $mdTheming.PALETTES;
    }

    /**
     * Get registered themes
     *
     * @returns {*}
     */
    function getRegisteredThemes() {
      return $mdTheming.THEMES;
    }

    /**
     * Set active theme
     *
     * @param themeName
     */
    function setActiveTheme(themeName) {
      // If theme does not exist, fallback to the default theme
      if (angular.isUndefined(service.themes.list[themeName])) {
        // If there is no theme called "default"...
        if (angular.isUndefined(service.themes.list.default)) {
          $log.error('You must have at least one theme named "default"');
          return;
        }
        $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

        // Otherwise set theme to default theme
        service.themes.active.name = 'default';
        service.themes.active.theme = service.themes.list.default;
        $cookies.put('selectedTheme', service.themes.active.name);
        return;
      }
      service.themes.active.name = themeName;
      service.themes.active.theme = service.themes.list[themeName];
      $cookies.put('selectedTheme', themeName);
    }

    /**
     * Set available themes list
     *
     * @param themeList
     */
    function setThemesList(themeList) {
      service.themes.list = themeList;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').config(config);

  /** @ngInject */
  function config($mdThemingProvider, fusePalettes, fuseThemes) {
    // Inject Cookies Service
    var $cookies;
    angular.injector(['ngCookies']).invoke(['$cookies', function (_$cookies) {
      $cookies = _$cookies;
    }]);

    // Check if custom theme exist in cookies
    var customTheme = $cookies.getObject('customTheme');
    if (customTheme) {
      fuseThemes['custom'] = customTheme;
    }
    $mdThemingProvider.alwaysWatchTheme(true);

    // Define custom palettes
    angular.forEach(fusePalettes, function (palette) {
      $mdThemingProvider.definePalette(palette.name, palette.options);
    });

    // Register custom themes
    angular.forEach(fuseThemes, function (theme, themeName) {
      $mdThemingProvider.theme(themeName).primaryPalette(theme.primary.name, theme.primary.hues).accentPalette(theme.accent.name, theme.accent.hues).warnPalette(theme.warn.name, theme.warn.hues).backgroundPalette(theme.background.name, theme.background.hues);
    });
  }
})();
"use strict";

(function () {
  'use strict';

  var fuseThemes = {
    default: {
      primary: {
        name: 'fuse-paleblue',
        hues: {
          'default': '700',
          'hue-1': '500',
          'hue-2': '600',
          'hue-3': '400'
        }
      },
      accent: {
        name: 'light-blue',
        hues: {
          'default': '600',
          'hue-1': '400',
          'hue-2': '700',
          'hue-3': 'A100'
        }
      },
      warn: {
        name: 'red'
      },
      background: {
        name: 'grey',
        hues: {
          'default': 'A100',
          'hue-1': 'A100',
          'hue-2': '100',
          'hue-3': '300'
        }
      }
    },
    'pinkTheme': {
      primary: {
        name: 'blue-grey',
        hues: {
          'default': '800',
          'hue-1': '600',
          'hue-2': '400',
          'hue-3': 'A100'
        }
      },
      accent: {
        name: 'pink',
        hues: {
          'default': '400',
          'hue-1': '300',
          'hue-2': '600',
          'hue-3': 'A100'
        }
      },
      warn: {
        name: 'blue'
      },
      background: {
        name: 'grey',
        hues: {
          'default': 'A100',
          'hue-1': 'A100',
          'hue-2': '100',
          'hue-3': '300'
        }
      }
    },
    'tealTheme': {
      primary: {
        name: 'fuse-blue',
        hues: {
          'default': '900',
          'hue-1': '600',
          'hue-2': '500',
          'hue-3': 'A100'
        }
      },
      accent: {
        name: 'teal',
        hues: {
          'default': '500',
          'hue-1': '400',
          'hue-2': '600',
          'hue-3': 'A100'
        }
      },
      warn: {
        name: 'deep-orange'
      },
      background: {
        name: 'grey',
        hues: {
          'default': 'A100',
          'hue-1': 'A100',
          'hue-2': '100',
          'hue-3': '300'
        }
      }
    }
  };
  angular.module('app.core').constant('fuseThemes', fuseThemes);
})();
"use strict";

(function () {
  'use strict';

  var fusePalettes = [{
    name: 'fuse-blue',
    options: {
      '50': '#ebf1fa',
      '100': '#c2d4ef',
      '200': '#9ab8e5',
      '300': '#78a0dc',
      '400': '#5688d3',
      '500': '#3470ca',
      '600': '#2e62b1',
      '700': '#275498',
      '800': '#21467e',
      '900': '#1a3865',
      'A100': '#c2d4ef',
      'A200': '#9ab8e5',
      'A400': '#5688d3',
      'A700': '#275498',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': '50 100 200 A100',
      'contrastStrongLightColors': '300 400'
    }
  }, {
    name: 'fuse-paleblue',
    options: {
      '50': '#ececee',
      '100': '#c5c6cb',
      '200': '#9ea1a9',
      '300': '#7d818c',
      '400': '#5c616f',
      '500': '#3c4252',
      '600': '#353a48',
      '700': '#2d323e',
      '800': '#262933',
      '900': '#1e2129',
      'A100': '#c5c6cb',
      'A200': '#9ea1a9',
      'A400': '#5c616f',
      'A700': '#2d323e',
      'contrastDefaultColor': 'light',
      'contrastDarkColors': '50 100 200 A100',
      'contrastStrongLightColors': '300 400'
    }
  }];
  angular.module('app.core').constant('fusePalettes', fusePalettes);
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').factory('fuseGenerator', fuseGeneratorService);

  /** @ngInject */
  function fuseGeneratorService($cookies, $log, fuseTheming) {
    // Storage for simplified themes object
    var themes = {};
    var service = {
      generate: generate,
      rgba: rgba
    };
    return service;

    //////////

    /**
     * Generate less variables for each theme from theme's
     * palette by using material color naming conventions
     */
    function generate() {
      // Get registered themes and palettes and copy
      // them so we don't modify the original objects
      var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
      var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

      // First, create a simplified object that stores
      // all registered themes and their colors

      // Iterate through registered themes
      angular.forEach(registeredThemes, function (registeredTheme) {
        themes[registeredTheme.name] = {};

        // Iterate through color types (primary, accent, warn & background)
        angular.forEach(registeredTheme.colors, function (colorType, colorTypeName) {
          themes[registeredTheme.name][colorTypeName] = {
            'name': colorType.name,
            'levels': {
              'default': {
                'color': rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
              },
              'hue1': {
                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
              },
              'hue2': {
                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
              },
              'hue3': {
                'color': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
              }
            }
          };
        });
      });

      // Process themes one more time and then store them in the service for external use
      processAndStoreThemes(themes);

      // Iterate through simplified themes
      // object and create style variables
      var styleVars = {};

      // Iterate through registered themes
      angular.forEach(themes, function (theme, themeName) {
        styleVars = {};
        styleVars['@themeName'] = themeName;

        // Iterate through color types (primary, accent, warn & background)
        angular.forEach(theme, function (colorTypes, colorTypeName) {
          // Iterate through color levels (default, hue1, hue2 & hue3)
          angular.forEach(colorTypes.levels, function (colors, colorLevelName) {
            // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
            angular.forEach(colors, function (color, colorName) {
              styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
            });
          });
        });

        // Render styles
        render(styleVars);
      });
    }

    // ---------------------------
    //  INTERNAL HELPER FUNCTIONS
    // ---------------------------

    /**
     * Process and store themes for global use
     *
     * @param _themes
     */
    function processAndStoreThemes(_themes) {
      // Here we will go through every registered theme one more time
      // and try to simplify their objects as much as possible for
      // easier access to their properties.
      var themes = angular.copy(_themes);

      // Iterate through themes
      angular.forEach(themes, function (theme) {
        // Iterate through color types (primary, accent, warn & background)
        angular.forEach(theme, function (colorType, colorTypeName) {
          theme[colorTypeName] = colorType.levels;
          theme[colorTypeName].color = colorType.levels.default.color;
          theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
          theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
          theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
          theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
          delete theme[colorTypeName].default;
        });
      });

      // Store themes and set selected theme for the first time
      fuseTheming.setThemesList(themes);

      // Remember selected theme.
      var selectedTheme = $cookies.get('selectedTheme');
      if (selectedTheme) {
        fuseTheming.setActiveTheme(selectedTheme);
      } else {
        fuseTheming.setActiveTheme('default');
      }
    }

    /**
     * Render css files
     *
     * @param styleVars
     */
    function render(styleVars) {
      var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';
      var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
      var css = cssTemplate.replace(regex, function (matched) {
        return styleVars[matched];
      });
      var headEl = angular.element('head');
      var styleEl = angular.element('<style type="text/css"></style>');
      styleEl.html(css);
      headEl.append(styleEl);
    }

    /**
     * Convert color array to rgb/rgba
     * Also apply contrasts if needed
     *
     * @param color
     * @param _contrastLevel
     * @returns {string}
     */
    function rgba(color, _contrastLevel) {
      var contrastLevel = _contrastLevel || false;

      // Convert 255,255,255,0.XX to 255,255,255
      // According to Google's Material design specs, white primary
      // text must have opacity of 1 and we will fix that here
      // because Angular Material doesn't care about that spec
      if (color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255) {
        color.splice(3, 4);
      }

      // If contrast level provided, apply it to the current color
      if (contrastLevel) {
        color = applyContrast(color, contrastLevel);
      }

      // Convert color array to color string (rgb/rgba)
      if (color.length === 3) {
        return 'rgb(' + color.join(',') + ')';
      } else if (color.length === 4) {
        return 'rgba(' + color.join(',') + ')';
      } else {
        $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
      }
    }

    /**
     * Apply given contrast level to the given color
     *
     * @param color
     * @param contrastLevel
     */
    function applyContrast(color, contrastLevel) {
      var contrastLevels = {
        'white': {
          '1': '1',
          '2': '0.7',
          '3': '0.3',
          '4': '0.12'
        },
        'black': {
          '1': '0.87',
          '2': '0.54',
          '3': '0.26',
          '4': '0.12'
        }
      };

      // If white
      if (color[0] === 255 && color[1] === 255 && color[2] === 255) {
        color[3] = contrastLevels.white[contrastLevel];
      }
      // If black
      else if (color[0] === 0 && color[1] === 0 && color[2] === 0) {
        color[3] = contrastLevels.black[contrastLevel];
      }
      return color;
    }

    /**
     * Uppercase first
     */
    function ucfirst(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').controller('MsThemeOptionsController', MsThemeOptionsController).directive('msThemeOptions', msThemeOptions);

  /** @ngInject */
  function MsThemeOptionsController($cookies, fuseTheming) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;
    vm.layoutModes = [{
      label: 'Boxed',
      value: 'boxed'
    }, {
      label: 'Wide',
      value: 'wide'
    }];
    vm.layoutStyles = [{
      label: 'Vertical Navigation',
      value: 'verticalNavigation',
      figure: '/assets/images/theme-options/vertical-nav.jpg'
    }, {
      label: 'Vertical Navigation with Fullwidth Toolbar',
      value: 'verticalNavigationFullwidthToolbar',
      figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
    }, {
      label: 'Vertical Navigation with Fullwidth Toolbar 2',
      value: 'verticalNavigationFullwidthToolbar2',
      figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
    }, {
      label: 'Horizontal Navigation',
      value: 'horizontalNavigation',
      figure: '/assets/images/theme-options/horizontal-nav.jpg'
    }, {
      label: 'Content with Toolbar',
      value: 'contentWithToolbar',
      figure: '/assets/images/theme-options/content-with-toolbar.jpg'
    }, {
      label: 'Content Only',
      value: 'contentOnly',
      figure: '/assets/images/theme-options/content-only.jpg'
    }];
    vm.layoutMode = 'wide';
    vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

    // Methods
    vm.setActiveTheme = setActiveTheme;
    vm.getActiveTheme = getActiveTheme;
    vm.updateLayoutMode = updateLayoutMode;
    vm.updateLayoutStyle = updateLayoutStyle;

    //////////

    /**
     * Set active theme
     *
     * @param themeName
     */
    function setActiveTheme(themeName) {
      fuseTheming.setActiveTheme(themeName);
    }

    /**
     * Get active theme
     *
     * @returns {service.themes.active|{name, theme}}
     */
    function getActiveTheme() {
      return fuseTheming.themes.active;
    }

    /**
     * Update layout mode
     */
    function updateLayoutMode() {
      var bodyEl = angular.element('body');

      // Update class on body element
      bodyEl.toggleClass('boxed', vm.layoutMode === 'boxed');
    }

    /**
     * Update layout style
     */
    function updateLayoutStyle() {
      // Update the cookie
      $cookies.put('layoutStyle', vm.layoutStyle);

      // Reload the page to apply the changes
      location.reload();
    }
  }

  /** @ngInject */
  function msThemeOptions($mdSidenav) {
    return {
      restrict: 'E',
      scope: {},
      controller: 'MsThemeOptionsController as vm',
      templateUrl: 'app/core/theme-options/theme-options.html',
      compile: function compile(tElement) {
        tElement.addClass('ms-theme-options');
        return function postLink(scope) {
          /**
           * Toggle options sidenav
           */
          function toggleOptionsSidenav() {
            // Toggle the fuse theme options panel
            $mdSidenav('fuse-theme-options').toggle();
          }

          // Expose the toggle function
          scope.toggleOptionsSidenav = toggleOptionsSidenav;
        };
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').factory('msUtils', msUtils);

  /** @ngInject */
  function msUtils($window) {
    // Private variables
    var mobileDetect = new MobileDetect($window.navigator.userAgent),
      browserInfo = null;
    var service = {
      exists: exists,
      detectBrowser: detectBrowser,
      guidGenerator: guidGenerator,
      isMobile: isMobile,
      toggleInArray: toggleInArray
    };
    return service;

    //////////

    /**
     * Check if item exists in a list
     *
     * @param item
     * @param list
     * @returns {boolean}
     */
    function exists(item, list) {
      return list.indexOf(item) > -1;
    }

    /**
     * Returns browser information
     * from user agent data
     *
     * Found at http://www.quirksmode.org/js/detect.html
     * but modified and updated to fit for our needs
     */
    function detectBrowser() {
      // If we already tested, do not test again
      if (browserInfo) {
        return browserInfo;
      }
      var browserData = [{
        string: $window.navigator.userAgent,
        subString: 'Edge',
        versionSearch: 'Edge',
        identity: 'Edge'
      }, {
        string: $window.navigator.userAgent,
        subString: 'Chrome',
        identity: 'Chrome'
      }, {
        string: $window.navigator.userAgent,
        subString: 'OmniWeb',
        versionSearch: 'OmniWeb/',
        identity: 'OmniWeb'
      }, {
        string: $window.navigator.vendor,
        subString: 'Apple',
        versionSearch: 'Version',
        identity: 'Safari'
      }, {
        prop: $window.opera,
        identity: 'Opera'
      }, {
        string: $window.navigator.vendor,
        subString: 'iCab',
        identity: 'iCab'
      }, {
        string: $window.navigator.vendor,
        subString: 'KDE',
        identity: 'Konqueror'
      }, {
        string: $window.navigator.userAgent,
        subString: 'Firefox',
        identity: 'Firefox'
      }, {
        string: $window.navigator.vendor,
        subString: 'Camino',
        identity: 'Camino'
      }, {
        string: $window.navigator.userAgent,
        subString: 'Netscape',
        identity: 'Netscape'
      }, {
        string: $window.navigator.userAgent,
        subString: 'MSIE',
        identity: 'Explorer',
        versionSearch: 'MSIE'
      }, {
        string: $window.navigator.userAgent,
        subString: 'Trident/7',
        identity: 'Explorer',
        versionSearch: 'rv'
      }, {
        string: $window.navigator.userAgent,
        subString: 'Gecko',
        identity: 'Mozilla',
        versionSearch: 'rv'
      }, {
        string: $window.navigator.userAgent,
        subString: 'Mozilla',
        identity: 'Netscape',
        versionSearch: 'Mozilla'
      }];
      var osData = [{
        string: $window.navigator.platform,
        subString: 'Win',
        identity: 'Windows'
      }, {
        string: $window.navigator.platform,
        subString: 'Mac',
        identity: 'Mac'
      }, {
        string: $window.navigator.platform,
        subString: 'Linux',
        identity: 'Linux'
      }, {
        string: $window.navigator.platform,
        subString: 'iPhone',
        identity: 'iPhone'
      }, {
        string: $window.navigator.platform,
        subString: 'iPod',
        identity: 'iPod'
      }, {
        string: $window.navigator.platform,
        subString: 'iPad',
        identity: 'iPad'
      }, {
        string: $window.navigator.platform,
        subString: 'Android',
        identity: 'Android'
      }];
      var versionSearchString = '';
      function searchString(data) {
        for (var i = 0; i < data.length; i++) {
          var dataString = data[i].string;
          var dataProp = data[i].prop;
          versionSearchString = data[i].versionSearch || data[i].identity;
          if (dataString) {
            if (dataString.indexOf(data[i].subString) !== -1) {
              return data[i].identity;
            }
          } else if (dataProp) {
            return data[i].identity;
          }
        }
      }
      function searchVersion(dataString) {
        var index = dataString.indexOf(versionSearchString);
        if (index === -1) {
          return;
        }
        return parseInt(dataString.substring(index + versionSearchString.length + 1));
      }
      var browser = searchString(browserData) || 'unknown-browser';
      var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
      var os = searchString(osData) || 'unknown-os';

      // Prepare and store the object
      browser = browser.toLowerCase();
      version = browser + '-' + version;
      os = os.toLowerCase();
      browserInfo = {
        browser: browser,
        version: version,
        os: os
      };
      return browserInfo;
    }

    /**
     * Generates a globally unique id
     *
     * @returns {*}
     */
    function guidGenerator() {
      var S4 = function S4() {
        return ((1 + Math.random()) * 0x10000 || 0).toString(16).substring(1);
      };
      return S4() + S4() + S4() + S4() + S4() + S4();
    }

    /**
     * Return if current device is a
     * mobile device or not
     */
    function isMobile() {
      return mobileDetect.mobile();
    }

    /**
     * Toggle in array (push or splice)
     *
     * @param item
     * @param array
     */
    function toggleInArray(item, array) {
      if (array.indexOf(item) === -1) {
        array.push(item);
      } else {
        array.splice(array.indexOf(item), 1);
      }
    }
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').provider('msApi', msApiProvider);

  /** @ngInject **/
  function msApiProvider() {
    /* ----------------- */
    /* Provider          */
    /* ----------------- */
    var provider = this;

    // Inject the $log service
    var $log = angular.injector(['ng']).get('$log');

    // Data
    var baseUrl = '';
    var api = [];

    // Methods
    provider.setBaseUrl = setBaseUrl;
    provider.getBaseUrl = getBaseUrl;
    provider.getApiObject = getApiObject;
    provider.register = register;

    //////////

    /**
     * Set base url for API endpoints
     *
     * @param url {string}
     */
    function setBaseUrl(url) {
      baseUrl = url;
    }

    /**
     * Return the base url
     *
     * @returns {string}
     */
    function getBaseUrl() {
      return baseUrl;
    }

    /**
     * Return the api object
     *
     * @returns {object}
     */
    function getApiObject() {
      return api;
    }

    /**
     * Register API endpoint
     *
     * @param key
     * @param resource
     */
    function register(key, resource) {
      if (!angular.isString(key)) {
        $log.error('"path" must be a string (eg. `dashboard.project`)');
        return;
      }
      if (!angular.isArray(resource)) {
        $log.error('"resource" must be an array and it must follow $resource definition');
        return;
      }

      // Store the API object
      api[key] = {
        url: baseUrl + (resource[0] || ''),
        paramDefaults: resource[1] || [],
        actions: resource[2] || [],
        options: resource[3] || {}
      };
    }

    /* ----------------- */
    /* Service           */
    /* ----------------- */
    this.$get = function ($log, $q, $resource, $rootScope) {
      // Data

      // Methods
      var service = {
        setBaseUrl: setBaseUrl,
        getBaseUrl: getBaseUrl,
        register: register,
        resolve: resolve,
        request: request
      };
      return service;

      //////////

      /**
       * Resolve an API endpoint
       *
       * @param action {string}
       * @param parameters {object}
       * @returns {promise|boolean}
       */
      function resolve(action, parameters) {
        // Emit an event
        $rootScope.$broadcast('msApi::resolveStart');
        var actionParts = action.split('@'),
          resource = actionParts[0],
          method = actionParts[1],
          params = parameters || {};
        if (!resource || !method) {
          $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
          return false;
        }

        // Create a new deferred object
        var deferred = $q.defer();

        // Get the correct resource definition from api object
        var apiObject = api[resource];
        if (!apiObject) {
          $log.error('Resource "' + resource + '" is not defined in the api service!');
          deferred.reject('Resource "' + resource + '" is not defined in the api service!');
        } else {
          // Generate the $resource object based on the stored API object
          var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

          // Make the call...
          resourceObject[method](params,
          // Success
          function (response) {
            deferred.resolve(response);

            // Emit an event
            $rootScope.$broadcast('msApi::resolveSuccess');
          },
          // Error
          function (response) {
            deferred.reject(response);

            // Emit an event
            $rootScope.$broadcast('msApi::resolveError');
          });
        }

        // Return the promise
        return deferred.promise;
      }

      /**
       * Make a request to an API endpoint
       *
       * @param action {string}
       * @param [parameters] {object}
       * @param [success] {function}
       * @param [error] {function}
       *
       * @returns {promise|boolean}
       */
      function request(action, parameters, success, error) {
        // Emit an event
        $rootScope.$broadcast('msApi::requestStart');
        var actionParts = action.split('@'),
          resource = actionParts[0],
          method = actionParts[1],
          params = parameters || {};
        if (!resource || !method) {
          $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
          return false;
        }

        // Create a new deferred object
        var deferred = $q.defer();

        // Get the correct resource definition from api object
        var apiObject = api[resource];
        if (!apiObject) {
          $log.error('Resource "' + resource + '" is not defined in the api service!');
          deferred.reject('Resource "' + resource + '" is not defined in the api service!');
        } else {
          // Generate the $resource object based on the stored API object
          var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

          // Make the call...
          resourceObject[method](params,
          // SUCCESS
          function (response) {
            // Emit an event
            $rootScope.$broadcast('msApi::requestSuccess');

            // Resolve the promise
            deferred.resolve(response);

            // Call the success function if there is one
            if (angular.isDefined(success) && angular.isFunction(success)) {
              success(response);
            }
          },
          // ERROR
          function (response) {
            // Emit an event
            $rootScope.$broadcast('msApi::requestError');

            // Reject the promise
            deferred.reject(response);

            // Call the error function if there is one
            if (angular.isDefined(error) && angular.isFunction(error)) {
              error(response);
            }
          });
        }

        // Return the promise
        return deferred.promise;
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').factory('apiResolver', apiResolverService);

  /** @ngInject */
  function apiResolverService($q, $log, api) {
    var service = {
      resolve: resolve
    };
    return service;

    //////////
    /**
     * Resolve api
     * @param action
     * @param parameters
     */
    function resolve(action, parameters) {
      var actionParts = action.split('@'),
        resource = actionParts[0],
        method = actionParts[1],
        params = parameters || {};
      if (!resource || !method) {
        $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
        return false;
      }

      // Create a new deferred object
      var deferred = $q.defer();

      // Get the correct api object from api service
      var apiObject = getApiObject(resource);
      if (!apiObject) {
        $log.error('Resource "' + resource + '" is not defined in the api service!');
        deferred.reject('Resource "' + resource + '" is not defined in the api service!');
      } else {
        apiObject[method](params,
        // Success
        function (response) {
          deferred.resolve(response);
        },
        // Error
        function (response) {
          deferred.reject(response);
        });
      }

      // Return the promise
      return deferred.promise;
    }

    /**
     * Get correct api object
     *
     * @param resource
     * @returns {*}
     */
    function getApiObject(resource) {
      // Split the resource in case if we have a dot notated object
      var resourceParts = resource.split('.'),
        apiObject = api;

      // Loop through the resource parts and go all the way through
      // the api object and return the correct one
      for (var l = 0; l < resourceParts.length; l++) {
        if (angular.isUndefined(apiObject[resourceParts[l]])) {
          $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
          apiObject = false;
          break;
        }
        apiObject = apiObject[resourceParts[l]];
      }
      if (!apiObject) {
        return false;
      }
      return apiObject;
    }
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').directive('sccHighlightText', sccHighlightText);

  /**
   * Drop-in replacement for md-highlight-text that works on any element.
   *
   * Usage (same API as md-highlight-text):
   *   <td scc-highlight-text="searchTerm">{{item.name}}</td>
   *   <span scc-highlight-text="searchTerm">{{item.email}}</span>
   */
  function sccHighlightText() {
    return {
      restrict: 'A',
      link: function link(scope, element, attrs) {
        var originalText = '';
        function makeSpan(text, highlighted) {
          var span = document.createElement('span');
          if (highlighted) {
            span.className = 'search-highlight';
          }
          span.appendChild(document.createTextNode(text));
          return span;
        }
        function render() {
          var text = element.text().trim();
          if (text) {
            originalText = text;
          }
          var term = scope.$eval(attrs.sccHighlightText) || '';
          var el = element[0];

          // Clear existing content.
          while (el.firstChild) {
            el.removeChild(el.firstChild);
          }
          if (!term || !originalText) {
            el.appendChild(makeSpan(originalText, false));
            return;
          }
          var escaped = term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
          var re = new RegExp(escaped, 'gi');
          var lastIndex = 0;
          var match;
          while ((match = re.exec(originalText)) !== null) {
            if (match.index > lastIndex) {
              el.appendChild(makeSpan(originalText.substring(lastIndex, match.index), false));
            }
            el.appendChild(makeSpan(match[0], true));
            lastIndex = re.lastIndex;
          }
          if (lastIndex < originalText.length) {
            el.appendChild(makeSpan(originalText.substring(lastIndex), false));
          }
        }

        // Watch the search term expression for changes.
        scope.$watch(attrs.sccHighlightText, render);

        // Also watch for text content changes (e.g. when data loads).
        scope.$watch(function () {
          var nodes = element[0].childNodes;
          var text = '';
          for (var i = 0; i < nodes.length; i++) {
            text += nodes[i].textContent;
          }
          return text.trim();
        }, function (newText) {
          if (newText && newText !== originalText) {
            originalText = newText;
            render();
          }
        });
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').directive('hljs', hljsDirective);

  /** @ngInject */
  function hljsDirective($timeout, $q, $interpolate) {
    return {
      restrict: 'E',
      compile: function compile(element, attr) {
        var code;
        //No attribute? code is the content
        if (!attr.code) {
          code = element.html();
          element.empty();
        }
        return function (scope, element, attr) {
          if (attr.code) {
            // Attribute? code is the evaluation
            code = scope.$eval(attr.code);
          }
          var shouldInterpolate = scope.$eval(attr.shouldInterpolate);
          $q.when(code).then(function (code) {
            if (code) {
              if (shouldInterpolate) {
                code = $interpolate(code)(scope);
              }
              var contentParent = angular.element('<pre><code class="highlight" ng-non-bindable></code></pre>');
              element.append(contentParent);
              // Defer highlighting 1-frame to prevent GA interference...
              $timeout(function () {
                render(code, contentParent);
              }, 34, false);
            }
          });
          function render(contents, parent) {
            var codeElement = parent.find('code');
            var lines = contents.split('\n');

            // Remove empty lines
            lines = lines.filter(function (line) {
              return line.trim().length;
            });

            // Make it so each line starts at 0 whitespace
            var firstLineWhitespace = lines[0].match(/^\s*/)[0];
            var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
            lines = lines.map(function (line) {
              return line.replace(startingWhitespaceRegex, '').replace(/\s+$/, '');
            });
            var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
            highlightedCode.value = highlightedCode.value.replace(/=<span class="hljs-value">""<\/span>/gi, '').replace('<head>', '').replace('<head/>', '');
            codeElement.append(highlightedCode.value).addClass('highlight');
          }
        };
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('filterByTags', filterByTags).filter('filterSingleByTags', filterSingleByTags);

  /** @ngInject */
  function filterByTags() {
    return function (items, tags) {
      if (items.length === 0 || tags.length === 0) {
        return items;
      }
      var filtered = [];
      items.forEach(function (item) {
        var match = tags.every(function (tag) {
          var tagExists = false;
          item.tags.forEach(function (itemTag) {
            if (itemTag.name === tag.name) {
              tagExists = true;
              return;
            }
          });
          return tagExists;
        });
        if (match) {
          filtered.push(item);
        }
      });
      return filtered;
    };
  }

  /** @ngInject */
  function filterSingleByTags() {
    return function (itemTags, tags) {
      if (itemTags.length === 0 || tags.length === 0) {
        return;
      }
      if (itemTags.length < tags.length) {
        return [];
      }
      var filtered = [];
      var match = tags.every(function (tag) {
        var tagExists = false;
        itemTags.forEach(function (itemTag) {
          if (itemTag.name === tag.name) {
            tagExists = true;
            return;
          }
        });
        return tagExists;
      });
      if (match) {
        filtered.push(itemTags);
      }
      return filtered;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('filterByPropIds', filterByPropIds);

  /** @ngInject */
  function filterByPropIds() {
    return function (items, parameter, ids) {
      if (items.length === 0 || !ids || ids.length === 0) {
        return items;
      }
      var filtered = [];
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var match = false;
        for (var j = 0; j < ids.length; j++) {
          var id = ids[j];
          if (item[parameter].indexOf(id) > -1) {
            match = true;
            break;
          }
        }
        if (match) {
          filtered.push(item);
        }
      }
      return filtered;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('filterByIds', filterByIds);

  /** @ngInject */
  function filterByIds() {
    return function (items, ids) {
      if (items.length === 0 || !ids) {
        return items;
      }
      if (ids.length === 0) {
        return [];
      }
      var filtered = [];
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var match = false;
        for (var j = 0; j < ids.length; j++) {
          var id = ids[j];
          if (item.id === id) {
            match = true;
            break;
          }
        }
        if (match) {
          filtered.push(item);
        }
      }
      return filtered;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('toTrusted', toTrustedFilter).filter('htmlToPlaintext', htmlToPlainTextFilter).filter('nospace', nospaceFilter).filter('humanizeDoc', humanizeDocFilter);

  /** @ngInject */
  function toTrustedFilter($sce) {
    return function (value) {
      return $sce.trustAsHtml(value);
    };
  }

  /** @ngInject */
  function htmlToPlainTextFilter() {
    return function (text) {
      return String(text).replace(/<[^>]+>/gm, '');
    };
  }

  /** @ngInject */
  function nospaceFilter() {
    return function (value) {
      return !value ? '' : value.replace(/ /g, '');
    };
  }

  /** @ngInject */
  function humanizeDocFilter() {
    return function (doc) {
      if (!doc) {
        return;
      }
      if (doc.type === 'directive') {
        return doc.name.replace(/([A-Z])/g, function ($1) {
          return '-' + $1.toLowerCase();
        });
      }
      return doc.label || doc.name;
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').filter('altDate', altDate);

  /** @ngInject */
  function altDate() {
    return function (value) {
      var diff = Date.now() - new Date(value);

      /**
       * If in a hour
       * e.g. "2 minutes ago"
       */
      if (diff < 60 * 60 * 1000) {
        return moment(value).fromNow();
      }
      /*
       * If in the day
       * e.g. "11:23"
       */else if (diff < 60 * 60 * 24 * 1000) {
        return moment(value).format('HH:mm');
      }
      /*
       * If in week
       * e.g "Tuesday"
       */else if (diff < 60 * 60 * 24 * 7 * 1000) {
        return moment(value).format('dddd');
      }
      /*
       * If more than a week
       * e.g. 03/29/2016
       */else {
        return moment(value).calendar();
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').provider('fuseConfig', fuseConfigProvider);

  /** @ngInject */
  function fuseConfigProvider() {
    // Default configuration
    var fuseConfiguration = {
      'disableCustomScrollbars': false,
      'disableMdInkRippleOnMobile': true,
      'disableCustomScrollbarsOnMobile': true
    };

    // Methods
    this.config = config;

    //////////

    /**
     * Extend default configuration with the given one
     *
     * @param configuration
     */
    function config(configuration) {
      fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
    }

    /**
     * Service
     */
    this.$get = function () {
      var service = {
        getConfig: getConfig,
        setConfig: setConfig
      };
      return service;

      //////////

      /**
       * Returns a config value
       */
      function getConfig(configName) {
        if (angular.isUndefined(fuseConfiguration[configName])) {
          return false;
        }
        return fuseConfiguration[configName];
      }

      /**
       * Creates or updates config object
       *
       * @param configName
       * @param configValue
       */
      function setConfig(configName, configValue) {
        fuseConfiguration[configName] = configValue;
      }
    };
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.toolbar', []).config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('app/toolbar');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.toolbar').controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, authentication, schools, dataSets) {
    var vm = this;

    // Data
    $rootScope.global = {
      search: ''
    };
    vm.bodyEl = angular.element('body');
    vm.userStatusOptions = [{
      'title': 'Online',
      'icon': 'icon-checkbox-marked-circle',
      'color': '#4CAF50'
    }, {
      'title': 'Away',
      'icon': 'icon-clock',
      'color': '#FFC107'
    }, {
      'title': 'Do not Disturb',
      'icon': 'icon-minus-circle',
      'color': '#F44336'
    }, {
      'title': 'Invisible',
      'icon': 'icon-checkbox-blank-circle-outline',
      'color': '#BDBDBD'
    }, {
      'title': 'Offline',
      'icon': 'icon-checkbox-blank-circle-outline',
      'color': '#616161'
    }];
    vm.languages = {
      en: {
        'title': 'English',
        'translation': 'TOOLBAR.ENGLISH',
        'code': 'en',
        'flag': 'us'
      },
      es: {
        'title': 'Greek',
        'translation': 'TOOLBAR.GREEK',
        'code': 'el',
        'flag': 'gr'
      }
    };

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    vm.changeLanguage = changeLanguage;
    vm.setUserStatus = setUserStatus;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.search = search;
    vm.searchResultClick = searchResultClick;
    vm.getSelectedSchool = getSelectedSchool;
    vm.getSelectedDataSet = getSelectedDataSet;
    vm.getUser = getUser;
    //////////

    init();

    /**
     * Initialize
     */
    function init() {
      // Select the first status as a default
      vm.userStatus = vm.userStatusOptions[0];

      // Get the selected language directly from angular-translate module setting
      vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Sets User Status
     * @param status
     */
    function setUserStatus(status) {
      vm.userStatus = status;
    }

    /**
     * Logout Function
     */
    function logout() {
      authentication.logout();
    }

    /**
     * Change Language
     */
    function changeLanguage(lang) {
      vm.selectedLanguage = lang;

      /**
       * Show temporary message if user selects a language other than English
       *
       * angular-translate module will try to load language specific json files
       * as soon as you change the language. And because we don't have them, there
       * will be a lot of errors in the page potentially breaking couple functions
       * of the template.
       *
       * To prevent that from happening, we added a simple "return;" statement at the
       * end of this if block. If you have all the translation files, remove this if
       * block and the translations should work without any problems.
       */
      //            if ( lang.code !== 'en' )
      //            {
      //                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';
      //
      //                $mdToast.show({
      //                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
      //                    hideDelay: 7000,
      //                    position : 'top right',
      //                    parent   : '#content'
      //                });
      //
      //                return;
      //            }

      // Change the language
      $translate.use(lang.code);
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }

    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }

    /**
     * Search action
     *
     * @param query
     * @returns {Promise}
     */
    function search(query) {
      var navigation = [],
        flatNavigation = msNavigationService.getFlatNavigation(),
        deferred = $q.defer();

      // Iterate through the navigation array and
      // make sure it doesn't have any groups or
      // none ui-sref items
      for (var x = 0; x < flatNavigation.length; x++) {
        if (flatNavigation[x].uisref) {
          navigation.push(flatNavigation[x]);
        }
      }

      // If there is a query, filter the navigation;
      // otherwise we will return the entire navigation
      // list. Not exactly a good thing to do but it's
      // for demo purposes.
      if (query) {
        navigation = navigation.filter(function (item) {
          if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
            return true;
          }
        });
      }

      // Fake service delay
      $timeout(function () {
        deferred.resolve(navigation);
      }, 1000);
      return deferred.promise;
    }

    /**
     * Search result click action
     *
     * @param item
     */
    function searchResultClick(item) {
      // If item has a link
      if (item.uisref) {
        // If there are state params,
        // use them...
        if (item.stateParams) {
          $state.go(item.state, item.stateParams);
        } else {
          $state.go(item.state);
        }
      }
    }
    function getUser() {
      return authentication.getUser();
    }
    function getSelectedDataSet() {
      return dataSets.getSelected();
    }
    function getSelectedSchool() {
      return schools.getSelectedSchool();
    }
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.quick-panel').controller('QuickPanelController', QuickPanelController);

  /** @ngInject */
  function QuickPanelController(msApi) {
    var vm = this;

    // Data
    vm.date = new Date();
    vm.settings = {
      notify: true,
      cloud: false,
      retro: true
    };
    msApi.request('quickPanel.activities@get', {},
    // Success
    function (response) {
      vm.activities = response.data;
    });
    msApi.request('quickPanel.events@get', {},
    // Success
    function (response) {
      vm.events = response.data;
    });
    msApi.request('quickPanel.notes@get', {},
    // Success
    function (response) {
      vm.notes = response.data;
    });

    // Methods

    //////////
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.navigation', []).config(config);

  /** @ngInject */
  function config() {}
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.navigation').controller('NavigationController', NavigationController);

  /** @ngInject */
  function NavigationController($scope) {
    var vm = this;

    // Data
    vm.bodyEl = angular.element('body');
    vm.folded = false;
    vm.msScrollOptions = {
      suppressScrollX: true
    };

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

    //////////

    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      vm.folded = !vm.folded;
    }

    // Close the mobile menu on $stateChangeSuccess
    $scope.$on('$stateChangeSuccess', function () {
      vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
    });
  }
})();
"use strict";

(function () {
  'use strict';

  /**
   * Main module of the Fuse
   */
  angular.module('fuse', [
  // Core
  'app.core',
  // Navigation
  'app.navigation',
  // Toolbar
  'app.toolbar',
  // Quick Panel
  'app.quick-panel',
  //
  'app.scc', 'app.chat']);
})();
"use strict";

(function () {
  'use strict';

  angular.module('fuse').controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $rootScope) {
    // Data

    //////////

    // Remove the splash screen
    $scope.$on('$viewContentAnimationEnded', function (event) {
      if (event.targetScope.$id === $scope.$id) {
        $rootScope.$broadcast('msSplashScreen::remove');
      }
    });
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').run(runBlock);

  /** @ngInject */
  function runBlock(msUtils, fuseGenerator, fuseConfig) {
    /**
     * Generate extra classes based on registered themes so we
     * can use same colors with non-angular-material elements
     */
    fuseGenerator.generate();

    /**
     * Disable md-ink-ripple effects on mobile
     * if 'disableMdInkRippleOnMobile' config enabled
     */
    if (fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile()) {
      var bodyEl = angular.element('body');
      bodyEl.attr('md-no-ink', true);
    }

    /**
     * Put isMobile() to the html as a class
     */
    if (msUtils.isMobile()) {
      angular.element('html').addClass('is-mobile');
    }

    /**
     * Put browser information to the html as a class
     */
    var browserInfo = msUtils.detectBrowser();
    if (browserInfo) {
      var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
      angular.element('html').addClass(htmlClass);
    }
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('app.core').config(config);

  /** @ngInject */
  function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider) {
    // Enable debug logging
    $logProvider.debugEnabled(true);

    /*eslint-disable */

    // ng-aria configuration
    $ariaProvider.config({
      tabindex: false
    });

    // Fuse theme configurations
    fuseConfigProvider.config({
      'disableCustomScrollbars': false,
      'disableCustomScrollbarsOnMobile': true,
      'disableMdInkRippleOnMobile': true
    });

    // msScroll configuration
    msScrollConfigProvider.config({
      wheelPropagation: true
    });

    /*eslint-enable */
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('fuse').run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $timeout, $state) {
    // Activate loading indicator
    var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
      //$rootScope.loadingProgress = true;
    });

    // De-activate loading indicator
    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
      $timeout(function () {
        //$rootScope.loadingProgress = false;
      });
    });

    // Store state in the root scope for easy access
    $rootScope.state = $state;

    // Cleanup
    $rootScope.$on('$destroy', function () {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
    });
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('fuse').config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise('/monitoring');

    /**
     * Layout Style Switcher
     *
     * This code is here for demonstration purposes.
     * If you don't need to switch between the layout
     * styles like in the demo, you can set one manually by
     * typing the template urls into the `State definitions`
     * area and remove this code
     */
    // Inject $cookies
    var $cookies;
    angular.injector(['ngCookies']).invoke(['$cookies', function (_$cookies) {
      $cookies = _$cookies;
    }]);

    // Get active layout
    var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';
    var layouts = {
      verticalNavigation: {
        main: 'app/core/layouts/vertical-navigation.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar2: {
        main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
        toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
      },
      horizontalNavigation: {
        main: 'app/core/layouts/horizontal-navigation.html',
        toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
      },
      contentOnly: {
        main: 'app/core/layouts/content-only.html',
        toolbar: '',
        navigation: ''
      },
      contentWithToolbar: {
        main: 'app/core/layouts/content-with-toolbar.html',
        toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
        navigation: ''
      }
    };
    // END - Layout Style Switcher

    // State definitions
    $stateProvider.state('app', {
      abstract: true,
      views: {
        'main@': {
          templateUrl: layouts[layoutStyle].main,
          controller: 'MainController as vm'
        },
        'toolbar@app': {
          templateUrl: layouts[layoutStyle].toolbar,
          controller: 'ToolbarController as vm'
        },
        'navigation@app': {
          templateUrl: layouts[layoutStyle].navigation,
          controller: 'NavigationController as vm'
        },
        'quickPanel@app': {
          templateUrl: 'app/quick-panel/quick-panel.html',
          controller: 'QuickPanelController as vm'
        }
      }
    });
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('fuse').controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(fuseTheming) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;

    //////////
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('fuse');
})();
"use strict";

(function () {
  'use strict';

  angular.module('fuse').config(config);

  /** @ngInject */
  function config($translateProvider) {
    // Put your common app configurations here

    // angular-translate configuration
    $translateProvider.useLoader('$translatePartialLoader', {
      urlTemplate: '{part}/i18n/{lang}.json'
    });
    $translateProvider.preferredLanguage('el');
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
  }
})();
"use strict";

(function () {
  'use strict';

  angular.module('fuse').factory('api', apiService);

  /** @ngInject */
  function apiService($resource) {
    /**
     * You can use this service to define your API urls. The "api" service
     * is designed to work in parallel with "apiResolver" service which you can
     * find in the "app/core/services/api-resolver.service.js" file.
     *
     * You can structure your API urls whatever the way you want to structure them.
     * You can either use very simple definitions, or you can use multi-dimensional
     * objects.
     *
     * Here's a very simple API url definition example:
     *
     *      api.getBlogList = $resource('http://api.example.com/getBlogList');
     *
     * While this is a perfectly valid $resource definition, most of the time you will
     * find yourself in a more complex situation where you want url parameters:
     *
     *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
     *
     * You can also define your custom methods. Custom method definitions allow you to
     * add hardcoded parameters to your API calls that you want to sent every time you
     * make that API call:
     *
     *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
     *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
     *      });
     *
     * In addition to these definitions, you can also create multi-dimensional objects.
     * They are nothing to do with the $resource object, it's just a more convenient
     * way that we have created for you to packing your related API urls together:
     *
     *      api.blog = {
     *                   list     : $resource('http://api.example.com/blog'),
     *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
     *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
     *                       get: {
     *                            method: 'GET',
     *                            params: {
     *                                getByDate: true
     *                            }
     *                       }
     *                   })
     *       }
     *
     * If you look at the last example from above, we overrode the 'get' method to put a
     * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
     * object will also be sent along with whatever data we are sending.
     *
     * All the above methods are using standard $resource service. You can learn more about
     * it at: https://docs.angularjs.org/api/ngResource/service/$resource
     *
     * -----
     *
     * After you defined your API urls, you can use them in Controllers, Services and even
     * in the UIRouter state definitions.
     *
     * If we use the last example from above, you can do an API call in your Controllers and
     * Services like this:
     *
     *      function MyController (api)
     *      {
     *          // Get the blog list
     *          api.blog.list.get({},
     *
     *              // Success
     *              function (response)
     *              {
     *                  console.log(response);
     *              },
     *
     *              // Error
     *              function (response)
     *              {
     *                  console.error(response);
     *              }
     *          );
     *
     *          // Get the blog with the id of 3
     *          var id = 3;
     *          api.blog.getById.get({'id': id},
     *
     *              // Success
     *              function (response)
     *              {
     *                  console.log(response);
     *              },
     *
     *              // Error
     *              function (response)
     *              {
     *                  console.error(response);
     *              }
     *          );
     *
     *          // Get the blog with the date by using custom defined method
     *          var date = 112314232132;
     *          api.blog.getByDate.get({'date': date},
     *
     *              // Success
     *              function (response)
     *              {
     *                  console.log(response);
     *              },
     *
     *              // Error
     *              function (response)
     *              {
     *                  console.error(response);
     *              }
     *          );
     *      }
     *
     * Because we are directly using $resource service, all your API calls will return a
     * $promise object.
     *
     * --
     *
     * If you want to do the same calls in your UI Router state definitions, you need to use
     * "apiResolver" service we have prepared for you:
     *
     *      $stateProvider.state('app.blog', {
     *          url      : '/blog',
     *          views    : {
     *               'content@app': {
     *                   templateUrl: 'app/main/apps/blog/blog.html',
     *                   controller : 'BlogController as vm'
     *               }
     *          },
     *          resolve  : {
     *              Blog: function (apiResolver)
     *              {
     *                  return apiResolver.resolve('blog.list@get');
     *              }
     *          }
     *      });
     *
     *  You can even use parameters with apiResolver service:
     *
     *      $stateProvider.state('app.blog.show', {
     *          url      : '/blog/:id',
     *          views    : {
     *               'content@app': {
     *                   templateUrl: 'app/main/apps/blog/blog.html',
     *                   controller : 'BlogController as vm'
     *               }
     *          },
     *          resolve  : {
     *              Blog: function (apiResolver, $stateParams)
     *              {
     *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
     *              }
     *          }
     *      });
     *
     *  And the "Blog" object will be available in your BlogController:
     *
     *      function BlogController(Blog)
     *      {
     *          var vm = this;
     *
     *          // Data
     *          vm.blog = Blog;
     *
     *          ...
     *      }
     */

    var api = {};

    // Base Url
    api.baseUrl = 'app/data/';

    // api.sample = $resource(api.baseUrl + 'sample/sample.json');

    return api;
  }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div class=\"ms-theme-options-list\" \nlayout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">Layout Style:</div><md-radio-group \nlayout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" ng-change=\"vm.updateLayoutStyle()\">\n<md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">\n{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><md-divider></md-divider><div \nclass=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/chat/chat.html","<div id=\"chat-app\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\"><div\n class=\"content-card\" layout=\"row\" flex><md-sidenav class=\"sidenav left-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/apps/chat/sidenavs/left/left-sidenav.html\'\" layout=\"column\"></md-sidenav><div \nclass=\"start-point\" ng-if=\"!vm.chat\" flex layout=\"column\" flex layout-align=\"center center\"><div \nclass=\"big-circle md-whiteframe-4dp\"><md-icon class=\"s128 md-accent\" md-font-icon=\"icon-hangouts\"></md-icon></div><span\n class=\"app-title\" translate=\"CHAT.APP_TITLE\">Chat App</span> <span class=\"hide show-gt-md secondary-text\" \ntranslate=\"CHAT.START_MESSAGE\">Select contact to start the chat!..</span><md-button class=\"md-raised hide-gt-md\" \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\" translate=\"CHAT.START_MESSAGE\">Select contact to start the chat!..\n</md-button></div><div ng-if=\"vm.chat\" class=\"chat\" layout=\"column\" flex><md-toolbar class=\"chat-toolbar\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"hide-gt-md responsive-chats-button md-icon-button\" \nng-click=\"vm.toggleLeftSidenavView(false);vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"chats button\"><md-icon \nmd-font-icon=\"icon-hangouts s36\"></md-icon></md-button><div class=\"chat-contact\" layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.toggleSidenav(\'right-sidenav\')\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"/> <i class=\"icon icon- s16 status\" \nng-class=\"vm.contacts.getById(vm.chatContactId).status\"></i></div><div class=\"chat-contact-name\">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div><md-menu md-position-mode=\"target-right target\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.toggleSidenav(\'right-sidenav\')\" \ntranslate=\"CHAT.CONTACT_INFO\">Contact Info</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.clearMessages()\" translate=\"CHAT.CLEAR_MESSAGES\">Clear Messages</md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content id=\"chat-content\" flex ms-scroll><div class=\"chat-messages\" \nng-if=\"vm.chat\"><div layout=\"row\" ng-repeat=\"dialog in vm.chat\" class=\"md-padding message-row\" ng-class=\"dialog.who\">\n<img ng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"/> <img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" \nng-src=\"{{vm.user.avatar}}\"><div class=\"bubble\"><div class=\"message\">{{dialog.message}}</div><div \nclass=\"time secondary-text\">{{dialog.time | altDate}}</div></div></div></div></md-content><div \nclass=\"chat-footer flex-noshrink\" layout=\"row\" layout-align=\"center center\"><form ng-submit=\"vm.reply()\" flex \nclass=\"reply-form\" layout=\"row\" layout-align=\"start center\"><md-input-container flex md-no-float><textarea \nng-keyup=\"vm.reply($event)\" md-no-autogrow ng-model=\"vm.replyMessage\" ng-class=\"{\'grow\': vm.textareaGrow}\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"CHAT.REPLY_PLACEHOLDER\">\n                            </textarea></md-input-container><md-button class=\"md-fab\" type=\"submit\" \naria-label=\"Send message\" translate translate-attr-aria-label=\"CHAT.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\">\n</md-icon></md-button></form></div></div><md-sidenav class=\"sidenav right-sidenav md-sidenav-right\" layout=\"column\" \nmd-component-id=\"right-sidenav\" ms-sidenav-helper ng-include=\"\'app/main/apps/chat/sidenavs/right/right-sidenav.html\'\">\n</md-sidenav></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><img src=\"/assets/images/logos/soc.png\" alt=\"SoC\" \nstyle=\"width: 50px; min-width: 50px; margin-left: -10px\"> <span class=\"logo-text\">SoC</span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\">\n</md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\">\n</ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"/><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"/><div class=\"status {{contact.status}}\"></div><div\n ng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"/><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"/> \n<img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular><div class=\"h4\" \nstyle=\"text-align: right\"><span hide-xs>Ενεργό σχολείο:</span><md-icon md-svg-src=\"assets/icons/svg/school.svg\">\n</md-icon>{{vm.getSelectedSchool().name}} <span flex></span> <a class=\"md-icon-button\" \nui-sref=\"app.scc.private.school\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></a><br/><span hide-xs>\nΕνεργή διδακτική περίοδος:</span><md-icon md-svg-src=\"assets/icons/svg/data-set.svg\"></md-icon><span \nng-if=\"vm.getSelectedDataSet()\">{{vm.getSelectedDataSet().name}}</span> <span ng-if=\"!vm.getSelectedDataSet()\">-</span>\n <span flex></span> <a class=\"md-icon-button\" ui-sref=\"app.scc.private.data-set\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s18\"></md-icon></a></div><div class=\"h4\"><br/></div><div class=\"toolbar-separator\"></div><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"></div><span class=\"username\" hide show-gt-sm>{{vm.getUser().email}}</span>\n<md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content \nwidth=\"3\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><div \nclass=\"toolbar-separator\"></div><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>{{vm.getUser().email}}</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <md-icon class=\"icon s28\" md-font-icon=\"{{node.icon}}\" ng-if=\"node.icon\"></md-icon>\n            <md-icon class=\"icon s28\" md-svg-src=\"assets/icons/svg/{{node.svgIcon}}.svg\" ng-if=\"node.svgIcon\"></md-icon>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <md-icon class=\"icon s28\" md-font-icon=\"{{node.icon}}\" ng-if=\"node.icon\"></md-icon>\n            <md-icon class=\"icon s28\" md-svg-src=\"assets/icons/svg/{{node.svgIcon}}.svg\" ng-if=\"node.svgIcon\"></md-icon>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/scc/components/activate-account/activate-account.html","<div id=\"activate-account\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"activate-account-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"activate-account-form\" class=\"md-whiteframe-8dp\"><img \nsrc=\"/assets/images/logos/soc.png\" alt=\"SoC\" style=\"width: 140px; margin: auto; display:block\"><div class=\"title\" \ntranslate=\"SCC.ACTIVATE_ACCOUNT.TITLE\">Activation</div><md-progress-linear md-mode=\"indeterminate\" \nng-disabled=\"vm.result != \'pending\'\"></md-progress-linear><div class=\"subtitle\" ng-if=\"vm.result == \'pending\'\"><span \ntranslate=\"SCC.ACTIVATE_ACCOUNT.PENDING_MSG\"></span></div><div class=\"subtitle\" ng-if=\"vm.result == \'success\'\"><span \ntranslate=\"SCC.ACTIVATE_ACCOUNT.SUCCESS_MSG\"></span><br/><a class=\"link\" ui-sref=\"app.scc.public.login\" \ntranslate=\"SCC.ACTIVATE_ACCOUNT.LOGIN_LINK\">Login!</a></div><div class=\"subtitle\" ng-if=\"vm.result == \'failure\'\"><span \ntranslate=\"SCC.ACTIVATE_ACCOUNT.FAILURE_MSG\"></span></div></div></div></div>");
$templateCache.put("app/main/scc/components/availability/availability-comment-dialog.html","<md-dialog aria-label=\"Comment\"><form ng-submit=\"$ctrl.save()\"><md-dialog-content><div class=\"md-dialog-content\"><h2 \nclass=\"md-title\" translate=\"SCC.AVAILABILITY.COMMENT\"></h2><md-input-container class=\"md-block\"><label \ntranslate=\"SCC.AVAILABILITY.COMMENT_PLACEHOLDER\"></label><textarea ng-model=\"$ctrl.comment\" rows=\"3\" \nmd-maxlength=\"512\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions><md-button \nng-click=\"$ctrl.cancel()\" translate=\"SCC.AVAILABILITY.CANCEL\"></md-button><md-button type=\"submit\" class=\"md-primary\" \ntranslate=\"SCC.AVAILABILITY.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/scc/components/availability/availability.html","<div class=\"scc-availability\"><md-content class=\"md-padding\" ng-if=\"!$ctrl.selectedDataSet\"><span \ntranslate=\"SCC.AVAILABILITY.NO_SELECTED_DATASET\"></span> <a class=\"link\" ui-sref=\"app.scc.private.data-set\"><span \ntranslate=\"SCC.AVAILABILITY.SELECT_DATASET\"></span></a></md-content><div ng-if=\"$ctrl.selectedDataSet\"><div \nclass=\"scc-availability-instructions\"><span translate=\"SCC.AVAILABILITY.INSTRUCTIONS\"></span></div><div \nscc-availability-grid scc-entity-type=\"$ctrl.entityType\" scc-entity-id=\"$ctrl.entityId\" \nscc-data-set=\"$ctrl.selectedDataSet\"><div class=\"scc-schedule-header\" layout=\"row\"><div \nclass=\"scc-schedule-row-header\">-</div><div ng-repeat=\"ss in $ctrl.scheduleSlots[0]\" \nclass=\"scc-schedule-column-header\" flex>{{ss.day|sccDay}}</div></div><div ng-repeat=\"r in $ctrl.scheduleSlots\" \nclass=\"scc-schedule-row\" layout=\"row\"><div class=\"scc-schedule-row-header\"><span \nng-if=\"r[0].timeSlot % 3 == 0 && $index > 0\">{{r[0].timeSlot|sccTimeSlot}}</span></div><div ng-repeat=\"ts in r\" \nscc-availability-slot scc-day=\"ts.day\" scc-time-slot=\"ts.timeSlot\" scc-disabled=\"ts.disabled\" flex \nng-class=\"{\'hour-change\': ts.timeSlot % 12 == 11}\"></div></div><div scc-unavailability-block scc-model=\"block\" \nng-repeat=\"block in $ctrl.blocks track by $index\"><div class=\"scc-unavailability-block-move-handle\"><strong>\n{{block.timeSlot|sccTimeSlot}}-{{block.timeSlot+block.duration|sccTimeSlot}}</strong></div><div \nclass=\"scc-unavailability-block-actions\"><md-icon md-font-icon=\"icon-comment\" \nclass=\"scc-unavailability-block-comment-icon\" ng-class=\"{\'has-comment\': block.comment}\" \nng-click=\"$ctrl.editComment($event, block)\"><md-tooltip md-direction=\"bottom\">\n{{\'SCC.AVAILABILITY.EDIT_COMMENT\' | translate}}</md-tooltip></md-icon><md-icon md-font-icon=\"icon-close\" \nclass=\"scc-unavailability-block-close-icon\" ng-click=\"$ctrl.removeBlock($event, block)\"><md-tooltip \nmd-direction=\"bottom\">{{\'SCC.AVAILABILITY.DELETE_BLOCK\' | translate}}</md-tooltip></md-icon></div><div \nclass=\"scc-unavailability-block-content\"><span ng-if=\"block.comment\">{{block.comment}}</span></div><div \nclass=\"scc-unavailability-block-resize-handle\"></div></div></div></div></div>");
$templateCache.put("app/main/scc/components/billing-info/billing-info.html","<span translate=\"SCC.BILLING_INFO.FORM_COMPLETION_GUIDE\"></span><div layout-gt-xs=\"row\"><md-input-container flex=\"20\" \nflex-gt-xs=\"20\"><label translate=\"SCC.BILLING_INFO.PHONE_CODE\"></label><input type=\"text\" name=\"phoneCountryCode\" \nng-model=\"$ctrl.billingInfo.phoneCountryCode\" required><errors-container errors=\"$ctrl.form.phoneCountryCode.$error\"/>\n</md-input-container><md-input-container flex=\"80\" flex-gt-xs=\"80\"><label translate=\"SCC.BILLING_INFO.PHONE\"></label>\n<input type=\"text\" name=\"phone\" ng-model=\"$ctrl.billingInfo.phone\" required><div ng-messages=\"$ctrl.form.phone.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Phone is required.</span></div></div></md-input-container></div><div \nlayout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label translate=\"SCC.BILLING_INFO.FIRST_NAME\">\n</label><input ng-model=\"$ctrl.billingInfo.firstName\"><div ng-messages=\"$ctrl.form.firstName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>First Name is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-xs><label translate=\"SCC.BILLING_INFO.LAST_NAME\"></label><input \nng-model=\"$ctrl.billingInfo.lastName\"><div ng-messages=\"$ctrl.form.lastName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Last Name is required.</span></div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-xs><label translate=\"SCC.BILLING_INFO.BUSINESS_NAME\">\n</label><input ng-model=\"$ctrl.billingInfo.businessName\"><div ng-messages=\"$ctrl.form.businessName.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Business Name is required.</span></div></div></md-input-container></div>\n<md-input-container class=\"md-block\"><label translate=\"SCC.BILLING_INFO.ADDRESS_LINE1\"></label><input \nng-model=\"$ctrl.billingInfo.addressLine1\"><div ng-messages=\"$ctrl.form.businessName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Address (line1) is required.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"SCC.BILLING_INFO.ADDRESS_LINE2\"></label><input \nng-model=\"$ctrl.billingInfo.addressLine2\"><div ng-messages=\"$ctrl.form.businessName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Address (line2) is required.</span></div></div></md-input-container><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"SCC.BILLING_INFO.CITY\"></label>\n<input ng-model=\"$ctrl.billingInfo.city\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"SCC.BILLING_INFO.STATE\"></label><input ng-model=\"$ctrl.billingInfo.state\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"SCC.BILLING_INFO.POSTAL_CODE\"></label><input \nname=\"postalCode\" ng-model=\"$ctrl.billingInfo.postalCode\" required ng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div \nng-messages=\"$ctrl.form.postalCode.$error\" role=\"alert\" multiple><div ng-message=\"required\" class=\"my-message\">\nYou must supply a postal code.</div><div ng-message=\"pattern\" class=\"my-message\">\nThat doesn\'t look like a valid postal code.</div><div ng-message=\"md-maxlength\" class=\"my-message\">\nDon\'t use the long version silly...we don\'t need to be that specific...</div></div></md-input-container></div>");
$templateCache.put("app/main/scc/components/buy/buy.html","<div id=\"buy\" layout=\"column\" layout-align=\"center center\" style=\"min-height: 100vh\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent\"></md-progress-circular></div>");
$templateCache.put("app/main/scc/components/classroom/classroom.html","<form name=\"form\"><carded-table translation-scope=\"SCC.CLASSROOM\" filter=\"$ctrl.dataTable.filter\" \nsearch-focused=\"$ctrl.dataTable.searchFocused\" records-number=\"$ctrl.getAllEntities().length\" svg-icon=\"classroom\">\n<form-errors-container form=\"form\" translation-scope=\"SCC.CLASSROOM.ERROR\"/><div ng-if=\"$mdMedia(\'gt-xs\')\">\n<md-table-container><table md-table md-row-select multiple ng-model=\"$ctrl.selectedEntities\"><thead md-head \nmd-order=\"$ctrl.dataTable.order\"><tr md-row><th md-column md-order-by=\"name\"><span translate=\"SCC.CLASSROOM.NAME\">Name\n</span></th><th md-column><span translate=\"SCC.CLASSROOM.ACTIONS\">Actions</span></th></tr></thead><tbody md-body><tr>\n<td md-cell><md-button class=\"md-icon-button\" ng-if=\"$ctrl.selectedEntities.length\" \ndata-ng-click=\"$ctrl.deleteSelected($event)\"><md-icon md-font-icon=\"icon-delete\" class=\"md_dark md-24\"/></md-button>\n</td><td md-cell><md-input-container><input type=\"text\" name=\"classroom.name\" maxlength=\"127\" \ndata-ng-model=\"$ctrl.classroom.name\" scc-enter=\"$ctrl.createEntity()\"/><errors-container \nerrors=\"form[\'classroom.name\'].$error\"/></md-input-container></td><td md-cell style=\"white-space: nowrap\"><a href=\"#\" \nclass=\"md-icon-button\" data-ng-click=\"$ctrl.createEntity()\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"s24\">\n</md-icon><span hide-sm hide-md>Δημιουργία</span> </a></td></tr><tr md-row md-select=\"classroom\" md-select-id=\"id\" \nng-repeat=\"classroom in $ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | limitTo: $ctrl.dataTable.limit : $ctrl.dataTable.limit*($ctrl.dataTable.page-1)\n				          | filter: $ctrl.tableRowFilter([\'name\',\'shortName\',\'maxHoursPerWeek\'],$ctrl.dataTable.filter)\">\n<td md-cell scc-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{classroom.name}}</td><td md-cell \nstyle=\"white-space: nowrap\"><a href=\"#\" class=\"md-icon-button\" data-ng-click=\"$ctrl.showEditPanel($event,classroom)\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"md_dark md-24\"/><span hide-sm hide-md>Επεξεργασία</span> </a><a href=\"#\" \nclass=\"md-icon-button\" data-ng-click=\"$ctrl.deleteEntity($event,classroom)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md_dark md-24\"/><span hide-sm hide-md>Διαγραφή</span> </a></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"$ctrl.dataTable.limit\" md-limit-options=\"$ctrl.dataTable.limitOptions\" \nmd-page=\"$ctrl.dataTable.page\" md-label=\"{{paginationLabels}}\" md-total=\"{{$ctrl.getAllEntities().length}}\" \nmd-page-select md-boundary-links></md-table-pagination></div><div ng-if=\"!$mdMedia(\'gt-xs\')\" class=\"mobile-list\">\n<md-card class=\"mobile-create-card\" ng-hide=\"$ctrl.dataTable.searchFocused\"><md-card-content layout=\"column\">\n<md-input-container><label translate=\"SCC.CLASSROOM.NAME\">Name</label><input type=\"text\" name=\"classroom.name\" \nmaxlength=\"127\" data-ng-model=\"$ctrl.classroom.name\" scc-enter=\"$ctrl.createEntity()\"/><errors-container \nerrors=\"form[\'classroom.name\'].$error\"/></md-input-container><md-button class=\"md-accent md-raised\" \nng-click=\"$ctrl.createEntity()\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"s18\"></md-icon>Δημιουργία</md-button>\n</md-card-content></md-card><md-card class=\"mobile-entity-card\" \nng-repeat=\"classroom in filteredClassrooms = ($ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | filter: $ctrl.tableRowFilter([\'name\',\'shortName\',\'maxHoursPerWeek\'],$ctrl.dataTable.filter))\" \nng-click=\"$ctrl.showEditPanel($event,classroom)\"><md-card-content layout=\"row\" layout-align=\"start center\"><div flex \nlayout=\"column\"><span class=\"mobile-entity-name\" scc-highlight-text=\"$ctrl.dataTable.filter\">{{classroom.name}}</span>\n</div><md-button class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.deleteEntity($event,classroom); $event.stopPropagation();\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md_dark md-24\"></md-icon></md-button></md-card-content></md-card><div class=\"mobile-no-results\" \nng-if=\"$ctrl.dataTable.filter && filteredClassrooms.length === 0\"><md-icon md-font-icon=\"icon-magnify\" class=\"s24\">\n</md-icon><span>Δεν βρέθηκαν αποτελέσματα</span></div></div></carded-table></form>");
$templateCache.put("app/main/scc/components/classroom/edit-classroom-dialog.html","<md-dialog aria-label=\"Αίθουσα {{$ctrl.oldClassroomName}}\"><form name=\"form\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Αίθουσα {{$ctrl.oldClassroomName}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-icon=\"icon-close\"/></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\"><md-input-container class=\"md-block\" flex-gt-sm><label \nfor=\"classroom.name\">Όνομα</label><input type=\"text\" name=\"classroom.name\" maxlength=\"127\" \ndata-ng-model=\"$ctrl.classroom.name\"/><errors-container errors=\"form[\'classroom.name\'].$error\"/></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label for=\"classroom.shortName\">Σύντομο όνομα</label><input \nmaxlength=\"6\" type=\"text\" name=\"classroom.shortName\" data-ng-model=\"$ctrl.classroom.shortName\"/><errors-container \nerrors=\"form[\'classroom.shortName\'].$error\"/></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button data-ng-click=\"$ctrl.close()\" class=\"md-raised md-primary\">ΑΚΥΡΟ</md-button><md-button \ndata-ng-click=\"$ctrl.submit()\" class=\"md-raised md-primary\">ΕΝΗΜΕΡΩΣΗ</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/scc/components/data-set/data-set-details.html","<carded-simple translation-scope=\"SCC.DATA_SET\" svg-icon=\"data_set\" title=\"{{$ctrl.data_set.name}}\"><md-nav-bar \nmd-selected-nav-item=\"$ctrl.tab\"><md-nav-item md-nav-sref=\"app.scc.private.data-set.details\" name=\"generalInfo\"><span \ntranslate=\"SCC.DATA_SET.GENERAL_INFO.TAB\"></span></md-nav-item><md-nav-item \nmd-nav-sref=\"app.scc.private.data-set.details\" name=\"workingHours\"><span translate=\"SCC.DATA_SET.WORKING_HOURS.TAB\">\n</span></md-nav-item></md-nav-bar><md-content class=\"md-padding\"><div ng-if=\"$ctrl.selectedTab == \'generalInfo\'\">\n<dataset-general-info dataset-id=\"$ctrl.dataSetId\" dirty=\"$ctrl.dirty\"></dataset-general-info></div><div \nng-if=\"$ctrl.selectedTab == \'workingHours\'\"><dataset-working-hours dataset-id=\"$ctrl.dataSetId\" dirty=\"$ctrl.dirty\">\n</dataset-working-hours></div></md-content></carded-simple>");
$templateCache.put("app/main/scc/components/data-set/data-set-general-info.html","<form name=\"form\"><h1 class=\"md-display-1\"><md-button class=\"md-icon-button\" ng-if=\"!$ctrl.editable\" \ndata-ng-click=\"$ctrl.startEditing()\"><md-icon md-font-icon=\"icon-pencil\" class=\"md_dark md-16\"/></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"$ctrl.editable\" data-ng-click=\"$ctrl.save()\"><md-icon md-font-icon=\"icon-content-save\" \nclass=\"md_dark md-16\"/></md-button><md-button class=\"md-icon-button\" ng-if=\"$ctrl.editable\" \ndata-ng-click=\"$ctrl.cancelEditing()\"><md-icon md-font-icon=\"icon-close\" class=\"md_dark md-16\"/></md-button></h1>\n<md-input-container class=\"md-block\" flex-gt-sm><label for=\"dataSet.name\">Όνομα</label><input type=\"text\" \nname=\"dataSet.name\" data-ng-model=\"$ctrl.dataSet.name\" ng-disabled=\"!$ctrl.editable\"/><errors-container \nerrors=\"form[\'dataSet.name\'].$error\"/></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \nfor=\"dataSet.dateFrom\">Έναρξη περιόδου</label><local-date-picker input-name=\"\'dataSet.dateFrom\'\" \nerrors=\"form[\'dataSet.dateFrom\'].$error\" local-date=\"$ctrl.dataSet.dateFrom\" disabled/></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label for=\"dataSet.dateTo\">Λήξη περιόδου</label><local-date-picker \ninput-name=\"\'dataSet.dateTo\'\" errors=\"form[\'dataSet.dateTo\'].$error\" local-date=\"$ctrl.dataSet.dateTo\" disabled/>\n</md-input-container></form>");
$templateCache.put("app/main/scc/components/data-set/data-set-list.html","<form name=\"form\"><carded-table translation-scope=\"SCC.DATA_SET\" filter=\"$ctrl.dataTable.filter\" \nsearch-focused=\"$ctrl.dataTable.searchFocused\" records-number=\"$ctrl.getAllEntities().length\" svg-icon=\"data-set\" \nid=\"data-sets\"><div layout=\"row\" class=\"md-padding\" hide-xs><md-icon class=\"s32\" md-font-icon=\"icon-information\" \nstyle=\"margin-right: 18px\"/><div class=\"secondary-text md-body-1\">\nΕδώ μπορείτε να ορίσετε τις διδακτικές περιόδους του σχολείου σας.<p>\nΚάθε περίοδος έχει τα δικά της τμήματα και το δικό της ωρολόγιο πρόγραμμα. Μπορείτε να επιλέξετε ποια περίοδος θα είναι ενεργή, ώστε να βλέπετε και να επεξεργάζεστε τα τμήματα και το πρόγραμμα που ανήκουν σε αυτήν.\n</p>\nΜην ξεχάσετε να ορίσετε και τις ώρες λειτουργίας του σχολείου για κάθε περίοδο. Έτσι θα σας είναι πιο εύκολο να δημιουργήσετε το ωρολόγιο πρόγραμμα.\n<p></p></div></div><div ng-if=\"$mdMedia(\'gt-xs\')\"><md-table-container><table md-table md-row-select multiple \nng-model=\"$ctrl.selectedEntities\"><thead md-head md-order=\"$ctrl.dataTable.order\"><tr md-row><th md-column \nmd-order-by=\"name\"><span translate=\"SCC.DATA_SET.NAME\">Name</span></th><th md-column md-order-by=\"dateFrom\"><span \ntranslate=\"SCC.DATA_SET.DATE_FROM\">Date from</span></th><th md-column md-order-by=\"dateTo\"><span \ntranslate=\"SCC.DATA_SET.DATE_TO\">Date to</span></th><th md-column><span translate=\"SCC.DATA_SET.ACTIONS\">Actions</span>\n</th></tr></thead><tbody md-body><tr><td md-cell><md-button class=\"md-icon-button\" \nng-if=\"$ctrl.selectedEntities.length\" data-ng-click=\"$ctrl.deleteSelected($event)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md_dark md-24\"/></md-button></td><td md-cell><md-input-container><input type=\"text\" name=\"dataSet.name\" \ndata-ng-model=\"$ctrl.dataSet.name\" scc-enter=\"$ctrl.createEntity()\" maxlength=\"127\"/><errors-container \nerrors=\"form[\'dataSet.name\'].$error\"/></md-input-container></td><td md-cell><md-input-container><local-date-picker \ninput-name=\"\'dataSet.dateFrom\'\" scc-enter=\"$ctrl.createEntity()\" local-date=\"$ctrl.dataSet.dateFrom\" \nerrors=\"form[\'dataSet.dateFrom\'].$error\"/></md-input-container></td><td md-cell><md-input-container><local-date-picker \ninput-name=\"\'dataSet.dateTo\'\" scc-enter=\"$ctrl.createEntity()\" local-date=\"$ctrl.dataSet.dateTo\" \nerrors=\"form[\'dataSet.dateTo\'].$error\"/></md-input-container></td><td md-cell style=\"white-space: nowrap\"><a href=\"#\" \nclass=\"md-icon-button\" data-ng-click=\"$ctrl.createEntity()\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"s24\">\n</md-icon><span hide-sm hide-md>Δημιουργία</span> </a></td></tr><tr md-row md-select=\"dataSet\" md-select-id=\"id\" \nng-class=\"{\'selected-dataset\':$ctrl.isSelectedDataSet(dataSet)}\" \nng-repeat=\"dataSet in $ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | limitTo: $ctrl.dataTable.limit : $ctrl.dataTable.limit*($ctrl.dataTable.page-1)\n				          | filter: $ctrl.tableRowFilter([\'name\'],$ctrl.dataTable.filter)\">\n<td md-cell scc-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{dataSet.name}}</td><td md-cell \nscc-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{dataSet.dateFrom | date : \'mediumDate\'}}</td><td \nmd-cell scc-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{dataSet.dateTo | date : \'mediumDate\'}}\n</td><td md-cell style=\"white-space: nowrap\"><a class=\"md-icon-button\" \nui-sref=\"app.scc.private.data-set.details({dataSetId: {{dataSet.id}}})\"><md-icon md-font-icon=\"icon-view-list\" \nclass=\"md_dark md-24\"/><span hide-sm hide-md>Περισσότερα</span> </a><a class=\"md-icon-button\" href=\"#\" \nclass=\"md-icon-button\" data-ng-click=\"$ctrl.deleteEntity($event,dataSet)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md_dark md-24\"/><span hide-sm hide-md>Διαγραφή</span> </a><a class=\"md-icon-button\" href=\"#\" \nclass=\"md-icon-button\" data-ng-click=\"$ctrl.selectDataSet(dataSet)\" ng-if=\"!$ctrl.isSelectedDataSet(dataSet)\"><md-icon \nmd-font-icon=\"icon-pin\" class=\"s24\"></md-icon><span hide-sm hide-md>Επιλογή ως ενεργή</span> </a><span \nng-if=\"$ctrl.isSelectedDataSet(dataSet)\"><md-icon md-font-icon=\"icon-pin\" class=\"s24\"></md-icon><span hide-sm hide-md>\nΕνεργή</span></span></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"$ctrl.dataTable.limit\" md-limit-options=\"$ctrl.dataTable.limitOptions\" md-page=\"$ctrl.dataTable.page\" \nmd-label=\"{{paginationLabels}}\" md-total=\"{{$ctrl.getAllEntities().length}}\" md-page-select md-boundary-links>\n</md-table-pagination></div><div ng-if=\"!$mdMedia(\'gt-xs\')\" class=\"mobile-list\"><md-card class=\"mobile-create-card\" \nng-hide=\"$ctrl.dataTable.searchFocused\"><md-card-content layout=\"column\"><md-input-container><label \ntranslate=\"SCC.DATA_SET.NAME\">Name</label><input type=\"text\" name=\"dataSet.name\" data-ng-model=\"$ctrl.dataSet.name\" \nscc-enter=\"$ctrl.createEntity()\" maxlength=\"127\"/><errors-container errors=\"form[\'dataSet.name\'].$error\"/>\n</md-input-container><label class=\"mobile-field-label\" translate=\"SCC.DATA_SET.DATE_FROM\">Date from</label>\n<local-date-picker input-name=\"\'dataSet.dateFrom\'\" scc-enter=\"$ctrl.createEntity()\" \nlocal-date=\"$ctrl.dataSet.dateFrom\" errors=\"form[\'dataSet.dateFrom\'].$error\"/><label class=\"mobile-field-label\" \ntranslate=\"SCC.DATA_SET.DATE_TO\">Date to</label><local-date-picker input-name=\"\'dataSet.dateTo\'\" \nscc-enter=\"$ctrl.createEntity()\" local-date=\"$ctrl.dataSet.dateTo\" errors=\"form[\'dataSet.dateTo\'].$error\"/><md-button \nclass=\"md-accent md-raised\" ng-click=\"$ctrl.createEntity()\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"s18\">\n</md-icon>Δημιουργία</md-button></md-card-content></md-card><md-card class=\"mobile-entity-card\" \nng-class=\"{\'selected-dataset\':$ctrl.isSelectedDataSet(dataSet)}\" \nng-repeat=\"dataSet in filteredDataSets = ($ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | filter: $ctrl.tableRowFilter([\'name\'],$ctrl.dataTable.filter))\" \nui-sref=\"app.scc.private.data-set.details({dataSetId: {{dataSet.id}}})\"><md-card-content layout=\"row\" \nlayout-align=\"start center\"><div flex layout=\"column\"><span class=\"mobile-entity-name\" \nscc-highlight-text=\"$ctrl.dataTable.filter\">{{dataSet.name}}</span> <span class=\"mobile-entity-detail\">\n{{dataSet.dateFrom | date : \'mediumDate\'}} - {{dataSet.dateTo | date : \'mediumDate\'}}</span></div><md-button \nclass=\"md-icon-button\" ng-if=\"!$ctrl.isSelectedDataSet(dataSet)\" \ndata-ng-click=\"$ctrl.selectDataSet(dataSet); $event.stopPropagation();\"><md-icon md-font-icon=\"icon-pin\" \nclass=\"md_dark md-24\"></md-icon></md-button><md-icon ng-if=\"$ctrl.isSelectedDataSet(dataSet)\" md-font-icon=\"icon-pin\" \nclass=\"s24\" style=\"margin-right: 12px\"></md-icon><md-button class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.deleteEntity($event,dataSet); $event.stopPropagation();\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md_dark md-24\"></md-icon></md-button></md-card-content></md-card><div class=\"mobile-no-results\" \nng-if=\"$ctrl.dataTable.filter && filteredDataSets.length === 0\"><md-icon md-font-icon=\"icon-magnify\" class=\"s24\">\n</md-icon><span>Δεν βρέθηκαν αποτελέσματα</span></div></div></carded-table></form>");
$templateCache.put("app/main/scc/components/data-set/data-set-working-hours.html","<form name=\"form\"><h1 class=\"md-display-1\"><md-button class=\"md-icon-button\" ng-if=\"!$ctrl.editable\" \ndata-ng-click=\"$ctrl.startEditing()\"><md-icon md-font-icon=\"icon-pencil\" class=\"md_dark md-16\"/></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"$ctrl.editable\" data-ng-click=\"$ctrl.save()\"><md-icon md-font-icon=\"icon-content-save\" \nclass=\"md_dark md-16\"/></md-button><md-button class=\"md-icon-button\" ng-if=\"$ctrl.editable\" \ndata-ng-click=\"$ctrl.cancelEditing()\"><md-icon md-font-icon=\"icon-close\" class=\"md_dark md-16\"/></md-button></h1><div \nstyle=\"display: flex; flex-direction: row\"><div ng-repeat=\"day in $ctrl.daysOfWeek\" layout=\"column\" \nclass=\"data-set-day-section\"><h4>{{ day | sccDay }}</h4><div class=\"data-set-time-slot\" \nng-repeat=\"slot in $ctrl.schedule[day].slots\" layout=\"row\" layout-align=\"start center\" class=\"time-slot\"><div \nclass=\"data-set-time-slot-row\">Από:<mdp-time-picker mdp-auto-switch=\"true\" ng-model=\"slot.start\" mdp-format=\"HH:mm\" \nmdp-disabled=\"!$ctrl.editable\" style=\"display: inline-block\"></mdp-time-picker><input type=\"hidden\" \nname=\"dataSet.scheduleTable[{{day}}].slots[{{$index}}].start\" data-ng-model=\"slot.start\"/><errors-container \nerrors=\"form[\'dataSet.scheduleTable[\'+day+\'].slots[\'+$index+\'].start\'].$error\"/></div><div \nclass=\"data-set-time-slot-row\">Έως:<mdp-time-picker mdp-input-name=\"dataSet.scheduleTable[5].slots[0].end\" \nmdp-auto-switch=\"true\" ng-model=\"slot.end\" mdp-format=\"HH:mm\" mdp-disabled=\"!$ctrl.editable\" \nstyle=\"display: inline-block\"></mdp-time-picker><input type=\"hidden\" \nname=\"dataSet.scheduleTable[{{day}}].slots[{{$index}}].end\" data-ng-model=\"slot.end\"/><errors-container \nerrors=\"form[\'dataSet.scheduleTable[\'+day+\'].slots[\'+$index+\'].end\'].$error\"/></div><md-button class=\"md-icon-button\" \nng-click=\"$ctrl.removeSlot(day, $index)\" ng-if=\"$ctrl.editable\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md_dark md-16\"/></md-button></div><md-button ng-if=\"$ctrl.editable\" class=\"md-raised md-primary\" \nng-click=\"$ctrl.addSlot(day)\" ng-disabled=\"$ctrl.schedule[day].length >= 8\"><md-icon md-font-icon=\"icon-plus-circle\" \nclass=\"s24\"></md-icon></md-button></div></div></form>");
$templateCache.put("app/main/scc/components/duration-picker/duration-picker.html","<div ng-if=\"!$ctrl.readonly\" class=\"duration-picker\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"dp-row\" role=\"group\" aria-label=\"{{$ctrl.label || \'Duration\'}}\"><input type=\"text\" ng-model=\"$ctrl.hours\" \nstyle=\"display: none\"/><md-input-container class=\"dp-field dp-hours\" md-is-error=\"$ctrl.hasErrors()\"><label>Ώρες\n</label><md-select aria-label=\"Ώρες\" ng-model=\"$ctrl.hours\" ng-change=\"$ctrl.onPartsChanged()\" \nng-required=\"$ctrl.required\"><md-option ng-repeat=\"h in $ctrl.hourOptions\" ng-value=\"h\">{{ h }}</md-option></md-select>\n<div class=\"md-errors-spacer\"></div></md-input-container><span class=\"dp-sep\" aria-hidden=\"true\">:</span>\n<md-input-container class=\"dp-field dp-minutes\" md-is-error=\"$ctrl.hasErrors()\"><label>Λεπτά</label><md-select \naria-label=\"Λεπτά\" ng-model=\"$ctrl.minutes\" ng-change=\"$ctrl.onPartsChanged()\" ng-required=\"$ctrl.required\"><md-option \nng-repeat=\"m in $ctrl.minutesOptions track by m\" ng-value=\"m\">{{ (\"\"+m).padStart(2,\"0\") }}</md-option></md-select><div \nclass=\"md-errors-spacer\"></div></md-input-container></div></div><div ng-if=\"$ctrl.readonly\">\n{{$ctrl.hours}} ώρες και {{$ctrl.minutes}} λεπτά</div>");
$templateCache.put("app/main/scc/components/errors-container/errors-container.html","<div ng-messages=\"$ctrl.errors\" role=\"alert\" ng-messages-multiple><div ng-message-exp=\"er\" \nng-repeat=\"(er,val) in $ctrl.errors\" \ntranslate=\"{{$ctrl.translationScope?$ctrl.translationScope:\'SCC.ERROR\'}}.{{val.messageTemplate}}\" \ntranslate-values=\"{error: val}\"></div></div>");
$templateCache.put("app/main/scc/components/errors-container/form-errors-container.html","<div class=\"scc-form-errors\" ng-if=\"$ctrl.form.$sccFormError || $ctrl.form.$sccImplicitFieldsErrors\"><errors-container \nerrors=\"$ctrl.form.$sccFormError\" translation-scope=\"{{$ctrl.translationScope}}\"/><errors-container \nng-repeat=\"(path, errors) in $ctrl.form.$sccImplicitFieldsErrors\" errors=\"errors\" \ntranslation-scope=\"{{$ctrl.translationScope}}.{{path}}\"/></div>");
$templateCache.put("app/main/scc/components/forgot-password/forgot-password-mail-sent.html","<div id=\"forgot-password-mail-sent\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nid=\"forgot-password-mail-sent-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div \nid=\"forgot-password-mail-sent-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F</span></div><div \nclass=\"title\" translate=\"SCC.FORGOT_PASSWORD.MAIL_SENT.TITLE\">Mail sent!</div><div class=\"subtitle\" \ntranslate=\"SCC.FORGOT_PASSWORD.MAIL_SENT.SUBTITLE\">Check your email...</div></div></div></div>");
$templateCache.put("app/main/scc/components/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"SCC.FORGOT_PASSWORD.TITLE\">\nRecover your password</div><md-progress-linear md-mode=\"indeterminate\" ng-disabled=\"!$root.loadingProgress\">\n</md-progress-linear><form name=\"form\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"text\" \nname=\"email\" ng-model=\"vm.req.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"SCC.FORGOT_PASSWORD.EMAIL\"><errors-container errors=\"form[\'email\'].$error\" \ntranslation-scope=\"SCC.FORGOT_PASSWORD.ERROR.EMAIL\"/></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" ng-click=\"vm.demandPasswordReset()\" \ntranslate=\"SCC.FORGOT_PASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"SCC.FORGOT_PASSWORD.SEND_RESET_LINK\">\nSEND RESET LINK</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" \nui-sref=\"app.scc.public.login\" translate=\"SCC.FORGOT_PASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/scc/components/lesson/edit-lesson-dialog.html","<md-dialog aria-label=\"Μάθημα {{$ctrl.oldLessonName}}\"><form name=\"form\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Μάθημα {{$ctrl.oldLessonName}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"$ctrl.close()\"><md-icon md-font-icon=\"icon-close\"/></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\"><md-input-container class=\"md-block\" flex-gt-sm><label for=\"lesson.name\">Όνομα</label><input \ntype=\"text\" name=\"lesson.name\" data-ng-model=\"$ctrl.lesson.name\"/><errors-container \nerrors=\"form[\'lesson.name\'].$error\"/></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \nfor=\"lesson.shortName\">Σύντομο όνομα</label><input type=\"text\" name=\"lesson.shortName\" \ndata-ng-model=\"$ctrl.lesson.shortName\"/><errors-container errors=\"form[\'lesson.shortName\'].$error\"/>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \ndata-ng-click=\"$ctrl.close()\" class=\"md-raised md-primary\">ΑΚΥΡΟ</md-button><md-button data-ng-click=\"$ctrl.submit()\" \nclass=\"md-raised md-primary\">ΕΝΗΜΕΡΩΣΗ</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/scc/components/lesson/lesson.html","<form name=\"form\"><carded-table translation-scope=\"SCC.LESSON\" filter=\"$ctrl.dataTable.filter\" \nsearch-focused=\"$ctrl.dataTable.searchFocused\" records-number=\"$ctrl.getAllEntities().length\" svg-icon=\"lesson\">\n<form-errors-container form=\"form\" translation-scope=\"SCC.LESSON.ERROR\"/><div ng-if=\"$mdMedia(\'gt-xs\')\">\n<md-table-container><table md-table md-row-select multiple ng-model=\"$ctrl.selectedEntities\"><thead md-head \nmd-order=\"$ctrl.dataTable.order\"><tr md-row><th md-column md-order-by=\"name\"><span translate=\"SCC.LESSON.NAME\">Name\n</span></th><th md-column><span translate=\"SCC.LESSON.ACTIONS\">Actions</span></th></tr></thead><tbody md-body><tr><td \nmd-cell><md-button class=\"md-icon-button\" ng-if=\"$ctrl.selectedEntities.length\" \ndata-ng-click=\"$ctrl.deleteSelected($event)\"><md-icon md-font-icon=\"icon-delete\" class=\"md_dark md-24\"/></md-button>\n</td><td md-cell><md-input-container><input type=\"text\" name=\"lesson.name\" data-ng-model=\"$ctrl.lesson.name\" \nscc-enter=\"$ctrl.createEntity()\"/><errors-container errors=\"form[\'lesson.name\'].$error\"/></md-input-container></td><td \nmd-cell style=\"white-space: nowrap\"><a href=\"#\" class=\"md-icon-button\" data-ng-click=\"$ctrl.createEntity()\"><md-icon \nmd-font-icon=\"icon-plus-circle\" class=\"s24\"></md-icon><span hide-sm hide-md>Δημιουργία</span> </a></td></tr><tr md-row \nmd-select=\"lesson\" md-select-id=\"id\" \nng-repeat=\"lesson in $ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | limitTo: $ctrl.dataTable.limit : $ctrl.dataTable.limit*($ctrl.dataTable.page-1)\n				          | filter: $ctrl.tableRowFilter([\'name\',\'shortName\',\'maxHoursPerWeek\'],$ctrl.dataTable.filter)\">\n<td md-cell scc-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{lesson.name}}</td><td md-cell \nstyle=\"white-space: nowrap\"><a href=\"#\" class=\"md-icon-button\" data-ng-click=\"$ctrl.showEditPanel($event,lesson)\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"md_dark md-24\"/><span hide-sm hide-md>Επεξεργασία</span> </a><a href=\"#\" \nclass=\"md-icon-button\" data-ng-click=\"$ctrl.deleteEntity($event,lesson)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md_dark md-24\"/><span hide-sm hide-md>Διαγραφή</span> </a></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"$ctrl.dataTable.limit\" md-limit-options=\"$ctrl.dataTable.limitOptions\" \nmd-page=\"$ctrl.dataTable.page\" md-label=\"{{paginationLabels}}\" md-total=\"{{$ctrl.getAllEntities().length}}\" \nmd-page-select md-boundary-links></md-table-pagination></div><div ng-if=\"!$mdMedia(\'gt-xs\')\" class=\"mobile-list\">\n<md-card class=\"mobile-create-card\" ng-hide=\"$ctrl.dataTable.searchFocused\"><md-card-content layout=\"column\">\n<md-input-container><label translate=\"SCC.LESSON.NAME\">Name</label><input type=\"text\" name=\"lesson.name\" \ndata-ng-model=\"$ctrl.lesson.name\" scc-enter=\"$ctrl.createEntity()\"/><errors-container \nerrors=\"form[\'lesson.name\'].$error\"/></md-input-container><md-button class=\"md-accent md-raised\" \nng-click=\"$ctrl.createEntity()\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"s18\"></md-icon>Δημιουργία</md-button>\n</md-card-content></md-card><md-card class=\"mobile-entity-card\" \nng-repeat=\"lesson in filteredLessons = ($ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | filter: $ctrl.tableRowFilter([\'name\',\'shortName\',\'maxHoursPerWeek\'],$ctrl.dataTable.filter))\" \nng-click=\"$ctrl.showEditPanel($event,lesson)\"><md-card-content layout=\"row\" layout-align=\"start center\"><div flex \nlayout=\"column\"><span class=\"mobile-entity-name\" scc-highlight-text=\"$ctrl.dataTable.filter\">{{lesson.name}}</span>\n</div><md-button class=\"md-icon-button\" data-ng-click=\"$ctrl.deleteEntity($event,lesson); $event.stopPropagation();\">\n<md-icon md-font-icon=\"icon-delete\" class=\"md_dark md-24\"></md-icon></md-button></md-card-content></md-card><div \nclass=\"mobile-no-results\" ng-if=\"$ctrl.dataTable.filter && filteredLessons.length === 0\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"s24\"></md-icon><span>Δεν βρέθηκαν αποτελέσματα</span></div></div></carded-table>\n</form>");
$templateCache.put("app/main/scc/components/lesson-delivery/lesson-delivery-notes.html","<form name=\"form\"><h1 class=\"md-display-1\"><span translate=\"SCC.LESSON_DELIVERY.NOTES.TITLE\">Salary details</span>\n<md-button class=\"md-icon-button\" ng-if=\"!$ctrl.editable\" data-ng-click=\"$ctrl.startEditing()\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"md_dark md-16\"/></md-button><md-button class=\"md-icon-button\" ng-if=\"$ctrl.editable\" \ndata-ng-click=\"$ctrl.save()\"><md-icon md-font-icon=\"icon-content-save\" class=\"md_dark md-16\"/></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"$ctrl.editable\" data-ng-click=\"$ctrl.cancelEditing()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"md_dark md-16\"/></md-button></h1><div ng-repeat=\"note in $ctrl.notes\" layout=\"row\">{{note.title}}</div></form>");
$templateCache.put("app/main/scc/components/lesson-delivery/lesson-delivery.html","<carded-simple translation-scope=\"SCC.LESSON_DELIVERY\" svg-icon=\"lesson-delivery\" title=\"Μάθημα \'Φυσική\' 28/3/2018\">\n<md-nav-bar md-selected-nav-item=\"$ctrl.tab\"><md-nav-item md-nav-sref=\"app.scc.private.lesson-delivery\" name=\"notes\">\n<span translate=\"SCC.LESSON_DELIVERY.NOTES_TAB\"></span></md-nav-item><md-nav-item \nmd-nav-sref=\"app.scc.private.lesson-delivery\" name=\"absences\"><span translate=\"SCC.LESSON_DELIVERY.ABSENCES_TAB\">\n</span></md-nav-item></md-nav-bar><md-content class=\"md-padding\"><div ng-if=\"$ctrl.selectedTab == \'notes\'\">NOTESgg\n<lesson-delivery-notes dirty=\"$ctrl.dirty\"></lesson-delivery-notes></div><div ng-if=\"$ctrl.selectedTab == \'absences\'\">\nABSENCES I</div></md-content></carded-simple>");
$templateCache.put("app/main/scc/components/local-date-picker/local-date-picker.html","<md-datepicker name=\"{{$ctrl.inputName}}\" ng-model=\"$ctrl.date\" ng-disabled=\"$ctrl.disabled\"/><errors-container \nerrors=\"$ctrl.errors\"/>");
$templateCache.put("app/main/scc/components/login/login.html","<div id=\"login\" layout=\"row\" layout-align=\"start\"><div id=\"login-intro\" flex hide show-gt-sm><img \nsrc=\"/assets/images/logos/soc.png\" alt=\"SoC\" style=\"width: 150px\"><div class=\"title\" translate=\"SCC.LOGIN.INTRO_TITLE\">\nWelcome to the FUSE!</div><div class=\"description\" translate=\"SCC.LOGIN.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"login-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-form\"><div \nclass=\"logo md-accent-bg\" hide-gt-sm><span>F</span></div><div class=\"title\" translate=\"SCC.LOGIN.TITLE\">\nLog in to your account</div><md-progress-linear md-mode=\"indeterminate\" ng-disabled=\"!$root.loadingProgress\">\n</md-progress-linear><form name=\"form\" novalidate><form-errors-container form=\"form\" \ntranslation-scope=\"SCC.LOGIN.ERROR\"/><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"email\" \nng-model=\"vm.req.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"SCC.LOGIN.EMAIL\"><errors-container \ntranslation-scope=\"SCC.LOGIN.ERROR.EMAIL\" errors=\"form[\'email\'].$error\"/></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.req.password\" \nplaceholder=\"{{ \'SCC.LOGIN.PASSWORD\' | translate }}\"/><errors-container translation-scope=\"SCC.LOGIN.ERROR.PASSWORD\" \nerrors=\"form[\'password\'].$error\"/></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"space-between center\"><a ui-sref=\"app.scc.public.forgot-password\" \nclass=\"forgot-password md-accent-color\" translate=\"SCC.LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" ng-click=\"vm.login()\" translate=\"SCC.LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"SCC.LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"SCC.LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.scc.public.register\" translate=\"SCC.LOGIN.CREATE_ACCOUNT\">\nCreate an account</a></div></div></div></div>");
$templateCache.put("app/main/scc/components/monitoring/monitoring.html","<carded-simple icon=\"icon-binoculars\" title=\"{{\'SCC.MONITORING.TITLE\' | translate}}\"><div ng-if=\"!$ctrl.hasSchool()\" \nclass=\"md-padding\" layout=\"row\" layout-align=\"center center\" style=\"padding: 48px 16px\"><span \nclass=\"md-subhead secondary-text\">Παρακαλούμε επιλέξτε σχολείο για να δείτε το παρατηρητήριο.</span></div><div \nng-if=\"$ctrl.hasSchool()\" layout=\"row\" layout-align=\"space-between center\" style=\"padding: 8px 16px 0 16px\"><span \nclass=\"md-display-1\" style=\"font-weight: 600\">{{$ctrl.schoolName}}</span><div><i class=\"icon-clock secondary-text\" \nstyle=\"font-size: 24px; vertical-align: middle; margin-right: 8px\"></i> <span class=\"md-display-1\" \nstyle=\"vertical-align: middle\">{{$ctrl.schoolClock}}</span></div></div><div ng-if=\"$ctrl.hasSchool()\" layout=\"row\" \nlayout-xs=\"column\" layout-align=\"center stretch\" class=\"md-padding\"><md-card flex><md-card-content layout=\"column\" \nlayout-align=\"center center\"><span class=\"md-display-2\">{{$ctrl.numberOfActiveTeachers}}</span> <span \nclass=\"md-subhead secondary-text\">Καθηγητές σε μάθημα</span></md-card-content></md-card><md-card flex><md-card-content \nlayout=\"column\" layout-align=\"center center\"><span class=\"md-display-2\">{{$ctrl.numberOfActiveStudentsGroups}}</span> \n<span class=\"md-subhead secondary-text\">Τμήματα σε μάθημα</span></md-card-content></md-card><md-card flex>\n<md-card-content layout=\"column\" layout-align=\"center center\"><span class=\"md-display-2\">\n{{$ctrl.numberOfActiveStudents}}</span> <span class=\"md-subhead secondary-text\">Μαθητές σε μάθημα</span>\n</md-card-content></md-card></div><div ng-if=\"$ctrl.hasSchool()\"><h2 class=\"md-title\" style=\"padding: 0 16px\">\nΤρέχοντα μαθήματα</h2><md-table-container ng-if=\"$ctrl.currentSessions.length > 0\"><table md-table><thead md-head><tr \nmd-row><th md-column>Μάθημα</th><th md-column>Τμήμα</th><th md-column>Καθηγητής</th><th md-column>Αίθουσα</th><th \nmd-column>Μαθητές</th><th md-column>Ώρα</th><th md-column>Πρόοδος</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"session in $ctrl.currentSessions\"><td md-cell>{{session.teachingNeed.lesson.name}}</td><td md-cell><a \nui-sref=\"app.scc.private.students-group.details({studentsGroupId: {{session.teachingNeed.studentsGroup.id}}})\">\n{{session.teachingNeed.studentsGroup.name}}</a></td><td md-cell><a \nui-sref=\"app.scc.private.teacher.details({teacherId: {{session.teachingNeed.teacher.id}}})\">\n{{session.teachingNeed.teacher.name}}</a></td><td md-cell>{{session.teachingNeed.classroom.name}}</td><td md-cell>\n{{session.teachingNeed.studentsGroup.size}}</td><td md-cell>\n{{$ctrl.formatTime(session.timeSlot)}} - {{$ctrl.formatTime(session.timeSlot + session.duration)}}</td><td md-cell \nstyle=\"min-width: 120px\"><md-progress-linear md-mode=\"determinate\" value=\"{{$ctrl.sessionProgress(session)}}\">\n</md-progress-linear></td></tr></tbody></table></md-table-container><div \nng-if=\"$ctrl.loaded && $ctrl.currentSessions.length === 0\" class=\"md-padding\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"md-subhead secondary-text\">Δεν υπάρχουν μαθήματα σε εξέλιξη αυτή τη στιγμή.\n</span></div><h2 class=\"md-title\" style=\"padding: 16px 16px 0 16px\">Προηγούμενα μαθήματα</h2><md-table-container \nng-if=\"$ctrl.previousSessions.length > 0\"><table md-table><thead md-head><tr md-row><th md-column>Μάθημα</th><th \nmd-column>Τμήμα</th><th md-column>Καθηγητής</th><th md-column>Αίθουσα</th><th md-column>Μαθητές</th><th md-column>Ώρα\n</th><th md-column>Τελείωσε πριν</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"session in $ctrl.previousSessions\"><td md-cell>{{session.teachingNeed.lesson.name}}</td><td md-cell><a \nui-sref=\"app.scc.private.students-group.details({studentsGroupId: {{session.teachingNeed.studentsGroup.id}}})\">\n{{session.teachingNeed.studentsGroup.name}}</a></td><td md-cell><a \nui-sref=\"app.scc.private.teacher.details({teacherId: {{session.teachingNeed.teacher.id}}})\">\n{{session.teachingNeed.teacher.name}}</a></td><td md-cell>{{session.teachingNeed.classroom.name}}</td><td md-cell>\n{{session.teachingNeed.studentsGroup.size}}</td><td md-cell>\n{{$ctrl.formatTime(session.timeSlot)}} - {{$ctrl.formatTime(session.timeSlot + session.duration)}}</td><td md-cell>\n{{$ctrl.finishedAgo(session)}}</td></tr></tbody></table></md-table-container><div \nng-if=\"$ctrl.loaded && $ctrl.previousSessions.length === 0\" class=\"md-padding\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"md-subhead secondary-text\">Δεν υπάρχουν προηγούμενα μαθήματα σήμερα.</span>\n</div><h2 class=\"md-title\" style=\"padding: 16px 16px 0 16px\">Επόμενα μαθήματα</h2><md-table-container \nng-if=\"$ctrl.upcomingSessions.length > 0\"><table md-table><thead md-head><tr md-row><th md-column>Μάθημα</th><th \nmd-column>Τμήμα</th><th md-column>Καθηγητής</th><th md-column>Αίθουσα</th><th md-column>Μαθητές</th><th md-column>Ώρα\n</th><th md-column>Ξεκινάει σε</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"session in $ctrl.upcomingSessions\"><td md-cell>{{session.teachingNeed.lesson.name}}</td><td md-cell><a \nui-sref=\"app.scc.private.students-group.details({studentsGroupId: {{session.teachingNeed.studentsGroup.id}}})\">\n{{session.teachingNeed.studentsGroup.name}}</a></td><td md-cell><a \nui-sref=\"app.scc.private.teacher.details({teacherId: {{session.teachingNeed.teacher.id}}})\">\n{{session.teachingNeed.teacher.name}}</a></td><td md-cell>{{session.teachingNeed.classroom.name}}</td><td md-cell>\n{{session.teachingNeed.studentsGroup.size}}</td><td md-cell>\n{{$ctrl.formatTime(session.timeSlot)}} - {{$ctrl.formatTime(session.timeSlot + session.duration)}}</td><td md-cell>\n{{$ctrl.startsIn(session)}}</td></tr></tbody></table></md-table-container><div \nng-if=\"$ctrl.loaded && $ctrl.upcomingSessions.length === 0\" class=\"md-padding\" layout=\"row\" \nlayout-align=\"center center\"><span class=\"md-subhead secondary-text\">Δεν υπάρχουν επόμενα μαθήματα σήμερα.</span></div>\n</div></carded-simple>");
$templateCache.put("app/main/scc/components/notes/notes.html","<div id=\"notes\" class=\"\" layout=\"column\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll \nmd-component-id=\"main-sidenav\" ms-sidenav-helper ng-include=\"\'app/main/apps/notes/sidenavs/main/main-sidenav.html\'\">\n</md-sidenav><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"NOTES.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n<div class=\"main-title\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"logo-icon mr-8\" \nmd-font-icon=\"icon-lightbulb\"></md-icon><span class=\"title\" ng-if=\"vm.noteListType === \'notes\'\" \ntranslate=\"NOTES.NOTES\">Notes</span> <span class=\"title\" ng-if=\"vm.noteListType === \'reminders\'\" \ntranslate=\"NOTES.REMINDERS\">Reminders</span> <span class=\"title\" ng-if=\"vm.noteListType === \'archive\'\" \ntranslate=\"NOTES.ARCHIVE\">Archive</span> <span class=\"title\" ng-if=\"vm.noteListType.name\">{{vm.noteListType.name}}\n</span> <span ng-if=\"filteredNotes.length\" class=\"pl-8 white-text secondary-text notes-count\">\n({{filteredNotes.length}})</span></div></div><div flex></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.openSearchToolbar()\" aria-label=\"open search toolbar\" translate \ntranslate-attr-aria-label=\"NOTES.OPEN_SEARCH_TOOLBAR\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon>\n</md-button></div><div ng-show=\"vm.searchToolbar\" \nclass=\"md-toolbar-tools search-toolbar animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeSearchToolbar()\" translate translate-attr-aria-label=\"NOTES.CLOSE\" \naria-label=\"close\"><md-icon md-font-icon=\"icon-close\" class=\"mr-8\"></md-icon></md-button><input \nid=\"search-notes-input\" placeholder=\"Search notes\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"NOTES.SEARCH_NOTES\" ng-model-options=\"{\'debounce\': 200}\" flex></div></md-toolbar>\n<md-content ms-scroll flex><ms-new-note ng-hide=\"vm.noteListType === \'archive\'\" class=\"md-whiteframe-2dp\">\n</ms-new-note><ms-masonry class=\"notes\" options=\'{\"columnCount\":2}\'><ms-masonry-item class=\"note\" \nng-repeat=\"note in vm.notes | filter:vm.search | filter:vm.filters | filterByPropIds:\'labels\':vm.labelFilterIds |  orderBy: \'time\':true | filter:query as filteredNotes track by note.id \" \nms-note-item=\"note\" ng-click=\"vm.editNote($event, note.id)\"></ms-masonry-item></ms-masonry><div \nclass=\"no-results text-center\" ng-if=\"filteredNotes.length === 0 &&  vm.search === \'\'\"><div class=\"message\" \nng-if=\"vm.noteListType === \'notes\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-lightbulb\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_YET\">No notes yet...</div></div><div class=\"message\" \nng-if=\"vm.noteListType === \'reminders\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-bell\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_WITH_REMINDERS\">No notes with reminders</div></div><div class=\"message\" \nng-if=\"vm.noteListType === \'archive\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-archive\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_ARCHIVED_NOTES\">No archived Notes</div></div><div class=\"message\" \nng-if=\"vm.noteListType.name\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-label\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_WITH_THIS_LABEL\">No notes with this label</div></div></div><div \nclass=\"no-results text-center\" ng-if=\"filteredNotes.length === 0 &&  vm.search !== \'\'\"><div class=\"message\"><md-icon \nclass=\"message-icon s96\" md-font-icon=\"icon-lightbulb\"></md-icon><div class=\"message-text\" \ntranslate=\"NOTES.NO_RESULTS\">No results...</div></div></div></md-content></div>");
$templateCache.put("app/main/scc/components/offers-table/offers-table.html","<div layout=\"column\" flex><div class=\"md-title\">Select package</div><div class=\"price-tables\" layout-gt-sm=\"row\" \nlayout=\"column\" layout-align=\"start start\" layout-wrap><div ng-repeat=\"offer in $ctrl.offersList\" flex \nclass=\"price-table style-3 md-whiteframe-1dp\" ng-class=\"{\'md-whiteframe-24dp\':$ctrl.selectedProduct == offer.product}\" \nlayout=\"column\"><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"s60\" \nng-if=\"$ctrl.selectedProduct == offer.product\"></md-icon><div class=\"package-type\"><div class=\"title\" \ntranslate=\"SCC.OFFERS_TABLE.PRODUCTS.{{offer.product}}.TITLE\">Title</div><div class=\"subtitle\" \ntranslate=\"SCC.OFFERS_TABLE.PRODUCTS.{{offer.product}}.DESCRIPTION\">Description</div></div><div \nclass=\"price md-primary-bg\" layout=\"row\" layout-align=\"center start\" ng-if=\"offer.bestCostPerMonth\"><div \nclass=\"currency\">€</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value\">{{offer.bestCostPerMonth}}</div>\n<div class=\"period\">monthly</div></div></div><div class=\"price md-primary-bg\" layout=\"row\" layout-align=\"center start\" \nng-if=\"offer.cost\"><div class=\"currency\">€</div><div layout=\"row\" layout-align=\"center end\"><div class=\"value\">\n{{offer.cost}}</div></div></div><div class=\"offer-options layout-column\" layout=\"colmn\" ng-if=\"offer.options.length\">\n<md-radio-group ng-model=\"$ctrl.selectedOption\"><div ng-repeat=\"option in offer.options | orderBy : \'cost\'\" \nclass=\"offer-option\"><md-radio-button value=\"{{option}}\" class=\"no-margin\" ng-click=\"$ctrl.select(option)\">\n{{\"SCC.OFFERS_TABLE.DURATIONS.\" + option.duration | translate}} : €{{option.cost}}</md-radio-button></div>\n</md-radio-group></div><md-divider/><div class=\"terms\"><div class=\"term\" \ntranslate=\"SCC.OFFERS_TABLE.PRODUCTS.{{offer.product}}.NOTES\">Some note here</div></div><md-button \nclass=\"cta-button md-raised md-accent\" ng-click=\"$ctrl.select({product: offer.product, cost: offer.cost})\" \nng-if=\"!offer.options\">SELECT</md-button></div></div></div>");
$templateCache.put("app/main/scc/components/register/register-success.html","<div id=\"register-success\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-success-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"register-success-form\" class=\"md-whiteframe-8dp\"><img \nsrc=\"/assets/images/logos/soc.png\" alt=\"SoC\" style=\"width: 140px; margin: auto; display:block\"><div class=\"title\" \ntranslate=\"SCC.REGISTER.SUCCESS.TITLE\">Successful registration!</div><div class=\"subtitle\" \ntranslate=\"SCC.REGISTER.SUCCESS.SUBTITLE\">Check your email...</div></div></div></div>");
$templateCache.put("app/main/scc/components/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><img src=\"/assets/images/logos/soc.png\" \nalt=\"SoC\" style=\"width: 140px; margin: auto; display:block\"><div class=\"title\" translate=\"SCC.REGISTER.TITLE\">\nCreate an account</div><md-progress-linear md-mode=\"indeterminate\" ng-disabled=\"!$root.loadingProgress\">\n</md-progress-linear><form name=\"form\" novalidate><form-errors-container form=\"form\" \ntranslation-scope=\"SCC.REGISTER.ERROR\"/><md-input-container class=\"md-block\" md-no-float><input type=\"text\" \nname=\"user.email\" ng-model=\"vm.req.user.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"SCC.REGISTER.EMAIL\" maxlength=\"128\"><errors-container errors=\"form[\'user.email\'].$error\" \ntranslation-scope=\"SCC.REGISTER.ERROR.EMAIL\"/></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"user.password\" ng-model=\"vm.req.user.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"SCC.REGISTER.PASSWORD\" maxlength=\"40\"><errors-container \nerrors=\"form[\'user.password\'].$error\" translation-scope=\"SCC.REGISTER.ERROR.PASSWORD\"/></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"user.passwordConfirmation\" \nng-model=\"vm.req.user.passwordConfirmation\" placeholder=\"Password (Confirm)\" maxlength=\"40\" translate \ntranslate-attr-placeholder=\"SCC.REGISTER.PASSWORD_CONFIRM\"><errors-container \nerrors=\"form[\'user.passwordConfirmation\'].$error\" translation-scope=\"SCC.REGISTER.ERROR.PASSWORD_CONFIRMATION\"/>\n</md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" \nng-model=\"vm.acceptTerms\" aria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\"><span translate=\"SCC.REGISTER.READ_ACCEPT\">I read and accept</span> <a href=\"#\" \nclass=\"md-accent-color\" translate=\"SCC.REGISTER.TERMS_COND\">terms and conditions</a></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine || !vm.acceptTerms\" \ntranslate=\"SCC.REGISTER.CREATE_ACCOUNT\" translate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\" ng-click=\"vm.register()\">\nCREATE MY ACCOUNT</md-button></form><div class=\"login\" layout=\"row\" layout-xs=\"column\" layout-align=\"center center\">\n<span class=\"text\" translate=\"SCC.REGISTER.ALREADY_HAVE\">Already have an account?</span> <a class=\"link\" \nui-sref=\"app.scc.public.login\" translate=\"SCC.REGISTER.LOGIN\">Log in</a></div></div></div></div>");
$templateCache.put("app/main/scc/components/reset-password/reset-password-success.html","<div id=\"reset-password-success\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div \nid=\"reset-password-success-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div \nid=\"reset-password-success-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F</span></div><div \nclass=\"title\" translate=\"SCC.RESET_PASSWORD.SUCCESS.TITLE\">Successful registration!</div><div class=\"subtitle\"><a \nui-sref=\"app.scc.public.login\" translate=\"SCC.RESET_PASSWORD.SUCCESS.GO_TO_LOGIN\">Login here</a></div></div></div>\n</div>");
$templateCache.put("app/main/scc/components/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"SCC.RESET_PASSWORD.TITLE\">\nReset your password</div><md-progress-linear md-mode=\"indeterminate\" ng-disabled=\"!$root.loadingProgress\">\n</md-progress-linear><form name=\"form\" ng-submit=\"vm.resetPassword()\" novalidate><form-errors-container form=\"form\" \ntranslation-scope=\"SCC.RESET_PASSWORD.ERROR\"/><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.req.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"SCC.RESET_PASSWORD.PASSWORD\"><errors-container errors=\"form[\'password\'].$error\" \ntranslation-scope=\"SCC.RESET_PASSWORD.ERROR.PASSWORD\"/></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"passwordConfirmation\" ng-model=\"vm.req.passwordConfirmation\" \nplaceholder=\"Password (Confirm)\" translate translate-attr-placeholder=\"SCC.RESET_PASSWORD.PASSWORD_CONFIRMATION\">\n<errors-container errors=\"form[\'passwordConfirmation\'].$error\" \ntranslation-scope=\"SCC.RESET_PASSWORD.ERROR.PASSWORD_CONFIRMATION\"/></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"UPDATE MY PASSWORD\" \nng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" translate=\"SCC.RESET_PASSWORD.UPDATE_PASSWORD\" \ntranslate-attr-aria-label=\"SCC.RESET_PASSWORD.UPDATE_PASSWORD\">RESET MY PASSWORD</md-button></form></div></div></div>");
$templateCache.put("app/main/scc/components/scheduler/aiScheduleDialog.html","<md-dialog aria-label=\"AI Schedule\"><form name=\"form\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nΣυμπλήρωση ωρολόγιου προγράμματος με ΑΙ</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"$ctrl.closeDialog()\"><md-icon md-font-icon=\"icon-close\"/></md-button></div></md-toolbar><md-dialog-content \nstyle=\"min-width: 540px; max-width: 720px\"><p>\nΜε αυτή την ενέργεια θα συμπληρωθεί αυτόματα το ωρολόγιο πρόγραμμα της διδακτικής περιόδου {{$ctrl.getDataSetName()}}. Οι διδακτικές ώρες που έχετε ήδη προγραμματίσει δεν θα τροποποιηθούν.\n</p><p ng-if=\"$ctrl.hasEntity()\">Επιλέξτε το εύρος προγραμματισμού:</p><md-radio-group \nng-model=\"$ctrl.schedulingScope\" ng-if=\"$ctrl.hasEntity()\"><md-radio-button value=\"ALL\" class=\"md-primary\">\nΌλες οι διδακτικές ανάγκες</md-radio-button><md-radio-button value=\"CURRENT_ENTITY\" class=\"md-primary\">\nΜόνο οι διδακτικές ανάγκες {{$ctrl.getEntityTypeLabel()}} {{$ctrl.getEntityName()}}</md-radio-button></md-radio-group>\n<p style=\"margin-top: 20px\">Επιλέξτε τήν επιθυμητή διάρκεια του κάθε μαθήματος:</p><duration-picker \nng-model=\"$ctrl.lessonDeliveryDuration\" name=\"lessonDeliveryDuration\" errors=\"form[\'lessonDeliveryDuration\'].$error\">\n</duration-picker><p style=\"margin-top: 20px\"><strong>Βήμα 1.</strong> Περιγράψτε τις προτιμήσεις σας (προαιρετικά):\n</p><md-input-container class=\"md-block\"><label>\nπ.χ. Τα μαθήματα Μαθηματικών να γίνονται νωρίς στην εβδομάδα. Όχι πάνω από 3 ώρες την ημέρα ανά καθηγητή. Τα μαθήματα Γλώσσας να είναι 2 ώρες (24 slots).\n</label><textarea ng-model=\"$ctrl.userPreferences\" rows=\"5\" md-maxlength=\"2000\" maxlength=\"2000\"></textarea>\n</md-input-container><md-button class=\"md-primary md-raised\" ng-click=\"$ctrl.parseRules()\" \nng-disabled=\"$ctrl.busy || !$ctrl.userPreferences\"><md-icon md-font-icon=\"icon-lightbulb\"></md-icon>\nΑνάλυση προτιμήσεων με ΑΙ</md-button><p ng-if=\"$ctrl.parsing\"><em>Παρακαλώ περιμένετε, η ΑΙ αναλύει τις προτιμήσεις…\n</em></p><div ng-if=\"$ctrl.rulesParsed\" style=\"margin-top: 20px\"><p><strong>Βήμα 2.</strong>\n Ελέγξτε τους κανόνες που εντοπίστηκαν:</p><p ng-if=\"$ctrl.rules.length === 0\"><em>\nΔεν εντοπίστηκαν κανόνες — θα γίνει απλός προγραμματισμός.</em></p><md-list><md-list-item \nng-repeat=\"rule in $ctrl.rules track by $index\" class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{$ctrl.ruleLabel(rule)}}</h3><p ng-if=\"rule.description\">{{rule.description}}</p></div><md-button \nclass=\"md-icon-button md-warn\" ng-click=\"$ctrl.removeRule($index)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></md-list-item></md-list></div><p ng-if=\"$ctrl.scheduling\"><em>Παρακαλώ περιμένετε, ο αλγόριθμος εργάζεται…\n</em></p></md-dialog-content><md-dialog-actions><md-button ng-click=\"$ctrl.createSchedule()\" ng-disabled=\"$ctrl.busy\" \nclass=\"md-primary md-raised\">Προγραμματισμός</md-button><md-button ng-click=\"$ctrl.closeDialog()\" \nng-disabled=\"$ctrl.busy\" class=\"md-primary\">Κλείσιμο</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/scc/components/scheduler/conflictDialog.html","<md-dialog><md-dialog-content><div ng-if=\"$ctrl.teacherConflicts.length\">Ο καθηγητής <a \nng-click=\"$ctrl.showScheduleForEntity(\'TEACHER\', $ctrl.lessonDelivery.teachingNeed.teacher.id)\">\n{{$ctrl.lessonDelivery.teachingNeed.teacher.name}}</a> κάνει ταυτόχρονα:<ul><li \nng-repeat=\"c in $ctrl.teacherConflicts\">{{c.lessonDeliveryInConflict.teachingNeed.lesson.name}} στο τμήμα <a \nng-click=\"$ctrl.showScheduleForEntity(\'STUDENTS_GROUP\', c.lessonDeliveryInConflict.teachingNeed.studentsGroup.id)\">\n{{c.lessonDeliveryInConflict.teachingNeed.studentsGroup.name}}</a> στην αίθουσα <a \nng-click=\"$ctrl.showScheduleForEntity(\'CLASSROOM\', c.lessonDeliveryInConflict.teachingNeed.classroom.id)\">\n{{c.lessonDeliveryInConflict.teachingNeed.classroom.name}}</a></li></ul></div><div \nng-if=\"$ctrl.studentsGroupConflicts.length\">Το τμήμα <a \nng-click=\"$ctrl.showScheduleForEntity(\'STUDENTS_GROUP\', $ctrl.lessonDelivery.teachingNeed.studentsGroup.id)\">\n{{$ctrl.lessonDelivery.teachingNeed.studentsGroup.name}}</a> κάνει ταυτόχρονα:<ul><li \nng-repeat=\"c in $ctrl.studentsGroupConflicts\">{{c.lessonDeliveryInConflict.teachingNeed.lesson.name}} με τον καθηγητή \n<a ng-click=\"$ctrl.showScheduleForEntity(\'TEACHER\', c.lessonDeliveryInConflict.teachingNeed.teacher.id)\">\n{{c.lessonDeliveryInConflict.teachingNeed.teacher.name}}</a> στην αίθουσα <a \nng-click=\"$ctrl.showScheduleForEntity(\'CLASSROOM\', c.lessonDeliveryInConflict.teachingNeed.classroom.id)\">\n{{c.lessonDeliveryInConflict.teachingNeed.classroom.name}}</a></li></ul></div><div \nng-if=\"$ctrl.classroomConflicts.length\">Στην αίθουσα <a \nng-click=\"$ctrl.showScheduleForEntity(\'CLASSROOM\', $ctrl.lessonDelivery.teachingNeed.classroom.id)\">\n{{$ctrl.lessonDelivery.teachingNeed.classroom.name}}</a> γίνονται ταυτόχρονα:<ul><li \nng-repeat=\"c in $ctrl.classroomConflicts\">{{c.lessonDeliveryInConflict.teachingNeed.lesson.name}} στο τμήμα <a \nng-click=\"$ctrl.showScheduleForEntity(\'STUDENTS_GROUP\', c.lessonDeliveryInConflict.teachingNeed.studentsGroup.id)\">\n{{c.lessonDeliveryInConflict.teachingNeed.studentsGroup.name}}</a> από τον καθηγητή <a \nng-click=\"$ctrl.showScheduleForEntity(\'TEACHER\', c.lessonDeliveryInConflict.teachingNeed.teacher.id)\">\n{{c.lessonDeliveryInConflict.teachingNeed.teacher.name}}</a></li></ul></div></md-dialog-content><md-dialog-actions>\n<md-button ng-click=\"$ctrl.closeDialog()\" class=\"md-primary\">Κλείσιμο</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/scc/components/scheduler/downloadScheduleDialog.html","<md-dialog><form name=\"form\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>Λήψη εκτυπώσιμου προγράμματος</h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.closeDialog()\"><md-icon md-font-icon=\"icon-close\"/>\n</md-button></div></md-toolbar><md-dialog-content><div style=\"width: 600px\">\nΛάβετε ένα εκτυπώσιμο αρχείο με τα ωρολόγια προγράμματα καθηγητών, μαθητών και αιθουσών. Επιλέξτε παρακάτω τι να περιλαμβάνεται στο αρχείο.\n</div><br/><div class=\"theme-option\"><div class=\"option-title\">Διδακτικά τμήματα</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"$ctrl.studentsSelection\"><md-radio-button ng-value=\"\'NONE\'\">Κανένα\n</md-radio-button><md-radio-button ng-value=\"\'ALL\'\">Όλα</md-radio-button><md-radio-button ng-value=\"\'SELECTED\'\" \nng-if=\"$ctrl.entity\"><span ng-if=\"$ctrl.aspect==\'STUDENTS_GROUP\'\">Διδακτικό τμήμα {{$ctrl.entity.name}}</span> <span \nng-if=\"$ctrl.aspect==\'TEACHER\'\">Όλα τα τμήματα του καθηγητή {{$ctrl.entity.name}}</span> <span \nng-if=\"$ctrl.aspect==\'CLASSROOM\'\">Όλα τα τμήματα της αίθουσας {{$ctrl.entity.name}}</span></md-radio-button>\n</md-radio-group></div><br/><div class=\"theme-option\"><div class=\"option-title\">Καθηγητές</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"$ctrl.teachersSelection\"><md-radio-button ng-value=\"\'NONE\'\">Κανένας\n</md-radio-button><md-radio-button ng-value=\"\'ALL\'\">Όλοι</md-radio-button><md-radio-button ng-value=\"\'SELECTED\'\" \nng-if=\"$ctrl.entity\"><span ng-if=\"$ctrl.aspect==\'STUDENTS_GROUP\'\">Όλοι οι καθηγητές του τμήματος {{$ctrl.entity.name}}\n</span> <span ng-if=\"$ctrl.aspect==\'TEACHER\'\">Ο καθηγητής {{$ctrl.entity.name}}</span> <span \nng-if=\"$ctrl.aspect==\'CLASSROOM\'\">Όλοι οι καθηγητές μαθητές της αίθουσας {{$ctrl.entity.name}}</span></md-radio-button>\n</md-radio-group></div><br/><div class=\"theme-option\"><div class=\"option-title\">Αίθουσες</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"$ctrl.classroomsSelection\"><md-radio-button ng-value=\"\'NONE\'\">Καμία\n</md-radio-button><md-radio-button ng-value=\"\'ALL\'\">Όλες</md-radio-button><md-radio-button ng-value=\"\'SELECTED\'\" \nng-if=\"$ctrl.entity\"><span ng-if=\"$ctrl.aspect==\'STUDENTS_GROUP\'\">Όλες οι αίθουσες του τμήματος {{$ctrl.entity.name}}\n</span> <span ng-if=\"$ctrl.aspect==\'TEACHER\'\">Όλες οι αίθουσες του καθηγητή {{$ctrl.entity.name}}</span> <span \nng-if=\"$ctrl.aspect==\'CLASSROOM\'\">Αίθουσα {{$ctrl.entity.name}}</span></md-radio-button></md-radio-group></div><br/>\n<div class=\"theme-option\"><div class=\"option-title\">Τύπος αρχείου</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"$ctrl.format\"><md-radio-button ng-value=\"\'PDF\'\">PDF</md-radio-button>\n<md-radio-button ng-value=\"\'DOCX\'\">Word</md-radio-button><md-radio-button ng-value=\"\'HTML\'\">HTML</md-radio-button>\n</md-radio-group></div></md-dialog-content><md-dialog-actions><md-button \nng-click=\"$ctrl.downloadPersonalizedSchedule()\" class=\"md-primary\">Λήψη</md-button><md-button \nng-click=\"$ctrl.closeDialog()\" class=\"md-primary\">Κλείσιμο</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/scc/components/scheduler/scheduler.html","<carded-simple ng-if=\"!$ctrl.isDatasetSelected()\" translation-scope=\"SCC.SCHEDULER\" svg-icon=\"scheduler\" \ntitle=\"{{\'SCC.SCHEDULER.TITLE\' | translate}}\"><md-content class=\"md-padding\">\n{{\'SCC.SCHEDULER.NO_SELECTED_DATASET\' | translate}} <a class=\"link\" ui-sref=\"app.scc.private.data-set\" \ntranslate=\"SCC.SCHEDULER.SELECT_DATASET\">Choose dataset</a></md-content></carded-simple><form name=\"form\"><div \nid=\"scheduler\" ng-if=\"$ctrl.isDatasetSelected()\" class=\"page-layout carded fullwidth single-scroll\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" flex><div class=\"header\"><div \nclass=\"white-fg toolbar layout-align-space-between-center layout-row\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"logo layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-svg-src=\"assets/icons/svg/scheduler.svg\"></md-icon><span class=\"h2\" translate=\"SCC.SCHEDULER.TITLE\">\nΩρολόγιο πρόγραμμα</span><md-select ng-model=\"$ctrl.selectedAspect\" ng-change=\"$ctrl.selectedEntityId=null\" \nplaceholder=\"επιλέξτε\"><md-option ng-value=\"\'TEACHER\'\">καθηγητή</md-option><md-option ng-value=\"\'STUDENTS_GROUP\'\">\nδιδακτικού τμήματος</md-option><md-option ng-value=\"\'CLASSROOM\'\">αίθουσας</md-option></md-select><md-select \nng-show=\"$ctrl.selectedAspect\" placeholder=\"επιλέξτε\" ng-model=\"$ctrl.selectedEntityId\" \nng-change=\"$ctrl.showScheduleForEntity($ctrl.selectedAspect, $ctrl.selectedEntityId)\"><md-select-header \nstyle=\"padding-right: 11px\"><a ng-if=\"$ctrl.selectedAspect == \'TEACHER\'\" ui-sref=\"app.scc.private.teacher\">\nκαταχώρηση νέου</a> <a ng-if=\"$ctrl.selectedAspect == \'STUDENTS_GROUP\'\" ui-sref=\"app.scc.private.students-group\">\nκαταχώρηση νέου</a> <a ng-if=\"$ctrl.selectedAspect == \'CLASSROOM\'\" ui-sref=\"app.scc.private.classroom\">καταχώρηση νέας\n</a></md-select-header><md-option ng-repeat=\"entity in $ctrl.getSelectedAspectEntities() | orderBy:\'name\'\" \nng-value=\"entity.id\">{{entity.name}}</md-option></md-select></div><div layout=\"row\" layout-align=\"end center\" \nclass=\"layout-align-end-center layout-row\"><md-button ng-disabled=\"$ctrl.selectedEntityId == null\" \nclass=\"md-icon-button\" data-ng-click=\"$ctrl.clearSchedule()\"><md-tooltip md-direction=\"bottom\">Καθαρισμός προγράμματος\n</md-tooltip><md-icon md-font-icon=\"icon-delete\" class=\"md-24\"/></md-button><md-button class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.showAiSchedulingPanel($event)\"><md-tooltip md-direction=\"bottom\">Συμπλήρωση προγράμματος με ΑΙ\n</md-tooltip><md-icon md-font-icon=\"icon-lightbulb\" class=\"md-24\"/></md-button><md-button class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.showDownloadSchedulePanel($event)\"><md-tooltip md-direction=\"bottom\">Λήψη ωρολόγιου προγράμματος\n</md-tooltip><md-icon md-font-icon=\"icon-download\" class=\"md-24\"/></md-button><md-button class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.showSendSchedulePanel($event)\"><md-tooltip md-direction=\"bottom\">\nΑποστολή ωρολόγιου προγράμματος με email</md-tooltip><md-icon md-font-icon=\"icon-send\" class=\"md-24\"/></md-button>\n</div></div></div><div ng-if=\"$ctrl.selectedEntityId==null\" class=\"content-card\"><md-content class=\"md-padding\">\n{{\'SCC.SCHEDULER.NO_SELECTED_ΕΝΤΙΤΥ\' | translate}}</md-content></div><div \nng-if=\"$ctrl.selectedEntityId!=null && $ctrl.teachingNeeds.length == 0\" class=\"content-card\"><md-content \nng-if=\"$ctrl.selectedAspect == \'STUDENTS_GROUP\'\" class=\"md-padding\">\nΔεν έχετε ορίσει διδακτικές ανάγκες για αυτό το τμήμα. Ορίστε τώρα <a \nui-sref=\"app.scc.private.students-group.details({studentsGroupId: {{$ctrl.selectedEntityId}}, tab:\'teachingNeeds\'})\">\nεδώ</a>.</md-content><md-content ng-if=\"$ctrl.selectedAspect == \'TEACHER\'\" class=\"md-padding\">\nΔεν υπάρχουν διδακτικές υποχρεώσεις για αυτόν τον καθηγητή ακόμα. Αν θέλετε ο καθηγητής να διδάξει σε κάποιο τμήμα, όριστε τις αντίστοιχες διδακτικές ανάγκες στο τμήμα \n<a ui-sref=\"app.scc.private.students-group\">εδώ</a>.</md-content></div><div \nng-if=\"$ctrl.selectedEntityId!=null && $ctrl.teachingNeeds.length > 0\" scc-schedule \nscc-teaching-needs=\"$ctrl.teachingNeeds\" scc-lesson-deliveries=\"$ctrl.lessonDeliveries\" \nscc-schedule-change=\"$ctrl.updateSchedule()\"><div class=\"content-card\"><div class=\"toolbar\"><span \nng-if=\"$ctrl.aspect==\'STUDENTS_GROUP\'\" class=\"md-title\">Διδακτικές ανάγκες</span> <span \nng-if=\"$ctrl.aspect==\'TEACHER\'\" class=\"md-title\">Διδακτικές υποχρεώσεις</span> <span ng-if=\"$ctrl.aspect==\'CLASSROOM\'\" \nclass=\"md-title\">Διδακτικές ανάγκες</span> (σύρτε στον εβδομαδιαίο πίνακα προγραμματισμού)</div><div \nscc-lesson-delivery-disposer layout=\"row\"><div ng-class=\"{fulfilled: tn.remainingTimeSlots <= 0}\" scc-teaching-need \nscc-model=\"tn\" ng-repeat=\"tn in $ctrl.teachingNeeds\" flex><div class=\"scc-teaching-need-content\" hide show-gt-xs><span \nng-if=\"$ctrl.aspect!=\'LESSON\'\"><md-icon md-svg-src=\"assets/icons/svg/lesson.svg\" class=\"md_dark md-18\"/>\n{{tn.lesson.name}}<br/></span><span ng-if=\"$ctrl.aspect!=\'STUDENTS_GROUP\'\"><md-icon \nmd-svg-src=\"assets/icons/svg/students-group.svg\" class=\"md-18\">school</md-icon>{{tn.studentsGroup.name}}<br/></span>\n<span ng-if=\"$ctrl.aspect!=\'TEACHER\'\"><md-icon md-svg-src=\"assets/icons/svg/teacher.svg\" class=\"md-18\">person</md-icon>\n{{tn.teacher.name}}<br/></span><span ng-if=\"$ctrl.aspect!=\'CLASSROOM\'\"><md-icon \nmd-svg-src=\"assets/icons/svg/classroom.svg\" class=\"md-18\">store_mall_directory</md-icon>{{tn.classroom.name}}<br/>\n</span><md-icon md-svg-src=\"assets/icons/svg/clock.svg\" class=\"md-18\"></md-icon>{{tn.remainingTimeSlots | sccTimeSlot}}\n<br/></div><div class=\"scc-teaching-need-content\" hide-gt-xs><span ng-if=\"$ctrl.aspect!=\'LESSON\'\"><md-icon \nmd-svg-src=\"assets/icons/svg/lesson.svg\" class=\"md-18\">library_books</md-icon>{{tn.lesson.shortName}}<br/></span><span \nng-if=\"$ctrl.aspect!=\'STUDENTS_GROUP\'\"><md-icon md-svg-src=\"assets/icons/svg/students-group.svg\" class=\"md-18\">school\n</md-icon>{{tn.studentsGroup.shortName}}<br/></span><span ng-if=\"$ctrl.aspect!=\'TEACHER\'\"><md-icon \nmd-svg-src=\"assets/icons/svg/teacher.svg\" class=\"md-18\">person</md-icon>{{tn.teacher.shortName}}<br/></span><span \nng-if=\"$ctrl.aspect!=\'CLASSROOM\'\"><md-icon md-svg-src=\"assets/icons/svg/classroom.svg\" class=\"md-18\">\nstore_mall_directory</md-icon>{{tn.classroom.shortName}}<br/></span>{{tn.timeSlotsPerWeek | sccTimeSlot}}<br/></div>\n</div></div></div><br><div class=\"content-card\"><div class=\"toolbar\"><span class=\"md-title\">Εβδομαδιαίος πίνακας</span>\n</div><div><div class=\"scc-schedule-header\" layout=\"row\"><div class=\"scc-schedule-row-header\">-</div><div \nng-repeat=\"ss in $ctrl.scheduleSlots[0]\" class=\"scc-schedule-column-header\" flex>{{ss.day|sccDay}}</div></div><div \nng-repeat=\"r in $ctrl.scheduleSlots\" class=\"scc-schedule-row\" layout=\"row\"><div class=\"scc-schedule-row-header\"><span \nng-if=\"r[0].timeSlot % 3 == 0 && $index > 0\">{{r[0].timeSlot|sccTimeSlot}}</span></div><div ng-repeat=\"ts in r\" \nscc-schedule-slot scc-day=\"ts.day\" scc-time-slot=\"ts.timeSlot\" scc-disabled=\"ts.disabled\" flex \nng-class=\"{\'hour-change\':ts.timeSlot % 12 == 11}\"><div class=\"scc-availability-overlay\" \nng-style=\"$ctrl.getSlotStyle(ts)\" ng-class=\"{clickable: $ctrl.getSlotUnavailableCount(ts) > 0}\" \nng-click=\"$ctrl.showSlotUnavailability($event, ts)\"></div></div></div><div class=\"scc-hidden\"><div scc-lesson-delivery \nscc-model=\"ld\" ng-repeat=\"ld in $ctrl.lessonDeliveries\" \nng-class=\"{\'in-conflict\':ld.conflicts.length, \'teacher-unavailable\':!ld.conflicts.length && ld.teacherUnavailability, \'students-unavailable\':!ld.conflicts.length && !ld.teacherUnavailability && ld.studentsUnavailability}\" \nng-click=\"$ctrl.showLessonDeliveryIssues($event, ld)\"><md-tooltip ng-if=\"ld.hasIssues\" md-direction=\"bottom\">\nΚλικ γισ να δείτε τα προλβήματα</md-tooltip><md-icon md-font-icon=\"icon-alert-circle\" \nclass=\"md-icon-button md-18 conflicts-indicator\" ng-if=\"ld.hasIssues\"></md-icon><div \nclass=\"scc-lesson-delivery-move-handle\"><strong>{{ld.timeSlot|sccTimeSlot}}-{{ld.timeSlot+ld.duration|sccTimeSlot}}\n</strong></div><hr/><div class=\"scc-lesson-delivery-content\" hide show-gt-xs><span ng-if=\"$ctrl.aspect!=\'LESSON\'\">\n<md-icon md-svg-src=\"assets/icons/svg/lesson.svg\" class=\"md_dark md-18\"/>{{ld.teachingNeed.lesson.name}}<br/></span><a \nng-if=\"$ctrl.aspect!=\'STUDENTS_GROUP\'\" \nng-click=\"$ctrl.showScheduleForEntity(\'STUDENTS_GROUP\', ld.teachingNeed.studentsGroup.id)\"><md-icon \nmd-svg-src=\"assets/icons/svg/students-group.svg\" class=\"md-18\"></md-icon>{{ld.teachingNeed.studentsGroup.name}}<br/>\n</a><a ng-if=\"$ctrl.aspect!=\'TEACHER\'\" ng-click=\"$ctrl.showScheduleForEntity(\'TEACHER\', ld.teachingNeed.teacher.id)\">\n<md-icon md-svg-src=\"assets/icons/svg/teacher.svg\" class=\"md-18\"></md-icon>{{ld.teachingNeed.teacher.name}}<br/></a><a \nng-if=\"$ctrl.aspect!=\'CLASSROOM\'\" ng-click=\"$ctrl.showScheduleForEntity(\'CLASSROOM\', ld.teachingNeed.classroom.id)\">\n<md-icon md-svg-src=\"assets/icons/svg/classroom.svg\" class=\"md-18\"></md-icon>{{ld.teachingNeed.classroom.name}}<br/>\n</a></div><div class=\"scc-lesson-delivery-content\" hide-gt-xs><span ng-if=\"$ctrl.aspect!=\'LESSON\'\"><md-icon \nmd-svg-src=\"assets/icons/svg/lesson.svg\" class=\"md-18\">library_books</md-icon>{{ld.teachingNeed.lesson.shortName}}<br/>\n</span><span ng-if=\"$ctrl.aspect!=\'STUDENTS_GROUP\'\"><md-icon md-svg-src=\"assets/icons/svg/students-group.svg\" \nclass=\"md-18\">school</md-icon>{{ld.teachingNeed.studentsGroup.shortName}}<br/></span><span \nng-if=\"$ctrl.aspect!=\'TEACHER\'\"><md-icon md-svg-src=\"assets/icons/svg/teacher.svg\" class=\"md-18\">person</md-icon>\n{{ld.teachingNeed.teacher.shortName}}<br/></span><span ng-if=\"$ctrl.aspect!=\'CLASSROOM\'\"><md-icon \nmd-svg-src=\"assets/icons/svg/classroom.svg\" class=\"md-18\">store_mall_directory</md-icon>\n{{ld.teachingNeed.classroom.shortName}}<br/></span></div><div class=\"scc-lesson-delivery-resize-handle\"></div></div>\n</div></div></div></div></div></div></form>");
$templateCache.put("app/main/scc/components/scheduler/sendScheduleDialog.html","<md-dialog><form name=\"form\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nΑπόστολή προσωπικού ωρολόγιου προγράμματος με email</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"$ctrl.closeDialog()\"><md-icon md-font-icon=\"icon-close\"/></md-button></div></md-toolbar><md-dialog-content>\n<div style=\"width: 600px\">\nΑποστείλετε προσωπικά email με επισυναπτόμενα τα ωρολόγια προγράμματα καθηγητών και μαθητών. Επιλέξτε παρακάτω σε ποιόυς να αποσταλεί το email.\n</div><br/><div class=\"theme-option\"><div class=\"option-title\">Μαθητές</div><md-radio-group layout=\"row\" \nlayout-align=\"start center\" ng-model=\"$ctrl.studentsSelection\"><md-radio-button ng-value=\"\'NONE\'\">Κανένας\n</md-radio-button><md-radio-button ng-value=\"\'ALL\'\">Όλοι</md-radio-button><md-radio-button ng-value=\"\'SELECTED\'\" \nng-if=\"$ctrl.entity\"><span ng-if=\"$ctrl.aspect==\'STUDENTS_GROUP\'\">Ολοι οι μαθητές του τμήματος {{$ctrl.entity.name}}\n</span> <span ng-if=\"$ctrl.aspect==\'TEACHER\'\">Όλοι οι μαθητές του καθηγητή {{$ctrl.entity.name}}</span> <span \nng-if=\"$ctrl.aspect==\'CLASSROOM\'\">Όλοι οι μαθητές της αίθουσας {{$ctrl.entity.name}}</span></md-radio-button>\n</md-radio-group></div><br/><div class=\"theme-option\"><div class=\"option-title\">Καθηγητές</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"$ctrl.teachersSelection\"><md-radio-button ng-value=\"\'NONE\'\">Κανένας\n</md-radio-button><md-radio-button ng-value=\"\'ALL\'\">Όλοι</md-radio-button><md-radio-button ng-value=\"\'SELECTED\'\" \nng-if=\"$ctrl.entity\"><span ng-if=\"$ctrl.aspect==\'STUDENTS_GROUP\'\">Όλοι οι καθηγητές του τμήματος {{$ctrl.entity.name}}\n</span> <span ng-if=\"$ctrl.aspect==\'TEACHER\'\">Ο καθηγητής {{$ctrl.entity.name}}</span> <span \nng-if=\"$ctrl.aspect==\'CLASSROOM\'\">Όλοι οι καθηγητές μαθητές της αίθουσας {{$ctrl.entity.name}}</span></md-radio-button>\n</md-radio-group></div><br/><md-input-container class=\"md-block\" flex-gt-sm><label for=\"emailSubject\">Θέμα email\n</label><input type=\"text\" name=\"emailSubject\" data-ng-model=\"$ctrl.emailSubject\"/><errors-container \nerrors=\"form[\'emailSubject\'].$error\"/></md-input-container><md-input-container md-no-float><label for=\"emailText\">\nΠεριεχόμενο email</label><textarea rows=\"4\" style=\"width: 600px\" type=\"text\" placeholder=\"Γράψτε το μήνυμά σας εδώ\" \nng-model=\"$ctrl.emailText\">\n			</textarea></md-input-container></md-dialog-content><md-dialog-actions><md-button \nng-click=\"$ctrl.sendPersonalizedSchedule()\" class=\"md-primary\">Αποστολή</md-button><md-button \nng-click=\"$ctrl.closeDialog()\" class=\"md-primary\">Κλείσιμο</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/scc/components/scheduler/slotUnavailabilityDialog.html","<md-dialog aria-label=\"Slot unavailability\"><md-dialog-content><div class=\"md-dialog-content\"><h2 class=\"md-title\">\nΜη διαθέσιμοι μαθητές</h2><p ng-if=\"!$ctrl.students\">Φόρτωση...</p><p \nng-if=\"$ctrl.students && $ctrl.students.length === 0\">Κανείς.</p><ul \nng-if=\"$ctrl.students && $ctrl.students.length > 0\"><li ng-repeat=\"s in $ctrl.students\">{{s.studentName}}<span \nng-if=\"s.comment\"> — {{s.comment}}</span></li></ul></div></md-dialog-content><md-dialog-actions><md-button \nng-click=\"$ctrl.closeDialog()\" class=\"md-primary\">Κλείσιμο</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/scc/components/scheduler/smartScheduleDialog.html","<md-dialog><form name=\"form\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nΈξυπνη συμπλήρωση ωρολόγιου προγράμματος</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"$ctrl.closeDialog()\"><md-icon md-font-icon=\"icon-close\"/></md-button></div></md-toolbar><md-dialog-content>\n<p>\nΜε αυτή την ενέργεια θα συμπληρωθεί αυτόματα το ωρολόγιο πρόγραμμα της διδακτικής περιόδου {{$ctrl.getDataSetName()}}.\n</p><p>\nΟι διδακτικές ώρες που έχετε ήδη προγραματίσει δεν θα τροποποιηθούν, όμως όλες οι εναπομείνασες διδακτικές ανάγκες θα προγραμματιστούν αυτόματα.\n</p><p ng-if=\"$ctrl.hasEntity()\">Επιλέξτε το εύρος προγραμματισμού:</p><md-radio-group \nng-model=\"$ctrl.schedulingScope\" ng-if=\"$ctrl.hasEntity()\"><md-radio-button value=\"ALL\" class=\"md-primary\">\nΌλες οι διδακτικές ανάγκες</md-radio-button><md-radio-button value=\"CURRENT_ENTITY\" class=\"md-primary\">\nΜόνο οι διδακτικές ανάγκες {{$ctrl.getEntityTypeLabel()}} {{$ctrl.getEntityName()}}</md-radio-button></md-radio-group>\n<p style=\"margin-top: 20px\">Επιλέξτε τήν επιθυμητή διάρκεια του κάθε μαθήματος:</p><duration-picker \nng-model=\"$ctrl.lessonDeliveryDuration\" name=\"lessonDeliveryDuration\" errors=\"form[\'lessonDeliveryDuration\'].$error\">\n</duration-picker></md-dialog-content><md-dialog-actions><md-button ng-click=\"$ctrl.createSmartSchedule()\" \nclass=\"md-primary\">Αυτόματος προγραματισμός</md-button><md-button ng-click=\"$ctrl.closeDialog()\" class=\"md-primary\">\nΚλείσιμο</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/scc/components/scheduler/unavailabilityDialog.html","<md-dialog aria-label=\"Issues\"><md-dialog-content><div class=\"md-dialog-content\"><div \nng-if=\"$ctrl.teacherConflicts.length\">Ο καθηγητής <a \nng-click=\"$ctrl.showScheduleForEntity(\'TEACHER\', $ctrl.lessonDelivery.teachingNeed.teacher.id)\">\n{{$ctrl.lessonDelivery.teachingNeed.teacher.name}}</a> κάνει ταυτόχρονα:<ul><li \nng-repeat=\"c in $ctrl.teacherConflicts\">{{c.lessonDeliveryInConflict.teachingNeed.lesson.name}} στο τμήμα <a \nng-click=\"$ctrl.showScheduleForEntity(\'STUDENTS_GROUP\', c.lessonDeliveryInConflict.teachingNeed.studentsGroup.id)\">\n{{c.lessonDeliveryInConflict.teachingNeed.studentsGroup.name}}</a> στην αίθουσα <a \nng-click=\"$ctrl.showScheduleForEntity(\'CLASSROOM\', c.lessonDeliveryInConflict.teachingNeed.classroom.id)\">\n{{c.lessonDeliveryInConflict.teachingNeed.classroom.name}}</a></li></ul></div><div \nng-if=\"$ctrl.studentsGroupConflicts.length\">Το τμήμα <a \nng-click=\"$ctrl.showScheduleForEntity(\'STUDENTS_GROUP\', $ctrl.lessonDelivery.teachingNeed.studentsGroup.id)\">\n{{$ctrl.lessonDelivery.teachingNeed.studentsGroup.name}}</a> κάνει ταυτόχρονα:<ul><li \nng-repeat=\"c in $ctrl.studentsGroupConflicts\">{{c.lessonDeliveryInConflict.teachingNeed.lesson.name}} με τον καθηγητή \n<a ng-click=\"$ctrl.showScheduleForEntity(\'TEACHER\', c.lessonDeliveryInConflict.teachingNeed.teacher.id)\">\n{{c.lessonDeliveryInConflict.teachingNeed.teacher.name}}</a> στην αίθουσα <a \nng-click=\"$ctrl.showScheduleForEntity(\'CLASSROOM\', c.lessonDeliveryInConflict.teachingNeed.classroom.id)\">\n{{c.lessonDeliveryInConflict.teachingNeed.classroom.name}}</a></li></ul></div><div \nng-if=\"$ctrl.classroomConflicts.length\">Στην αίθουσα <a \nng-click=\"$ctrl.showScheduleForEntity(\'CLASSROOM\', $ctrl.lessonDelivery.teachingNeed.classroom.id)\">\n{{$ctrl.lessonDelivery.teachingNeed.classroom.name}}</a> γίνονται ταυτόχρονα:<ul><li \nng-repeat=\"c in $ctrl.classroomConflicts\">{{c.lessonDeliveryInConflict.teachingNeed.lesson.name}} στο τμήμα <a \nng-click=\"$ctrl.showScheduleForEntity(\'STUDENTS_GROUP\', c.lessonDeliveryInConflict.teachingNeed.studentsGroup.id)\">\n{{c.lessonDeliveryInConflict.teachingNeed.studentsGroup.name}}</a> από τον καθηγητή <a \nng-click=\"$ctrl.showScheduleForEntity(\'TEACHER\', c.lessonDeliveryInConflict.teachingNeed.teacher.id)\">\n{{c.lessonDeliveryInConflict.teachingNeed.teacher.name}}</a></li></ul></div><div ng-if=\"$ctrl.teacherUnavailability\">\n<h4 class=\"md-subhead\">Μη διαθεσιμότητα καθηγητή</h4>Ο καθηγητής <strong>{{$ctrl.teacherUnavailability.teacherName}}\n</strong> έχει δηλώσει μη διαθεσιμότητα σε αυτό το διάστημα.<ul><li \nng-repeat=\"b in $ctrl.teacherUnavailability.blocks\">{{b.timeSlot|sccTimeSlot}}-{{b.timeSlot+b.duration|sccTimeSlot}} \n<span ng-if=\"b.comment\">— {{b.comment}}</span></li></ul></div><div ng-if=\"$ctrl.studentsUnavailability\"><h4 \nclass=\"md-subhead\">Μη διαθεσιμότητα μαθητών</h4>\n{{$ctrl.studentsUnavailability.peakCount}} από {{$ctrl.studentsUnavailability.totalStudents}} μαθητές μη διαθέσιμοι.<ul\n ng-if=\"$ctrl.unavailableStudents\"><li ng-repeat=\"s in $ctrl.unavailableStudents\">{{s.studentName}}<span \nng-if=\"s.comment\"> — {{s.comment}}</span></li></ul></div></div></md-dialog-content><md-dialog-actions><md-button \nng-click=\"$ctrl.closeDialog()\" class=\"md-primary\">Κλείσιμο</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/scc/components/school/create-school-success.html","<simple-page><div layout=\"row\">Congrats!</div></simple-page>");
$templateCache.put("app/main/scc/components/school/create-school.html","<simple-page><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">School Information</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"name\" ng-model=\"vm.req.school.name\" placeholder=\"School name\" \nrequired><div ng-messages=\"wizardStep1.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nSchool name is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Product selection</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate><offers-table selected-product=\"vm.req.product\" \nselected-duration=\"vm.req.productSubscriptionDuration\" offers-list=\"vm.offers\" selected-cost=\"vm.req.communicatedCost\">\n</offers-table><input ng-model=\"vm.req.product\" ng-show=\"false\" required><input \nng-model=\"vm.req.productSubscriptionDuration\" ng-show=\"false\" required></form></md-tab-body></md-tab><md-tab \nng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Billing Information</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" \nms-form-wizard-form novalidate><billing-info billing-info=\"vm.billingInfo\" form=\"wizardStep3\"/></form></md-tab-body>\n</md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid || wizardStep3.$invalid\"><md-tab-label><span\n class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$invalid\">4\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep4.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Confirmation</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep4\" ms-form-wizard-form novalidate>{{vm.req}}<br/></form></md-tab-body></md-tab></md-tabs><div \nclass=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-accent\" \nng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous</md-button><div class=\"steps\"><span \nng-repeat=\"form in msWizard.forms\" ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div>\n<md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.createSchool();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Create\n</md-button></div></ms-form-wizard></div></simple-page>");
$templateCache.put("app/main/scc/components/school/create-subscription-success.html","<simple-page><div layout=\"row\">Congrats!</div></simple-page>");
$templateCache.put("app/main/scc/components/school/create-subscription.html","<form name=\"form\"></form><simple-page><form-errors-container form=\"form\" translation-scope=\"SCC.LOGIN.ERROR\">\n</form-errors-container><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\" md-swipe-content><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Product selection</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" ms-form-wizard-form novalidate><offers-table selected-product=\"vm.req.product\" \nselected-duration=\"vm.req.duration\" selected-cost=\"vm.req.communicatedCost\" offers-list=\"vm.offers\"></offers-table>\n<input ng-show=\"false\" ng-model=\"vm.req.product\" required/> <input ng-show=\"false\" ng-model=\"vm.req.duration\" \nrequired/></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Billing Information</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep2\" ms-form-wizard-form novalidate><billing-info billing-info=\"vm.req.billingInfo\" form=\"wizardStep2\"/>\n</form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">3</span> <span \nclass=\"ms-form-wizard-step-text\">Confirmation</span></span></md-tab-label><md-tab-body>\n{{form.$sccFormError[\'server.NoOverlappingPendingPurchases\']}}<form name=\"wizardStep3\" ms-form-wizard-form novalidate>\n{{vm.req}}<br/><md-checkbox ng-if=\"form.$sccFormError[\'server.NoOverlappingPendingPurchases\']\" aria-label=\"FIXME!\" \nng-model=\"vm.req.cancelOverlappingPendingPurchases\">Cancel pending payments</md-checkbox></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.submit();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Request Subscription\n</md-button></div></ms-form-wizard></div></simple-page>");
$templateCache.put("app/main/scc/components/school/edit-school-dialog.html","<md-dialog aria-label=\"Σχολείο {{$ctrl.oldSchoolName}}\"><form name=\"form\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Σχολείο {{$ctrl.oldSchoolName}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"$ctrl.close()\"><md-icon md-font-icon=\"icon-close\"/></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\"><md-input-container class=\"md-block\" flex-gt-sm><label for=\"school.name\">Όνομα</label><input \ntype=\"text\" name=\"school.name\" data-ng-model=\"$ctrl.school.name\" maxlength=\"127\"/><errors-container \nerrors=\"form[\'school.name\'].$error\"/></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\nΖώνη ώρας</label><md-select ng-model=\"$ctrl.school.timezone\"><md-option value=\"Europe/Athens\">Europe/Athens</md-option>\n<md-option value=\"Europe/London\">Europe/London</md-option><md-option value=\"Europe/Berlin\">Europe/Berlin</md-option>\n<md-option value=\"Europe/Paris\">Europe/Paris</md-option><md-option value=\"Europe/Rome\">Europe/Rome</md-option>\n<md-option value=\"Europe/Madrid\">Europe/Madrid</md-option><md-option value=\"Europe/Bucharest\">Europe/Bucharest\n</md-option><md-option value=\"Europe/Istanbul\">Europe/Istanbul</md-option><md-option value=\"America/New_York\">\nAmerica/New_York</md-option><md-option value=\"America/Chicago\">America/Chicago</md-option><md-option \nvalue=\"America/Los_Angeles\">America/Los_Angeles</md-option><md-option value=\"Asia/Tokyo\">Asia/Tokyo</md-option>\n<md-option value=\"Australia/Sydney\">Australia/Sydney</md-option><md-option value=\"UTC\">UTC</md-option></md-select>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \ndata-ng-click=\"$ctrl.close()\" class=\"md-raised md-primary\">ΑΚΥΡΟ</md-button><md-button data-ng-click=\"$ctrl.submit()\" \nclass=\"md-raised md-primary\" ng-if=\"$ctrl.mode==\'edit\'\">ΕΝΗΜΕΡΩΣΗ</md-button><md-button data-ng-click=\"$ctrl.submit()\" \nclass=\"md-raised md-primary\" ng-if=\"$ctrl.mode!=\'edit\'\">ΔΗΜΙΟΥΡΓΙΑ</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/scc/components/school/extend-subscription-success.html","<simple-page><div layout=\"row\">Congrats!</div></simple-page>");
$templateCache.put("app/main/scc/components/school/extend-subscription.html","<form name=\"form\"></form><simple-page><form-errors-container form=\"form\" translation-scope=\"SCC.LOGIN.ERROR\">\n</form-errors-container><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Product selection</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" ms-form-wizard-form novalidate><offers-table selected-product=\"dummy\" \nselected-duration=\"vm.req.duration\" selected-cost=\"vm.req.communicatedCost\" offers-list=\"vm.offers\"></offers-table>\n<input ng-show=\"false\" ng-model=\"vm.req.duration\" required/> <input ng-show=\"false\" ng-model=\"vm.req.communicatedCost\" \nrequired/></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Billing Information</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep2\" ms-form-wizard-form novalidate><billing-info billing-info=\"vm.req.billingInfo\" form=\"wizardStep2\"/>\n</form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">3</span> <span \nclass=\"ms-form-wizard-step-text\">Confirmation</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" \nms-form-wizard-form novalidate>{{vm.req}}<br/><md-checkbox \nng-if=\"form.$sccFormError[\'server.NoOverlappingPendingPurchases\']\" aria-label=\"FIXME!\" \nng-model=\"vm.req.cancelOverlappingPendingPurchases\">Cancel pending payments</md-checkbox></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.submit();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Extend</md-button>\n</div></ms-form-wizard></div></simple-page>");
$templateCache.put("app/main/scc/components/school/school.html","<carded-table id=\"schools\" translation-scope=\"SCC.SCHOOL\" filter=\"$ctrl.dataTable.filter\" \nsearch-focused=\"$ctrl.dataTable.searchFocused\" records-number=\"$ctrl.getAllEntities().length\" svg-icon=\"school\"><form \nname=\"form\"><div ng-if=\"$mdMedia(\'gt-xs\')\"><md-table-container><table md-table md-row-select multiple \nng-model=\"$ctrl.selected\"><thead md-head md-order=\"$ctrl.dataTable.order\"><tr md-row><th md-column md-order-by=\"name\">\n<span translate=\"SCC.SCHOOL.NAME\">Name</span></th><th md-column><span translate=\"SCC.SCHOOL.SUBSCRIPTIONS\">\nSubscriptions</span></th><th md-column><span translate=\"SCC.SCHOOL.ACTIONS\">Actions</span></th></tr></thead><tbody \nmd-body><tr ng-class=\"{\'selected-school\':$ctrl.isSelectedSchool(school)}\" md-row md-select=\"school\" md-select-id=\"id\" \nng-repeat=\"school in $ctrl.getAllEntities()\n						  | orderBy: $ctrl.dataTable.order\n						  | limitTo: $ctrl.dataTable.limit : $ctrl.dataTable.limit*($ctrl.dataTable.page-1)\n						  | filter: $ctrl.tableRowFilter([\'name\'],$ctrl.dataTable.filter)\">\n<td md-cell scc-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{school.name}}</td><td md-cell>\nΔοκιμαστική (Beta) πρόσβαση</td><td md-cell style=\"white-space: nowrap\"><a href=\"#\" class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.showEditPanel($event,school,\'edit\')\"><md-icon md-font-icon=\"icon-pencil\" class=\"s24\"></md-icon>\n<span hide-sm hide-md>Επεξεργασία</span></a><md-button class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.selectSchool(school)\" ng-if=\"!$ctrl.isSelectedSchool(school)\"><md-icon md-font-icon=\"icon-pin\" \nclass=\"s24\"></md-icon></md-button></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"$ctrl.dataTable.limit\" md-limit-options=\"$ctrl.dataTable.limitOptions\" md-page=\"$ctrl.dataTable.page\" \nmd-total=\"{{$ctrl.getAllEntities().length}}\" md-label=\"{{paginationLabels}}\" md-page-select md-boundary-links>\n</md-table-pagination></div><div ng-if=\"!$mdMedia(\'gt-xs\')\" class=\"mobile-list\"><md-card class=\"mobile-entity-card\" \nng-class=\"{\'selected-school\':$ctrl.isSelectedSchool(school)}\" \nng-repeat=\"school in filteredSchools = ($ctrl.getAllEntities()\n					          | orderBy: $ctrl.dataTable.order\n					          | filter: $ctrl.tableRowFilter([\'name\'],$ctrl.dataTable.filter))\" \nng-click=\"$ctrl.showEditPanel($event,school,\'edit\')\"><md-card-content layout=\"row\" layout-align=\"start center\"><div \nflex layout=\"column\"><span class=\"mobile-entity-name\" scc-highlight-text=\"$ctrl.dataTable.filter\">{{school.name}}\n</span> <span class=\"mobile-entity-detail\">Δοκιμαστική (Beta) πρόσβαση</span></div><md-button class=\"md-icon-button\" \nng-if=\"!$ctrl.isSelectedSchool(school)\" data-ng-click=\"$ctrl.selectSchool(school); $event.stopPropagation();\"><md-icon \nmd-font-icon=\"icon-pin\" class=\"md_dark md-24\"></md-icon></md-button><md-icon ng-if=\"$ctrl.isSelectedSchool(school)\" \nmd-font-icon=\"icon-pin\" class=\"s24\" style=\"margin-right: 12px\"></md-icon></md-card-content></md-card><div \nclass=\"mobile-no-results\" ng-if=\"$ctrl.dataTable.filter && filteredSchools.length === 0\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"s24\"></md-icon><span>Δεν βρέθηκαν αποτελέσματα</span></div></div></form>\n</carded-table>");
$templateCache.put("app/main/scc/components/school/upgrade-subscription-success.html","<simple-page><div layout=\"row\">Congrats!</div></simple-page>");
$templateCache.put("app/main/scc/components/school/upgrade-subscription.html","<form name=\"form\"></form><simple-page><form-errors-container form=\"form\" translation-scope=\"SCC.LOGIN.ERROR\">\n</form-errors-container><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height \nmd-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Product selection</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" ms-form-wizard-form novalidate><offers-table selected-product=\"vm.req.product\" \nselected-duration=\"dummy\" selected-cost=\"vm.req.communicatedCost\" offers-list=\"vm.offers\"></offers-table><input \nng-show=\"false\" ng-model=\"vm.req.product\" required/> <input ng-show=\"false\" ng-model=\"vm.req.communicatedCost\" \nrequired/></form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Billing Information</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep2\" ms-form-wizard-form novalidate><billing-info billing-info=\"vm.req.billingInfo\" form=\"wizardStep2\"/>\n</form></md-tab-body></md-tab><md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\">3</span> <span \nclass=\"ms-form-wizard-step-text\">Confirmation</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" \nms-form-wizard-form novalidate>{{vm.req}}<br/><md-checkbox \nng-if=\"form.$sccFormError[\'server.NoOverlappingPendingPurchases\']\" aria-label=\"FIXME!\" \nng-model=\"vm.req.cancelOverlappingPendingPurchases\">Cancel pending payments</md-checkbox></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.submit();\" ng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()\">Upgrade</md-button>\n</div></ms-form-wizard></div></simple-page>");
$templateCache.put("app/main/scc/components/student/confirm-payment-dialog.html","<md-dialog aria-label=\"Πληρωμή (Μαθητής) - (Ημερομηνία)\"><form name=\"form\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Πληρωμή</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n<md-icon md-font-icon=\"icon-close\"/></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<div ng-if=\"$ctrl.precalculation.canBeNormalized\"><span \ntranslate=\"SCC.STUDENT.FEES.PAYMENT_DIALOG.NORMALIZATION_ELIGIBLE\"></span><md-switch \nng-model=\"$ctrl.req.normalizePayments\">{{$ctrl.req.normalizePayments?\"SCC.YES\":\"SCC.NO\" | translate}}</md-switch></div>\n<p>{{\"SCC.STUDENT.FEES.PAYMENT_DIALOG.TOTAL_AMOUNT\" | translate}}: {{$ctrl.req.communicatedSum}}</p></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button data-ng-click=\"$ctrl.close()\" \nclass=\"md-raised md-primary\">ΑΚΥΡΟ</md-button><md-button data-ng-click=\"$ctrl.submit()\" class=\"md-raised md-primary\">\nΠΛΗΡΩΜΗ</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/scc/components/student/edit-payment-dialog.html","<md-dialog aria-label=\"Πληρωμή (Καθηγητης) - (Ημερομηνία)\"><form name=\"form\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Πληρωμή</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n<md-icon md-font-icon=\"icon-close\"/></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<md-input-container class=\"md-block\" flex-gt-sm><label for=\"payment.amount\">Ποσό οφειλής</label><input type=\"number\" \nname=\"payment.amount\" data-ng-model=\"$ctrl.payment.amount\"/><errors-container errors=\"form[\'payment.amount\'].$error\"/>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label for=\"payment.paidAmount\">Εξοφλημένο ποσό\n</label><input type=\"number\" name=\"payment.paidAmount\" data-ng-model=\"$ctrl.payment.paidAmount\"/><errors-container \nerrors=\"form[\'payment.paidAmount\'].$error\"/></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label\n for=\"payent.comments\">Σχόλια</label><input type=\"text\" name=\"payent.comments\" data-ng-model=\"$ctrl.payent.comments\"/>\n<errors-container errors=\"form[\'payent.comments\'].$error\"/></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button data-ng-click=\"$ctrl.close()\" class=\"md-raised md-primary\">ΑΚΥΡΟ</md-button>\n<md-button data-ng-click=\"$ctrl.submit()\" class=\"md-raised md-primary\">ΕΝΗΜΕΡΩΣΗ</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/scc/components/student/student-details.html","<carded-simple translation-scope=\"SCC.STUDENT\" svg-icon=\"student\" title=\"{{$ctrl.student.name}}\"><md-nav-bar \nmd-selected-nav-item=\"$ctrl.tab\"><md-nav-item md-nav-sref=\"app.scc.private.student.details\" name=\"generalInfo\"><span \ntranslate=\"SCC.STUDENT.GENERAL_INFO_TAB\"></span></md-nav-item><md-nav-item \nmd-nav-sref=\"app.scc.private.student.details\" name=\"feesInfo\"><span translate=\"SCC.STUDENT.FEES_DETAILS_TAB\"></span>\n</md-nav-item><md-nav-item md-nav-sref=\"app.scc.private.student.details\" name=\"availability\"><span \ntranslate=\"SCC.STUDENT.AVAILABILITY_TAB\"></span></md-nav-item></md-nav-bar><md-content class=\"md-padding\"><div \nng-if=\"$ctrl.selectedTab == \'generalInfo\'\"><student-general-info student-id=\"$ctrl.studentId\" dirty=\"$ctrl.dirty\">\n</student-general-info><student-groups-info student-id=\"$ctrl.studentId\"></student-groups-info></div><div \nng-if=\"$ctrl.selectedTab == \'feesInfo\'\"><student-fees-info student-id=\"$ctrl.studentId\" dirty=\"$ctrl.dirty\">\n</student-fees-info><student-payments student-id=\"$ctrl.studentId\"></student-payments></div><div \nng-if=\"$ctrl.selectedTab == \'availability\'\"><scc-availability entity-type=\"\'student\'\" entity-id=\"$ctrl.studentId\" \nselected-data-set=\"$ctrl.getSelectedDataSet()\"></scc-availability></div></md-content></carded-simple>");
$templateCache.put("app/main/scc/components/student/student-fees-info.html","<form name=\"form\"><h1 class=\"md-display-1\"><span translate=\"SCC.STUDENT.FEES.TITLE\">Fees details</span><md-button \nclass=\"md-icon-button\" ng-if=\"!$ctrl.editable\" data-ng-click=\"$ctrl.startEditing()\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"md_dark md-16\"/></md-button><md-button class=\"md-icon-button\" ng-if=\"$ctrl.editable\" \ndata-ng-click=\"$ctrl.save()\"><md-icon md-font-icon=\"icon-content-save\" class=\"md_dark md-16\"/></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"$ctrl.editable\" data-ng-click=\"$ctrl.cancelEditing()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"md_dark md-16\"/></md-button></h1><div ng-repeat=\"agreement in $ctrl.feesAgreements\" layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex><label for=\"agreements[{{$index}}].feesType\" \ntranslate=\"SCC.STUDENT.FEES.TYPE\"></label><md-select name=\"agreements[{{$index}}].feesType\" \nng-model=\"agreement.feesType\" ng-disabled=\"!$ctrl.editable\"><md-option ng-value=\"\'HOURLY\'\" \ntranslate=\"SCC.STUDENT.FEES.HOURLY\">Hourly</md-option><md-option ng-value=\"\'MONTHLY\'\" \ntranslate=\"SCC.STUDENT.FEES.MONTHLY\">Monthly</md-option></md-select><errors-container \nerrors=\"form[(\'agreements[\'+$parent.$index+\'].feesType\')].$error\"/></md-input-container><md-input-container \nclass=\"md-block\" flex><label for=\"agreements[{{$index}}].amount\"><span ng-if=\"agreement.feesType == \'MONTHLY\'\" \ntranslate=\"SCC.STUDENT.FEES.MONTHLY_FEES\"></span> <span ng-if=\"agreement.feesType == \'HOURLY\'\" \ntranslate=\"SCC.STUDENT.FEES.HOURLY_FEES\"></span></label><input type=\"number\" name=\"agreements[{{$index}}].amount\" \ndata-ng-model=\"agreement.amount\" ng-disabled=\"!$ctrl.editable\"/><errors-container \nerrors=\"form[(\'agreements[\'+$parent.$index+\'].amount\')].$error\"/></md-input-container></div></form>");
$templateCache.put("app/main/scc/components/student/student-finder.html","<md-autocomplete md-input-name=\"{{$ctrl.inputName}}\" md-selected-item=\"$ctrl.student\" \nmd-search-text=\"$ctrl.searchText\" md-selected-item-change=\"$ctrl.selectedItemChanged(item)\" \nmd-items=\"item in ($ctrl.getAllItems() | filter:$ctrl.tableRowFilter([\'name\'],$ctrl.searchText))\" \nmd-item-text=\"item.name\" md-min-length=\"0\" md-floating-label=\"Όνομα μαθητή\" md-dropdown-position=\"bottom\">\n<md-item-template><span md-highlight-text=\"$ctrl.searchText\" md-highlight-flags=\"^i\">{{item.name}}</span>\n</md-item-template><md-not-found>Δεν βρέθηκαν μαθητές που να ταιριάζουν με \"{{$ctrl.searchText}}\". <a>Καταχώρηση νέου!\n</a></md-not-found><errors-container errors=\"$ctrl.errors\"/></md-autocomplete>");
$templateCache.put("app/main/scc/components/student/student-general-info.html","<form name=\"form\"><h1 class=\"md-display-1\">Γενικές πληροφορίες<md-button class=\"md-icon-button\" \nng-if=\"!$ctrl.editable\" data-ng-click=\"$ctrl.startEditing()\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md_dark md-16\"/></md-button><md-button class=\"md-icon-button\" ng-if=\"$ctrl.editable\" \ndata-ng-click=\"$ctrl.save()\"><md-icon md-font-icon=\"icon-content-save\" class=\"md_dark md-16\"/></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"$ctrl.editable\" data-ng-click=\"$ctrl.cancelEditing()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"md_dark md-16\"/></md-button></h1><md-input-container class=\"md-block\" flex-gt-sm><label for=\"student.name\">Όνομα\n</label><input type=\"text\" name=\"student.name\" data-ng-model=\"$ctrl.student.name\" ng-disabled=\"!$ctrl.editable\"/>\n<errors-container errors=\"form[\'student.name\'].$error\"/></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label for=\"student.email\">Email</label><input type=\"text\" name=\"student.email\" \ndata-ng-model=\"$ctrl.student.email\" ng-disabled=\"!$ctrl.editable\"/><errors-container \nerrors=\"form[\'student.email\'].$error\"/></md-input-container></form>");
$templateCache.put("app/main/scc/components/student/student-groups-info.html","<form name=\"form\"><h1 class=\"md-display-1\">Διδακτικά τμήματα</h1><div ng-if=\"$ctrl.dataSetIds.length === 0\" \nclass=\"empty-state-message\"><span>Ο μαθητής δεν ανήκει σε κάποιο διδακτικό τμήμα.</span></div><div \nng-repeat=\"dsId in $ctrl.dataSetIds\"><h3 class=\"md-title\">{{$ctrl.groupsByDataSet[dsId].dataSet.name}} <span \nclass=\"secondary-text md-body-1\">\n({{$ctrl.groupsByDataSet[dsId].dataSet.dateFrom | date:\'dd/MM/yyyy\'}} - {{$ctrl.groupsByDataSet[dsId].dataSet.dateTo | date:\'dd/MM/yyyy\'}})\n</span></h3><div ng-if=\"$ctrl.isSelectedDataSet(dsId)\"><div ng-if=\"$mdMedia(\'gt-xs\')\"><md-table-container><table \nmd-table><thead md-head><tr md-row><th md-column>Τμήμα</th><th md-column>Ενέργειες</th></tr></thead><tbody md-body><tr>\n<td md-cell><md-autocomplete md-input-name=\"studentsGroup\" md-selected-item=\"$ctrl.selectedStudentsGroup\" \nmd-search-text=\"studentsGroupSearch\" \nmd-items=\"studentsGroup in ($ctrl.getAllStudentsGroups() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],studentsGroupSearch))\" \nmd-item-text=\"studentsGroup.name\" md-floating-label=\"Διδακτικό τμήμα\" md-min-length=\"0\" md-dropdown-position=\"bottom\">\n<md-item-template><span md-highlight-text=\"studentsGroupSearch\" md-highlight-flags=\"^i\">{{studentsGroup.name}}</span>\n</md-item-template><md-not-found>Δεν βρέθηκαν τμήματα που να ταιριάζουν με \"{{studentsGroupSearch}}\".</md-not-found>\n</md-autocomplete></td><td md-cell style=\"white-space: nowrap\"><a href=\"#\" class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.addGroup()\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"s24\"></md-icon><span hide-sm hide-md>\nΠροσθήκη</span></a></td></tr><tr md-row ng-repeat=\"group in $ctrl.groupsByDataSet[dsId].groups\"><td md-cell><a \nui-sref=\"app.scc.private.students-group.details({studentsGroupId: {{group.id}}})\">{{group.name}}</a></td><td md-cell \nstyle=\"white-space: nowrap\"><a href=\"#\" class=\"md-icon-button\" data-ng-click=\"$ctrl.removeGroup($event, group)\">\n<md-icon md-font-icon=\"icon-delete\" class=\"md_dark md-24\"></md-icon><span hide-sm hide-md>Αφαίρεση</span></a></td></tr>\n</tbody></table></md-table-container><div ng-if=\"$ctrl.groupsByDataSet[dsId].groups.length === 0\" \nclass=\"empty-state-message\"><span>\nΟ μαθητής δεν ανήκει σε κάποιο τμήμα αυτής της περιόδου. Χρησιμοποιήστε την αναζήτηση παραπάνω για να τον προσθέσετε.\n</span></div></div><div ng-if=\"!$mdMedia(\'gt-xs\')\" class=\"mobile-list\"><md-card class=\"mobile-create-card\">\n<md-card-content layout=\"column\"><md-autocomplete md-input-name=\"studentsGroup\" \nmd-selected-item=\"$ctrl.selectedStudentsGroup\" md-search-text=\"studentsGroupSearch\" \nmd-items=\"studentsGroup in ($ctrl.getAllStudentsGroups() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],studentsGroupSearch))\" \nmd-item-text=\"studentsGroup.name\" md-floating-label=\"Διδακτικό τμήμα\" md-min-length=\"0\" md-dropdown-position=\"bottom\">\n<md-item-template><span md-highlight-text=\"studentsGroupSearch\" md-highlight-flags=\"^i\">{{studentsGroup.name}}</span>\n</md-item-template><md-not-found>Δεν βρέθηκαν τμήματα που να ταιριάζουν με \"{{studentsGroupSearch}}\".</md-not-found>\n</md-autocomplete><md-button class=\"md-accent md-raised\" ng-click=\"$ctrl.addGroup()\"><md-icon \nmd-font-icon=\"icon-plus-circle\" class=\"s18\"></md-icon>Προσθήκη</md-button></md-card-content></md-card><md-card \nclass=\"mobile-entity-card\" ng-repeat=\"group in $ctrl.groupsByDataSet[dsId].groups\" \nui-sref=\"app.scc.private.students-group.details({studentsGroupId: {{group.id}}})\"><md-card-content layout=\"row\" \nlayout-align=\"start center\"><div flex layout=\"column\"><span class=\"mobile-entity-name\">{{group.name}}</span></div>\n<md-button class=\"md-icon-button\" data-ng-click=\"$ctrl.removeGroup($event, group); $event.stopPropagation();\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md_dark md-24\"></md-icon></md-button></md-card-content></md-card><md-card \nclass=\"mobile-entity-card\" ng-if=\"$ctrl.groupsByDataSet[dsId].groups.length === 0\"><md-card-content \nclass=\"mobile-no-results\"><span>Δεν ανήκει σε κάποιο τμήμα.</span></md-card-content></md-card></div></div><div \nng-if=\"!$ctrl.isSelectedDataSet(dsId)\"><div ng-if=\"$mdMedia(\'gt-xs\')\"><md-table-container><table md-table><thead \nmd-head><tr md-row><th md-column>Τμήμα</th></tr></thead><tbody md-body><tr md-row \nng-repeat=\"group in $ctrl.groupsByDataSet[dsId].groups\"><td md-cell><a \nui-sref=\"app.scc.private.students-group.details({studentsGroupId: {{group.id}}})\">{{group.name}}</a></td></tr></tbody>\n</table></md-table-container><div ng-if=\"$ctrl.groupsByDataSet[dsId].groups.length === 0\" class=\"empty-state-message\">\n<span>Ο μαθητής δεν ανήκει σε κάποιο τμήμα αυτής της περιόδου.</span></div></div><div ng-if=\"!$mdMedia(\'gt-xs\')\" \nclass=\"mobile-list\"><md-card class=\"mobile-entity-card\" ng-repeat=\"group in $ctrl.groupsByDataSet[dsId].groups\" \nui-sref=\"app.scc.private.students-group.details({studentsGroupId: {{group.id}}})\"><md-card-content layout=\"row\" \nlayout-align=\"start center\"><div flex layout=\"column\"><span class=\"mobile-entity-name\">{{group.name}}</span></div>\n</md-card-content></md-card><md-card class=\"mobile-entity-card\" \nng-if=\"$ctrl.groupsByDataSet[dsId].groups.length === 0\"><md-card-content class=\"mobile-no-results\"><span>\nΔεν ανήκει σε κάποιο τμήμα.</span></md-card-content></md-card></div></div></div></form>");
$templateCache.put("app/main/scc/components/student/student-list.html","<form name=\"form\"><carded-table translation-scope=\"SCC.STUDENT\" filter=\"$ctrl.dataTable.filter\" \nsearch-focused=\"$ctrl.dataTable.searchFocused\" records-number=\"$ctrl.getAllEntities().length\" svg-icon=\"student\"><div \nng-if=\"$mdMedia(\'gt-xs\')\"><md-table-container><table md-table md-row-select multiple ng-model=\"$ctrl.selectedEntities\">\n<thead md-head md-order=\"$ctrl.dataTable.order\"><tr md-row><th md-column md-order-by=\"name\"><span \ntranslate=\"SCC.STUDENT.NAME\">Name</span></th><th md-column md-order-by=\"email\"><span translate=\"SCC.STUDENT.EMAIL\">\nEmail</span></th><th md-column>Διδακτικό τμήμα</th><th md-column><span translate=\"SCC.STUDENT.ACTIONS\">Actions</span>\n</th></tr></thead><tbody md-body><tr><td md-cell><md-button class=\"md-icon-button\" \nng-if=\"$ctrl.selectedEntities.length\" data-ng-click=\"$ctrl.deleteSelected($event)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md_dark md-24\"/></md-button></td><td md-cell><md-input-container><input type=\"text\" name=\"student.name\" \ndata-ng-model=\"$ctrl.student.name\" scc-enter=\"$ctrl.createEntity()\"/><errors-container \nerrors=\"form[\'student.name\'].$error\"/></md-input-container></td><td md-cell><md-input-container><input type=\"text\" \nname=\"student.email\" data-ng-model=\"$ctrl.student.email\" scc-enter=\"$ctrl.createEntity()\" min=\"0\"/><errors-container \nerrors=\"form[\'student.email\'].$error\"/></md-input-container></td><td md-cell><md-autocomplete \nmd-input-name=\"studentsGroup\" md-selected-item=\"$ctrl.selectedStudentsGroup\" md-search-text=\"studentsGroup.search\" \nmd-items=\"studentsGroup in ($ctrl.getAllStudentsGroups() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],studentsGroup.search))\" \nmd-item-text=\"studentsGroup.name\" md-floating-label=\"Διδακτικό τμήμα\" class=\"md-autocomplete-no-label\" \nmd-min-length=\"0\" ng-disabled=\"!$ctrl.isDatasetSelected()\" scc-enter=\"$ctrl.createEntity()\"><md-item-template><span \nmd-highlight-text=\"studentsGroup.search\" md-highlight-flags=\"^i\">{{studentsGroup.name}}</span></md-item-template>\n<md-not-found>Δεν βρέθηκαν τμήματα που να ταιριάζουν με \"{{studentsGroup.search}}\".</md-not-found></md-autocomplete>\n</td><td md-cell style=\"white-space: nowrap\"><a href=\"#\" class=\"md-icon-button\" data-ng-click=\"$ctrl.createEntity()\">\n<md-icon md-font-icon=\"icon-plus-circle\" class=\"s24\"></md-icon><span hide-sm hide-md>Δημιουργία</span> </a></td></tr>\n<tr md-row md-select=\"student\" md-select-id=\"id\" \nng-repeat=\"student in $ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | limitTo: $ctrl.dataTable.limit : $ctrl.dataTable.limit*($ctrl.dataTable.page-1)\n				          | filter: $ctrl.tableRowFilter([\'name\',\'shortName\',\'email\'],$ctrl.dataTable.filter)\">\n<td md-cell scc-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{student.name}}</td><td md-cell \nmd-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{student.email}}</td><td md-cell></td><td md-cell \nstyle=\"white-space: nowrap\"><a class=\"md-icon-button\" \nui-sref=\"app.scc.private.student.details({studentId: {{student.id}}})\"><md-icon md-font-icon=\"icon-view-list\" \nclass=\"md_dark md-24\"/><span hide-sm hide-md>Περισσότερα</span> </a><a href=\"#\" class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.deleteEntity($event,student)\"><md-icon md-font-icon=\"icon-delete\" class=\"md_dark md-24\"/><span \nhide-sm hide-md>Διαγραφή</span> </a></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"$ctrl.dataTable.limit\" md-limit-options=\"$ctrl.dataTable.limitOptions\" md-page=\"$ctrl.dataTable.page\" \nmd-label=\"{{paginationLabels}}\" md-total=\"{{$ctrl.getAllEntities().length}}\" md-page-select md-boundary-links>\n</md-table-pagination></div><div ng-if=\"!$mdMedia(\'gt-xs\')\" class=\"mobile-list\"><md-card class=\"mobile-create-card\" \nng-hide=\"$ctrl.dataTable.searchFocused\"><md-card-content layout=\"column\"><md-input-container><label \ntranslate=\"SCC.STUDENT.NAME\">Name</label><input type=\"text\" name=\"student.name\" data-ng-model=\"$ctrl.student.name\" \nscc-enter=\"$ctrl.createEntity()\"/><errors-container errors=\"form[\'student.name\'].$error\"/></md-input-container>\n<md-input-container><label translate=\"SCC.STUDENT.EMAIL\">Email</label><input type=\"text\" name=\"student.email\" \ndata-ng-model=\"$ctrl.student.email\" scc-enter=\"$ctrl.createEntity()\"/><errors-container \nerrors=\"form[\'student.email\'].$error\"/></md-input-container><md-autocomplete md-input-name=\"studentsGroup\" \nmd-selected-item=\"$ctrl.selectedStudentsGroup\" md-search-text=\"studentsGroup.search\" \nmd-items=\"studentsGroup in ($ctrl.getAllStudentsGroups() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],studentsGroup.search))\" \nmd-item-text=\"studentsGroup.name\" md-floating-label=\"Διδακτικό τμήμα\" md-min-length=\"0\" \nng-disabled=\"!$ctrl.isDatasetSelected()\" scc-enter=\"$ctrl.createEntity()\"><md-item-template><span \nmd-highlight-text=\"studentsGroup.search\" md-highlight-flags=\"^i\">{{studentsGroup.name}}</span></md-item-template>\n<md-not-found>Δεν βρέθηκαν τμήματα που να ταιριάζουν με \"{{studentsGroup.search}}\".</md-not-found></md-autocomplete>\n<md-button class=\"md-accent md-raised\" ng-click=\"$ctrl.createEntity()\"><md-icon md-font-icon=\"icon-plus-circle\" \nclass=\"s18\"></md-icon>Δημιουργία</md-button></md-card-content></md-card><md-card class=\"mobile-entity-card\" \nng-repeat=\"student in filteredStudents = ($ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | filter: $ctrl.tableRowFilter([\'name\',\'shortName\',\'email\'],$ctrl.dataTable.filter))\" \nui-sref=\"app.scc.private.student.details({studentId: {{student.id}}})\"><md-card-content layout=\"row\" \nlayout-align=\"start center\"><div flex layout=\"column\"><span class=\"mobile-entity-name\" \nscc-highlight-text=\"$ctrl.dataTable.filter\">{{student.name}}</span> <span class=\"mobile-entity-detail\" \nscc-highlight-text=\"$ctrl.dataTable.filter\">{{student.email}}</span></div><md-button class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.deleteEntity($event,student); $event.stopPropagation();\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md_dark md-24\"></md-icon></md-button></md-card-content></md-card><div class=\"mobile-no-results\" \nng-if=\"$ctrl.dataTable.filter && filteredStudents.length === 0\"><md-icon md-font-icon=\"icon-magnify\" class=\"s24\">\n</md-icon><span>Δεν βρέθηκαν αποτελέσματα</span></div></div></carded-table></form>");
$templateCache.put("app/main/scc/components/student/student-payments.html","<h1 class=\"md-display-1\"><span translate=\"SCC.STUDENT.PAYMENT.TITLE\">Student Payments</span></h1><div \nng-if=\"$ctrl.proEntitled === false\" layout=\"column\" layout-align=\"center center\" style=\"padding: 48px 16px\"><md-icon \nmd-font-icon=\"icon-lock\" style=\"font-size: 48px; height: 48px; width: 48px; color: #999; margin-bottom: 16px\">\n</md-icon><h2 class=\"md-title\" style=\"margin-bottom: 8px\">School on Cloud Pro</h2><p \nstyle=\"color: #666; text-align: center; max-width: 400px; margin-bottom: 24px\">\nΓια τη διαχείριση πληρωμών διδάκτρων απαιτείται συνδρομή στο School on Cloud Pro.</p><md-button \nclass=\"md-raised md-primary\" ng-click=\"$ctrl.showPaywall()\">Αναβάθμιση σε Pro</md-button></div><div \nng-if=\"$ctrl.proEntitled === true && $mdMedia(\'gt-xs\')\"><md-table-container ng-if=\"$ctrl.getAllEntities().length > 0\">\n<table md-table md-row-select multiple ng-model=\"$ctrl.selectedEntities\"><thead md-head \nmd-order=\"$ctrl.dataTable.order\"><tr md-row><th md-column md-order-by=\"fromDate\"><span \ntranslate=\"SCC.STUDENT.PAYMENT.FROM_DATE\">Name</span></th><th md-column md-order-by=\"toDate\"><span \ntranslate=\"SCC.STUDENT.PAYMENT.TO_DATE\">Name</span></th><th md-column md-order-by=\"lastUpdateDate\"><span \ntranslate=\"SCC.STUDENT.PAYMENT.LAST_UPDATE_DATE\">Name</span></th><th md-column md-order-by=\"amount\"><span \ntranslate=\"SCC.STUDENT.PAYMENT.AMOUNT\">Amount</span></th><th md-column md-order-by=\"paidAmount\"><span \ntranslate=\"SCC.STUDENT.PAYMENT.PAID_AMOUNT\">Paid Amount</span></th><th md-column><span translate=\"SCC.STUDENT.ACTIONS\">\nActions</span></th></tr></thead><tbody md-body><tr><td md-cell><md-button class=\"md-icon-button\" \nng-if=\"$ctrl.selectedEntities.length\" data-ng-click=\"$ctrl.deleteSelected($event)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md_dark md-24\"/></md-button></td><td md-cell><md-button class=\"md-icon-button\" \nng-if=\"$ctrl.selectedEntities.length\" data-ng-click=\"$ctrl.showPaymentDialog($event)\"><md-icon \nmd-font-icon=\"icon-credit-card\" class=\"md_dark md-24\"/></md-button></td><td md-cell></td><td md-cell></td><td md-cell>\n</td><td md-cell></td></tr><tr md-row md-select=\"entity\" md-select-id=\"id\" \nng-class=\"{\'fulfilledPayment\':(entity.paidAmount >= entity.amount), \'unfulfilledPayment\':(entity.paidAmount < entity.amount)}\" \nng-repeat=\"entity in $ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | limitTo: $ctrl.dataTable.limit : $ctrl.dataTable.limit*($ctrl.dataTable.page-1)\n				          | filter: $ctrl.tableRowFilter([\'fromDate\',\'toDate\',\'lastUpdateDate\',\'amount\',\'paidAmount\'],$ctrl.dataTable.filter)\">\n<td md-cell>{{entity.fromDate}}</td><td md-cell>{{entity.toDate}}</td><td md-cell>{{entity.lastUpdateDate}}</td><td \nmd-cell>{{entity.amount}}</td><td md-cell>{{entity.paidAmount}}</td><td md-cell style=\"white-space: nowrap\"><md-button \nclass=\"md-icon-button\" data-ng-click=\"$ctrl.showEditPanel($event,entity)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md_dark md-24\"/></md-button><md-button class=\"md-icon-button\" data-ng-click=\"$ctrl.pay($event,entity)\"><md-icon \nmd-font-icon=\"icon-credit-card\" class=\"md_dark md-24\"/></md-button></td></tr></tbody></table></md-table-container>\n<md-table-pagination ng-if=\"$ctrl.getAllEntities().length > 0\" md-limit=\"$ctrl.dataTable.limit\" \nmd-limit-options=\"$ctrl.dataTable.limitOptions\" md-page=\"$ctrl.dataTable.page\" \nmd-total=\"{{$ctrl.getAllEntities().length}}\" md-page-select md-boundary-links></md-table-pagination><div \nng-if=\"$ctrl.getAllEntities().length === 0\" class=\"empty-state-message\"><span translate=\"SCC.STUDENT.NO_PAYMENTS\">\nNo payments</span></div></div><div ng-if=\"$ctrl.proEntitled === true && !$mdMedia(\'gt-xs\')\" class=\"mobile-list\">\n<md-card class=\"mobile-entity-card\" \nng-class=\"{\'fulfilledPayment\':(entity.paidAmount >= entity.amount), \'unfulfilledPayment\':(entity.paidAmount < entity.amount)}\" \nng-repeat=\"entity in $ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | filter: $ctrl.tableRowFilter([\'fromDate\',\'toDate\',\'lastUpdateDate\',\'amount\',\'paidAmount\'],$ctrl.dataTable.filter)\" \nng-click=\"$ctrl.showEditPanel($event,entity)\"><md-card-content layout=\"row\" layout-align=\"start center\"><div flex \nlayout=\"column\"><span class=\"mobile-entity-name\">{{entity.fromDate}} - {{entity.toDate}}</span><div layout=\"row\" \nlayout-align=\"start center\" style=\"margin-top: 4px\"><div layout=\"column\" flex><span class=\"mobile-entity-detail\" \ntranslate=\"SCC.STUDENT.PAYMENT.AMOUNT\">Amount</span> <span class=\"mobile-entity-name\" style=\"font-weight: bold\">\n{{entity.amount}}€</span></div><div layout=\"column\" flex><span class=\"mobile-entity-detail\" \ntranslate=\"SCC.STUDENT.PAYMENT.PAID_AMOUNT\">Paid Amount</span> <span class=\"mobile-entity-name\" \nstyle=\"font-weight: bold\">{{entity.paidAmount}}€</span></div></div></div><md-button class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.pay($event,entity); $event.stopPropagation();\"><md-icon md-font-icon=\"icon-credit-card\" \nclass=\"md_dark md-24\"></md-icon></md-button></md-card-content></md-card><md-card class=\"mobile-entity-card\" \nng-if=\"$ctrl.getAllEntities().length === 0\"><md-card-content class=\"mobile-no-results\"><span \ntranslate=\"SCC.STUDENT.NO_PAYMENTS\">No payments</span></md-card-content></md-card></div>");
$templateCache.put("app/main/scc/components/students-group/copy-students-group-teaching-needs-dialog.html","<md-dialog aria-label=\"Αντιγραφή διδακτικών αναγκών\" style=\"width: 1000px\"><form name=\"form\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Αντιγραφή διδακτικών αναγκών</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"$ctrl.close()\"><md-icon md-font-icon=\"icon-close\"/></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-padding secondary-text md-body-1\" style=\"width: fit-content\" layout=\"row\" layout-align=\"start center\">\n<md-icon class=\"s32\" md-font-icon=\"icon-information\" style=\"margin-right: 18px\"></md-icon>\nΑντιγράψτε διδακτικές ανάγκες από ένα άλλο τμήμα. Μπορείτε να τις τροποποιήσετε πριν τις μεταφέρετε.</div>\n<md-autocomplete md-input-name=\"studentsGroup\" md-selected-item=\"$ctrl.studentsGroup\" \nmd-search-text=\"studentsGroup.search\" \nmd-items=\"studentsGroup in ($ctrl.getAllStudentsGroups() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],studentsGroup.search))\" \nmd-item-text=\"studentsGroup.name\" md-floating-label=\"Διδακτικό τμήμα\" md-min-length=\"0\" \nmd-selected-item-change=\"$ctrl.reloadTeachingNeeds()\"><md-item-template><span md-highlight-text=\"studentsGroup.search\" \nmd-highlight-flags=\"^i\">{{studentsGroup.name}}</span></md-item-template><md-not-found>\nΔεν βρέθηκαν τμήματα που να ταιριάζουν με \"{{studentsGroup.search}}\".</md-not-found></md-autocomplete><table md-table>\n<tbody md-body><tr md-row ng-repeat=\"teachingNeed in $ctrl.teachingNeeds\"><td md-cell><md-autocomplete \nmd-input-name=\"teachingNeed[{{$index}}].teacher\" md-selected-item=\"teachingNeed.teacher\" \nmd-search-text=\"teachingNeed.teacher_search\" \nmd-items=\"teacher in ($ctrl.getAllTeachers() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],teachingNeed.teacher_search))\" \nmd-item-text=\"teacher.name\" md-floating-label=\"Καθηγητής\" md-min-length=\"0\"><md-item-template><span \nmd-highlight-text=\"teachingNeed.teacher_search\" md-highlight-flags=\"^i\">{{teacher.name}}</span></md-item-template>\n<md-not-found>Δεν βρέθηκαν καθηγητές που να ταιριάζουν με \"{{teachingNeed.teacher_search}}\".</md-not-found>\n</md-autocomplete></td><td md-cell md-highlight-flags=\"i\"><md-autocomplete \nmd-input-name=\"teachingNeed[{{$index}}].lesson\" md-selected-item=\"teachingNeed.lesson\" \nmd-search-text=\"teachingNeed.lesson_search\" \nmd-items=\"lesson in ($ctrl.getAllLessons() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],teachingNeed.lesson_search))\" \nmd-item-text=\"lesson.name\" md-floating-label=\"Μάθημα\" md-min-length=\"0\"><md-item-template><span \nmd-highlight-text=\"teachingNeed.lesson_search\" md-highlight-flags=\"^i\">{{lesson.name}}</span></md-item-template>\n<md-not-found>Δεν βρέθηκαν μαθήατα που να ταιριάζουν με \"{{teachingNeed.lesson_search}}\".</md-not-found>\n</md-autocomplete></td><td md-cell md-highlight-flags=\"i\"><md-autocomplete \nmd-input-name=\"teachingNeed[{{$index}}].classroom\" md-selected-item=\"teachingNeed.classroom\" \nmd-search-text=\"teachingNeed.classroom_search\" \nmd-items=\"classroom in ($ctrl.getAllClassrooms() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],teachingNeed.classroom_search))\" \nmd-item-text=\"classroom.name\" md-floating-label=\"Αίθουσα\" md-min-length=\"0\"><md-item-template><span \nmd-highlight-text=\"teachingNeed.classroom_search\" md-highlight-flags=\"^i\">{{classroom.name}}</span></md-item-template>\n<md-not-found>Δεν βρέθηκαν αίθουσες που να ταιριάζουν με \"{{teachingNeed.classroom_search}}\".</md-not-found>\n</md-autocomplete></td><td md-cell><duration-picker ng-model=\"teachingNeed.timeSlotsPerWeek\" min-slots=\"0\" \nmax-slots=\"288\" max-hours=\"24\"></duration-picker></td></tr></tbody></table></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button data-ng-click=\"$ctrl.close()\" class=\"md-raised md-primary\">ΑΚΥΡΟ</md-button><md-button \ndata-ng-click=\"$ctrl.copy()\" class=\"md-raised md-primary\">ΑΝΤΙΓΡΑΦΗ</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/scc/components/students-group/edit-students-group-teaching-need-dialog.html","<md-dialog aria-label=\"Διδακτική ανάγκη\"><form name=\"form\" ng-cloak><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nΔιδακτική ανάγκη</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon \nmd-font-icon=\"icon-close\"/></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<md-autocomplete md-input-name=\"teachingNeed.teacher\" md-selected-item=\"$ctrl.teachingNeed.teacher\" \nmd-search-text=\"teachingNeed.teacherSearch\" \nmd-items=\"teacher in ($ctrl.getAllTeachers() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],teachingNeed.teacherSearch))\" \nmd-item-text=\"teacher.name\" md-floating-label=\"Καθηγητής\" md-min-length=\"0\"><md-item-template><span \nmd-highlight-text=\"teachingNeed.teacherSearch\" md-highlight-flags=\"^i\">{{teacher.name}}</span></md-item-template>\n<md-not-found>Δεν βρέθηκαν καθηγητές που να ταιριάζουν με \"{{teachingNeed.teacherSearch}}\". <a>Καταχώρηση νέου!</a>\n</md-not-found><errors-container errors=\"form[(\'teachingNeed.teacher\')].$error\"/></md-autocomplete><md-autocomplete \nmd-input-name=\"teachingNeed.lesson\" md-selected-item=\"$ctrl.teachingNeed.lesson\" \nmd-search-text=\"teachingNeed.lessonSearch\" \nmd-items=\"lesson in ($ctrl.getAllLessons() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],teachingNeed.lessonSearch))\" \nmd-item-text=\"lesson.name\" md-floating-label=\"Μάθημα\" scc-enter=\"$ctrl.createEntity()\" md-min-length=\"0\">\n<md-item-template><span md-highlight-text=\"teachingNeed.lessonSearch\" md-highlight-flags=\"^i\">{{lesson.name}}</span>\n</md-item-template><md-not-found>Δεν βρέθηκαν μαθήματα που να ταιριάζουν με \"{{teachingNeed.lessonSearch}}\". <a>\nΚαταχώρηση νέου!</a></md-not-found><errors-container errors=\"form[\'teachingNeed.lesson\'].$error\"/></md-autocomplete>\n<md-autocomplete md-input-name=\"teachingNeed.classroom\" md-selected-item=\"$ctrl.teachingNeed.classroom\" \nmd-search-text=\"teachingNeed.classroomSearch\" \nmd-items=\"classroom in ($ctrl.getAllClassrooms() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],teachingNeed.classroomSearch))\" \nmd-item-text=\"classroom.name\" md-floating-label=\"Αίθουσα\" scc-enter=\"$ctrl.createEntity()\" md-min-length=\"0\">\n<md-item-template><span md-highlight-text=\"teachingNeed.classroomSearch\" md-highlight-flags=\"^i\">{{classroom.name}}\n</span></md-item-template><md-not-found>Δεν βρέθηκαν αίθουσες που να ταιριάζουν με \"{{teachingNeed.classroomSearch}}\". \n<a>Καταχώρηση νέας!</a></md-not-found><errors-container errors=\"form[\'teachingNeed.classroom\'].$error\"/>\n</md-autocomplete><duration-picker ng-model=\"$ctrl.teachingNeed.timeSlotsPerWeek\" name=\"teachingNeed.timeSlotsPerWeek\" \nerrors=\"form[\'teachingNeed.timeSlotsPerWeek\'].$error\"></duration-picker></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button data-ng-click=\"$ctrl.close()\" class=\"md-raised md-primary\">ΑΚΥΡΟ</md-button><md-button \ndata-ng-click=\"$ctrl.submit()\" class=\"md-raised md-primary\">ΕΝΗΜΕΡΩΣΗ</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/scc/components/students-group/students-group-details.html","<carded-simple translation-scope=\"SCC.STUDENTS_GROUP\" svg-icon=\"students-group\" title=\"{{$ctrl.studentsGroup.name}}\">\n<md-nav-bar md-selected-nav-item=\"$ctrl.tab\"><md-nav-item md-nav-sref=\"app.scc.private.students-group.details\" \nname=\"generalInfo\"><span translate=\"SCC.STUDENTS_GROUP.GENERAL_INFO_TAB\"></span></md-nav-item><md-nav-item \nmd-nav-sref=\"app.scc.private.students-group.details\" name=\"teachingNeeds\"><span \ntranslate=\"SCC.STUDENTS_GROUP.TEACHING_NEEDS_TAB\"></span></md-nav-item></md-nav-bar><md-content class=\"md-padding\"><div\n ng-if=\"$ctrl.selectedTab == \'generalInfo\'\"><students-group-general-info students-group-id=\"$ctrl.studentsGroupId\" \ndirty=\"$ctrl.dirty\"></students-group-general-info><students-group-members students-group-id=\"$ctrl.studentsGroupId\">\n</students-group-members></div><div ng-if=\"$ctrl.selectedTab == \'teachingNeeds\'\"><students-group-teaching-needs \nstudents-group-id=\"$ctrl.studentsGroupId\" dirty=\"$ctrl.dirty\"></students-group-teaching-needs></div></md-content>\n</carded-simple>");
$templateCache.put("app/main/scc/components/students-group/students-group-general-info.html","<form name=\"form\"><h1 class=\"md-display-1\">Γενικές πληροφορίες<md-button class=\"md-icon-button\" \nng-if=\"!$ctrl.editable\" data-ng-click=\"$ctrl.startEditing()\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md_dark md-16\"/></md-button><md-button class=\"md-icon-button\" ng-if=\"$ctrl.editable\" \ndata-ng-click=\"$ctrl.save()\"><md-icon md-font-icon=\"icon-content-save\" class=\"md_dark md-16\"/></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"$ctrl.editable\" data-ng-click=\"$ctrl.cancelEditing()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"md_dark md-16\"/></md-button></h1><md-input-container class=\"md-block\" flex-gt-sm><label \nfor=\"studentsGroup.name\">Όνομα</label><input type=\"text\" name=\"studentsGroup.name\" \ndata-ng-model=\"$ctrl.studentsGroup.name\" ng-disabled=\"!$ctrl.editable\"/><errors-container \nerrors=\"form[\'studentsGroup.name\'].$error\"/></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label\n for=\"studentsGroup.shortName\">Σύντομο όνομα</label><input type=\"text\" name=\"studentsGroup.shortName\" \ndata-ng-model=\"$ctrl.studentsGroup.shortName\" ng-disabled=\"!$ctrl.editable\"/><errors-container \nerrors=\"form[\'studentsGroup.shortName\'].$error\"/></md-input-container></form>");
$templateCache.put("app/main/scc/components/students-group/students-group-list.html","<form name=\"form\"><carded-simple ng-if=\"!$ctrl.isDatasetSelected()\" translation-scope=\"SCC.STUDENTS_GROUP\" \nsvg-icon=\"students-group\" title=\"{{\'SCC.STUDENTS_GROUP.TITLE\' | translate}}\"><md-content class=\"md-padding\">\n{{\'SCC.STUDENTS_GROUP.NO_SELECTED_DATASET\' | translate}} <a class=\"link\" ui-sref=\"app.scc.private.data-set\" \ntranslate=\"SCC.STUDENTS_GROUP.SELECT_DATASET\">Choose dataset</a></md-content></carded-simple><carded-table \ntranslation-scope=\"SCC.STUDENTS_GROUP\" filter=\"$ctrl.dataTable.filter\" search-focused=\"$ctrl.dataTable.searchFocused\" \nrecords-number=\"$ctrl.getAllEntities().length\" svg-icon=\"students-group\" ng-if=\"$ctrl.isDatasetSelected()\">\n<form-errors-container form=\"form\" translation-scope=\"SCC.STUDENTS_GROUP.ERROR\"/><div ng-if=\"$mdMedia(\'gt-xs\')\">\n<md-table-container><table md-table md-row-select multiple ng-model=\"$ctrl.selectedEntities\"><thead md-head \nmd-order=\"$ctrl.dataTable.order\"><tr md-row><th md-column md-order-by=\"name\"><span translate=\"SCC.STUDENTS_GROUP.NAME\">\nName</span></th><th md-column><span translate=\"SCC.STUDENTS_GROUP.ACTIONS\">Actions</span></th></tr></thead><tbody \nmd-body><tr><td md-cell><md-button class=\"md-icon-button\" ng-if=\"$ctrl.selectedEntities.length\" \ndata-ng-click=\"$ctrl.deleteSelected($event)\"><md-icon md-font-icon=\"icon-delete\" class=\"md_dark md-24\"/></md-button>\n</td><td md-cell><md-input-container><input type=\"text\" name=\"studentsGroup.name\" \ndata-ng-model=\"$ctrl.studentsGroup.name\" scc-enter=\"$ctrl.createEntity()\"/><errors-container \nerrors=\"form[\'studentsGroup.name\'].$error\"/></md-input-container></td><td md-cell style=\"white-space: nowrap\"><a \nhref=\"#\" class=\"md-icon-button\" data-ng-click=\"$ctrl.createEntity()\"><md-icon md-font-icon=\"icon-plus-circle\" \nclass=\"s24\"></md-icon><span hide-sm hide-md>Δημιουργία</span> </a></td></tr><tr md-row md-select=\"studentsGroup\" \nmd-select-id=\"id\" \nng-repeat=\"studentsGroup in $ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | limitTo: $ctrl.dataTable.limit : $ctrl.dataTable.limit*($ctrl.dataTable.page-1)\n				          | filter: $ctrl.tableRowFilter([\'name\',\'shortName\'],$ctrl.dataTable.filter)\">\n<td md-cell scc-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{studentsGroup.name}}</td><td md-cell \nstyle=\"white-space: nowrap\"><a class=\"md-icon-button\" \nui-sref=\"app.scc.private.students-group.details({studentsGroupId: {{studentsGroup.id}}})\"><md-icon \nmd-font-icon=\"icon-view-list\" class=\"md_dark md-24\"/><span hide-sm hide-md>Περισσότερα</span> </a><a hide-md \nclass=\"md-icon-button\" \nui-sref=\"app.scc.private.students-group.details({studentsGroupId: {{studentsGroup.id}}, tab:\'teachingNeeds\'})\"><md-icon\n md-font-icon=\"icon-view-list\" class=\"md_dark md-24\"/><span hide-sm>Διδακτικές ανάγκες</span> </a><a href=\"#\" \nclass=\"md-icon-button\" data-ng-click=\"$ctrl.deleteEntity($event,studentsGroup)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md_dark md-24\"/><span hide-sm hide-md>Διαγραφή</span> </a></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"$ctrl.dataTable.limit\" md-limit-options=\"$ctrl.dataTable.limitOptions\" \nmd-page=\"$ctrl.dataTable.page\" md-label=\"{{paginationLabels}}\" md-total=\"{{$ctrl.getAllEntities().length}}\" \nmd-page-select md-boundary-links></md-table-pagination></div><div ng-if=\"!$mdMedia(\'gt-xs\')\" class=\"mobile-list\">\n<md-card class=\"mobile-create-card\" ng-hide=\"$ctrl.dataTable.searchFocused\"><md-card-content layout=\"column\">\n<md-input-container><label translate=\"SCC.STUDENTS_GROUP.NAME\">Name</label><input type=\"text\" \nname=\"studentsGroup.name\" data-ng-model=\"$ctrl.studentsGroup.name\" scc-enter=\"$ctrl.createEntity()\"/><errors-container \nerrors=\"form[\'studentsGroup.name\'].$error\"/></md-input-container><md-button class=\"md-accent md-raised\" \nng-click=\"$ctrl.createEntity()\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"s18\"></md-icon>Δημιουργία</md-button>\n</md-card-content></md-card><md-card class=\"mobile-entity-card\" \nng-repeat=\"studentsGroup in filteredStudentsGroups = ($ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | filter: $ctrl.tableRowFilter([\'name\',\'shortName\'],$ctrl.dataTable.filter))\" \nui-sref=\"app.scc.private.students-group.details({studentsGroupId: {{studentsGroup.id}}})\"><md-card-content \nlayout=\"row\" layout-align=\"start center\"><div flex layout=\"column\"><span class=\"mobile-entity-name\" \nscc-highlight-text=\"$ctrl.dataTable.filter\">{{studentsGroup.name}}</span></div><md-button class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.deleteEntity($event,studentsGroup); $event.stopPropagation();\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md_dark md-24\"></md-icon></md-button></md-card-content></md-card><div \nclass=\"mobile-no-results\" ng-if=\"$ctrl.dataTable.filter && filteredStudentsGroups.length === 0\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"s24\"></md-icon><span>Δεν βρέθηκαν αποτελέσματα</span></div></div></carded-table>\n</form>");
$templateCache.put("app/main/scc/components/students-group/students-group-members.html","<form name=\"form\"><h1 class=\"md-display-1\">Μαθητές μέλη</h1><form-errors-container form=\"form\" \ntranslation-scope=\"SCC.STUDENTS_GROUP.MEMBERS.ERROR\"/><div ng-if=\"$mdMedia(\'gt-xs\')\"><md-table-container><table \nmd-table md-row-select multiple ng-model=\"$ctrl.selectedEntities\"><thead md-head md-order=\"$ctrl.dataTable.order\"><tr \nmd-row><th md-column md-order-by=\"name\"><span translate=\"SCC.STUDENT.NAME\">Name</span></th><th md-column><span \ntranslate=\"SCC.STUDENT.ACTIONS\">Actions</span></th></tr></thead><tbody md-body><tr><td md-cell><md-button \nclass=\"md-icon-button\" ng-if=\"$ctrl.selectedEntities.length\" data-ng-click=\"$ctrl.deleteSelected($event)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md_dark md-24\"/></md-button></td><td md-cell><student-finder \nscc-enter=\"$ctrl.createEntity()\" student=\"$ctrl.student\" input-name=\"\'student\'\" errors=\"form[\'student\'].$error\">\n</student-finder></td><td md-cell><a class=\"md-icon-button\" href=\"#\" data-ng-click=\"$ctrl.createEntity()\"><md-icon \nmd-font-icon=\"icon-plus-circle\" class=\"s24\"></md-icon><span hide-sm hide-md>Προσθήκη</span> </a></td></tr><tr md-row \nmd-select=\"student\" md-select-id=\"id\" \nng-repeat=\"student in $ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | limitTo: $ctrl.dataTable.limit : $ctrl.dataTable.limit*($ctrl.dataTable.page-1)\n				          | filter: $ctrl.tableRowFilter([\'name\'],$ctrl.dataTable.filter)\">\n<td md-cell><a ui-sref=\"app.scc.private.student.details({studentId: {{student.id}}})\" \nscc-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{student.name}}</a></td><td md-cell \nstyle=\"white-space: nowrap\"><a href=\"#\" class=\"md-icon-button\" data-ng-click=\"$ctrl.deleteEntity($event,student)\">\n<md-icon md-font-icon=\"icon-delete\" class=\"md_dark md-24\"/><span hide-sm hide-md>Αφαίρεση</span> </a></td></tr></tbody>\n</table></md-table-container><md-table-pagination md-limit=\"$ctrl.dataTable.limit\" \nmd-limit-options=\"$ctrl.dataTable.limitOptions\" md-page=\"$ctrl.dataTable.page\" \nmd-label=\"{\n                     page: \'Σελίδα\',\n                     rowsPerPage: \'Γραμμές\',\n                     of: \'Από\'\n                 }\" \nmd-total=\"{{$ctrl.getAllEntities().length}}\" md-page-select md-boundary-links></md-table-pagination><div \nng-if=\"$ctrl.getAllEntities().length === 0\" class=\"empty-state-message\"><span>\nΤο τμήμα δεν έχει μαθητές μέλη. Χρησιμοποιήστε την αναζήτηση παραπάνω για να προσθέσετε μαθητές.</span></div></div><div\n ng-if=\"!$mdMedia(\'gt-xs\')\" class=\"mobile-list\"><md-card class=\"mobile-create-card\"><md-card-content layout=\"column\">\n<student-finder scc-enter=\"$ctrl.createEntity()\" student=\"$ctrl.student\" input-name=\"\'student\'\" \nerrors=\"form[\'student\'].$error\"></student-finder><md-button class=\"md-accent md-raised\" \nng-click=\"$ctrl.createEntity()\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"s18\"></md-icon>Προσθήκη</md-button>\n</md-card-content></md-card><md-card class=\"mobile-entity-card\" \nng-repeat=\"student in filteredMembers = ($ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | filter: $ctrl.tableRowFilter([\'name\'],$ctrl.dataTable.filter))\" \nui-sref=\"app.scc.private.student.details({studentId: {{student.id}}})\"><md-card-content layout=\"row\" \nlayout-align=\"start center\"><div flex layout=\"column\"><span class=\"mobile-entity-name\">{{student.name}}</span></div>\n<md-button class=\"md-icon-button\" data-ng-click=\"$ctrl.deleteEntity($event,student); $event.stopPropagation();\">\n<md-icon md-font-icon=\"icon-delete\" class=\"md_dark md-24\"></md-icon></md-button></md-card-content></md-card><md-card \nclass=\"mobile-entity-card\" ng-if=\"$ctrl.getAllEntities().length === 0\"><md-card-content class=\"mobile-no-results\">\n<span>Δεν υπάρχουν μαθητές μέλη.</span></md-card-content></md-card></div></form>");
$templateCache.put("app/main/scc/components/students-group/students-group-teaching-needs.html","<form name=\"form\"><md-table-container><table md-table md-row-select multiple ng-model=\"$ctrl.selectedEntities\"><thead \nmd-head md-order=\"$ctrl.dataTable.order\"><tr md-row><th md-column md-order-by=\"teacher\"><span \ntranslate=\"SCC.STUDENTS_GROUP.TEACHING_NEEDS.TEACHER\">Teacher</span></th><th md-column md-order-by=\"lesson\"><span \ntranslate=\"SCC.STUDENTS_GROUP.TEACHING_NEEDS.LESSON\">Lesson</span></th><th md-column md-order-by=\"classroom\"><span \ntranslate=\"SCC.STUDENTS_GROUP.TEACHING_NEEDS.CLASSROOM\">Classroom</span></th><th md-column \nmd-order-by=\"timeSlotsPerWeek\"><span translate=\"SCC.STUDENTS_GROUP.TEACHING_NEEDS.HOURS\">Hours</span></th><th \nmd-column><span translate=\"SCC.STUDENTS_GROUP.TEACHING_NEEDS.ACTIONS\">Actions</span></th></tr></thead><tbody md-body>\n<tr><td md-cell><md-button class=\"md-icon-button\" ng-if=\"$ctrl.selectedEntities.length\" \ndata-ng-click=\"$ctrl.deleteSelected($event)\"><md-icon md-font-icon=\"icon-delete\" class=\"md_dark md-24\"/></md-button>\n</td><td md-cell><md-autocomplete md-input-name=\"teachingNeed.teacher\" md-selected-item=\"$ctrl.teachingNeed.teacher\" \nmd-search-text=\"teachingNeed.teacherSearch\" \nmd-items=\"teacher in ($ctrl.getAllTeachers() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],teachingNeed.teacherSearch))\" \nmd-item-text=\"teacher.name\" md-floating-label=\"Καθηγητής\" md-min-length=\"0\" scc-enter=\"$ctrl.createEntity()\">\n<md-item-template><span md-highlight-text=\"teachingNeed.teacherSearch\" md-highlight-flags=\"^i\">{{teacher.name}}</span>\n</md-item-template><md-not-found>Δεν βρέθηκαν καθηγητές που να ταιριάζουν με \"{{teachingNeed.teacherSearch}}\". <a>\nΚαταχώρηση νέου!</a></md-not-found><errors-container errors=\"form[(\'teachingNeed.teacher\')].$error\"/></md-autocomplete>\n</td><td md-cell><md-autocomplete md-input-name=\"teachingNeed.lesson\" md-selected-item=\"$ctrl.teachingNeed.lesson\" \nmd-search-text=\"teachingNeed.lessonSearch\" \nmd-items=\"lesson in ($ctrl.getAllLessons() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],teachingNeed.lessonSearch))\" \nmd-item-text=\"lesson.name\" md-floating-label=\"Μάθημα\" md-min-length=\"0\" scc-enter=\"$ctrl.createEntity()\">\n<md-item-template><span md-highlight-text=\"teachingNeed.lessonSearch\" md-highlight-flags=\"^i\">{{lesson.name}}</span>\n</md-item-template><md-not-found>Δεν βρέθηκαν μαθήματα που να ταιριάζουν με \"{{teachingNeed.lessonSearch}}\". <a>\nΚαταχώρηση νέου!</a></md-not-found><errors-container errors=\"form[\'teachingNeed.lesson\'].$error\"/></md-autocomplete>\n</td><td md-cell><md-autocomplete md-input-name=\"teachingNeed.classroom\" \nmd-selected-item=\"$ctrl.teachingNeed.classroom\" md-search-text=\"teachingNeed.classroomSearch\" \nmd-items=\"classroom in ($ctrl.getAllClassrooms() | filter:$ctrl.tableRowFilter([\'name\',\'shortName\'],teachingNeed.classroomSearch))\" \nmd-item-text=\"classroom.name\" md-floating-label=\"Αίθουσα\" md-min-length=\"0\" scc-enter=\"$ctrl.createEntity()\">\n<md-item-template><span md-highlight-text=\"teachingNeed.classroomSearch\" md-highlight-flags=\"^i\">{{classroom.name}}\n</span></md-item-template><md-not-found>Δεν βρέθηκαν αίθουσες που να ταιριάζουν με \"{{teachingNeed.classroomSearch}}\". \n<a>Καταχώρηση νέας!</a></md-not-found><errors-container errors=\"form[\'teachingNeed.classroom\'].$error\"/>\n</md-autocomplete></td><td md-cell><duration-picker ng-model=\"$ctrl.teachingNeed.timeSlotsPerWeek\" \nname=\"teachingNeed.timeSlotsPerWeek\" errors=\"form[\'teachingNeed.timeSlotsPerWeek\'].$error\"></duration-picker></td><td \nmd-cell style=\"padding-bottom: 15px\"><a href=\"#\" class=\"md-icon-button\" data-ng-click=\"$ctrl.createEntity()\"><md-icon \nmd-font-icon=\"icon-plus-circle\" class=\"s24\"></md-icon>Προσθήκη </a><a href=\"#\" class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.showCopyFromOtherGroupDialog()\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s24\"></md-icon>\nΑντιγραφή από άλλο τμήμα </a></td></tr><tr md-row md-select=\"teachingNeed\" md-select-id=\"id\" \nng-repeat=\"teachingNeed in $ctrl.getAllEntities()\n                          | orderBy: $ctrl.dataTable.order\n                          | limitTo: $ctrl.dataTable.limit : $ctrl.dataTable.limit*($ctrl.dataTable.page-1)\n                          | filter: $ctrl.tableRowFilter([\'name\',\'shortName\'],$ctrl.dataTable.filter)\">\n<td md-cell md-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{teachingNeed.teacher.name}}</td><td \nmd-cell md-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{teachingNeed.lesson.name}}</td><td md-cell \nmd-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{teachingNeed.classroom.name}}</td><td md-cell>\n<duration-picker ng-model=\"teachingNeed.timeSlotsPerWeek\" min-slots=\"0\" max-slots=\"288\" max-hours=\"24\" required \nreadonly></duration-picker></td><td md-cell><a href=\"#\" class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.showEditPanel($event,teachingNeed)\"><md-icon md-font-icon=\"icon-pencil\" class=\"md_dark md-24\"/>\nΕπεξεργασία</a> <a href=\"#\" class=\"md-icon-button\" data-ng-click=\"$ctrl.deleteEntity($event,teachingNeed)\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"md_dark md-24\"/>Διαγραφή </a></td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"$ctrl.dataTable.limit\" md-limit-options=\"$ctrl.dataTable.limitOptions\" \nmd-page=\"$ctrl.dataTable.page\" \nmd-label=\"{\n                     page: \'Σελίδα\',\n                     rowsPerPage: \'Γραμμές\',\n                     of: \'Από\'\n                 }\" \nmd-total=\"{{$ctrl.getAllEntities().length}}\" md-page-select md-boundary-links></md-table-pagination></form>");
$templateCache.put("app/main/scc/components/teacher/confirm-payment-dialog.html","<md-dialog aria-label=\"Πληρωμή (Καθηγητης) - (Ημερομηνία)\"><form name=\"form\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Πληρωμή</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n<md-icon md-font-icon=\"icon-close\"/></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<div ng-if=\"$ctrl.precalculation.canBeNormalized\"><span \ntranslate=\"SCC.TEACHER.SALARY.PAYMENT_DIALOG.NORMALIZATION_ELIGIBLE\"></span><md-switch \nng-model=\"$ctrl.req.normalizePayments\">{{$ctrl.req.normalizePayments?\"SCC.YES\":\"SCC.NO\" | translate}}</md-switch></div>\n<p>{{\"SCC.TEACHER.SALARY.PAYMENT_DIALOG.TOTAL_AMOUNT\" | translate}}: {{$ctrl.req.communicatedSum}}</p></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><md-button data-ng-click=\"$ctrl.close()\" \nclass=\"md-raised md-primary\">ΑΚΥΡΟ</md-button><md-button data-ng-click=\"$ctrl.submit()\" class=\"md-raised md-primary\">\nΠΛΗΡΩΜΗ</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/scc/components/teacher/edit-payment-dialog.html","<md-dialog aria-label=\"Πληρωμή (Καθηγητης) - (Ημερομηνία)\"><form name=\"form\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Πληρωμή</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n<md-icon md-font-icon=\"icon-close\"/></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\">\n<md-input-container class=\"md-block\" flex-gt-sm><label for=\"payment.amount\">Ποσό ωφειλής</label><input type=\"number\" \nname=\"payment.amount\" data-ng-model=\"$ctrl.payment.amount\"/><errors-container errors=\"form[\'payment.amount\'].$error\"/>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label for=\"payment.paidAmount\">Εξοφλημένο ποσό\n</label><input type=\"number\" name=\"payment.paidAmount\" data-ng-model=\"$ctrl.payment.paidAmount\"/><errors-container \nerrors=\"form[\'payment.paidAmount\'].$error\"/></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label\n for=\"payent.comments\">Σχόλια</label><input type=\"text\" name=\"payent.comments\" data-ng-model=\"$ctrl.payent.comments\"/>\n<errors-container errors=\"form[\'payent.comments\'].$error\"/></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button data-ng-click=\"$ctrl.close()\" class=\"md-raised md-primary\">ΑΚΥΡΟ</md-button>\n<md-button data-ng-click=\"$ctrl.submit()\" class=\"md-raised md-primary\">ΕΝΗΜΕΡΩΣΗ</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/scc/components/teacher/edit-teacher-dialog.html","<md-dialog aria-label=\"Καθηγητής {{$ctrl.oldTeacherName}}\"><form name=\"form\" ng-cloak><md-toolbar><div \nclass=\"md-toolbar-tools\"><h2>Καθηγητής {{$ctrl.oldTeacherName}}</h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"$ctrl.close()\"><md-icon md-font-icon=\"icon-close\"/></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\"><md-input-container class=\"md-block\" flex-gt-sm><label \nfor=\"teacher.name\">Όνομα</label><input type=\"text\" name=\"teacher.name\" data-ng-model=\"$ctrl.teacher.name\"/>\n<errors-container errors=\"form[\'teacher.name\'].$error\"/></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label for=\"teacher.shortName\">Σύντομο όνομα</label><input type=\"text\" name=\"teacher.shortName\" \ndata-ng-model=\"$ctrl.teacher.shortName\"/><errors-container errors=\"form[\'teacher.shortName\'].$error\"/>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label for=\"teacher.email\">Email</label><input \ntype=\"text\" name=\"teacher.email\" data-ng-model=\"$ctrl.teacher.email\"/><errors-container \nerrors=\"form[\'teacher.email\'].$error\"/></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button data-ng-click=\"$ctrl.close()\" class=\"md-raised md-primary\">ΑΚΥΡΟ</md-button><md-button \ndata-ng-click=\"$ctrl.submit()\" class=\"md-raised md-primary\">ΕΝΗΜΕΡΩΣΗ</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/scc/components/teacher/teacher-details.html","<carded-simple translation-scope=\"SCC.TEACHER\" svg-icon=\"teacher\" title=\"{{$ctrl.teacher.name}}\"><md-nav-bar \nmd-selected-nav-item=\"$ctrl.tab\"><md-nav-item md-nav-sref=\"app.scc.private.teacher.details\" name=\"generalInfo\"><span \ntranslate=\"SCC.TEACHER.GENERAL_INFO_TAB\"></span></md-nav-item><md-nav-item \nmd-nav-sref=\"app.scc.private.teacher.details\" name=\"salaryInfo\"><span translate=\"SCC.TEACHER.SALARY_DETAILS_TAB\">\n</span></md-nav-item><md-nav-item md-nav-sref=\"app.scc.private.teacher.details\" name=\"availability\"><span \ntranslate=\"SCC.TEACHER.AVAILABILITY_TAB\"></span></md-nav-item></md-nav-bar><md-content class=\"md-padding\"><div \nng-if=\"$ctrl.selectedTab == \'generalInfo\'\"><teacher-general-info teacher-id=\"$ctrl.teacherId\" dirty=\"$ctrl.dirty\">\n</teacher-general-info></div><div ng-if=\"$ctrl.selectedTab == \'salaryInfo\'\"><teacher-salary-info \nteacher-id=\"$ctrl.teacherId\" dirty=\"$ctrl.dirty\"></teacher-salary-info><teacher-payments teacher-id=\"$ctrl.teacherId\">\n</teacher-payments></div><div ng-if=\"$ctrl.selectedTab == \'availability\'\"><scc-availability entity-type=\"\'teacher\'\" \nentity-id=\"$ctrl.teacherId\" selected-data-set=\"$ctrl.getSelectedDataSet()\"></scc-availability></div></md-content>\n</carded-simple>");
$templateCache.put("app/main/scc/components/teacher/teacher-general-info.html","<form name=\"form\"><h1 class=\"md-display-1\">Γενικές πληροφορίες<md-button class=\"md-icon-button\" \nng-if=\"!$ctrl.editable\" data-ng-click=\"$ctrl.startEditing()\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md_dark md-16\"/></md-button><md-button class=\"md-icon-button\" ng-if=\"$ctrl.editable\" \ndata-ng-click=\"$ctrl.save()\"><md-icon md-font-icon=\"icon-content-save\" class=\"md_dark md-16\"/></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"$ctrl.editable\" data-ng-click=\"$ctrl.cancelEditing()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"md_dark md-16\"/></md-button></h1><md-input-container class=\"md-block\" flex-gt-sm><label for=\"teacher.name\">Όνομα\n</label><input type=\"text\" name=\"teacher.name\" data-ng-model=\"$ctrl.teacher.name\" ng-disabled=\"!$ctrl.editable\"/>\n<errors-container errors=\"form[\'teacher.name\'].$error\"/></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label for=\"teacher.email\">Email</label><input type=\"text\" name=\"teacher.email\" \ndata-ng-model=\"$ctrl.teacher.email\" ng-disabled=\"!$ctrl.editable\"/><errors-container \nerrors=\"form[\'teacher.email\'].$error\"/></md-input-container></form>");
$templateCache.put("app/main/scc/components/teacher/teacher-list.html","<form name=\"form\"><carded-table translation-scope=\"SCC.TEACHER\" filter=\"$ctrl.dataTable.filter\" \nsearch-focused=\"$ctrl.dataTable.searchFocused\" records-number=\"$ctrl.getAllEntities().length\" svg-icon=\"teacher\">\n<form-errors-container form=\"form\" translation-scope=\"SCC.TEACHER.ERROR\"/><div ng-if=\"$mdMedia(\'gt-xs\')\">\n<md-table-container><table md-table md-row-select multiple ng-model=\"$ctrl.selectedEntities\"><thead md-head \nmd-order=\"$ctrl.dataTable.order\"><tr md-row><th md-column md-order-by=\"name\"><span translate=\"SCC.TEACHER.NAME\">Name\n</span></th><th md-column md-order-by=\"maxHoursPerWeek\"><span translate=\"SCC.TEACHER.EMAIL\">Email</span></th><th \nmd-column><span translate=\"SCC.TEACHER.ACTIONS\">Actions</span></th></tr></thead><tbody md-body><tr><td md-cell>\n<md-button class=\"md-icon-button\" ng-if=\"$ctrl.selectedEntities.length\" data-ng-click=\"$ctrl.deleteSelected($event)\">\n<md-icon md-font-icon=\"icon-delete\" class=\"md_dark md-24\"/></md-button></td><td md-cell><md-input-container><input \ntype=\"text\" name=\"teacher.name\" data-ng-model=\"$ctrl.teacher.name\" scc-enter=\"$ctrl.createEntity()\"/><errors-container \nerrors=\"form[\'teacher.name\'].$error\"/></md-input-container></td><td md-cell><md-input-container><input type=\"text\" \nname=\"teacher.email\" data-ng-model=\"$ctrl.teacher.email\" scc-enter=\"$ctrl.createEntity()\"/><errors-container \nerrors=\"form[\'teacher.email\'].$error\"/></md-input-container></td><td md-cell style=\"white-space: nowrap\"><a href=\"#\" \nclass=\"md-icon-button\" data-ng-click=\"$ctrl.createEntity()\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"s24\">\n</md-icon><span hide-sm hide-md>Δημιουργία</span> </a></td></tr><tr md-row md-select=\"teacher\" md-select-id=\"id\" \nng-repeat=\"teacher in $ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | limitTo: $ctrl.dataTable.limit : $ctrl.dataTable.limit*($ctrl.dataTable.page-1)\n				          | filter: $ctrl.tableRowFilter([\'name\',\'shortName\',\'maxHoursPerWeek\'],$ctrl.dataTable.filter)\">\n<td md-cell scc-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{teacher.name}}</td><td md-cell \nscc-highlight-text=\"$ctrl.dataTable.filter\" md-highlight-flags=\"i\">{{teacher.email}}</td><td md-cell \nstyle=\"white-space: nowrap\"><a class=\"md-icon-button\" \nui-sref=\"app.scc.private.teacher.details({teacherId: {{teacher.id}}})\"><md-icon md-font-icon=\"icon-view-list\" \nclass=\"md_dark md-24\"/><span hide-sm hide-md>Περισσότερα</span> </a><a class=\"md-icon-button\" href=\"#\" \ndata-ng-click=\"$ctrl.deleteEntity($event,teacher)\"><md-icon md-font-icon=\"icon-delete\" class=\"md_dark md-24\"/><span \nhide-sm hide-md>Διαγραφή</span></a></td></tr></tbody></table></md-table-container><md-table-pagination \nmd-limit=\"$ctrl.dataTable.limit\" md-limit-options=\"$ctrl.dataTable.limitOptions\" md-page=\"$ctrl.dataTable.page\" \nmd-label=\"{{paginationLabels}}\" md-total=\"{{$ctrl.getAllEntities().length}}\" md-page-select md-boundary-links>\n</md-table-pagination></div><div ng-if=\"!$mdMedia(\'gt-xs\')\" class=\"mobile-list\"><md-card class=\"mobile-create-card\" \nng-hide=\"$ctrl.dataTable.searchFocused\"><md-card-content layout=\"column\"><md-input-container><label \ntranslate=\"SCC.TEACHER.NAME\">Name</label><input type=\"text\" name=\"teacher.name\" data-ng-model=\"$ctrl.teacher.name\" \nscc-enter=\"$ctrl.createEntity()\"/><errors-container errors=\"form[\'teacher.name\'].$error\"/></md-input-container>\n<md-input-container><label translate=\"SCC.TEACHER.EMAIL\">Email</label><input type=\"text\" name=\"teacher.email\" \ndata-ng-model=\"$ctrl.teacher.email\" scc-enter=\"$ctrl.createEntity()\"/><errors-container \nerrors=\"form[\'teacher.email\'].$error\"/></md-input-container><md-button class=\"md-accent md-raised\" \nng-click=\"$ctrl.createEntity()\"><md-icon md-font-icon=\"icon-plus-circle\" class=\"s18\"></md-icon>Δημιουργία</md-button>\n</md-card-content></md-card><md-card class=\"mobile-entity-card\" \nng-repeat=\"teacher in filteredTeachers = ($ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | filter: $ctrl.tableRowFilter([\'name\',\'shortName\',\'maxHoursPerWeek\'],$ctrl.dataTable.filter))\" \nui-sref=\"app.scc.private.teacher.details({teacherId: {{teacher.id}}})\"><md-card-content layout=\"row\" \nlayout-align=\"start center\"><div flex layout=\"column\"><span class=\"mobile-entity-name\" \nscc-highlight-text=\"$ctrl.dataTable.filter\">{{teacher.name}}</span> <span class=\"mobile-entity-detail\" \nscc-highlight-text=\"$ctrl.dataTable.filter\">{{teacher.email}}</span></div><md-button class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.deleteEntity($event,teacher); $event.stopPropagation();\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md_dark md-24\"></md-icon></md-button></md-card-content></md-card><div class=\"mobile-no-results\" \nng-if=\"$ctrl.dataTable.filter && filteredTeachers.length === 0\"><md-icon md-font-icon=\"icon-magnify\" class=\"s24\">\n</md-icon><span>Δεν βρέθηκαν αποτελέσματα</span></div></div></carded-table></form>");
$templateCache.put("app/main/scc/components/teacher/teacher-payments.html","<h1 class=\"md-display-1\"><span translate=\"SCC.TEACHER.PAYMENT.TITLE\">Teacher Payments</span></h1><div \nng-if=\"$ctrl.proEntitled === false\" layout=\"column\" layout-align=\"center center\" style=\"padding: 48px 16px\"><md-icon \nmd-font-icon=\"icon-lock\" style=\"font-size: 48px; height: 48px; width: 48px; color: #999; margin-bottom: 16px\">\n</md-icon><h2 class=\"md-title\" style=\"margin-bottom: 8px\">School on Cloud Pro</h2><p \nstyle=\"color: #666; text-align: center; max-width: 400px; margin-bottom: 24px\">\nΓια τη διαχείριση πληρωμών μισθοδοσίας απαιτείται συνδρομή στο School on Cloud Pro.</p><md-button \nclass=\"md-raised md-primary\" ng-click=\"$ctrl.showPaywall()\">Αναβάθμιση σε Pro</md-button></div><div \nng-if=\"$ctrl.proEntitled === true && $mdMedia(\'gt-xs\')\"><md-table-container ng-if=\"$ctrl.getAllEntities().length > 0\">\n<table md-table md-row-select multiple ng-model=\"$ctrl.selectedEntities\"><thead md-head \nmd-order=\"$ctrl.dataTable.order\"><tr md-row><th md-column md-order-by=\"fromDate\"><span \ntranslate=\"SCC.TEACHER.PAYMENT.FROM_DATE\">Name</span></th><th md-column md-order-by=\"toDate\"><span \ntranslate=\"SCC.TEACHER.PAYMENT.TO_DATE\">Name</span></th><th md-column md-order-by=\"lastUpdateDate\"><span \ntranslate=\"SCC.TEACHER.PAYMENT.LAST_UPDATE_DATE\">Name</span></th><th md-column md-order-by=\"amount\"><span \ntranslate=\"SCC.TEACHER.PAYMENT.AMOUNT\">Amount</span></th><th md-column md-order-by=\"paidAmount\"><span \ntranslate=\"SCC.TEACHER.PAYMENT.PAID_AMOUNT\">Paid Amount</span></th><th md-column><span translate=\"SCC.TEACHER.ACTIONS\">\nActions</span></th></tr></thead><tbody md-body><tr><td md-cell><md-button class=\"md-icon-button\" \nng-if=\"$ctrl.selectedEntities.length\" data-ng-click=\"$ctrl.deleteSelected($event)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"md_dark md-24\"/></md-button></td><td md-cell><md-button class=\"md-icon-button\" \nng-if=\"$ctrl.selectedEntities.length\" data-ng-click=\"$ctrl.showPaymentDialog($event)\"><md-icon \nmd-font-icon=\"icon-credit-card\" class=\"md_dark md-24\"/></md-button></td><td md-cell></td><td md-cell></td><td md-cell>\n</td><td md-cell></td></tr><tr md-row md-select=\"entity\" md-select-id=\"id\" \nng-class=\"{\'fulfilledPayment\':(entity.paidAmount >= entity.amount), \'unfulfilledPayment\':(entity.paidAmount < entity.amount)}\" \nng-repeat=\"entity in $ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | limitTo: $ctrl.dataTable.limit : $ctrl.dataTable.limit*($ctrl.dataTable.page-1)\n				          | filter: $ctrl.tableRowFilter([\'fromDate\',\'toDate\',\'lastUpdateDate\',\'amount\',\'paidAmount\'],$ctrl.dataTable.filter)\">\n<td md-cell>{{entity.fromDate}}</td><td md-cell>{{entity.toDate}}</td><td md-cell>{{entity.lastUpdateDate}}</td><td \nmd-cell>{{entity.amount}}</td><td md-cell>{{entity.paidAmount}}</td><td md-cell style=\"white-space: nowrap\"><md-button \nclass=\"md-icon-button\" data-ng-click=\"$ctrl.showEditPanel($event,entity)\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"md_dark md-24\"/></md-button><md-button class=\"md-icon-button\" data-ng-click=\"$ctrl.pay($event,entity)\"><md-icon \nmd-font-icon=\"icon-credit-card\" class=\"md_dark md-24\"/></md-button></td></tr></tbody></table></md-table-container>\n<md-table-pagination ng-if=\"$ctrl.getAllEntities().length > 0\" md-limit=\"$ctrl.dataTable.limit\" \nmd-limit-options=\"$ctrl.dataTable.limitOptions\" md-page=\"$ctrl.dataTable.page\" \nmd-total=\"{{$ctrl.getAllEntities().length}}\" md-page-select md-boundary-links></md-table-pagination><div \nng-if=\"$ctrl.getAllEntities().length === 0\" class=\"empty-state-message\"><span translate=\"SCC.TEACHER.NO_PAYMENTS\">\nNo payments</span></div></div><div ng-if=\"$ctrl.proEntitled === true && !$mdMedia(\'gt-xs\')\" class=\"mobile-list\">\n<md-card class=\"mobile-entity-card\" \nng-class=\"{\'fulfilledPayment\':(entity.paidAmount >= entity.amount), \'unfulfilledPayment\':(entity.paidAmount < entity.amount)}\" \nng-repeat=\"entity in $ctrl.getAllEntities()\n				          | orderBy: $ctrl.dataTable.order\n				          | filter: $ctrl.tableRowFilter([\'fromDate\',\'toDate\',\'lastUpdateDate\',\'amount\',\'paidAmount\'],$ctrl.dataTable.filter)\" \nng-click=\"$ctrl.showEditPanel($event,entity)\"><md-card-content layout=\"row\" layout-align=\"start center\"><div flex \nlayout=\"column\"><span class=\"mobile-entity-name\">{{entity.fromDate}} - {{entity.toDate}}</span><div layout=\"row\" \nlayout-align=\"start center\" style=\"margin-top: 4px\"><div layout=\"column\" flex><span class=\"mobile-entity-detail\" \ntranslate=\"SCC.TEACHER.PAYMENT.AMOUNT\">Amount</span> <span class=\"mobile-entity-name\" style=\"font-weight: bold\">\n{{entity.amount}}€</span></div><div layout=\"column\" flex><span class=\"mobile-entity-detail\" \ntranslate=\"SCC.TEACHER.PAYMENT.PAID_AMOUNT\">Paid Amount</span> <span class=\"mobile-entity-name\" \nstyle=\"font-weight: bold\">{{entity.paidAmount}}€</span></div></div></div><md-button class=\"md-icon-button\" \ndata-ng-click=\"$ctrl.pay($event,entity); $event.stopPropagation();\"><md-icon md-font-icon=\"icon-credit-card\" \nclass=\"md_dark md-24\"></md-icon></md-button></md-card-content></md-card><md-card class=\"mobile-entity-card\" \nng-if=\"$ctrl.getAllEntities().length === 0\"><md-card-content class=\"mobile-no-results\"><span \ntranslate=\"SCC.TEACHER.NO_PAYMENTS\">No payments</span></md-card-content></md-card></div>");
$templateCache.put("app/main/scc/components/teacher/teacher-salary-info.html","<form name=\"form\"><h1 class=\"md-display-1\"><span translate=\"SCC.TEACHER.SALARY.TITLE\">Salary details</span><md-button \nclass=\"md-icon-button\" ng-if=\"!$ctrl.editable\" data-ng-click=\"$ctrl.startEditing()\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"md_dark md-16\"/></md-button><md-button class=\"md-icon-button\" ng-if=\"$ctrl.editable\" \ndata-ng-click=\"$ctrl.save()\"><md-icon md-font-icon=\"icon-content-save\" class=\"md_dark md-16\"/></md-button><md-button \nclass=\"md-icon-button\" ng-if=\"$ctrl.editable\" data-ng-click=\"$ctrl.cancelEditing()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"md_dark md-16\"/></md-button></h1><div ng-repeat=\"agreement in $ctrl.salaryAgreements\" layout=\"row\" \nlayout-xs=\"column\"><md-input-container class=\"md-block\" flex><label for=\"agreements[{{$index}}].salaryType\" \ntranslate=\"SCC.TEACHER.SALARY.TYPE\"></label><md-select name=\"agreements[{{$index}}].salaryType\" \nng-model=\"agreement.salaryType\" ng-disabled=\"!$ctrl.editable\"><md-option ng-value=\"\'HOURLY\'\" \ntranslate=\"SCC.TEACHER.SALARY.HOURLY\">Hourly</md-option><md-option ng-value=\"\'MONTHLY\'\" \ntranslate=\"SCC.TEACHER.SALARY.MONTHLY\">Monthly</md-option></md-select><errors-container \nerrors=\"form[(\'agreements[\'+$parent.$index+\'].salaryType\')].$error\"/></md-input-container><md-input-container \nclass=\"md-block\" flex><label for=\"agreements[{{$index}}].amount\"><span ng-if=\"agreement.salaryType == \'MONTHLY\'\" \ntranslate=\"SCC.TEACHER.SALARY.MONTHLY_SALARY\"></span> <span ng-if=\"agreement.salaryType == \'HOURLY\'\" \ntranslate=\"SCC.TEACHER.SALARY.HOURLY_SALARY\"></span></label><input type=\"number\" name=\"agreements[{{$index}}].amount\" \ndata-ng-model=\"agreement.amount\" ng-disabled=\"!$ctrl.editable\"/><errors-container \nerrors=\"form[(\'agreements[\'+$parent.$index+\'].amount\')].$error\"/></md-input-container></div></form>");
$templateCache.put("app/main/scc/page-templates/carded-simple/carded-simple.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div \nclass=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"{{$ctrl.icon}}\" ng-if=\"$ctrl.icon\">\n</md-icon><md-icon md-svg-src=\"assets/icons/svg/{{$ctrl.svgIcon}}.svg\" ng-if=\"$ctrl.svgIcon\"></md-icon><span \nclass=\"h2 white-fg\">{{$ctrl.title}}</span></div></div></div><div class=\"content-card\"><ng-transclude></ng-transclude>\n</div></div></div>");
$templateCache.put("app/main/scc/page-templates/carded-table/carded-table.html","<div class=\"page-layout carded fullwidth carded-table\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div class=\"white-fg\" \nlayout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{$ctrl.icon}}\" ng-if=\"$ctrl.icon\"></md-icon><md-icon \nmd-svg-src=\"assets/icons/svg/{{$ctrl.svgIcon}}.svg\" ng-if=\"$ctrl.svgIcon\"></md-icon><span \ntranslate=\"{{$ctrl.translationScope}}.TITLE\">Data Sets</span></div><div class=\"order-count secondary-text\"><span \ntranslate=\"{{$ctrl.translationScope}}.NUMBER\">Datasets Number</span>: <span>{{$ctrl.recordsNumber}}</span></div></div>\n<div class=\"search\" layout=\"row\" layout-align=\"start center\" flex><md-icon md-font-icon=\"icon-magnify\" \nclass=\"white-text icon search-icon\"></md-icon><input id=\"e-commerce-products-search\" class=\"search-input\" \ntype=\"search\" placeholder=\"Search\" ng-model=\"$ctrl.filter\" ng-focus=\"$ctrl.searchFocused = true\" \nng-blur=\"$ctrl.searchFocused = false\" translate \ntranslate-attr-placeholder=\"{{$ctrl.translationScope}}.SEARCH_PLACEHOLDER\" flex></div></div><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"simple-table-container md-whiteframe-4dp\"><ng-transclude></ng-transclude></div></div>\n</div></div>");
$templateCache.put("app/main/scc/page-templates/simple-page/simple-page.html","<div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>Content toolbar</span>\n</div><md-content class=\"content\" ms-scroll><ng-transclude></ng-transclude></md-content></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/apps/chat/sidenavs/left/left-sidenav.html","<div ng-show=\"vm.leftSidenavView === \'contacts\'\" class=\"view contacts-view animate-slide-left\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html\'\" layout=\"column\" flex></div><div \nng-show=\"vm.leftSidenavView ===\'user\'\" class=\"view user-view animate-slide-left\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/user/user-view.html\'\" layout=\"column\" flex></div><div \nng-hide=\"vm.leftSidenavView\" class=\"view chats-view animate-slide-right\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/chats/chats-view.html\'\" layout=\"column\" flex></div>");
$templateCache.put("app/main/apps/chat/sidenavs/right/right-sidenav.html","<div class=\"view contact-view\" ng-include=\"\'app/main/apps/chat/sidenavs/right/views/contact/contact-view.html\'\" \nlayout=\"column\" flex></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/scc/components/notes/directives/ms-new-note/ms-new-note.html","<ms-note-form note-type=\"\'new\'\"></ms-note-form><div ms-new-note-button class=\"new-note-button\"><span \ntranslate=\"NOTES.TAKE_A_NOTE\">Take a note..</span></div>");
$templateCache.put("app/main/scc/components/notes/directives/ms-note-form/ms-note-form.html","<form ng-submit=\"MsNoteForm.submit()\" ng-class=\"MsNoteForm.note.color\"><div ng-if=\"MsNoteForm.note.image\" \nclass=\"image-wrapper\"><img class=\"md-card-image\" ng-src=\"{{MsNoteForm.note.image}}\"><md-button \nclass=\"md-fab md-mini delete-image-button\" ng-click=\"MsNoteForm.deleteImage()\" aria-label=\"delete image\" translate \ntranslate-attr-aria-label=\"NOTES.DELETE_IMAGE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><input \ntype=\"text\" class=\"note-title-input\" placeholder=\"Title\" ng-model=\"MsNoteForm.note.title\" \nng-class=\"MsNoteForm.note.color\"><md-input-container md-no-float ng-class=\"MsNoteForm.note.color\"><textarea \ntype=\"text\" class=\"note-description-textarea\" placeholder=\"Take a note..\" translate \ntranslate-attr-placeholder=\"NOTES.TAKE_A_NOTE\" ng-model=\"MsNoteForm.note.description\">\n    </textarea>\n</md-input-container><md-list class=\"checklist\" ng-if=\"MsNoteForm.note.checklist.length > 0\"><md-divider></md-divider>\n<md-list-item ng-repeat=\"item in MsNoteForm.note.checklist\"><md-checkbox ng-model=\"item.checked\" \naria-label=\"toggle check\"></md-checkbox><p ng-class=\"{\'text-strike md-secondary-text\':item.checked}\">{{item.text}}</p>\n<md-icon ng-click=\"$event.preventDefault();$event.stopPropagation();MsNoteForm.deleteCheckItem(item)\" \nclass=\"md-secondary\" md-font-icon=\"icon-close-circle\" aria-label=\"remove\"></md-icon><md-divider></md-divider>\n</md-list-item></md-list><div class=\"checklist-form\" \nng-if=\"MsNoteForm.note.checklist.length > 0 || MsNoteForm.checkListForm\" layout=\"row\" layout-align=\"space-between end\">\n<md-input-container class=\"\" md-no-float flex><input id=\"new-checklist-item-input\" type=\"text\" placeholder=\"List item\" \nng-model=\"MsNoteForm.newCheckListItem\" \nng-keydown=\"$event.keyCode === 13 ? $event.preventDefault() + MsNoteForm.addChecklistItem():\'\';\"></md-input-container>\n<md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.addChecklistItem()\" aria-label=\"add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"labels\" ng-if=\"MsNoteForm.note.labels.length > 0\" \nlayout=\"row\" layout-wrap layout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteForm.note.labels\" \nng-class=\"MsNoteForm.labels.getById(labelId).color\">{{MsNoteForm.labels.getById(labelId).name}}</div></div><div \nng-if=\"MsNoteForm.type ===\'edit\'\" class=\"date text-right p-16\">{{MsNoteForm.note.time | altDate}}</div><div \nclass=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"actions\" layout=\"row\" layout-align=\"center center\"><div id=\"image-uploader\" \nflow-init=\"MsNoteForm.ngFlowOptions\" flow-name=\"MsNoteForm.ngFlow.flow\" flow-files-submitted=\"MsNoteForm.upload()\" \nflow-file-success=\"MsNoteForm.imageSuccess($file, $message)\" flow-complete=\"MsNoteForm.uploadComplete()\" \nflow-file-added=\"!!{svg:1,png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()]\"><md-button flow-btn \nclass=\"add-img-button md-icon-button\" aria-label=\"Add image\" translate translate-attr-aria-label=\"NOTES.ADD_IMAGE\">\n<md-icon md-font-icon=\"icon-file-image-box\" class=\"s20\"></md-icon></md-button></div><md-button class=\"md-icon-button\" \naria-label=\"checklist\" ng-click=\"MsNoteForm.checklistFormToggle()\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked\" class=\"s20\"></md-icon></md-button><md-menu class=\"label-menu\"><md-button \nclass=\"md-icon-button\" aria-label=\"Label\" translate translate-attr-aria-label=\"NOTES.LABEL\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-label\" class=\"s20\"></md-icon></md-button>\n<md-menu-content class=\"notes-labels-menu-content\" width=\"4\" ms-scroll><md-menu-item><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Search labels...\" type=\"text\" \nng-model=\"MsNoteForm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"NOTES.SEARCH_LABELS\">\n</md-input-container></md-menu-item><md-menu-item class=\"label\" \nng-repeat=\"label in MsNoteForm.labels | filter: MsNoteForm.labelSearchText\"><md-button class=\"label-toggle-button\" \nmd-prevent-menu-close ng-class=\"label.color\" ng-click=\"MsNoteForm.toggleInArray(label.id, MsNoteForm.note.labels)\" \naria-label=\"Toggle Label\" translate translate-attr-aria-label=\"NOTES.TOGGLE_LABEL\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span>{{label.name}}</span> <i \nng-if=\"MsNoteForm.exists(label.id, MsNoteForm.note.labels)\" class=\"icon-check s16\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.toggleArchive()\" \naria-label=\"archive\"><md-icon md-font-icon=\"icon-archive\" class=\"s20\"></md-icon></md-button><ms-material-color-picker \nng-model=\"MsNoteForm.note.color\"><md-button class=\"md-icon-button\" aria-label=\"color\"><md-icon \nmd-font-icon=\"icon-palette\" class=\"s20\"></md-icon></md-button></ms-material-color-picker><md-datepicker \nclass=\"reminder\" ng-model=\"MsNoteForm.note.reminder\" md-placeholder=\"Προσθήκη υπενθύμισης\" ms-datepicker-fix>\n</md-datepicker></div><div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" \nng-click=\"MsNoteForm.deleteNote()\" class=\"md-icon-button\" aria-label=\"delete note\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" type=\"submit\" translate=\"NOTES.SAVE\" \nng-disabled=\"MsNoteForm.isNotValid()\">Save</md-button><md-button ng-if=\"MsNoteForm.type ===\'new\'\" type=\"submit\" \ntranslate=\"NOTES.ADD\" ng-disabled=\"MsNoteForm.isNotValid()\">Add</md-button></div></div></form>");
$templateCache.put("app/main/scc/components/notes/directives/ms-note-item/ms-note-item.html","<md-card ng-class=\"MsNoteItem.note.color\"><img ng-if=\"MsNoteItem.note.image\" class=\"md-card-image\" \nng-src=\"{{MsNoteItem.note.image}}\"><md-card-content><md-card-title ng-if=\"MsNoteItem.note.title\"><md-card-title-text>\n{{MsNoteItem.note.title}}</md-card-title-text></md-card-title><md-description ng-if=\"MsNoteItem.note.description\">\n<span>{{MsNoteItem.note.description}}</span></md-description><div ng-if=\"MsNoteItem.note.checklist.length > 0\" \nclass=\"checklist\"><div class=\"checklist-item\" ng-repeat=\"checkItem in  MsNoteItem.note.checklist\" layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"checkItem.checked\" \nng-click=\"$event.preventDefault();$event.stopPropagation()\" aria-label=\"{{checkItem.text}}\"></md-checkbox><span \nclass=\"text-truncate\" ng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\" flex>{{checkItem.text}}</span>\n</div></div><div class=\"labels\" ng-if=\"MsNoteItem.note.labels.length > 0\" layout=\"row\" layout-wrap \nlayout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteItem.note.labels\" \nng-click=\"$event.preventDefault();$event.stopPropagation();vm.filterChange(vm.labels.getById(labelId))\" \nng-class=\"vm.labels.getById(labelId).color\">{{vm.labels.getById(labelId).name}}</div></div><div \nng-if=\"vm.noteListType ===\'reminders\' && MsNoteItem.note.reminder\" class=\"reminder secondary-text text-right\"><md-icon \nmd-font-icon=\"icon-bell\" class=\"s16 mr-8\"></md-icon><span>{{MsNoteItem.note.reminder | altDate}}</span></div>\n</md-card-content></md-card>");
$templateCache.put("app/main/scc/components/notes/sidenavs/main/main-sidenav.html","<div ms-scroll class=\"content\"><md-list><md-list-item ng-click=\"vm.filterChange(\'notes\')\" \nng-class=\"{\'selected\':vm.listType ===\'notes\'}\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-lightbulb\" class=\"mr-16\"></md-icon><span translate=\"NOTES.NOTES\">Notes</span></div></md-list-item>\n<md-list-item ng-click=\"vm.filterChange(\'reminders\')\" ng-class=\"{\'selected\':vm.listType ===\'reminders\'}\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-bell\" class=\"mr-16\"></md-icon><span \ntranslate=\"NOTES.REMINDERS\">Reminders</span></div></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"NOTES.LABELS\">Labels</span></md-subheader><md-list-item \nng-repeat=\"label in vm.labels\" ng-class=\"{\'selected\':vm.noteListType.name === label.name}\" class=\"label\" layout=\"row\" \nlayout-align=\"start center\" flex><ms-material-color-picker ng-model=\"label.color\"><md-icon class=\"mr-16\" \nmd-font-icon=\"icon-label\" ng-style=\"{color:$selectedColor.bgColorValue}\"></md-icon></ms-material-color-picker><span \nclass=\"label-name text-transclude\" flex ng-hide=\"editLabelForm.$visible\" ng-click=\"vm.filterChange(label)\">\n{{label.name}} </span><span flex editable-text=\"label.name\" e-form=\"editLabelForm\" ng-show=\"editLabelForm.$visible\">\n{{label.name}}</span><md-button class=\"md-icon-button\" ng-hide=\"editLabelForm.$visible\" \nng-click=\"editLabelForm.$show()\" aria-label=\"edit label\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-hide=\"editLabelForm.$visible\" \nng-click=\"vm.deleteLabel($event, label)\" aria-label=\"delete label\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\">\n</md-icon></md-button></md-list-item><md-list-item class=\"new-label-form\" ng-show=\"newLabelForm.$visible\"><p \neditable-text=\"vm.newLabel.name\" e-form=\"newLabelForm\" onaftersave=\"vm.addNewLabel(vm.newLabel)\"></p></md-list-item>\n<md-list-item class=\"\" ng-click=\"newLabelForm.$show()\" ng-hide=\"newLabelForm.$visible\"><p class=\"md-accent-fg\" \ntranslate=\"NOTES.NEW_LABEL\">New Label</p></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.filterChange(\'archive\')\" ng-class=\"{\'selected\':vm.listType ===\'archive\'}\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-archive\" class=\"mr-16\"></md-icon><span \ntranslate=\"NOTES.ARCHIVE\">Archive</span></div></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/chats/chats-view.html","<md-toolbar class=\"md-tall\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div class=\"avatar-wrapper\"><img \nng-click=\"vm.toggleLeftSidenavView(\'user\')\" ng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar\" \nalt=\"{{vm.user.name}}\"/><md-menu id=\"user-status-menu\"><i ng-click=\"$mdOpenMenu()\" class=\"icon icon- s16 status\" \nng-class=\"vm.user.status\"></i><md-menu-content><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'online\')\"><div \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon s16 status icon-checkbox-marked-circle mr-8 green-fg\"></i> \n<span translate=\"CHAT.STATUS_ONLINE\">Online</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setUserStatus(\'away\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-clock mr-8 yellow-fg\"></i> <span translate=\"CHAT.STATUS_AWAY\">Away</span></div></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'do-not-disturb\')\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 status icon-minus-circle mr-8 red-fg\"></i> <span \ntranslate=\"CHAT.STATUS_DO_NOT_DISTURB\">Do not disturb</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setUserStatus(\'offline\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-checkbox-blank-circle-outline mr-8 green-fg\"></i> <span translate=\"CHAT.STATUS_OFFLINE\">\nOffline</span></div></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nmd-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.toggleLeftSidenavView(\'user\')\" translate=\"CHAT.PROFILE\">Profile</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"\" translate=\"CHAT.LOGOUT\">Logout</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.chatSearch\" type=\"text\" \nplaceholder=\"Search or start new chat\" translate=\"\" translate-attr-placeholder=\"CHAT.CHAT_SEARCH_PLACEHOLDER\"></div>\n</div></div></md-toolbar><md-content flex ms-scroll><md-list class=\"chat-list\"><div \nng-show=\"vm.chatSearch && filteredChat.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredChat.length + filteredContact.length }\" \ntranslate=\"CHAT.CHATS\">CHATS</div><md-list-item class=\"contact md-3-line\" \nng-style=\"{\'transform\': ( vm.chatSearch && filteredChat.length > 0 ) ?\'translate3d(0px, \'+($index + 1)* 100+\'%, 0px)\': \'translate3d(0px, \'+$index* 100+\'%, 0px)\', \'z-index\': filteredChat.length + filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:{}} | filter: {name: vm.chatSearch}  |  orderBy: \'lastMessage.time\' :true | filter:query as filteredChat\" \nng-click=\"vm.getChat(contact.id)\" ng-class=\"{\'unread\':contact.unread}\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar avatar\" alt=\"{{contact.name}}\"/> <i class=\"icon icon- s16 status\" \nng-class=\"contact.status\"></i></div><div class=\"md-list-item-text\"><h3 class=\"name\">{{contact.name}}</h3><p \nclass=\"last-message text-truncate\">{{contact.lastMessage.message}}</p></div><div layout=\"column\" \nlayout-align=\"center end\"><div class=\"last-message-time\">{{contact.lastMessage.time | altDate}}</div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div></div><md-divider>\n</md-divider></md-list-item></md-list><md-list class=\"contact-list\"><div \nng-show=\"vm.chatSearch && filteredContact.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ? \'translate3d(0px, \'+(filteredChat.length +1) * 100+\'%, 0px)\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredContact.length}\" \ntranslate=\"CHAT.CONTACTS\">CONTACTS</div><md-list-item class=\"contact md-3-line\" ng-show=\"vm.chatSearch\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ?\'translate3d(0px, \'+(filteredChat.length + $index +2)* 100+\'%, 0px)\': \'translate3d(0px, \'+ ($index + 1)* 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:null} | filter: {name: vm.chatSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-click=\"vm.getChat(contact.id)\"><div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar avatar\" alt=\"{{contact.name}}\"/> <i class=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div>\n<div class=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"mood\">{{contact.mood}}</p></div><md-divider>\n</md-divider></md-list-item></md-list><div ng-hide=\"(filteredChat.length + filteredContact.length) > 0\" \nclass=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..</div></md-content><md-button \nclass=\"md-fab contacts-button\" ng-click=\"vm.toggleLeftSidenavView(\'contacts\')\" aria-label=\"contacts button\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><h3><span translate=\"CHAT.CONTACTS\">CONTACTS</span></h3></div><div\n class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.contactSearch\" type=\"text\" \nplaceholder=\"Search contact\" translate=\"\" translate-attr-placeholder=\"CHAT.CONTACTS_SEARCH_PLACEHOLDER\"></div></div>\n</div></md-toolbar><md-content flex ms-scroll><md-list class=\"contact-list\"><md-list-item class=\"contact md-3-line\" \nng-repeat=\"contact in vm.contacts  | filter: {name: vm.contactSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-click=\"vm.getChat(contact.id)\"><div class=\"fist-letter md-accent-fg\" \nng-if=\"vm.contacts[$index].name.charAt(0) !== vm.contacts[$index-1].name.charAt(0)\">{{contact.name.charAt(0)}}</div>\n<div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar avatar\" alt=\"{{contact.name}}\"/> <i \nclass=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div><div class=\"md-list-item-text\"><h3>{{contact.name}}\n</h3><p class=\"mood\">{{contact.mood}}</p></div></md-list-item></md-list><div ng-if=\"filteredContact.length <= 0\" \nclass=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..</div></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/user/user-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar user-avatar huge\" alt=\"{{vm.user.name}}\"/><div class=\"user-name\">\n{{vm.user.name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex ms-scroll ms-padding><md-card>\n<md-card-title>Mood</md-card-title><md-card-content><span class=\"mood\" editable-textarea=\"vm.user.mood\" e-rows=\"7\" \ne-cols=\"40\">{{vm.user.mood || \'CHAT.ENTER_MOOD_MESSAGE\' | translate}}</span></md-card-content></md-card></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/right/views/contact/contact-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \ntranslate=\"CHAT.CONTACT_INFO\">Contact Info</div><div flex></div><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'right-sidenav\')\" aria-label=\"back\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"md-avatar avatar contact-avatar huge\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"/><div class=\"contact-name\">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex \nms-scroll ms-padding><md-card><md-card-title translate=\"CHAT.MOOD\">Mood</md-card-title><md-card-content><span \nclass=\"mood\" ng-if=\"vm.contacts.getById(vm.chatContactId).mood\">{{vm.contacts.getById(vm.chatContactId).mood}}</span>\n</md-card-content></md-card></md-content>");}]);